(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7897,9542],{

/***/ 47554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(868);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        default: {
            background: "transparent"
        },
        btnType: function(param) {
            var btnType = param.btnType, hover = param.hover, hoverColor = param.hoverColor;
            var ref, ref1;
            return {
                backgroundColor: ((ref = theme.palette[btnType]) === null || ref === void 0 ? void 0 : ref.main) || "transparent",
                padding: "6px 0px",
                borderRadius: "20px",
                fontFamily: "googlesansmedium",
                textAlign: "center",
                "&:hover": {
                    backgroundColor: hover ? (ref1 = theme.palette[hover]) === null || ref1 === void 0 ? void 0 : ref1.light : "transparent",
                    transition: "all 0.2s ease-in",
                    color: hoverColor || "unset"
                }
            };
        },
        startIcon: {
            marginRight: "4px",
            marginBottom: "2px"
        },
        endIcon: {
            marginLeft: "4px",
            marginBottom: "2px"
        }
    };
});
function ButtonV2(_param) {
    var _tooltipTitle = _param.tooltipTitle, tooltipTitle = _tooltipTitle === void 0 ? "" : _tooltipTitle, children = _param.children, startIcon = _param.startIcon, endIcon = _param.endIcon, className = _param.className, btnType = _param.btnType, _hover = _param.hover, hover = _hover === void 0 ? false : _hover, hoverColor = _param.hoverColor, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "tooltipTitle",
        "children",
        "startIcon",
        "endIcon",
        "className",
        "btnType",
        "hover",
        "hoverColor"
    ]);
    var classes = useStyles({
        btnType: btnType,
        hover: hover,
        hoverColor: hoverColor
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        title: tooltipTitle,
        disableHoverListener: !tooltipTitle && true,
        arrow: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.btnType, className),
            classes: {
                startIcon: classes.startIcon,
                endIcon: classes.endIcon
            },
            startIcon: startIcon,
            endIcon: endIcon
        }, restProps), {
            children: children
        }))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ButtonV2); // btnType contain: 'success' , 'warning', 'info', 'error', 'primary', 'secondary'
 // hover contain: default is false, true will obey light color with btnType color


/***/ }),

/***/ 77753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43004);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);





var _obj;
var ICON_SIZE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.INCREASED */ .w4.INCREASED, {
    src: constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_INCREASE_ICON */ .Hq,
    width: 18,
    height: 18
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.DECREASED */ .w4.DECREASED, {
    src: constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_DECREASE_ICON */ .KB,
    width: 16,
    height: 16
}), _obj);
var FluctuatedPriceIcon = function(param) {
    var fluctuatedType = param.fluctuatedType;
    var icon = ICON_SIZE[fluctuatedType];
    if (!icon) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: icon.src,
        width: icon.width,
        height: icon.height,
        layout: "fixed",
        alt: fluctuatedType === constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .FLUCTUATED_TYPE.INCREASED */ .w4.INCREASED ? "price increased" : "price decreased"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FluctuatedPriceIcon);


/***/ }),

/***/ 50586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39636);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80366);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43775);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);








var BottomDrawerMV2 = function(param) {
    var isShow = param.isShow, handleClose = param.handleClose, titleClass = param.titleClass, _title = param.title, title = _title === void 0 ? "" : _title, _offHeader = param.offHeader, offHeader = _offHeader === void 0 ? false : _offHeader, classContainer = param.classContainer, classContent = param.classContent, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        classes: {
            paper: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().drawerContainer), classContainer)
        },
        anchor: "bottom",
        open: isShow,
        onClose: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
            children: [
                !offHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            classes: {
                                root: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().iconButton)
                            },
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: titleClass,
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().content), classContent),
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomDrawerMV2);


/***/ }),

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5596);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);






function PasswordWarningText(param) {
    var className = param.className;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().text_warning), className && className),
        children: translatePopupAction("popup_login.password_security_login").replace("{BRAND_NAME}", constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .BRAND_NAME */ .RS)
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PasswordWarningText);


/***/ }),

/***/ 47448:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var shimmer = function(w, h, color) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#f3f3f3" offset="20%" />\n      <stop stop-color="#f3f3f3" offset="50%" />\n      <stop stop-color="#f3f3f3" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="').concat(color, '" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
/* harmony default export */ __webpack_exports__["Z"] = (shimmer);


/***/ }),

/***/ 37566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_CartPriceFluctuationModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components-v2/atoms/Mobile/BottomDrawer/index.js
var BottomDrawer = __webpack_require__(50586);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/components-v2/atoms/FluctuatedPriceIcon/index.js
var FluctuatedPriceIcon = __webpack_require__(77753);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 2 modules
var TagComponent = __webpack_require__(22535);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationItem/styles.module.css
var styles_module = __webpack_require__(99182);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartPriceFluctuationItem/index.js




















// product là cart item đã enrich, kèm price (giá mới) / currentPrice (giá lúc thêm vào
// giỏ) / fluctuatedType / warningMessage lấy từ fluctuatedItems của BE.
// isQuantityReadOnly: ở /checkout chỉ cho xem số lượng, muốn sửa thì quay lại giỏ hàng.
var CartPriceFluctuationItem = function(param) {
    var product = param.product, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isQuantityReadOnly = param.isQuantityReadOnly, isQuantityReadOnly = _isQuantityReadOnly === void 0 ? false : _isQuantityReadOnly;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,context/* useCart */.jD)(), updateCartItem = ref1.updateCartItem, validate200Item = ref1.validate200Item;
    var ref2 = product || {}, sku = ref2.sku, _name = ref2.name, name = _name === void 0 ? "" : _name, _slug = ref2.slug, slug = _slug === void 0 ? "" : _slug, _volume = ref2.volume, volume = _volume === void 0 ? "" : _volume, _tags = ref2.tags, tags = _tags === void 0 ? [] : _tags, _statusData = ref2.statusData, statusData = _statusData === void 0 ? {} : _statusData, _expiredDate = ref2.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _lotDates = ref2.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, _isDeal = ref2.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = ref2.deal, deal = _deal === void 0 ? null : _deal, _quantity = ref2.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _price = ref2.price, price = _price === void 0 ? 0 : _price, _currentPrice = ref2.currentPrice, currentPrice = _currentPrice === void 0 ? 0 : _currentPrice, fluctuatedType = ref2.fluctuatedType, _warningMessage = ref2.warningMessage, warningMessage = _warningMessage === void 0 ? "" : _warningMessage, _imagesProxy = ref2.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _isGift = ref2.isGift, isGift = _isGift === void 0 ? false : _isGift, _maxQuantity = ref2.maxQuantity, maxQuantity = _maxQuantity === void 0 ? 0 : _maxQuantity, _messageLimitOrder = ref2.messageLimitOrder, messageLimitOrder = _messageLimitOrder === void 0 ? "" : _messageLimitOrder;
    var ref3 = (0,react.useState)(quantity), value = ref3[0], setValue = ref3[1];
    var ref4 = (0,react.useState)(false), isUpdating = ref4[0], setIsUpdating = ref4[1];
    (0,react.useEffect)(function() {
        setValue(quantity);
    }, [
        quantity
    ]);
    var isIncreased = fluctuatedType === Enums/* FLUCTUATED_TYPE.INCREASED */.w4.INCREASED;
    var remainingPrice = Math.abs(price - currentPrice);
    // ngày cận date nằm ở lô có isNearExpired, expiredDate của cart item thường rỗng
    var nearExpiredLot = lotDates === null || lotDates === void 0 ? void 0 : lotDates.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isNearExpired) === true;
    });
    var handleUpdateQuantity = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newQuantity) {
            var response, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (newQuantity < 1) return [
                            2
                        ];
                        setValue(newQuantity);
                        if (newQuantity === quantity) return [
                            2
                        ];
                        setIsUpdating(true);
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = newQuantity, _tmp), true, true)
                        ];
                    case 1:
                        response = _state.sent();
                        setIsUpdating(false);
                        // BE từ chối (vượt giới hạn mua...) thì trả input về số lượng thật trong giỏ
                        if (!(0,clients/* isValid */.JY)(response)) setValue(quantity);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateQuantity(newQuantity) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDecrease = function() {
        return handleUpdateQuantity(value - 1);
    };
    var handleIncrease = function() {
        if (!validate200Item(sku)) return;
        handleUpdateQuantity(value + 1);
    };
    var handleInputChange = function(e) {
        var ref, ref1;
        var val = e === null || e === void 0 ? void 0 : (ref = e.currentTarget) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^\d]/g, "");
        setValue(val === "" ? "" : Number(val));
    };
    var handleBlur = function() {
        var newQuantity = Number(value) || 0;
        if (newQuantity < 1) {
            setValue(quantity);
            return;
        }
        handleUpdateQuantity(maxQuantity > 0 ? Math.min(newQuantity, maxQuantity) : newQuantity);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((styles_module_default()).item, isMobile && (styles_module_default()).item_mobile),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (styles_module_default()).image_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                    src: (imagesProxy === null || imagesProxy === void 0 ? void 0 : imagesProxy[0]) || (isGift ? Images/* GIFT_IMAGE */.AON : Images/* MISSING_IMAGE */.g_W),
                    fallbackSrc: isGift ? Images/* GIFT_IMAGE */.AON : Images/* MISSING_IMAGE */.g_W,
                    width: isMobile ? 96 : 72,
                    height: isMobile ? 96 : 72,
                    quality: 100,
                    alt: "product-img-".concat(sku),
                    className: (styles_module_default()).image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                        href: "/product/".concat(slug || "", "/loading"),
                        prefetch: false,
                        className: (styles_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).product_name,
                            children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name
                        })
                    }),
                    !!volume && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (styles_module_default()).product_volume,
                        children: volume
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (styles_module_default()).product_tags,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                            product: {
                                tags: tags,
                                statusData: statusData,
                                expiredDate: (nearExpiredLot === null || nearExpiredLot === void 0 ? void 0 : nearExpiredLot.expiredDate) || expiredDate || ""
                            },
                            isGift: isGift
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).price_block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).price_label,
                                children: translateCart("original_price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).old_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(currentPrice)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).price_label, (styles_module_default()).price_label_strong),
                                children: translateCart("new_price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).new_price,
                                children: (0,FormatNumber/* formatCurrency */.xG)(price)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).fluctuation_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                                fluctuatedType: fluctuatedType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)((styles_module_default()).fluctuation_text, isIncreased && (styles_module_default()).increased),
                                children: "".concat(isIncreased ? translateCart("price_increase") : translateCart("price_save"), " ").concat((0,FormatNumber/* formatCurrency */.xG)(remainingPrice))
                            })
                        ]
                    }),
                    !!warningMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).price_row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).price_label,
                                children: translateCart("price_change_reason")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).reason_text,
                                children: warningMessage
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).quantity_block,
                children: [
                    !!messageLimitOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).limit_text,
                        children: messageLimitOrder
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).quantity_control,
                        children: [
                            !isQuantityReadOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MinusButton */.P4, {
                                className: (styles_module_default()).minus_button,
                                disabled: isUpdating || value <= 1,
                                onClick: handleDecrease
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (styles_module_default()).quantity_input_wrapper,
                                children: [
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Icons/* CART_QUANTITY_ICON */.ik,
                                        width: 14,
                                        height: 13,
                                        layout: "fixed",
                                        alt: "quantity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InputProduct */._W, {
                                        className: (styles_module_default()).quantity_input,
                                        product: product,
                                        value: value,
                                        onChange: handleInputChange,
                                        onBlur: handleBlur,
                                        disabled: isUpdating || isQuantityReadOnly,
                                        style: isMobile ? {
                                            width: "".concat(String(value !== null && value !== void 0 ? value : "").length + 1, "ch")
                                        } : undefined
                                    })
                                ]
                            }),
                            !isQuantityReadOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* PlusButton */.sS, {
                                disabled: isUpdating || maxQuantity > 0 && value >= maxQuantity,
                                onClick: handleIncrease
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_CartPriceFluctuationItem = (CartPriceFluctuationItem);

// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/styles.module.css
var CartPriceFluctuationModal_styles_module = __webpack_require__(57624);
var CartPriceFluctuationModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(CartPriceFluctuationModal_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/index.js
















var VISIBLE_ITEMS = 2;
var FluctuationGroup = function(param) {
    var _products = param.products, products = _products === void 0 ? [] : _products, _isIncreased = param.isIncreased, isIncreased = _isIncreased === void 0 ? false : _isIncreased, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isQuantityReadOnly = param.isQuantityReadOnly, isQuantityReadOnly = _isQuantityReadOnly === void 0 ? false : _isQuantityReadOnly;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    if (products.length === 0) return null;
    var isCollapsible = products.length > VISIBLE_ITEMS;
    var visibleProducts = isCollapsible && !isExpanded ? products.slice(0, VISIBLE_ITEMS) : products;
    var groupTitle = isIncreased ? translateCart("price_increased_group") : translateCart("price_decreased_group");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (CartPriceFluctuationModal_styles_module_default()).group,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((CartPriceFluctuationModal_styles_module_default()).group_header, isIncreased && (CartPriceFluctuationModal_styles_module_default()).group_header_increased),
                children: groupTitle.replace("{number}", products.length)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((CartPriceFluctuationModal_styles_module_default()).items, isCollapsible && !isExpanded && (CartPriceFluctuationModal_styles_module_default()).items_collapsed),
                children: visibleProducts.map(function(product) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(mocules_CartPriceFluctuationItem, {
                        product: product,
                        isMobile: isMobile,
                        isQuantityReadOnly: isQuantityReadOnly
                    }, "fluctuation-".concat(product === null || product === void 0 ? void 0 : product.sku));
                })
            }),
            isCollapsible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).see_all,
                onClick: function() {
                    return setIsExpanded(!isExpanded);
                },
                endIcon: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                "data-test": "btn-fluctuation-see-all",
                children: isExpanded ? translateCart("price_collapse") : translateCart("price_see_all")
            })
        ]
    });
};
/**
 * Xác nhận biến động giá, dùng ở 2 chỗ:
 *  - /cart: bấm thanh toán -> xác nhận giá mới rồi mới sang /checkout.
 *  - /checkout: bấm đặt hàng -> xác nhận giá mới rồi đặt hàng luôn (isFromCheckout).
 */ var CartPriceFluctuationModal = function(param) {
    var visible = param.visible, onClose = param.onClose, onBack = param.onBack, onConfirm = param.onConfirm, _products = param.products, products = _products === void 0 ? [] : _products, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isFromCheckout = param.isFromCheckout, isFromCheckout = _isFromCheckout === void 0 ? false : _isFromCheckout;
    var ref = (0,esm/* useTranslation */.$G)("cart"), translateCart = ref.t;
    var ref1 = (0,react.useState)(false), isConfirming = ref1[0], setIsConfirming = ref1[1];
    var decreasedProducts = products.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.fluctuatedType) === Enums/* FLUCTUATED_TYPE.DECREASED */.w4.DECREASED;
    });
    var increasedProducts = products.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.fluctuatedType) === Enums/* FLUCTUATED_TYPE.INCREASED */.w4.INCREASED;
    });
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsConfirming(true);
                        return [
                            4,
                            onConfirm()
                        ];
                    case 1:
                        _state.sent();
                        setIsConfirming(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (CartPriceFluctuationModal_styles_module_default()).title,
                    "data-test": "fluctuation-modal-title",
                    children: translateCart("price_fluctuation_title").replace("{number}", products.length)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuationGroup, {
                        products: decreasedProducts,
                        isMobile: isMobile,
                        isQuantityReadOnly: isFromCheckout
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuationGroup, {
                        products: increasedProducts,
                        isIncreased: true,
                        isMobile: isMobile,
                        isQuantityReadOnly: isFromCheckout
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CartPriceFluctuationModal_styles_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (CartPriceFluctuationModal_styles_module_default()).disclaimer,
                        children: translateCart("price_fluctuation_disclaimer")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (CartPriceFluctuationModal_styles_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (CartPriceFluctuationModal_styles_module_default()).btn_back,
                                onClick: onBack || onClose,
                                "data-test": "btn-fluctuation-back",
                                children: translateCart("back_to_cart")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (CartPriceFluctuationModal_styles_module_default()).btn_continue,
                                onClick: handleConfirm,
                                disabled: isConfirming,
                                "data-test": "btn-fluctuation-continue",
                                children: isFromCheckout ? translateCart("price_fluctuation_checkout") : translateCart("price_fluctuation_continue")
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomDrawer/* default */.Z, {
            isShow: visible,
            handleClose: onClose,
            offHeader: true,
            classContainer: (CartPriceFluctuationModal_styles_module_default()).drawer_paper,
            classContent: (CartPriceFluctuationModal_styles_module_default()).drawer_content,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (CartPriceFluctuationModal_styles_module_default()).wrapper,
            children: content
        })
    });
};
/* harmony default export */ var mocules_CartPriceFluctuationModal = (CartPriceFluctuationModal);


/***/ }),

/***/ 36401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var constants_ErrorCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83084);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34588);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93454);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);









function ErrProductCard(param) {
    var _product = param.product, product = _product === void 0 ? null : _product;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("alert-action"), translateAlertAction = ref.t;
    var _deal = product.deal, deal = _deal === void 0 ? null : _deal, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _defaultImage = product.defaultImage, defaultImage = _defaultImage === void 0 ? null : _defaultImage, _name = product.name, name = _name === void 0 ? "" : _name, _quantity = product.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _errorCode = product.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _slug = product.slug, slug = _slug === void 0 ? "" : _slug, _imagesProxy = product.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _errorMessage = product.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage;
    var errProductMessage = translateAlertAction("message_error_cart.".concat(errorCode)) || errorMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        item: true,
        container: true,
        alignItems: "center",
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                item: true,
                xs: 4,
                style: {
                    padding: "20px 0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().img_container),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_5__/* .ImageFallbackProductImage */ .nZ, {
                        width: 56,
                        height: 56,
                        alt: "product-img-".concat(slug),
                        fallbackSrc: imagesProxy[0] || defaultImage,
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().imageMain),
                        src: defaultImage,
                        quality: 100
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                item: true,
                xs: 8,
                container: true,
                justifyContent: "flex-start",
                alignItems: "center",
                style: {
                    minHeight: "86px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                            href: "/product/".concat(slug || "", "/loading"),
                            prefetch: false,
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                align: "left",
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_name),
                                children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name || ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            align: "right",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_quantity),
                            children: [
                                "x",
                                quantity
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            align: "right",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().text_product_err),
                            children: errProductMessage
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(ErrProductCard));


/***/ }),

/***/ 17863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41749);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ErrProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36401);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4890);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);








function ErrorProductsPayment() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_1__/* .useCart */ .jD)(), _errProducts = ref1.errProducts, errProducts = _errProducts === void 0 ? [] : _errProducts;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            container: true,
            direction: "column",
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    item: true,
                    container: true,
                    justifyContent: "space-between",
                    alignItems: "center",
                    style: {
                        width: "100%",
                        padding: "0px 19px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: translateCommon("total_error_products")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: (errProducts === null || errProducts === void 0 ? void 0 : errProducts.length) || 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    item: true,
                    container: true,
                    direction: "row",
                    style: {
                        width: "100%",
                        padding: "0px 19px",
                        marginTop: "20px",
                        maxHeight: "373px",
                        overflowY: "auto"
                    },
                    children: errProducts.map(function(item) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    product: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    style: {
                                        width: "100%"
                                    }
                                })
                            ]
                        }, item === null || item === void 0 ? void 0 : item.sku);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ErrorProductsPayment);


/***/ }),

/***/ 40907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55517);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80366);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43004);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var _ErrProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36401);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72910);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);















function ModalListProduct(_param) {
    var _content = _param.content, content = _content === void 0 ? null : _content, _title = _param.title, title = _title === void 0 ? "" : _title, _isShowPopupConfirm = _param.isShowPopupConfirm, isShowPopupConfirm = _isShowPopupConfirm === void 0 ? false : _isShowPopupConfirm, handleClosePopup = _param.handleClosePopup, handleClick = _param.handleClick, _icon = _param.icon, icon = _icon === void 0 ? true : _icon, _btnCancelText = _param.btnCancelText, btnCancelText = _btnCancelText === void 0 ? "" : _btnCancelText, _btnOkText = _param.btnOkText, btnOkText = _btnOkText === void 0 ? "" : _btnOkText, _products = _param.products, products = _products === void 0 ? [] : _products, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "content",
        "title",
        "isShowPopupConfirm",
        "handleClosePopup",
        "handleClick",
        "icon",
        "btnCancelText",
        "btnOkText",
        "products",
        "isMobile"
    ]);
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps), {
            open: isShowPopupConfirm,
            onClose: handleClosePopup,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().modal_mobile_wrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                container: true,
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 11,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            align: "left",
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_top_mobile),
                                            children: translatePopupAction("popup-products.check_again_cart_have_err_products")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            onClick: handleClosePopup,
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ic_close),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().icon_close)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                container: true,
                                style: {
                                    maxHeight: "373px",
                                    overflowY: "auto"
                                },
                                children: products && products.length > 0 && products.map(function(product) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                product: product
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                style: {
                                                    width: "100%"
                                                }
                                            })
                                        ]
                                    }, product === null || product === void 0 ? void 0 : product.sku);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        style: {
                            width: "100%",
                            marginTop: "20px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ok_mobile),
                            onClick: handleClick,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(constants_Icons__WEBPACK_IMPORTED_MODULE_2__/* .ICON_WISHLIST_DEL_V2 */ .G9, {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().icon_del)
                                }),
                                translatePopupAction("popup-products.delete_all_products")
                            ]
                        })
                    })
                ]
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, restProps), {
        open: isShowPopupConfirm,
        onClose: handleClosePopup,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().modal_wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_icon),
                                children: "!"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().text_title),
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: content
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            container: true,
                            style: {
                                maxHeight: "373px",
                                overflowY: "auto"
                            },
                            children: products && products.length > 0 && products.map(function(product) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            product: product
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    ]
                                }, product === null || product === void 0 ? void 0 : product.sku);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    container: true,
                    justifyContent: "space-between",
                    alignItems: "center",
                    style: {
                        width: "100%",
                        marginTop: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_cancel),
                            onClick: handleClosePopup,
                            children: btnCancelText || translatePopupAction("popup-products.re_check")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().btn_ok),
                            onClick: handleClick,
                            children: btnOkText || translatePopupAction("popup-products.agree")
                        })
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ModalListProduct);


/***/ }),

/***/ 53371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BLUR_DATA_URL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32692);
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4024);
/* harmony import */ var _material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72578);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18042);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98121);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86010);
/* harmony import */ var components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47448);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66520);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76480);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34588);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94328);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_15__);

























var BLUR_DATA_URL = {
    DART_PC: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(300, 300, "#bcbcbc1c"))),
    DART_MOBILE: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(42, 42, "#bcbcbc1c"))),
    BRIGHT_PC: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(545, 545, "#f3f3f3"))),
    BRIGHT_MOBILE: "data:image/svg+xml;base64,".concat(utils__WEBPACK_IMPORTED_MODULE_7__/* .StringUtils.toBase64 */ .xZ.toBase64((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(42, 42, "#f3f3f3")))
};
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        modal: {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#FFFFFF",
            width: "940px",
            height: "651px",
            borderRadius: "10px",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        mobileModal: {
            position: "absolute",
            display: "flex",
            width: "95%",
            height: "400px",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        closeBtn: {
            width: "30px",
            height: "30px",
            color: "#C0C0C0"
        },
        nameBoxText: {
            display: "box",
            lineClamp: 2,
            boxOrient: "vertical",
            overflow: "hidden"
        },
        navigateBtn: {
            width: "40px",
            height: "40px",
            background: "rgba(0, 0, 0, 0.15)",
            position: "absolute",
            color: "#ffffff",
            "&:hover": {
                background: "rgba(0, 0, 0, 0.15)",
                color: "#2CD888"
            }
        },
        navigateIc: {
            width: "40px",
            height: "40px"
        },
        navBtnMobile: {
            background: "rgba(0, 0, 0, 0.15)",
            width: "40px",
            height: "40px"
        }
    });
});
function getModalStyle() {
    return {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}
var PopupMultilImage = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _images = param.images, images = _images === void 0 ? [] : _images, _open = param.open, open = _open === void 0 ? false : _open, handleClose = param.handleClose, _imageName = param.imageName, imageName = _imageName === void 0 ? "" : _imageName, _selectedImage = param.selectedImage, selectedImage = _selectedImage === void 0 ? 0 : _selectedImage, handleClickImage = param.handleClickImage, handlePrevious = param.handlePrevious, handleNext = param.handleNext;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(getModalStyle), modalStyle = ref[0];
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            open: open,
            onClose: handleClose,
            "aria-labelledby": "image-gallery-title",
            "aria-describedby": "image-gallery-description",
            closeAfterTransition: true,
            BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
            BackdropProps: {
                timeout: 500
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: modalStyle,
                className: classes.mobileModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    container: true,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapperMobileImg),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        onClick: handlePrevious,
                                        "aria-label": "prev",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().leftNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                        width: 300,
                                        height: 300,
                                        layout: "fill",
                                        alt: "image-gallery-item",
                                        fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageMainMobile),
                                        src: "".concat(images[selectedImage], "?size=origin"),
                                        quality: 100,
                                        isUseLoaderCache: true,
                                        placeholder: "blur",
                                        blurDataURL: BLUR_DATA_URL.DART_PC
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        onClick: handleNext,
                                        "aria-label": "next",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().rightNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapper_mobile_thumbnail),
                                children: (images === null || images === void 0 ? void 0 : images.length) === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().flex_center),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper_mobile), (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                            width: 42,
                                            height: 42,
                                            alt: "thumbnailImage",
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                            src: images && "".concat(images[0]),
                                            fallbackSrc: images[0],
                                            quality: 100,
                                            placeholder: "blur",
                                            blurDataURL: BLUR_DATA_URL.DART_MOBILE
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().slider)
                                }, constants_data__WEBPACK_IMPORTED_MODULE_1__/* .settingsMobileMultiImageBoxV2 */ .As), {
                                    children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleClickImage(idx);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper_mobile), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                                width: 42,
                                                height: 42,
                                                alt: "thumbnailImage",
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                                src: "".concat(img),
                                                fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                                quality: 100,
                                                placeholder: "blur",
                                                blurDataURL: BLUR_DATA_URL.DART_MOBILE
                                            })
                                        }, img);
                                    })
                                }))
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "image-gallery-title",
        "aria-describedby": "image-gallery-description",
        closeAfterTransition: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: modalStyle,
                className: classes.modal,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().closeWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: handleClose,
                            "aria-label": "close",
                            style: {
                                height: "18px",
                                width: "18px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                className: classes.closeBtn
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            container: true,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapperImg),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                onClick: handlePrevious,
                                                className: classes.navigateBtn,
                                                "aria-label": "prev",
                                                style: {
                                                    left: "40px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils__WEBPACK_IMPORTED_MODULE_7__/* .ImageFallback */ .oy, {
                                                width: 545,
                                                height: 545,
                                                // layout="fill"
                                                alt: "image-gallery-item",
                                                fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MISSING_IMAGE */ .g_W,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageMain),
                                                src: "".concat(images[selectedImage], "?size=origin"),
                                                quality: 100,
                                                isUseLoaderCache: true,
                                                placeholder: "blur",
                                                blurDataURL: BLUR_DATA_URL.BRIGHT_PC
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                onClick: handleNext,
                                                className: classes.navigateBtn,
                                                "aria-label": "next",
                                                style: {
                                                    left: "590px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    item: true,
                                    style: {
                                        width: "250px",
                                        marginLeft: "50px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().imageNameText), classes.nameBoxText),
                                            children: imageName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().wrapper_thumbnail), (images === null || images === void 0 ? void 0 : images.length) > 21 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().scroll_vertical)),
                                            children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    onClick: function() {
                                                        return handleClickImage(idx);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image_wrapper), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_selected)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__/* .ImageFallbackProductImage */ .nZ, {
                                                        width: 42,
                                                        height: 42,
                                                        alt: "thumbnailImage",
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_15___default().thumbnail_image),
                                                        src: img && "".concat(img),
                                                        fallbackSrc: img,
                                                        quality: 100,
                                                        isUseLoaderCache: true,
                                                        placeholder: "blur",
                                                        blurDataURL: BLUR_DATA_URL.BRIGHT_MOBILE
                                                    })
                                                }, img);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopupMultilImage);


/***/ }),

/***/ 39530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_PopupSharing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Facebook.js
var Facebook = __webpack_require__(60802);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(58530);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/fb.js
var fb = __webpack_require__(33665);
;// CONCATENATED MODULE: ./src/utils/FacebookShare.js
/* eslint-disable no-undef */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable react/jsx-no-target-blank */ 














var styleContainer = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#4b67b7",
    padding: "4px 6px",
    color: "#fff",
    fontFamily: "ggsm",
    borderRadius: "4px",
    maxWidth: "max-content"
};
var styleWrapper = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "space-between",
    position: "relative"
};
var styleFacebookIframe = {
    display: "flex",
    alignItems: "center",
    height: "100%",
    position: "relative"
};
// const domainBuymed = 'https://thuocsi.vn';
var currentTime = new Date().getTime();
var checkNextSymbol = function(link) {
    var regex = /[?]\w/g;
    if (regex.test(link)) {
        return "&";
    }
    return "?";
};
function FacebookShareButton(param) {
    var _luckyWheelCode = param.luckyWheelCode, luckyWheelCode = _luckyWheelCode === void 0 ? "" : _luckyWheelCode, _isSharePopup = param.isSharePopup, isSharePopup = _isSharePopup === void 0 ? false : _isSharePopup, gamificationDetailID = param.gamificationDetailID, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, setOpenConfirmSharing = param.setOpenConfirmSharing, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, reRenderMission = param.reRenderMission, _completedMission = param.completedMission, completedMission = _completedMission === void 0 ? function(socialNetwork) {} : _completedMission;
    var getEnvDomain = function() {
        if (sysconfig/* ENV */.Vi === "prd" || sysconfig/* ENV */.Vi === "uat") {
            return "https://buymed.co.th";
        }
        return "https://stg.th.buymed.tech";
    };
    var domainBuymed = "".concat(getEnvDomain(), "/lucky-wheel");
    // const postInfo = {
    //   method: 'feed',
    //   name: 'Sharing post',
    //   link: redirectLink || domainBuymed,
    // };
    var router = (0,next_router.useRouter)();
    // const { pathname } = router;
    var user = (0,Auth/* useAuth */.aC)().user;
    var t = (0,es/* useTranslation */.$G)().t;
    // const { accountID, customerID } = user || {};
    (0,react.useEffect)(function() {
        (0,fb/* initFBSharing */.$9)();
        return function() {
            (0,fb/* cleanup */.Eq)();
        };
    }, []);
    var handleOpenSharePopup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var shareLink, url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    shareLink = redirectLink || domainBuymed;
                    url = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(shareLink));
                    window.open(url, "_blank");
                    // FBCheckLogin({ postInfo, user, luckyWheelCode, gamificationDetailID, setOpenConfirmSharing, reRenderMission });
                    completedMission(Enums/* POPUP_SHARING_ITEM.FACEBOOK */.uc.FACEBOOK);
                } catch (error) {
                    console.error(error);
                }
                return [
                    2
                ];
            });
        });
        return function handleOpenSharePopup() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (isSharePopup) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 3,
            md: 3,
            style: styleWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    // class="fb-share-button lucky-wheel-fb-share-btn"
                    className: "lucky-wheel-fb-share-btn",
                    style: styleFacebookIframe,
                    // data-href={redirectLink || domainBuymed}
                    // data-layout="button"
                    // data-size="large"
                    onClick: function() {
                        handleOpenSharePopup();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: "Facebook"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: "https://connect.facebook.net/en_GB/all.js#xfbml=1&appId=".concat(sysconfig/* FACEBOOK_APP_ID */.lZ),
                    strategy: "lazyOnload"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "fb-button-share",
                style: styleContainer,
                onClick: function() {
                    handleOpenSharePopup();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
                    " ",
                    t("common:share")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://connect.facebook.net/en_GB/all.js#xfbml=1&appId=".concat(sysconfig/* FACEBOOK_APP_ID */.lZ),
                strategy: "lazyOnload"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FileCopyOutlined.js
var FileCopyOutlined = __webpack_require__(83173);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
;// CONCATENATED MODULE: ./src/components-v3/mocules/SocialSharing/index.js












var SocialSharing = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _socialPlatform = param.socialPlatform, socialPlatform = _socialPlatform === void 0 ? "" : _socialPlatform, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _completedMission = param.completedMission, completedMission = _completedMission === void 0 ? function(socialNetwork) {} : _completedMission;
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var pathname = router.pathname;
    var handleCopyLinkSharing = function() {
        utils/* NotifyUtils.success */.QP.success(t("copiedToTheClipBoard"));
    };
    var handleShareLine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                window.open("https://line.me/R/msg/text/?".concat(encodeURIComponent(redirectLink)), "_blank");
                completedMission(Enums/* POPUP_SHARING_ITEM.LINE */.uc.LINE);
                return [
                    2
                ];
            });
        });
        return function handleShareLine() {
            return _ref.apply(this, arguments);
        };
    }();
    switch(socialPlatform){
        case Enums/* POPUP_SHARING_ITEM.LINE */.uc.LINE:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            onClick: handleShareLine,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/static/images/footer/line-2.svg",
                                alt: "line-icon",
                                style: {
                                    width: 32,
                                    height: 32
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Line"
                        })
                    ]
                });
            }
        case "CURRENT":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                            text: redirectLink || window.location.href,
                            onCopy: handleCopyLinkSharing,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileCopyOutlined/* default */.Z, {
                                style: {
                                    height: 32,
                                    width: 32
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: t("common:copy_link")
                        })
                    ]
                });
            }
        default:
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var mocules_SocialSharing = (SocialSharing);

// EXTERNAL MODULE: ./src/components-v3/mocules/PopupSharing/styles.module.css
var styles_module = __webpack_require__(3793);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v3/mocules/PopupSharing/index.js

















var styleSharing = {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fff",
    borderRadius: "8px",
    boxShadow: 24,
    p: "12px 16px",
    color: "#000",
    display: "flex",
    flexDirection: "column",
    gap: 12
};
var styleMobileSharing = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "#fff",
    borderRadius: "8px",
    boxShadow: 24,
    p: "12px 16px",
    color: "#000",
    display: "flex",
    flexDirection: "column",
    gap: 12
};
var PopupSharing = function(param) {
    var _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _handleClose = param.handleClose, handleClose = _handleClose === void 0 ? function() {} : _handleClose, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _t = param.t, t = _t === void 0 ? function() {} : _t, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, _luckyWheelCode = param.luckyWheelCode, luckyWheelCode = _luckyWheelCode === void 0 ? "" : _luckyWheelCode, _gamificationDetailID = param.gamificationDetailID, gamificationDetailID = _gamificationDetailID === void 0 ? "" : _gamificationDetailID, _setOpenConfirmSharing = param.setOpenConfirmSharing, setOpenConfirmSharing = _setOpenConfirmSharing === void 0 ? function() {} : _setOpenConfirmSharing, _reRenderMission = param.reRenderMission, reRenderMission = _reRenderMission === void 0 ? function() {} : _reRenderMission;
    var user = (0,context/* useAuth */.aC)().user;
    var ref = (0,react.useState)(false), isCopied = ref[0], setIsCopied = ref[1];
    var completedMission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(socialNetwork) {
            var action, ref, accountID, customerID, _tmp, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        action = "";
                        if (socialNetwork === Enums/* POPUP_SHARING_ITEM.FACEBOOK */.uc.FACEBOOK) {
                            action = "share facebook";
                        } else if (socialNetwork === Enums/* POPUP_SHARING_ITEM.LINE */.uc.LINE) {
                            action = "share line";
                        }
                        _tmp = {};
                        ref = user || _tmp, accountID = ref.accountID, customerID = ref.customerID;
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* postGamificationScore */.Fk)((_tmp1.type = Enums/* ENUM_CONDITION_TYPE.SHARE */.gP.SHARE, _tmp1.customerID = customerID, _tmp1.accountID = accountID, _tmp1.action = action, _tmp1.luckyWheelCode = luckyWheelCode, _tmp1.gamificationDetailID = gamificationDetailID, _tmp1.socialNetwork = socialNetwork, _tmp1))
                        ];
                    case 1:
                        _state.sent();
                        // await postShareLog({
                        //   customerID,
                        //   accountID,
                        //   source: isMobile ? 'thuocsi-mobile' : 'thuocsi-web',
                        //   page: getEnvDomain() + pathname,
                        //   screen: pathname.replace('/', ''),
                        //   shareUrl: redirectLink || domainBuymed,
                        //   platform: POPUP_SHARING_ITEM.FACEBOOK,
                        // });
                        if (reRenderMission) {
                            // set timeout here because the API above need a little time to update the data
                            setTimeout(function() {
                                reRenderMission();
                            }, 5000);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function completedMission(socialNetwork) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isOpen,
        onClose: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: isMobile ? styleMobileSharing : styleSharing,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h2",
                            style: {
                                fontFamily: "ggsm"
                            },
                            children: t("share")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleClose,
                            style: {
                                padding: 0,
                                width: "32px",
                                height: "32px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                style: {
                                    stroke: "#c0c0c0",
                                    strokeWidth: 1
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: (0,clsx_m/* default */.Z)((styles_module_default()).sharingContent_wrapper, isMobile && (styles_module_default()).mobileSharingContent_wrapper),
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SocialSharing, {
                            socialPlatform: "CURRENT",
                            redirectLink: redirectLink,
                            isMobile: isMobile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SocialSharing, {
                            title: "Share on LINE",
                            socialPlatform: "LINE",
                            redirectLink: redirectLink,
                            isMobile: isMobile,
                            completedMission: completedMission
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton, {
                            luckyWheelCode: luckyWheelCode,
                            isSharePopup: true,
                            gamificationDetailID: gamificationDetailID,
                            redirectLink: redirectLink,
                            setOpenConfirmSharing: setOpenConfirmSharing,
                            isMobile: isMobile,
                            reRenderMission: reRenderMission,
                            completedMission: completedMission
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_PopupSharing = (PopupSharing);


/***/ }),

/***/ 50979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5233);


// BV-1586: nhãn dưới giá đã giảm của dòng giỏ ("ราคาหลังหักส่วนลด").
// Tách component để chỉ dùng namespace cart khi dòng giỏ thật sự có priceAfterVoucher
// (ProductCardBuy còn được dùng ở các trang không tải namespace cart).
var CartPriceAfterVoucherLabel = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("cart").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: className,
        "data-test": "price-after-voucher-label",
        children: t("priceAfterVoucher")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartPriceAfterVoucherLabel);


/***/ }),

/***/ 86635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_TextareaAutosize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87343);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15149);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76480);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74118);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97230);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_10__);











var CartNote = function() {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var note = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useCart */ .jD)().note;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(note), noteValue = ref1[0], setNoteValue = ref1[1];
    var handleUpdateNote = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(val) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients__WEBPACK_IMPORTED_MODULE_1__/* .CartClientV2.updateNote */ .HP.updateNote(val)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                            utils__WEBPACK_IMPORTED_MODULE_5__/* .NotifyUtils.success */ .QP.success(translateCommon("update_note_success"));
                        } else {
                            utils__WEBPACK_IMPORTED_MODULE_5__/* .NotifyUtils.error */ .QP.error((res === null || res === void 0 ? void 0 : res.message) || translateCommon("update_note_fail"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(val) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleSetNote = function(e) {
        var valNote = e.target.value;
        setNoteValue(valNote);
        (0,utils_debounce__WEBPACK_IMPORTED_MODULE_6__/* .debounceFunc500 */ .X4)(function() {
            return handleUpdateNote(valNote);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setNoteValue(note);
    }, [
        note
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextareaAutosize__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        name: "note",
        value: noteValue,
        onChange: handleSetNote,
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default().text_area),
        "aria-label": "Ghi ch\xfa của kh\xe1ch h\xe0ng",
        placeholder: translateCommon("note_of_customer"),
        maxRows: 4,
        "data-test": "note-cart"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.memo(CartNote));


/***/ }),

/***/ 39542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13402);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_3__);







var CustomModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? true : _icon, children = param.children, onClose = param.onClose, onClickOk = param.onClickOk, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, content = param.content, _btnOk = param.btnOk, btnOk = _btnOk === void 0 ? "C\xf3" : _btnOk, _btnOnClose = param.btnOnClose, btnOnClose = _btnOnClose === void 0 ? "Kh\xf4ng" : _btnOnClose, _btnCloseRender = param.btnCloseRender, btnCloseRender = _btnCloseRender === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .ButtonDefaultLogin */ .O2, {
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().font_gg),
        btnType: "warning",
        onClick: onClose,
        "data-test": "btn-custom-modal-cancel",
        children: btnOnClose
    }) : _btnCloseRender, _btnOkRender = param.btnOkRender, btnOkRender = _btnOkRender === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .ButtonDefaultLogin */ .O2, {
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().font_gg),
        onClick: onClickOk,
        "data-test": "btn-custom-modal-ok",
        children: btnOk
    }) : _btnOkRender, customBtnRender = param.customBtnRender;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().confirm_modal_wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().text_icon),
                                children: "!"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().modal_title),
                            "data-test": "modal-custom-title",
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().modal_content),
                            "data-test": "modal-custom-content",
                            children: content
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        textAlign: "center",
                        marginTop: "16px"
                    },
                    children: [
                        btnCloseRender && btnCloseRender,
                        btnOkRender && btnOkRender,
                        customBtnRender && customBtnRender
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(CustomModal));


/***/ }),

/***/ 40174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68786);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_6__);










var DeleteAddressModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(props) {
    var onClose = props.onClose, onClickOk = props.onClickOk, visible = props.visible, className = props.className, restProps = props.restProps;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().confirm_modal_wrap),
            "data-test": "modal-delete-address",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().text_icon),
                                children: "!"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: translatePopupAction("popup-removeAddress.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_content),
                            children: translatePopupAction("popup-removeAddress.content")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().brown_btn)),
                            onClick: onClose,
                            children: translatePopupAction("popup-removeAddress.no")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            onClick: onClickOk,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().fill_btn)),
                            "data-test": "btn-ok-delete-modal",
                            children: translatePopupAction("popup-removeAddress.yes")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (DeleteAddressModal);


/***/ }),

/***/ 59784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39335);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_6__);










var EditOrderModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(function(props) {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("popup-action"), translatePopupAction = ref.t;
    var onClose = props.onClose, onClickOk = props.onClickOk, visible = props.visible, className = props.className, restProps = props.restProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().confirm_modal_wrap),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().warning_icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().text_icon),
                                children: "!"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: translatePopupAction("popup-edit-order.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_content),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: translatePopupAction("popup-edit-order.content")
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        marginTop: "16px",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().brown_btn)),
                            onClick: onClose,
                            "data-test": "btn-cancel-edit-order",
                            children: translatePopupAction("popup-edit-order.cancel")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            onClick: onClickOk,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().btn), (_style_module_css__WEBPACK_IMPORTED_MODULE_6___default().fill_btn)),
                            "data-test": "btn-ok-edit-order",
                            children: translatePopupAction("popup-edit-order.confirm")
                        })
                    ]
                })
            ]
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (EditOrderModal);


/***/ }),

/***/ 41936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ HISTORY_BOARD_TAB; },
/* harmony export */   "kE": function() { return /* binding */ CONDITION_TYPE; }
/* harmony export */ });
/* unused harmony exports MOBILE_POPUP_TYPE, POPUP_SHARING_ITEM */
// export const MobilePopupTitle = {
//   [ENUM_MOBILE_POPUP_TYPE.MISSON]: 'Nhiệm vụ',
//   [ENUM_MOBILE_POPUP_TYPE.HISTORY]: 'Lịch sử trúng thưởng',
//   [ENUM_MOBILE_POPUP_TYPE.GUILDLINE]: 'Hướng dẫn',
// };
// export type PopupWarningType = 'reward' | 'turn' | 'not_found';
// export type ConditionSocialType = 'FACEBOOK' | 'ZALO';
// export type SpinnerPopupType = 'MISSON' | 'HISTORY' | 'GUIDLINE'
var MOBILE_POPUP_TYPE = {
    MISSON: "MISSION",
    HISTORY: "HISTORY",
    GUILDLINE: "GUILDLINE"
};
var HISTORY_BOARD_TAB = {
    HISTORY_REWARD: "REWARD",
    GUILDLINE: "GUILDLINE",
    MISSION: "MISSION"
};
var POPUP_SHARING_ITEM = {
    FACEBOOK: "FACEBOOK",
    ZALO: "ZALO",
    TELEGRAM: "TELEGRAM",
    LINKEDIN: "LINKEDIN",
    TWITTER: "TWITTER",
    VIBER: "VIBER"
};
var CONDITION_TYPE = {
    SHARE: "SHARE",
    DISCOVER: "DISCOVER"
};


/***/ }),

/***/ 31896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_LuckyWheel; }
});

// UNUSED EXPORTS: spinContainer

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(58769);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/linearProgressClasses.js
var linearProgressClasses = __webpack_require__(28962);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(58530);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/components-v3/mocules/PopupSharing/index.js + 2 modules
var PopupSharing = __webpack_require__(39530);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/events/events.js
var events = __webpack_require__(25293);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/luckyWheel.js
var luckyWheel = __webpack_require__(86553);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/components/mocules/LuckyWheel/ArrowAnimation/styles.module.css
var styles_module = __webpack_require__(1773);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/LuckyWheel/ArrowAnimation/index.js



var ArrowAnimation = function(param) {
    var _isWhite = param.isWhite, isWhite = _isWhite === void 0 ? false : _isWhite, _classes = param.classes, classes = _classes === void 0 ? "" : _classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (0,clsx_m/* default */.Z)((styles_module_default()).drawArrow, classes),
        width: "138",
        height: "81",
        viewBox: "0 0 138 81",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Vector 12",
            d: "M3 78.0003C24.3689 71.3566 60 58 67 46.5C74 35 65.7998 29.0198 58.2678 27.0922C54 26 47.5722 27.8723 43.0826 32.2366C34.6385 40.4452 31.8999 57.4484 47.3752 62.0848C64.2223 67.1322 79.7736 60.7288 97.5851 40.5963C115.397 20.4638 121.718 11.3579 128.909 6.99799C133.682 4.10377 129.023 5.06886 125.475 5.06886C120.428 5.06886 118.417 5.33075 119.948 5.06886C124.422 4.30345 129.45 4.35547 133.523 3.19332C137.878 1.95083 131.279 7.06735 130.626 8.01616C128.567 11.0074 126.226 15.8442 126.226 19.5375",
            stroke: isWhite ? "#fff" : "#000",
            strokeWidth: "5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ var LuckyWheel_ArrowAnimation = (ArrowAnimation);

// EXTERNAL MODULE: ./src/components/mocules/LuckyWheel/constants.js
var constants = __webpack_require__(41936);
// EXTERNAL MODULE: ./src/components/mocules/LuckyWheel/styles.module.css
var LuckyWheel_styles_module = __webpack_require__(74730);
var LuckyWheel_styles_module_default = /*#__PURE__*/__webpack_require__.n(LuckyWheel_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/LuckyWheel/index.js






















// import { getData, getFirst, isValid } from 'clients/Clients';












// import PopupSharing from '../PopupSharing';










var spinContainer = new (events_default()).EventEmitter();
function getRandomInt(min, max) {
    return Math.random() * (max - min) + min;
}
// const DEG_TO_RAD = Math.PI / 180;
var RAD_TO_DEG = 180 / Math.PI;
var PAGE_DEFAULT = 1;
var LoaderContainer = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
    className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).historyReward_loading),
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
        size: "32px",
        color: "primary"
    })
});
var BorderLinearProgress = (0,styled/* default */.ZP)(LinearProgress/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: 20,
        borderRadius: 10
    }, (0,_define_property/* default */.Z)(_obj, "&.".concat(linearProgressClasses/* default.colorPrimary */.Z.colorPrimary), {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(linearProgressClasses/* default.bar */.Z.bar), {
        borderRadius: 0,
        backgroundColor: theme.palette.mode === "light" ? "#F29763" : "#F29763"
    }), _obj;
});
var defaultvalueSpinnerLog = {
    data: [],
    total: 0
};
var LuckyWheelPrizeTooltip = (0,styled/* default */.ZP)(function(_param) // eslint-disable-next-line react/no-children-prop
/*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        classes: {
            popper: className
        },
        children: props.children,
        title: props.title
    });
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: theme.palette.common.white,
        boxShadow: "0px 4px 4px 0px #0000001F;"
    });
});
var drawReward = function(ctx, PI, sweep, img, itemW, itemH, itemX, itemY, text, cx, cy, radius, angle, arcsweep, color) {
    ctx.save();
    // Reward
    ctx.translate(cx * 2, cy * 2);
    ctx.rotate(angle);
    ctx.beginPath();
    // Stroke
    ctx.lineWidth = 5;
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.lineTo(0, 0);
    ctx.arc(0, 0, radius, 0, arcsweep);
    ctx.closePath();
    ctx.strokeStyle = "transparent";
    ctx.stroke();
    // Background
    ctx.fillStyle = color !== null && color !== void 0 ? color : "transparent"; // color bg
    ctx.fill();
    // Item
    ctx.rotate(PI / 2 + sweep / 2);
    ctx.drawImage(img, itemX, itemY, itemW, itemH);
    // restore the context to its original state
    ctx.restore();
};
var LuckyWheel = function(param) {
    var isMobile = param.isMobile, source = param.source, propWheelCode = param.propWheelCode;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("lucky-wheel").t;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref2 = user || {}, accountID = ref2.accountID, customerID = ref2.customerID;
    var ref3 = (0,react.useState)({
        rewards: [],
        luckyWheelCode: "",
        radius: 340,
        rotate: 0,
        easeOut: 0,
        angle: 0,
        top: null,
        offset: null,
        net: null,
        result: null,
        spinning: false,
        isStop: true,
        turns: 0,
        description: "",
        isAcceptFreeTurn: false,
        nextFreeTime: "",
        backgroundWeb: isMobile ? Images/* LUCKYWHEEL_MOBILE_BACKGROUND */.gXP : Images/* LUCKYWHEEL_BACKGROUND */.Asn,
        imageTitleWeb: Images/* LUCKYWHEEL_TITLE */.WLR
    }), spinnerInfo = ref3[0], setSpinnerInfo = ref3[1];
    var ref4 = (0,react.useState)(defaultvalueSpinnerLog), spinnerLog = ref4[0], setSpinnerLog = ref4[1];
    var ref5 = (0,react.useState)(constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION), historyBoardTab = ref5[0], setHistoryBoardTab = ref5[1];
    var ref6 = (0,react.useState)(), rewardIdxMap = ref6[0], setRewardIdxMap = ref6[1];
    var ref7 = (0,react.useState)({
        outOfTurn: false,
        outOfReward: false,
        notFound: false,
        gotPrize: false
    }), isOpenPopup = ref7[0], setOpenPopup = ref7[1];
    var ref8 = (0,react.useState)(0), triggerFetchTurn = ref8[0], setTriggerFetchTurn = ref8[1];
    var ref9 = (0,react.useState)({
        isFetching: false,
        isHasMore: true,
        isLoading: false
    }), historyReward = ref9[0], setHistoryReward = ref9[1];
    var ref10 = (0,react.useState)(PAGE_DEFAULT), pageScroll = ref10[0], setPageScroll = ref10[1];
    var ref11 = (0,react.useState)([]), spinnerMission = ref11[0], setSpinnerMission = ref11[1];
    var ref12 = (0,react.useState)(false), isNextFreeSpin = ref12[0], setNextFreeSpin = ref12[1];
    var ref13 = (0,react.useState)(false), shouldScroll = ref13[0], setShouldScroll = ref13[1];
    var ref14 = (0,react.useState)(), gamificationDetailID = ref14[0], setGamificationDetailID = ref14[1];
    var ref15 = (0,react.useState)(false), isEffectOOT = ref15[0], setEffectOOT = ref15[1];
    var ref16 = (0,react.useState)(false), isShowSharing = ref16[0], setShowSharing = ref16[1];
    var ref17 = (0,react.useState)(sysconfig/* WEB_HOST */.Ul), redirectLink = ref17[0], setRedirectLink = ref17[1];
    var ref18 = (0,react.useState)(true), isLoadingWheel = ref18[0], setLoadingWheel = ref18[1];
    var ref19 = (0,react.useState)([]), mapRewardPosition = ref19[0], setMapRewardPosition = ref19[1];
    var ref20 = (0,react.useState)({}), spinQuestion = ref20[0], setSpinQuestion = ref20[1];
    var btnSpinRef = (0,react.useRef)(null);
    var btnSpinHeadRef = (0,react.useRef)(null);
    var didMountRef = (0,react.useRef)(false);
    var spinnerInfoRef = (0,react.useRef)(spinnerInfo);
    var topPosition = function(num, angle) {
        // find position of arrow selector
        // set starting index and angle offset based on list length
        // works upto 12 options
        var topSpot = null;
        var degreesOff = null;
        if (num <= 3) {
            if (num === 2) {
                // with set 90deg wheel
                topSpot = num;
                degreesOff = Math.PI / 2;
            }
            if (num === 3) {
                // with set 90deg wheel
                topSpot = num;
                degreesOff = 2 * Math.PI / 3;
            }
        } else {
            topSpot = num;
            degreesOff = 0;
        }
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                top: topSpot,
                offset: degreesOff
            });
        });
    };
    var loadImage = function(image) {
        return new Promise(function(resolve, reject) {
            // eslint-disable-next-line no-param-reassign
            image.onload = function() {
                return resolve(image);
            };
            // eslint-disable-next-line no-param-reassign
            image.onerror = function(err) {
                return reject(err);
            };
        });
    };
    var initDrawReward = function(ctx, PI, sweep, cx, cy, radius) {
        var _loop = function(i) {
            var _i = spinnerInfo.rewards[i], name = _i.itemName, imageUrl = _i.itemUrl, tmp = _i.backgroundColor, bgc = tmp === void 0 ? "#fff" : tmp;
            var image = new Image();
            image.onload = function() {
                var imageItemW = 0;
                var imageItemH = 0;
                var imageItemX = 0;
                var imageItemY = 0;
                // item is square
                if (image.naturalWidth === image.naturalHeight) {
                    if (rewardCount > 9) {
                        imageItemW = isMobile ? 116 : 116;
                        imageItemH = isMobile ? 116 : 116;
                        imageItemX = isMobile ? -radius + 280 : -radius + 280;
                        imageItemY = -radius + 10; // space from angle
                    } else {
                        imageItemW = isMobile ? 128 : 128;
                        imageItemH = isMobile ? 128 : 128;
                        imageItemX = isMobile ? -radius + 280 : -radius + 280; // 31
                        imageItemY = -radius + 15; // space from angle
                    }
                }
                // item !== square
                if (image.naturalWidth !== image.naturalHeight) {
                    if (rewardCount >= 10) {
                        imageItemW = isMobile ? 124 : 128;
                        imageItemH = isMobile ? 62 : 64;
                        imageItemX = isMobile ? -radius + 275 : -radius + 275;
                        imageItemY = -radius + 20; // space from angle
                    } else if (rewardCount > 6 && rewardCount < 10) {
                        imageItemW = isMobile ? 148 : 148;
                        imageItemH = isMobile ? 84 : 84;
                        imageItemX = isMobile ? -radius + 265 : -radius + 265;
                        imageItemY = -radius + 20; // space from angle
                    } else {
                        imageItemW = isMobile ? 204 : 204;
                        imageItemH = isMobile ? 102 : 102;
                        imageItemX = isMobile ? -radius + 240 : -radius + 240;
                        imageItemY = -radius + 20; // space from angle
                    }
                }
                drawReward(ctx, PI, sweep, image, imageItemW, imageItemH, imageItemX, imageItemY, name, cx, cy, radius, sweep * i, sweep, bgc);
            };
            image.src = (0,ImageUtils/* getLinkProxyCDN */.SW)(imageUrl);
        };
        var rewardCount = spinnerInfo.rewards.length;
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < rewardCount; i++)_loop(i);
    };
    var renderSector = function() {
        var canvas = document.getElementById("wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width * 2;
            var ch = canvas.height * 2;
            var PI = Math.PI;
            var PI2 = PI * 2;
            var rewardCount = spinnerInfo.rewards.length;
            var sweep = PI2 / rewardCount;
            var cx = cw / 8;
            var cy = ch / 8;
            var radius = spinnerInfo.radius;
            if (ctx) {
                initDrawReward(ctx, PI, sweep, cx, cy, radius);
            }
        }
    };
    var renderWheel = function() {
        // determine number/size of sectors that need to created
        var numOptions = spinnerInfo.rewards.length || 0;
        var centralAngle = 360 * (1 / numOptions) * (Math.PI / 180);
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                angle: centralAngle
            });
        });
        // get index of starting position of selector
        topPosition(numOptions, centralAngle);
        // dynamically generate sectors from state list
        for(var i = 0; i < numOptions; i += 1){
            renderSector();
        }
    };
    var renderBorder = function() {
        var canvas = document.getElementById("border-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var backgroundWheel = new Image();
            backgroundWheel.src = Images/* LUCKYWHEEL_BORDER_WITH_CENTER */.UeK;
            if (ctx) {
                backgroundWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    if (!isMobile) {
                        ctx.drawImage(backgroundWheel, cw - 397.5, ch - 395, cw - 5, ch - 10);
                    } else {
                        ctx.drawImage(backgroundWheel, cw - 290, ch - 290, cw - 20, ch - 20);
                    }
                };
            }
        }
    };
    var renderSelector = function() {
        var canvas = document.getElementById("selector-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var selectorWheel = new Image();
            selectorWheel.src = Images/* LUCKYWHEEL_ARROW_SELECTOR */.PzX;
            if (ctx) {
                selectorWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    if (!isMobile) {
                        ctx.drawImage(selectorWheel, cw / 2 - 14, 0, 30, 87);
                    } else {
                        ctx.drawImage(selectorWheel, cw / 2 - 10, 0, 22, 65);
                    }
                };
            }
        }
    };
    var renderCenterWheel = function() {
        var canvas = document.getElementById("center-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var backgroundWheel = new Image();
            backgroundWheel.src = Images/* LUCKYWHEEL_CENTER */.gxg;
            if (ctx) {
                backgroundWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    ctx.shadowColor = "black";
                    ctx.shadowBlur = 22;
                    if (!isMobile) {
                        ctx.drawImage(backgroundWheel, cw / 2 - 25, ch / 2 - 25, cw / 8, ch / 8); // 400
                    } else {
                        ctx.drawImage(backgroundWheel, cw / 2 - 17.5, ch / 2 - 17.5, cw / 8, ch / 8);
                    }
                };
            }
        }
    };
    var inActiveBtnSpin = function() {
        if (btnSpinHeadRef && btnSpinHeadRef.current) {
            var ref;
            btnSpinHeadRef === null || btnSpinHeadRef === void 0 ? void 0 : (ref = btnSpinHeadRef.current) === null || ref === void 0 ? void 0 : ref.classList.remove((LuckyWheel_styles_module_default()).btnSpin_active);
        }
    };
    var activeButtonSpin = function() {
        if (btnSpinHeadRef && btnSpinHeadRef.current) {
            var ref;
            btnSpinHeadRef === null || btnSpinHeadRef === void 0 ? void 0 : (ref = btnSpinHeadRef.current) === null || ref === void 0 ? void 0 : ref.classList.add((LuckyWheel_styles_module_default()).btnSpin_active);
        }
    };
    var getResult = function(reward) {
        // set state variable to display result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                result: reward,
                isStop: true
            });
        });
        setTriggerFetchTurn(function(prev) {
            return prev + 1;
        });
        setOpenPopup(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                gotPrize: true
            });
        });
    };
    var spin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _questionCode, questionCode, _answerId, answerId, resSpin, currentDate, nextTimeDate, isFreeSpin, _tmp, _tmp1, ref, index, itemCode, idx, ref1, specifySpin, fullRots, arcLength, rotMax, rotMin, ref2, tmp, wrongAnswerId, _correctAnswerId, correctAnswerId, _tmp2, newQuestion, _tmp3, _tmp4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _questionCode = param.questionCode, questionCode = _questionCode === void 0 ? "" : _questionCode, _answerId = param.answerId, answerId = _answerId === void 0 ? null : _answerId;
                        // TODO: Get detail reward
                        if (!spinnerInfo.luckyWheelCode) {
                            NotifyUtils/* default.error */.Z.error("notFound");
                            return [
                                2
                            ];
                        }
                        currentDate = new Date();
                        if (spinnerInfo.nextFreeTime) {
                            nextTimeDate = new Date(spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.nextFreeTime);
                        }
                        isFreeSpin = currentDate.getTime() > (nextTimeDate === null || nextTimeDate === void 0 ? void 0 : nextTimeDate.getTime());
                        if (!(spinnerInfo.isAcceptFreeTurn && isFreeSpin)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* postSpinLuckyWheel */.PW)((_tmp.code = spinnerInfo.luckyWheelCode, _tmp.type = "FREE", _tmp.questionCode = questionCode, _tmp.answerId = answerId, _tmp))
                        ];
                    case 1:
                        // free spin
                        resSpin = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* postSpinLuckyWheel */.PW)((_tmp1.code = spinnerInfo.luckyWheelCode, _tmp1.questionCode = questionCode, _tmp1.answerId = answerId, _tmp1))
                        ];
                    case 3:
                        resSpin = _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp2 = {};
                        _tmp3 = {};
                        _tmp4 = {};
                        if ((0,clients/* isValid */.JY)(resSpin)) {
                            setSpinQuestion(null);
                            activeButtonSpin();
                            ref = (0,clients/* getFirst */.Xi)(resSpin), index = ref.index, itemCode = ref.itemCode;
                            ;
                            if (rewardIdxMap.get(itemCode)) {
                                ;
                                idx = spinnerInfo.top - ((ref1 = rewardIdxMap.get(itemCode)) !== null && ref1 !== void 0 ? ref1 : index); // idx will start at 0
                            } else {
                                // keep allow rotate, accept wrong place spin on, but make sure display correct reward
                                idx = null;
                            }
                            specifySpin = 0;
                            fullRots = Math.floor(Math.random() * 5) + 5; // Full spins the wheel should turn (min = 5, max = 10)
                            if (idx === null) {
                                specifySpin = fullRots * 360;
                            } else {
                                arcLength = 2 * Math.PI / spinnerInfo.rewards.length;
                                rotMax = arcLength * idx + arcLength - arcLength / 5; // reduce 20% width replace for wrong rate
                                rotMin = arcLength * (idx + 1) - arcLength + arcLength / 5; // add 20% width replace for wrong rate
                                specifySpin = fullRots * 360 + getRandomInt(rotMin, rotMax) * RAD_TO_DEG;
                            }
                            setSpinnerInfo(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    rotate: specifySpin,
                                    easeOut: 4,
                                    spinning: true,
                                    isStop: false
                                });
                            });
                            // calcalute result after wheel stops spinning
                            setTimeout(function() {
                                var formatData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,clients/* getFirst */.Xi)(resSpin)), {
                                    message: resSpin.message
                                });
                                getResult(formatData);
                            }, 4000);
                        } else {
                            // empty turn wheel
                            switch(resSpin.errorCode){
                                case "WRONG_ANSWER":
                                    {
                                        ref2 = (0,clients/* getFirst */.Xi)(resSpin) || _tmp2, tmp = ref2.answerId, wrongAnswerId = tmp === void 0 ? "" : tmp, _correctAnswerId = ref2.correctAnswerId, correctAnswerId = _correctAnswerId === void 0 ? "" : _correctAnswerId;
                                        newQuestion = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, spinQuestion), (_tmp4.wrongAnswerId = wrongAnswerId, _tmp4.correctAnswerId = correctAnswerId, _tmp4));
                                        setSpinQuestion(newQuestion);
                                        break;
                                    }
                                case "NOT_ENOUGH_ITEM":
                                    {
                                        setOpenPopup(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                outOfReward: true
                                            });
                                        });
                                        break;
                                    }
                                case "NOT_FOUND":
                                    {
                                        setOpenPopup(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                notFound: true
                                            });
                                        });
                                        break;
                                    }
                                default:
                                    {
                                        // remove popup only show effect and change tab
                                        setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION);
                                        setEffectOOT(true);
                                        break;
                                    }
                            }
                            inActiveBtnSpin();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function spin(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var reset = function() {
        // reset wheel and result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                rotate: 0,
                easeOut: 0,
                result: null,
                spinning: false
            });
        });
    };
    var handleResetPopupPrize = function() {
        // reset wheel and result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                rotate: 0,
                easeOut: 0,
                result: null,
                spinning: false
            });
        });
        inActiveBtnSpin();
        setOpenPopup(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                gotPrize: false
            });
        });
    };
    var handleClosePopup = function() {
        setOpenPopup({
            gotPrize: false,
            outOfReward: false,
            outOfTurn: false,
            notFound: false
        });
    };
    var handleReloadPage = function() {
        router.reload();
    };
    var handleShowSharing = function() {
        setShowSharing(true);
    };
    var handleScrollToBottom = function(e) {
        var bottom = Math.abs(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) <= 10;
        if (bottom) {
            if (spinnerLog && (!(spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data) || spinnerLog.total <= 20 || (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data.length) >= (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.total))) {
                setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyReward), {
                    isHasMore: false
                }));
            }
            if (historyReward.isHasMore && !historyReward.isLoading) {
                setPageScroll(function(prev) {
                    return prev + 1;
                });
            }
        }
    };
    var reRenderMission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var selfWheelMissionRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getMissionSelfLuckyWheel */.Tj)((_tmp.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp))
                        ];
                    case 1:
                        selfWheelMissionRes = _state.sent();
                        if ((0,clients/* isValid */.JY)(selfWheelMissionRes)) {
                            data = selfWheelMissionRes.data;
                            if (data) {
                                setSpinnerMission(data.filter(function(item) {
                                    return item.isActive;
                                }));
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function reRenderMission() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFindMoreTurn = function() {
        setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION);
        setEffectOOT(true);
        setOpenPopup({
            gotPrize: false,
            outOfReward: false,
            outOfTurn: false,
            notFound: false
        });
    };
    var handleGetQuestion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var spinQuestionRes, _tmp, e, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (spinnerInfo.turns <= 0) {
                            setOpenPopup(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    outOfTurn: true
                                });
                            });
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp = {};
                        return [
                            4,
                            PromoClient/* default.getSpinQuestion */.ZP.getSpinQuestion((_tmp.luckyWheelCode = propWheelCode, _tmp))
                        ];
                    case 2:
                        spinQuestionRes = _state.sent();
                        if (!(0,clients/* isValid */.JY)(spinQuestionRes)) throw spinQuestionRes;
                        setSpinQuestion((0,clients/* getFirst */.Xi)(spinQuestionRes));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        _tmp1 = {};
                        spin(_tmp1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGetQuestion() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClosePopupQuestion = function(param) {
        var _isAnswerWrong = param.isAnswerWrong, isAnswerWrong = _isAnswerWrong === void 0 ? false : _isAnswerWrong;
        if (isAnswerWrong) {
            setTriggerFetchTurn(function(prev) {
                return prev + 1;
            });
        }
        setSpinQuestion(null);
    };
    (0,react.useEffect)(function() {
        // get wheel and wheel's log
        (0,_async_to_generator/* default */.Z)(function() {
            var selfWheelRes, ref, ref1, code, items, turns, description, nextFreeTime, isAcceptFreeTurn, isEnableShare, imageTitleWeb, backgroundWeb, selfLogRes, _tmp, selfWheelMissionRes, _tmp1, currentDate, wheelNextFreeTime, checkNextFreeTime, newSpinnerIdxMap, data, total, data1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!propWheelCode) {
                            setLoadingWheel(false);
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            (0,PromoClient/* getSelfLuckyWheelRewards */.ji)(propWheelCode)
                        ];
                    case 1:
                        selfWheelRes = _state.sent();
                        if (!(0,clients/* isValid */.JY)(selfWheelRes)) return [
                            3,
                            4
                        ];
                        ref1 = (0,clients/* getFirst */.Xi)(selfWheelRes), code = ref1.code, items = ref1.items, turns = ref1.turns, description = ref1.description, nextFreeTime = ref1.nextFreeTime, isAcceptFreeTurn = ref1.isAcceptFreeTurn, isEnableShare = ref1.isEnableShare, imageTitleWeb = ref1.imageTitleWeb, backgroundWeb = ref1.backgroundWeb;
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = PAGE_DEFAULT * 20, _tmp))
                        ];
                    case 2:
                        selfLogRes = _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* getMissionSelfLuckyWheel */.Tj)((_tmp1.luckyWheelCode = code, _tmp1))
                        ];
                    case 3:
                        selfWheelMissionRes = _state.sent();
                        if (!items || items.length === 0) {
                            setLoadingWheel(false);
                            return [
                                2,
                                null
                            ];
                        }
                        currentDate = new Date();
                        wheelNextFreeTime = new Date(nextFreeTime);
                        checkNextFreeTime = currentDate.getTime() >= wheelNextFreeTime.getTime();
                        setSpinnerInfo(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                luckyWheelCode: code,
                                turns: checkNextFreeTime ? turns + 1 : turns,
                                rewards: (items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                    return item.isActive;
                                }).sort(function(a, b) {
                                    return a.index - b.index;
                                })) || [],
                                description: description,
                                nextFreeTime: nextFreeTime,
                                isAcceptFreeTurn: isAcceptFreeTurn,
                                isEnableShare: isEnableShare,
                                imageTitleWeb: (0,ImageUtils/* getLinkProxyCDN */.SW)(imageTitleWeb) || Images/* LUCKYWHEEL_TITLE */.WLR,
                                backgroundWeb: (0,ImageUtils/* getLinkProxyCDN */.SW)(backgroundWeb) || (isMobile ? Images/* LUCKYWHEEL_MOBILE_BACKGROUND */.gXP : Images/* LUCKYWHEEL_BACKGROUND */.Asn)
                            });
                        });
                        newSpinnerIdxMap = new Map((ref = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                            return item.isActive;
                        }).sort(function(a, b) {
                            return a.index - b.index;
                        })) === null || ref === void 0 ? void 0 : ref.map(function(child, idx) {
                            return [
                                child.itemCode,
                                idx + 1
                            ];
                        }));
                        setRewardIdxMap(newSpinnerIdxMap);
                        if ((0,clients/* isValid */.JY)(selfLogRes)) {
                            data = selfLogRes.data, total = selfLogRes.total;
                            if (data && total && total > 0) {
                                setSpinnerLog(selfLogRes);
                            }
                        }
                        if ((0,clients/* isValid */.JY)(selfWheelMissionRes)) {
                            data1 = selfWheelMissionRes.data;
                            if (data1) {
                                setSpinnerMission(data1.filter(function(item) {
                                    return item.isActive;
                                }));
                            }
                        }
                        _state.label = 4;
                    case 4:
                        setLoadingWheel(false);
                        return [
                            2,
                            null
                        ];
                }
            });
        })();
    }, [
        triggerFetchTurn,
        isNextFreeSpin,
        propWheelCode
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // render wheel part
        if ((spinnerInfo === null || spinnerInfo === void 0 ? void 0 : (ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            renderWheel();
            renderBorder();
            renderSelector();
            renderCenterWheel();
        }
    }, [
        spinnerInfo.rewards
    ]);
    (0,react.useEffect)(function() {
        // fetch more history log
        if (didMountRef.current) {
            (0,_async_to_generator/* default */.Z)(function() {
                var _tmp, _tmp1, selfLogRes, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(pageScroll !== 1)) return [
                                3,
                                2
                            ];
                            _tmp = {};
                            _tmp1 = {};
                            setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, historyReward), (_tmp1.isLoading = true, _tmp1)));
                            _tmp2 = {};
                            return [
                                4,
                                (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp2.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp2.limit = pageScroll * 20, _tmp2))
                            ];
                        case 1:
                            selfLogRes = _state.sent();
                            _tmp3 = {};
                            _tmp4 = {};
                            _tmp5 = {};
                            _tmp6 = {};
                            if (selfLogRes.status === "NOT_FOUND" || !historyReward.isHasMore) {
                                setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, historyReward), (_tmp4.isHasMore = false, _tmp4.isLoading = false, _tmp4)));
                            } else if (historyReward.isHasMore) {
                                if (spinnerLog && spinnerLog.data) {
                                    setSpinnerLog(function(prev) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                            data: (0,_to_consumable_array/* default */.Z)((0,clients/* getData */.Yu)(selfLogRes)),
                                            total: selfLogRes.total
                                        });
                                    });
                                    setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, historyReward), (_tmp6.isLoading = false, _tmp6)));
                                }
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        } else {
            didMountRef.current = true;
        }
        return function() {
            setHistoryReward({
                isFetching: false,
                isHasMore: true,
                isLoading: false
            });
        };
    }, [
        pageScroll
    ]);
    (0,react.useEffect)(function() {
        var intervalFreeSpin = setInterval(function() {
            var ref;
            var currentDate = new Date();
            if (currentDate.getTime() >= new Date(spinnerInfoRef === null || spinnerInfoRef === void 0 ? void 0 : (ref = spinnerInfoRef.current) === null || ref === void 0 ? void 0 : ref.nextFreeTime).getTime()) {
                setNextFreeSpin(true);
            } else {
                setNextFreeSpin(false);
            }
        }, 1000);
        return function() {
            clearInterval(intervalFreeSpin);
        };
    }, []);
    (0,react.useEffect)(function() {
        spinnerInfoRef.current = spinnerInfo;
    }, [
        spinnerInfo
    ]);
    (0,react.useEffect)(function() {
        spinContainer.on("misson", function() {
            setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION);
        });
        spinContainer.on("history", function() {
            setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.HISTORY_REWARD */.BF.HISTORY_REWARD);
        });
        spinContainer.on("guideline", function() {
            setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.GUILDLINE */.BF.GUILDLINE);
        });
    }, []);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setShouldScroll(true);
        }, 3000); // Adjust the delay time as needed
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        var parentEle = document.getElementById("spinnerWrapper");
        if (parentEle) {
            parentEle.scrollLeft = 350;
        }
    }, [
        shouldScroll
    ]);
    (0,react.useEffect)(function() {
        if (isEffectOOT) {
            setTimeout(function() {
                setEffectOOT(false);
            }, 5000);
        }
    }, [
        isEffectOOT
    ]);
    var TitleTooltip = function(param) {
        var name = param.name, url = param.url;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (LuckyWheel_styles_module_default()).tooltipPrizeWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (LuckyWheel_styles_module_default()).tooltipImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (0,ImageUtils/* getLinkProxyCDN */.SW)(url),
                        alt: name,
                        objectFit: "contain",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    className: (LuckyWheel_styles_module_default()).tooltipPrizeText,
                    children: name
                })
            ]
        });
    };
    var TempPrizeElement = function(props) {
        var ref;
        var listItem = props.listItem;
        var containerDegree = function() {
            switch(listItem.length){
                case 12:
                    return -90 + 15;
                case 11:
                    return -90 + 16;
                case 10:
                    return -90 + 17;
                case 9:
                    return -90 + 20;
                case 8:
                    return -90 + 23;
                case 7:
                    return -90 + 26;
                case 6:
                    return -90 + 31;
                case 5:
                    return -90 + 37;
                case 4:
                    return -90 + 46;
                case 3:
                    return -90 + 61;
                case 1:
                    return -90 + 181;
                default:
                    return 0;
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
                position: "absolute",
                height: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.radius,
                width: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.radius,
                translate: "-50% -50%",
                rotate: "".concat(containerDegree(), "deg"),
                top: "50%",
                left: "50%"
            },
            children: (ref = listItem === null || listItem === void 0 ? void 0 : listItem.sort(function(a, b) {
                return a.i - b.i;
            })) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(LuckyWheelPrizeTooltip, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTooltip, {
                        name: item.itemName,
                        url: item.itemUrl
                    }, item.i),
                    style: {
                        backgroundColor: "#fff"
                    },
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tempPrizePostion_".concat(item.i),
                        style: {
                            width: item.itemW,
                            height: item.itemH,
                            top: item.itemY,
                            left: item.itemX,
                            rotate: "".concat(-90 + item.i * (360 / ((ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length)), "deg"),
                            zIndex: 1
                        },
                        className: (LuckyWheel_styles_module_default()).tempPrizePosition,
                        "data-name": item.itemName,
                        "data-url": item.itemUrl
                    })
                }, item.i);
            })
        });
    };
    if (!user || !propWheelCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (spinnerInfo && ((ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        if (!isLoadingWheel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: "100%",
                height: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    style: {
                        color: "#000",
                        fontFamily: "ggsr",
                        fontSize: 18,
                        textAlign: "center"
                    },
                    children: t("notTakePlace")
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var _itemImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "spinnerWrapper",
        className: (LuckyWheel_styles_module_default()).spinnerReward_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            className: isMobile ? (LuckyWheel_styles_module_default()).mobileSpinner_container : (LuckyWheel_styles_module_default()).luckyWheel_container,
            style: {
                backgroundImage: "url(".concat(spinnerInfo.backgroundWeb, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    sm: 3,
                    md: 3,
                    className: isMobile ? (LuckyWheel_styles_module_default()).mobileSectionWheelTitle_container : (LuckyWheel_styles_module_default()).sectionWheelTitle_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isMobile ? (LuckyWheel_styles_module_default()).mobileWheelTitle_imageWrapper : (LuckyWheel_styles_module_default()).wheelTitle_imageWrapper,
                            style: {
                                backgroundImage: "url(".concat(spinnerInfo.imageTitleWeb, ")")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDownLuckyUser, {
                            code: spinnerInfo.luckyWheelCode,
                            isMobile: isMobile,
                            t: t
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    sm: 5,
                    md: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        style: {
                            position: "relative",
                            width: isMobile ? "100%" : "400px",
                            borderRadius: "12px",
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (LuckyWheel_styles_module_default()).drawCanvas_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "spin_1",
                                        className: isMobile ? (LuckyWheel_styles_module_default()).mobileLuckyWheel_central : (LuckyWheel_styles_module_default()).luckyWheel_central
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LuckyWheel_styles_module_default()).luckyWheel_borderWheel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LuckyWheel_styles_module_default()).luckyWheel_selector
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                        className: (LuckyWheel_styles_module_default()).canvasContainer,
                                        id: "wheel",
                                        width: "800",
                                        height: "800",
                                        style: {
                                            WebkitTransform: "rotate(".concat(spinnerInfo.rotate - 90, "deg)"),
                                            WebkitTransition: "-webkit-transform ".concat(spinnerInfo.easeOut, "s ease-out"),
                                            zIndex: 0,
                                            width: "100%"
                                        }
                                    }),
                                    isEffectOOT && /*#__PURE__*/ (0,jsx_runtime.jsx)(LuckyWheel_ArrowAnimation, {
                                        isWhite: true,
                                        classes: (LuckyWheel_styles_module_default()).positionArrowEffect
                                    }),
                                    !spinnerInfo.spinning ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TempPrizeElement, {
                                        listItem: mapRewardPosition
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSpin, {
                                // spin={spin}
                                reset: reset,
                                btnSpinHeadRef: btnSpinHeadRef,
                                btnSpinRef: btnSpinRef,
                                isSpinning: spinnerInfo.spinning,
                                isStop: spinnerInfo.isStop,
                                turns: spinnerInfo.turns,
                                handleGetQuestion: handleGetQuestion
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (LuckyWheel_styles_module_default()).boxHistoryReward,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: {
                            position: "relative",
                            height: "100%",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            sm: 4,
                            md: 4,
                            className: (LuckyWheel_styles_module_default()).historyBoard,
                            id: "spin_4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    className: (LuckyWheel_styles_module_default()).boardTab,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).missionTab, historyBoardTab === constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION && (LuckyWheel_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_MISSION_ICON */.B1H,
                                                    alt: "mission icon",
                                                    width: 29,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: t("missions")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).historyReward, historyBoardTab === constants/* HISTORY_BOARD_TAB.HISTORY_REWARD */.BF.HISTORY_REWARD && (LuckyWheel_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.HISTORY_REWARD */.BF.HISTORY_REWARD);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_TIME_ICON */.hnG,
                                                    alt: "mission icon",
                                                    width: 32,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: t("history")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).guildLine, historyBoardTab === constants/* HISTORY_BOARD_TAB.GUILDLINE */.BF.GUILDLINE && (LuckyWheel_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(constants/* HISTORY_BOARD_TAB.GUILDLINE */.BF.GUILDLINE);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_GUILDLINE_ICON */.uf0,
                                                    alt: "guidline icon",
                                                    width: 60,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: t("guide")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                historyBoardTab === constants/* HISTORY_BOARD_TAB.HISTORY_REWARD */.BF.HISTORY_REWARD && spinnerLog && spinnerLog.total > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).boardContainer),
                                    children: [
                                        historyReward.isLoading && LoaderContainer,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: (LuckyWheel_styles_module_default()).boardContainer_childList,
                                            onScroll: handleScrollToBottom,
                                            children: (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data) && (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    container: true,
                                                    className: (LuckyWheel_styles_module_default()).boardItem_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 3,
                                                            className: (LuckyWheel_styles_module_default()).boardItem_imageWrapper,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: (0,ImageUtils/* getLinkProxyCDN */.SW)((_itemImage = item.itemImage) !== null && _itemImage !== void 0 ? _itemImage : ""),
                                                                width: 80,
                                                                height: 40
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 9,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "body2",
                                                                    className: (LuckyWheel_styles_module_default()).boardItem_itemName,
                                                                    children: (0,luckyWheel/* convertLuckyMessage */.kE)(item === null || item === void 0 ? void 0 : item.message, t)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (LuckyWheel_styles_module_default()).boardItem_created,
                                                                    children: (0,format/* default */.Z)(new Date(item.createdTime), "HH:mm dd/MM/yyyy")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.id);
                                            }))
                                        })
                                    ]
                                }),
                                historyBoardTab === constants/* HISTORY_BOARD_TAB.GUILDLINE */.BF.GUILDLINE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).boardGuildLine),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (LuckyWheel_styles_module_default()).historyBoard_guildContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (LuckyWheel_styles_module_default()).historyBoard_guildLineText,
                                            dangerouslySetInnerHTML: {
                                                __html: spinnerInfo.description
                                            }
                                        })
                                    })
                                }),
                                historyBoardTab === constants/* HISTORY_BOARD_TAB.MISSION */.BF.MISSION && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).boardContainer, isEffectOOT && (LuckyWheel_styles_module_default()).glowOnEffect),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (LuckyWheel_styles_module_default()).boardContainer_childList,
                                        children: spinnerMission && ((ref1 = spinnerMission === null || spinnerMission === void 0 ? void 0 : spinnerMission.filter(function(item) {
                                            return item.isActive;
                                        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                            var ref, ref1, ref2, ref3, ref4;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                className: (LuckyWheel_styles_module_default()).boardMissionItem_container,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                className: (LuckyWheel_styles_module_default()).boardMissionItem_itemName,
                                                                children: item.missionName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (LuckyWheel_styles_module_default()).boardItemMission_content,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: (item === null || item === void 0 ? void 0 : (ref = item.condition) === null || ref === void 0 ? void 0 : ref.description) || ""
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                className: (0,clsx_m/* default */.Z)((item === null || item === void 0 ? void 0 : (ref1 = item.processInfos) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && (LuckyWheel_styles_module_default()).processBar_container),
                                                                children: item.processInfos && ((ref2 = item.processInfos) === null || ref2 === void 0 ? void 0 : ref2.map(function(process) {
                                                                    return process.target !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            gap: 4
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    color: "#000"
                                                                                },
                                                                                variant: "body2",
                                                                                children: (0,luckyWheel/* convertMissionType */.w6)(process.unitName, t)
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                                sx: {
                                                                                    width: "100%",
                                                                                    mr: 1,
                                                                                    position: "relative"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress, {
                                                                                        variant: "determinate",
                                                                                        value: process.value / process.target > 1 ? 100 : process.value / process.target * 100
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        style: {
                                                                                            position: "absolute",
                                                                                            top: 0,
                                                                                            left: "50%",
                                                                                            transform: "translate(-50%, -5%)",
                                                                                            fontSize: "14px",
                                                                                            fontFamily: "ggsr",
                                                                                            lineHeight: "22px"
                                                                                        },
                                                                                        children: "".concat((0,FormatNumber/* formatNumber */.uf)(process.value, sysconfig/* CURRENCY_SEPARATE */.UI, 2), " / ").concat((0,FormatNumber/* formatNumber */.uf)(process.target, sysconfig/* CURRENCY_SEPARATE */.UI, 2))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, process.id);
                                                                }))
                                                            })
                                                        ]
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.processInfos) && ((ref3 = item === null || item === void 0 ? void 0 : item.processInfos.filter(function(info) {
                                                        return info.isCompleted;
                                                    })) === null || ref3 === void 0 ? void 0 : ref3.length) !== (item === null || item === void 0 ? void 0 : (ref4 = item.processInfos) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        style: {
                                                            marginLeft: "auto"
                                                        },
                                                        children: (item === null || item === void 0 ? void 0 : item.condition.actionName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            style: {
                                                                marginLeft: "auto"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    var ref, respScoreDiscover, _tmp, ref1, ref2, _tmp1, ref3, ref4, _tmp2;
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                setGamificationDetailID(item.gamificationDetailID);
                                                                                if (!(item.condition.type === constants/* CONDITION_TYPE.SHARE */.kE.SHARE)) return [
                                                                                    3,
                                                                                    1
                                                                                ];
                                                                                // case sharing post
                                                                                setRedirectLink(item === null || item === void 0 ? void 0 : (ref = item.condition) === null || ref === void 0 ? void 0 : ref.actionLink);
                                                                                setShowSharing(true);
                                                                                return [
                                                                                    3,
                                                                                    4
                                                                                ];
                                                                            case 1:
                                                                                if (!(item.condition.type === constants/* CONDITION_TYPE.DISCOVER */.kE.DISCOVER)) return [
                                                                                    3,
                                                                                    3
                                                                                ];
                                                                                _tmp = {};
                                                                                return [
                                                                                    4,
                                                                                    (0,PromoClient/* postGamificationScore */.Fk)((_tmp.type = constants/* CONDITION_TYPE.DISCOVER */.kE.DISCOVER, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = "discovery mission", _tmp.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp.gamificationDetailID = item.gamificationDetailID, _tmp))
                                                                                ];
                                                                            case 2:
                                                                                respScoreDiscover = _state.sent();
                                                                                _tmp1 = {};
                                                                                if (respScoreDiscover.status === "OK") {
                                                                                    if (source === "mobile_app") {
                                                                                        ;
                                                                                        window === null || window === void 0 ? void 0 : (ref1 = window.ReactNativeWebView) === null || ref1 === void 0 ? void 0 : ref1.postMessage(JSON.stringify((_tmp1.type = "deep_link", _tmp1.value = "".concat(item === null || item === void 0 ? void 0 : (ref2 = item.condition) === null || ref2 === void 0 ? void 0 : ref2.actionLink), _tmp1)));
                                                                                    } else {
                                                                                        router.push(item.condition.actionLink || "");
                                                                                    }
                                                                                }
                                                                                return [
                                                                                    3,
                                                                                    4
                                                                                ];
                                                                            case 3:
                                                                                _tmp2 = {};
                                                                                if (source === "mobile_app") {
                                                                                    ;
                                                                                    window === null || window === void 0 ? void 0 : (ref3 = window.ReactNativeWebView) === null || ref3 === void 0 ? void 0 : ref3.postMessage(JSON.stringify((_tmp2.type = "deep_link", _tmp2.value = "".concat(item === null || item === void 0 ? void 0 : (ref4 = item.condition) === null || ref4 === void 0 ? void 0 : ref4.actionLink), _tmp2)));
                                                                                } else {
                                                                                    router.push(item.condition.actionLink || "");
                                                                                }
                                                                                _state.label = 4;
                                                                            case 4:
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                className: (0,clsx_m/* default */.Z)(item.isBlocked ? (LuckyWheel_styles_module_default()).boardMission_disablesBtn : (LuckyWheel_styles_module_default()).boardMissinItem_btn),
                                                                children: item.isBlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px"
                                                                    },
                                                                    children: [
                                                                        t("notUnlock"),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: Images/* LUCKYWHEEL_BLOCKED_ICON */.OZM,
                                                                            width: 15,
                                                                            height: 20
                                                                        }),
                                                                        " "
                                                                    ]
                                                                }) : item.condition.actionName
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        style: {
                                                            marginLeft: "auto",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            color: "#797979",
                                                            gap: 4
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {}),
                                                            " ",
                                                            t("completed")
                                                        ]
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.isBlocked) && (item === null || item === void 0 ? void 0 : item.parentMissionName) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        style: {
                                                            color: "#D55D2A",
                                                            fontSize: 12
                                                        },
                                                        children: [
                                                            t("completeMission"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: "#000"
                                                                },
                                                                children: item === null || item === void 0 ? void 0 : item.parentMissionName
                                                            }),
                                                            " ",
                                                            t("toUnlock")
                                                        ]
                                                    })
                                                ]
                                            }, item.id);
                                        }))
                                    })
                                })
                            ]
                        })
                    })
                }),
                spinnerInfo.isEnableShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: isMobile ? (LuckyWheel_styles_module_default()).mobileSharingContainer : (LuckyWheel_styles_module_default()).sharingContainer,
                    onClick: handleShowSharing,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            style: {
                                padding: "6px 0 0",
                                height: 40
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: Images/* LUCKYWHEEL_SHARE_ICON */.J7Q,
                                alt: "share icon",
                                width: 32,
                                height: 32
                            })
                        }),
                        t("share")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupSharing/* default */.Z, {
                    isOpen: isShowSharing,
                    handleClose: function() {
                        return setShowSharing(false);
                    },
                    isMobile: isMobile,
                    t: t,
                    luckyWheelCode: spinnerInfo.luckyWheelCode,
                    gamificationDetailID: gamificationDetailID,
                    reRenderMission: reRenderMission,
                    redirectLink: redirectLink
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.outOfTurn,
                    handleClose: handleClosePopup,
                    title: t("outOfTurn"),
                    subTitle: t("outOfTurnWarning"),
                    buttonText: t("findMoreTurn"),
                    type: "turn",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.outOfReward,
                    handleClose: handleClosePopup,
                    title: t("unbelievable"),
                    buttonText: t("iUnderstand"),
                    type: "reward",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.notFound,
                    handleClose: handleReloadPage,
                    title: t("luckyWheelIsNotAvailable"),
                    buttonText: t("reloadPage"),
                    subTitle: t("pleaseReloadPage"),
                    type: "not_found",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupGotPrize, {
                    open: isOpenPopup.gotPrize,
                    handleClose: handleResetPopupPrize,
                    t: t,
                    reward: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.result,
                    isMobile: isMobile
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupQuestion, {
                    open: !(0,ValidateUtils/* isEmpty */.xb)(spinQuestion),
                    handleClose: handleClosePopupQuestion,
                    question: spinQuestion,
                    spin: spin,
                    router: router,
                    t: t
                })
            ]
        })
    });
};
var ButtonSpin = function(param) {
    var spin = param.spin, reset = param.reset, btnSpinRef = param.btnSpinRef, btnSpinHeadRef = param.btnSpinHeadRef, isSpinning = param.isSpinning, isStop = param.isStop, turns = param.turns, handleGetQuestion = param.handleGetQuestion;
    var t = (0,esm/* useTranslation */.$G)("lucky-wheel").t;
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: btnSpinRef,
        className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).btnSpin_container, !isStop && (LuckyWheel_styles_module_default()).btnSpin_containerDisabled),
        onClick: isSpinning ? reset : handleGetQuestion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "spin_2",
            style: {
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: btnSpinHeadRef,
                    className: (LuckyWheel_styles_module_default()).btnSpin_head,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            width: "100%",
                            color: "#fff",
                            fontFamily: "ggsm",
                            fontSize: turns === 0 ? "26px" : "32px",
                            textTransform: "uppercase",
                            userSelect: "none",
                            textShadow: "1px 3px #00000066"
                        },
                        children: turns === 0 ? t("moreTurn") : t("spin")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LuckyWheel_styles_module_default()).btnSpin_bottom,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            justifyContent: "center",
                            alignItems: "flex-end",
                            display: "flex",
                            width: "100%",
                            color: "#fff",
                            fontFamily: "ggsm",
                            position: "absolute",
                            bottom: "5px",
                            userSelect: "none"
                        },
                        children: !turns ? t("remainZeroTurn") : t("remainTurns").replace("{turns}", turns)
                    })
                })
            ]
        })
    }));
};
var style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: "20px"
};
var PopupWarning = function(param) {
    var open = param.open, handleClose = param.handleClose, title = param.title, subTitle = param.subTitle, buttonText = param.buttonText, type = param.type, isMobile = param.isMobile, handleFindMoreTurn = param.handleFindMoreTurn;
    var t = (0,esm/* useTranslation */.$G)("lucky-wheel").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: style,
            style: {
                outline: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        position: "absolute",
                        right: 8,
                        top: 8,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        color: "#c0c0c0",
                        cursor: "pointer"
                    },
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        style: {
                            stroke: "#c0c0c0",
                            strokeWidth: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                textAlign: "center",
                                gap: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* LUCKWHEEL_ICON_WARNING */.hT8,
                                    alt: "warning icon",
                                    width: 40,
                                    height: 40
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    style: {
                                        fontFamily: "ggsm",
                                        lineHeight: "26px"
                                    },
                                    children: title
                                })
                            ]
                        }),
                        type === "reward" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (LuckyWheel_styles_module_default()).popupWarning_subTitle,
                            variant: "body2",
                            children: t("youOwnAllReward")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (LuckyWheel_styles_module_default()).popupWarning_subTitle,
                            variant: "body2",
                            children: subTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        textAlign: "center",
                        marginTop: "12px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return type === "turn" ? handleFindMoreTurn() : handleClose();
                        },
                        className: (LuckyWheel_styles_module_default()).btnClosePopup,
                        children: buttonText !== null && buttonText !== void 0 ? buttonText : "Close"
                    })
                })
            ]
        })
    });
};
var PopupGotPrize = function(param) {
    var open = param.open, handleClose = param.handleClose, reward = param.reward, isMobile = param.isMobile, t = param.t;
    var RenderFireWork = function() {
        var numberFireWord = new Set([
            1,
            2,
            3
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: Array.from(numberFireWord, function(child) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LuckyWheel_styles_module_default()).fireWork_effect
                }, child);
            })
        });
    };
    var highLightSplitText = function(text, start, end) {
        if (!text) return text;
        var startIndex = text.indexOf(start);
        var endIndex = text.lastIndexOf(end);
        if (startIndex === -1 || endIndex === -1) {
            return text;
        }
        startIndex += start.length;
        if (startIndex > endIndex) {
            return text;
        }
        return text.substring(startIndex, endIndex);
    };
    var ref, ref1;
    var textHightLight = ((ref1 = (ref = highLightSplitText(reward === null || reward === void 0 ? void 0 : reward.message, '<span style="color: #005C29;font-family: "ggsm">', "</span>")) !== null && ref !== void 0 ? ref : reward === null || reward === void 0 ? void 0 : reward.message) !== null && ref1 !== void 0 ? ref1 : "").replace(luckyWheel/* LUCKY_NEXT_TIME */.W7, t("LUCKY_NEXT_TIME")).replace(luckyWheel/* YOU_SPUN_AND_HIT */.i8, t("YOU_SPUN_AND_HIT")).replace(luckyWheel/* WRONG_ANSWER */.IJ, t("WRONG_ANSWER"));
    var encodeMessage = (0,luckyWheel/* convertLuckyMessage */.kE)(textHightLight, t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: style,
            style: {
                outline: 0
            },
            children: [
                (reward === null || reward === void 0 ? void 0 : reward.reward) && reward.reward.length > 0 && RenderFireWork(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        (reward === null || reward === void 0 ? void 0 : reward.itemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            style: {
                                position: "relative",
                                width: "100%",
                                height: "100px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,ImageUtils/* getLinkProxyCDN */.SW)(reward.itemUrl),
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: isMobile ? (LuckyWheel_styles_module_default()).mobilePopupGotPrize_subTitle : (LuckyWheel_styles_module_default()).popupGotPrize_subTitle,
                            variant: "body2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    fontSize: "16px"
                                },
                                dangerouslySetInnerHTML: {
                                    __html: encodeMessage
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    style: {
                        textAlign: "center",
                        marginTop: "12px",
                        display: "flex",
                        gap: 12,
                        width: "100%",
                        justifyContent: "center"
                    },
                    children: [
                        (reward === null || reward === void 0 ? void 0 : reward.actionName) && (reward === null || reward === void 0 ? void 0 : reward.actionLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: reward.actionLink || "",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (LuckyWheel_styles_module_default()).btnPopupUsing,
                                children: reward.actionName || t("useNow")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleClose,
                            className: (LuckyWheel_styles_module_default()).btnPopupReset,
                            children: t("continue")
                        })
                    ]
                })
            ]
        })
    });
};
var CountDownLuckyUser = function(param) {
    var code = param.code, isMobile = param.isMobile, t = param.t;
    var ref = (0,react.useState)([]), luckyUserList = ref[0], setLuckyUserList = ref[1];
    var ref1 = (0,react.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var ref2 = (0,react.useState)(false), opacity = ref2[0], setOpacity = ref2[1];
    var ref3 = (0,react.useState)([]), currentLuckyUser = ref3[0], setCurrentLuckyUser = ref3[1]; // display 4 for web
    var ref4 = (0,react.useState)(0), currentIdx = ref4[0], setCurrentIdx = ref4[1];
    var luckyUserListRef = (0,react.useRef)(luckyUserList);
    var currentIdxRef = (0,react.useRef)(currentIdx);
    var offsetRef = (0,react.useRef)(offset);
    var filterLuckyUsers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var luckyUserTarget, listLength, i, index;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setOpacity(false);
                luckyUserTarget = [];
                listLength = luckyUserListRef.current.length;
                // Use modulo to wrap around when reaching the end of the list
                // eslint-disable-next-line no-plusplus
                for(i = currentIdxRef.current; i < currentIdxRef.current + 4; i++){
                    index = i % listLength;
                    luckyUserTarget.push(luckyUserListRef.current[index]);
                }
                setTimeout(function() {
                    if (listLength === 0) {
                        setOpacity(false);
                        setCurrentLuckyUser([]);
                    } else {
                        setOpacity(true);
                        setCurrentLuckyUser(luckyUserTarget);
                        // Use modulo to wrap around when reaching the end of the list
                        setCurrentIdx(function(prev) {
                            return (prev + 4) % listLength;
                        }); // 4 user per time
                    }
                }, 500);
                return [
                    2
                ];
            });
        });
        return function filterLuckyUsers() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchLuckyUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var selfLogOtherRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = 20, _tmp.offset = 0, _tmp.type = "OTHER", _tmp))
                        ];
                    case 1:
                        selfLogOtherRes = _state.sent();
                        if ((0,clients/* isValid */.JY)(selfLogOtherRes)) {
                            data = selfLogOtherRes.data;
                            if (data) {
                                setLuckyUserList(data.map(function(item) {
                                    return item.messageHidden;
                                }));
                                setOffset(function(prev) {
                                    return prev + 20;
                                });
                                filterLuckyUsers();
                            }
                        }
                        setOffset(function(prev) {
                            return prev + 20;
                        });
                        filterLuckyUsers();
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchLuckyUser() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchLuckyUser();
        var intervalFetchList = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var luckyUserResp, _tmp, listMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = 20, _tmp.offset = offsetRef.current, _tmp.type = "OTHER", _tmp))
                        ];
                    case 1:
                        luckyUserResp = _state.sent();
                        if ((0,clients/* isValid */.JY)(luckyUserResp)) {
                            listMessage = (0,clients/* getData */.Yu)(luckyUserResp).map(function(item) {
                                return item.messageHidden;
                            });
                            setLuckyUserList(function(prev) {
                                return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(listMessage));
                            });
                            setOffset(function(prev) {
                                return prev + 20;
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        }), 100 * 1000);
        var intervalFadeEffect = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                filterLuckyUsers();
                return [
                    2
                ];
            });
        }), 25 * 1000);
        return function() {
            clearInterval(intervalFetchList);
            clearInterval(intervalFadeEffect);
        };
    }, []);
    (0,react.useEffect)(function() {
        // Using ref for updating value in interval
        luckyUserListRef.current = luckyUserList;
        currentIdxRef.current = currentIdx;
        offsetRef.current = offset;
    }, [
        luckyUserList,
        currentIdx,
        offset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            style: {
                transition: "0.8s linear"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)(isMobile ? (LuckyWheel_styles_module_default()).mobileLuckyUser_container : (LuckyWheel_styles_module_default()).luckyUser_container, currentLuckyUser.length === 0 && (LuckyWheel_styles_module_default()).luckyUser_containerHidden),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(opacity ? (LuckyWheel_styles_module_default()).show : (LuckyWheel_styles_module_default()).hide, isMobile ? (LuckyWheel_styles_module_default()).mobileLuckyUser_messageContent : (LuckyWheel_styles_module_default()).luckyUser_messageContent),
                    children: currentLuckyUser.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: isMobile ? (LuckyWheel_styles_module_default()).mobileLuckyUser_messageContent : (LuckyWheel_styles_module_default()).luckyUser_messageContent,
                            children: (0,luckyWheel/* convertLuckyMessage */.kE)(item, t)
                        }, item);
                    })
                })
            })
        })
    });
};
var PopupQuestion = function(param) {
    var _open = param.open, open = _open === void 0 ? true : _open, handleClose = param.handleClose, t = param.t, _question = param.question, question = _question === void 0 ? {} : _question, spin = param.spin;
    var ref = (0,react.useState)(null), answerSeleted = ref[0], setAnswerSeleted = ref[1];
    var ref1 = question || {}, _title = ref1.title, title = _title === void 0 ? "" : _title, tmp = ref1.question, questionName = tmp === void 0 ? "" : tmp, _answers = ref1.answers, answers = _answers === void 0 ? [] : _answers, _code = ref1.code, code = _code === void 0 ? "" : _code, _correctAnswerId = ref1.correctAnswerId, correctAnswerId = _correctAnswerId === void 0 ? "" : _correctAnswerId, _wrongAnswerId = ref1.wrongAnswerId, wrongAnswerId = _wrongAnswerId === void 0 ? "" : _wrongAnswerId;
    var handleSelectAnswer = function(param) {
        var answer = param.answer;
        if (wrongAnswerId) {
            return;
        }
        setAnswerSeleted(answer);
    };
    var handleSubmitAnswer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!answerSeleted) {
                    NotifyUtils/* default.error */.Z.error(t("pleaseSelectAnswer"));
                    return [
                        2
                    ];
                }
                setAnswerSeleted(null);
                _tmp = {};
                spin((_tmp.questionCode = code || "", _tmp.answerId = (answerSeleted === null || answerSeleted === void 0 ? void 0 : answerSeleted.answerId) || "", _tmp));
                return [
                    2
                ];
            });
        });
        return function handleSubmitAnswer() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        disableBackdropClick: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            flexDirection: "column",
            className: (LuckyWheel_styles_module_default()).popupQuestionContainer,
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LuckyWheel_styles_module_default()).popupQuestionTitle,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    className: (LuckyWheel_styles_module_default()).popupQuestionName,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                t("question"),
                                ": "
                            ]
                        }),
                        " ",
                        questionName
                    ]
                }),
                answers.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    container: true,
                    justifyContent: "center",
                    alignItems: "center",
                    className: (LuckyWheel_styles_module_default()).answersContainer,
                    children: answers.map(function(answer, idx) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: (0,clsx_m/* default */.Z)((LuckyWheel_styles_module_default()).answer, (answerSeleted === null || answerSeleted === void 0 ? void 0 : answerSeleted.answerId) === answer.answerId && (LuckyWheel_styles_module_default()).answerSelected, correctAnswerId === answer.answerId && (LuckyWheel_styles_module_default()).answerSuccess, wrongAnswerId === answer.answerId && (LuckyWheel_styles_module_default()).answerWrong),
                            onClick: function() {
                                return handleSelectAnswer({
                                    answer: answer
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (LuckyWheel_styles_module_default()).answerText,
                                children: [
                                    " ",
                                    answer.content,
                                    " "
                                ]
                            })
                        }, answer.answerId);
                    })
                }),
                wrongAnswerId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            className: (LuckyWheel_styles_module_default()).wrongAnswerMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("wrongAnswerMessage")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return handleClose({
                                        isAnswerWrong: true
                                    });
                                },
                                className: (LuckyWheel_styles_module_default()).btnSubmitAnswer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("close_and_go_back")
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSubmitAnswer,
                        className: (LuckyWheel_styles_module_default()).btnSubmitAnswer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("submit")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_LuckyWheel = (LuckyWheel);


/***/ }),

/***/ 27733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewRegisterOrderInvoiceForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47533);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64839);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15149);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53316);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87536);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76480);
/* harmony import */ var utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25872);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47638);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_14__);
/* eslint-disable react/jsx-wrap-multilines */ 


















function NewRegisterOrderInvoiceForm(param) {
    var invoice = param.invoice, orderId = param.orderId, className = param.className, onClose = param.onClose, getValueInvoice = param.getValueInvoice, invoiceRes = param.invoiceRes, invoiceInfoChooserItem = param.invoiceInfoChooserItem, customerEmail = param.customerEmail, check = param.check;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("detailOrders"), translateDetailOrder = ref.t;
    var ref1 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("alert-action"), translateAlertAction = ref1.t;
    var schema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
        companyName: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translateDetailOrder("new_reg_order_invoice_form.validate_name")),
        // same rule as checkout (validateMst): 13 digits, leading 0 allowed
        taxCode: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().test("valid-tax-code", "", function(value, param) {
            var createError = param.createError;
            var taxCodeError = utils__WEBPACK_IMPORTED_MODULE_4__/* .ValidateUtils.validateMst */ .IN.validateMst(value);
            return taxCodeError ? createError({
                message: translateAlertAction(taxCodeError)
            }) : true;
        }),
        postCode: yup__WEBPACK_IMPORTED_MODULE_6__/* .number */ .Rx().required(translateDetailOrder("new_reg_order_invoice_form.validate_post_code")).test("validate-postcode", translateDetailOrder("new_reg_order_invoice_form.validate_post_code"), function(value) {
            var str = typeof value === "number" ? value.toString() : value;
            var isNumeric = /^\d+$/.test(str);
            var hasLeadingZero = str.length > 1 && str.startsWith("0");
            var expectedLength = 5;
            return str.length === expectedLength && isNumeric && !hasLeadingZero;
        }),
        companyAddress: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(translateDetailOrder("new_reg_order_invoice_form.validate_address"))
    });
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_8__/* .yupResolver */ .X)(schema)
    }), errors = ref2.formState.errors, control = ref2.control, handleSubmit = ref2.handleSubmit;
    var handleSendRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(value) {
            var data, _tmp, _tmp1, requestInvoiceResult, message, errorCode, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_tmp, value), (_tmp1.orderId = orderId, _tmp1.email = (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "", _tmp1.invoiceRequest = true, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            clients__WEBPACK_IMPORTED_MODULE_1__/* .CustomerClient.updateInvoiceInfoOrder */ .YP.updateInvoiceInfoOrder(data)
                        ];
                    case 2:
                        requestInvoiceResult = _state.sent();
                        if (!(0,clients__WEBPACK_IMPORTED_MODULE_1__/* .isValidWithoutData */ .Wk)(requestInvoiceResult)) {
                            message = "";
                            errorCode = requestInvoiceResult.errorCode;
                            switch(errorCode){
                                case "ERR_UPDATE_MANUALLY_EXPORTED_INVOICE":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_MANUALLY_EXPORTED_INVOICE");
                                    break;
                                case "ERR_UPDATE_MANUALLY_IMPORTED_INVOICE":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_MANUALLY_IMPORTED_INVOICE");
                                    break;
                                case "ERR_UPDATE_INVOICE_MULTIPLE_TIMES":
                                    message = translateDetailOrder("error_message.ERR_UPDATE_INVOICE_MULTIPLE_TIMES");
                                    break;
                                case "ERR_INVALID_CHANGE_REQUEST_TIME":
                                    message = translateDetailOrder("error_message.ERR_INVALID_CHANGE_REQUEST_TIME");
                                    break;
                                case "ERR_INVALID_CHANGE_INVOICE_INFO_TIME":
                                    message = translateDetailOrder("error_message.ERR_INVALID_CHANGE_INVOICE_INFO_TIME");
                                    break;
                                case "MAKE_REQUEST_VERIFY_UPDATE_INVOICE":
                                    message = translateDetailOrder("error_message.MAKE_REQUEST_VERIFY_UPDATE_INVOICE");
                                    break;
                                default:
                                    message = requestInvoiceResult.message || translateDetailOrder("error_message.DEFAULT");
                            }
                            throw new Error(message);
                        }
                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].success */ .Z.success(translateDetailOrder("success_message_send_invoice_update"));
                        // clear
                        onClose();
                        getValueInvoice(data);
                        utils__WEBPACK_IMPORTED_MODULE_4__/* .gtag.requestInvoice */ .SX.requestInvoice();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendRequest(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(className, (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().form_sign_up), (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().slideLeft)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            className: className,
            onSubmit: handleSubmit(function(data) {
                return handleSendRequest(data);
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "companyName",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.companyName : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.companyName) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.name")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    id: "companyName",
                                    error: !!errors.companyName,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input)
                                }, field)),
                                ((ref = errors.companyName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        (ref1 = errors.companyName) === null || ref1 === void 0 ? void 0 : ref1.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "taxCode",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.taxCode : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.taxCode) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.tax_number")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    error: !!errors.taxCode,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input),
                                    inputProps: {
                                        maxLength: 13
                                    }
                                }, field)),
                                ((ref = errors.taxCode) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        (ref1 = errors.taxCode) === null || ref1 === void 0 ? void 0 : ref1.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "postCode",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.postCode : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.postCode) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("post_code")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    error: !!errors.postCode,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input),
                                    type: "number"
                                }, field)),
                                errors.postCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        errors.postCode.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
                    name: "companyAddress",
                    defaultValue: check ? invoiceInfoChooserItem === null || invoiceInfoChooserItem === void 0 ? void 0 : invoiceInfoChooserItem.companyAddress : (invoiceRes === null || invoiceRes === void 0 ? void 0 : invoiceRes.companyAddress) || "",
                    control: control,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .InputV2 */ .b0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                children: translateDetailOrder("new_reg_order_invoice_form.address")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textRequired),
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    error: !!errors.companyAddress,
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().input)
                                }, field)),
                                errors.companyAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().textError),
                                    "data-test": "signup-err-username",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ErrorOutlined__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().iconError)
                                        }),
                                        " ",
                                        errors.companyAddress.message
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    textAlign: "center",
                    marginTop: "30px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_14___default().sendData),
                        type: "submit",
                        children: translateDetailOrder("new_reg_order_invoice_form.send")
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 32181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(282);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71569);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5233);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: none !important;\n  padding: 0px 5px !important;\n  font-size: 18px !important;\n  color: white !important;\n  &.btn--default {\n    background-color: #919aa3 !important;\n  }\n  &.btn--delivery {\n    background-color: yellow !important;\n    color: #919aa3 !important;\n  }\n  &.btn--delivered {\n    background-color: #2e9afe !important;\n  }\n  &.btn--complete {\n    background-color: #00c9a7 !important;\n  }\n\n  &.btn--cancel {\n    background-color: #c34a36 !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-40d0d31a-0"
})(_templateObject());
var OrderStatusButton = function(param) {
    var className = param.className, status = param.status, handleSetOrderStatus = param.handleSetOrderStatus;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("myOrder"), translateMyOrder = ref.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
        variant: "contained",
        className: "".concat(className, " ").concat(constants_Enums__WEBPACK_IMPORTED_MODULE_2__/* .ENUM_ORDER_STATUS_COLOR */ .Ql[status]),
        onClick: function() {
            return handleSetOrderStatus(status);
        },
        children: translateMyOrder("my-order.".concat(status))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderStatusButton);


/***/ }),

/***/ 19963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ProductCardContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components-v2/atoms/FluctuatedPriceIcon/index.js
var FluctuatedPriceIcon = __webpack_require__(77753);
// EXTERNAL MODULE: ./src/components-v3/organisms/PriceBreakdown/CartPriceAfterVoucherLabel.js
var CartPriceAfterVoucherLabel = __webpack_require__(50979);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/PriceBreakdownUtils.js
var PriceBreakdownUtils = __webpack_require__(85998);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartItemPriceMobile/styles.module.css
var styles_module = __webpack_require__(9904);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CartItemPriceMobile/index.js






var CartItemPriceMobile = function(param) {
    var product = param.product;
    var ref = product || {}, _displayPrice = ref.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _salePrice = ref.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _currentPrice = ref.// currentPrice là giá tại thời điểm thêm vào giỏ, không phải giá hiện tại
    currentPrice, currentPrice = _currentPrice === void 0 ? 0 : _currentPrice, fluctuatedType = ref.fluctuatedType, _isDeal = ref.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = ref.deal, deal = _deal === void 0 ? null : _deal;
    // BV-1586: dòng có voucher phân bổ vào SKU -> giá chính = priceAfterVoucher, gạch ngang price của
    // cart item (deal/campaign thì là giá deal), nhãn "ราคาหลังหักส่วนลด". Không có field thì như cũ.
    var cartPriceAfterVoucher = (0,PriceBreakdownUtils/* getCartItemPriceAfterVoucher */.M_)(product);
    if (cartPriceAfterVoucher) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).price_after_voucher,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).price_row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                            fluctuatedType: fluctuatedType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).current_price,
                            "data-test": "price-after-voucher-mobile",
                            children: (0,FormatNumber/* formatCurrency */.xG)(cartPriceAfterVoucher.priceAfterVoucher)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).old_price,
                            "data-test": "old-price-text-mobile",
                            children: (0,FormatNumber/* formatCurrency */.xG)(cartPriceAfterVoucher.price)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPriceAfterVoucherLabel/* default */.Z, {
                    className: (styles_module_default()).price_after_voucher_label
                })
            ]
        });
    }
    // Item biến động giá: gạch ngang currentPrice, giống bản desktop ở ProductCardBuy.
    // Chặn currentPrice = 0 để không render ra giá gạch ngang bằng 0 khi thiếu data.
    var isShowFluctuatedPrice = !!fluctuatedType && currentPrice > 0;
    // Item deal: giữ nguyên hành vi cũ, gạch ngang salePrice.
    var isShowDealPrice = isDeal && !!deal && salePrice > 0 && salePrice !== displayPrice;
    var oldPrice = isShowFluctuatedPrice && currentPrice || isShowDealPrice && salePrice || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).price_row,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FluctuatedPriceIcon/* default */.Z, {
                fluctuatedType: fluctuatedType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).current_price,
                children: (0,FormatNumber/* formatCurrency */.xG)(displayPrice)
            }),
            oldPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).old_price,
                "data-test": "old-price-text-mobile",
                children: (0,FormatNumber/* formatCurrency */.xG)(oldPrice)
            })
        ]
    });
};
/* harmony default export */ var mocules_CartItemPriceMobile = (CartItemPriceMobile);

// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/zustand-lib/useGetTagPromotion.js
var useGetTagPromotion = __webpack_require__(98300);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfo/index.js
var SellerInfo = __webpack_require__(69200);
// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 2 modules
var TagComponent = __webpack_require__(22535);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardContent/styles.module.css
var ProductCardContent_styles_module = __webpack_require__(37315);
var ProductCardContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCardContent_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductCardContent/index.js
/* eslint-disable no-nested-ternary */ 























var ProductCardContent = function(param) {
    var page = param.page, cate = param.cate, cart = param.cart, className = param.className, row = param.row, isMobile = param.isMobile, isMobileV2 = param.isMobileV2, product = param.product, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _mobileV2Horizontal = param.mobileV2Horizontal, mobileV2Horizontal = _mobileV2Horizontal === void 0 ? false : _mobileV2Horizontal;
    var _Math;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var productMaxQuantity = product.maxQuantity, _name = product.name, name = _name === void 0 ? "" : _name, // productTags, // display in the cart
    tags = product.tags, volume = product.volume, _categoryCodes = product.categoryCodes, categoryCodes = _categoryCodes === void 0 ? [] : _categoryCodes, slug = product.slug, _seller = product.seller, seller = _seller === void 0 ? "" : _seller, _isDeal = product.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _deal = product.deal, deal = _deal === void 0 ? null : _deal, cartItemType = product.type, _statusData = product.statusData, statusData = _statusData === void 0 ? {} : _statusData, isGift = product.isGift, _requireGPPMessage = product.requireGPPMessage, requireGPPMessage = _requireGPPMessage === void 0 ? null : _requireGPPMessage, isCampaign = product.isCampaign, messageLimitOrder = product.messageLimitOrder, maxQuantityPerDay = product.maxQuantityPerDay, _availableProducts = product.availableProducts, availableProducts = _availableProducts === void 0 ? 0 : _availableProducts, quantityPurchasedToday = product.quantityPurchasedToday, _errorCode = product.errorCode, errorCode = _errorCode === void 0 ? null : _errorCode, _errorMessage = product.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage, _sellerCode = product.sellerCode, sellerCode = _sellerCode === void 0 ? null : _sellerCode, _lotDates = product.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, expiredDate = product.expiredDate, _isNearOutOfStock = product.isNearOutOfStock, isNearOutOfStock = _isNearOutOfStock === void 0 ? false : _isNearOutOfStock, sku = product.sku, _skuId = product.skuId, skuId = _skuId === void 0 ? "" : _skuId, _productCode = product.productCode, productCode = _productCode === void 0 ? "" : _productCode, maxQuantity = product.maxQuantity, _weightFeeInfo = product.weightFeeInfo, weightFeeInfo = _weightFeeInfo === void 0 ? null : _weightFeeInfo;
    var isNearExpiration = lotDates === null || lotDates === void 0 ? void 0 : lotDates.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isNearExpired) === true;
    });
    var mapSeller = (0,context/* useSetting */.yu)().mapSeller;
    var getErrorCart = (0,context/* useCart */.jD)().getErrorCart;
    var sellerInfo = (mapSeller === null || mapSeller === void 0 ? void 0 : mapSeller.get((seller === null || seller === void 0 ? void 0 : seller.code) || sellerCode)) || null;
    var maxQtyDeal = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) - (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0;
    // const percentDiscount = deal ? Math.round(100 - (dealPrice / salePrice) * 100) : null;
    var listMaxQuantity = [
        productMaxQuantity
    ];
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var router = (0,next_router.useRouter)();
    // nếu có số theo ngày thì mới tính
    if (maxQuantityPerDay > 0) {
        listMaxQuantity.push(maxQuantityPerDay - quantityPurchasedToday);
    }
    // limit theo ngày ( tìm min ) , nếu < 0 thì set lại về 0
    var maxQuantityProduct = isCampaign && availableProducts || isDeal && maxQtyDeal || (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(listMaxQuantity));
    if (maxQuantityProduct < 0) {
        maxQuantityProduct = 0;
    }
    // tags promo gift
    var ref1 = (0,useGetTagPromotion/* default */.Z)(), dataByPromoListsDetail = ref1.dataByPromoListsDetail, filterTagGift = ref1.filterTagGift;
    // productCardContent use productCode and productCardContentNew use skuId
    var isTagGift = filterTagGift(sku, dataByPromoListsDetail, skuId || productCode);
    var TagGiftComp = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (ProductCardContent_styles_module_default()).giftPromo,
                    children: translateCommon("gift_tag")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: " - "
                })
            ]
        });
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        className: "".concat(className, "\n      ").concat(row ? (ProductCardContent_styles_module_default()).product_content : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_content, (ProductCardContent_styles_module_default()).product_content_column)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCardContent_styles_module_default()).product_title,
                        children: [
                            isTagGift && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagGiftComp, {}),
                            ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isVip) && (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isStore) || (tags === null || tags === void 0 ? void 0 : tags.includes("DUREX")) || (tags === null || tags === void 0 ? void 0 : tags.includes("SANOFI"))) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#B98F0F",
                                            fontSize: isMobileV2 ? "12px" : "16px",
                                            fontFamily: "googleSansMedium"
                                        },
                                        className: (0,clsx_m/* default */.Z)(isTagGift ? (ProductCardContent_styles_module_default()).prioritizedPromo : ""),
                                        children: translateCommon(Enums/* FLAGSHIP_LABEL */.Yo)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            display: isTagGift ? "none" : ""
                                        },
                                        children: "\xa0 -\xa0 "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                href: "/product/".concat(slug || "", "/loading"),
                                prefetch: false,
                                padding: "5px 0px 5px 0px",
                                className: isMobileV2 ? (ProductCardContent_styles_module_default()).linkMobile : (ProductCardContent_styles_module_default()).link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_name, !isMobile && (ProductCardContent_styles_module_default()).flex_wrap, isMobileV2 && (ProductCardContent_styles_module_default()).product_name_mv2, mobileV2Horizontal && (ProductCardContent_styles_module_default()).product_name_mv2_horizontal),
                                    gutterBottom: true,
                                    variant: "h5",
                                    component: "h2",
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        var sellerInfoGA, _tmp, _tmp1, _tmp2, _tmp3;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _tmp = {};
                                                    return [
                                                        4,
                                                        getSellerByCode((_tmp.code = sellerCode, _tmp.tags = tags, _tmp))
                                                    ];
                                                case 1:
                                                    sellerInfoGA = _state.sent();
                                                    _tmp1 = {};
                                                    utils/* gtag.viewItemInPage */.SX.viewItemInPage((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                        sellerInfo: sellerInfoGA
                                                    }), _tmp1.path = router.pathname, _tmp1));
                                                    _tmp2 = {};
                                                    _tmp3 = {};
                                                    MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW */.Hq.SKU_DETAIL_VIEW, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfoGA, _tmp3)), router.pathname);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    "data-test": "product-content-name",
                                    children: isDeal && deal ? deal === null || deal === void 0 ? void 0 : deal.name : name || ""
                                })
                            }),
                            cart && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CartItemPriceMobile, {
                                product: product
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(isMobileV2 ? (ProductCardContent_styles_module_default()).mobileProduct_type : (ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted),
                                children: cart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "textSecondary",
                                    component: "p",
                                    children: volume || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_tags, (ProductCardContent_styles_module_default()).product_tags_column),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                    product: {
                                        tags: tags,
                                        statusData: statusData,
                                        expiredDate: (isNearExpiration === null || isNearExpiration === void 0 ? void 0 : isNearExpiration.expiredDate) || expiredDate || ""
                                    },
                                    isMobile: isMobile,
                                    isMobileV2: isMobileV2,
                                    page: page,
                                    isGift: isGift,
                                    link: link,
                                    isLinkTagDeal: isLinkTagDeal
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: row ? (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted) : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_type, (ProductCardContent_styles_module_default()).muted, (ProductCardContent_styles_module_default()).align_center),
                        children: cart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "textSecondary",
                            component: "p",
                            children: [
                                volume || "",
                                " ",
                                weightFeeInfo ? "x ".concat((ref2 = weightFeeInfo === null || weightFeeInfo === void 0 ? void 0 : weightFeeInfo.weight) !== null && ref2 !== void 0 ? ref2 : 0, " kg") : ""
                            ]
                        })
                    })
                ]
            }),
            row === cate && categoryCodes && categoryCodes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category, (ProductCardContent_styles_module_default()).muted),
                variant: "body2",
                color: "textSecondary",
                component: "p"
            }),
            requireGPPMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                variant: "body2",
                color: "error",
                component: "p",
                children: translateCommon("productStatus.".concat(requireGPPMessage))
            }),
            cart && (cartItemType === "DEAL" || cartItemType === "COMBO") && maxQtyDeal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: [
                        translateCommon("only_x_product_1"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: utils/* FormatNumber.formatNumber */.AV.formatNumber(maxQtyDeal)
                        }),
                        " ",
                        translateCommon("only_x_product_2")
                    ]
                })
            }),
            cart && messageLimitOrder && !isGift ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (ProductCardContent_styles_module_default()).boxPerDay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    color: "textSecondary",
                    variant: "body2",
                    component: "p",
                    children: messageLimitOrder || ""
                })
            }) : null,
            cart && isNearOutOfStock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: translateCommon("only_quantity_product").replace("{quantity}", utils/* FormatNumber.formatNumber */.AV.formatNumber(statusData === null || statusData === void 0 ? void 0 : statusData.quantity))
                })
            }),
            cart && errorCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: row ? (ProductCardContent_styles_module_default()).product_title_wrap : (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_title_wrap, (ProductCardContent_styles_module_default()).product_title_column_wrap),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    variant: "body2",
                    color: "error",
                    component: "p",
                    children: errorCode === "MAX_QUANTITY" && !isNearOutOfStock ? maxQuantityProduct === 0 ? translateCommon("message_order_exceed_limit_day") : quantityPurchasedToday === 0 ? translateCommon("only_quantity_please_update").replace("{quantity}", maxQuantityProduct) : translateCommon("buy_x_per_y_only_z").replace("{quantityPurchasedToday}", quantityPurchasedToday).replace("{maxQuantityPerDay}", maxQuantityPerDay || maxQuantity || 0).replace("{maxQuantityProduct}", maxQuantityProduct) : getErrorCart({
                        errorCode: errorCode,
                        errorMessage: errorMessage
                    })
                })
            }),
            errorCode !== "MAX_QUANTITY" && maxQuantityPerDay > 0 && maxQuantityProduct < data/* MAX_PRODUCT_QTY_DISPLAY */.Im && quantityPurchasedToday > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (ProductCardContent_styles_module_default()).boxPerDay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)((ProductCardContent_styles_module_default()).product_category),
                    color: "textSecondary",
                    variant: "body2",
                    component: "p",
                    children: translateCommon("buy_x_per_y_in_day").replace("{quantity}", quantityPurchasedToday).replace("{limit}", maxQuantityPerDay || maxQuantityProduct)
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ProductCardContent = (ProductCardContent);


/***/ }),

/***/ 88491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductDetailTabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41423);
/* harmony import */ var _material_ui_lab_TabContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78207);
/* harmony import */ var _material_ui_lab_TabList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37313);
/* harmony import */ var _material_ui_lab_TabPanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64532);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72045);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65369);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable react/no-danger */ 








function ProductDetailTabs(param) {
    var data = param.data, product = param.product, handleChange = param.handleChange, value = param.value, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("ingredient"), translateIngredient = ref.t;
    var ref1 = product || {}, _description = ref1.description, description = _description === void 0 ? {} : _description;
    var tabData = (data === null || data === void 0 ? void 0 : data.filter(function(item) {
        return item.value === value;
    })[0]) || {};
    var des = description && description[tabData.code] !== "" ? description[tabData.code] : translateIngredient("updating");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().root),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_lab_TabContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            value: value,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_TabList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        TabIndicatorProps: {
                            className: isMobileV2 ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().mobileIndicator) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().indicator)
                        },
                        onChange: handleChange,
                        "aria-label": "product details tabs",
                        variant: "scrollable",
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tabs),
                        children: data.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                classes: {
                                    root: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tab)
                                },
                                label: translateIngredient("tab.".concat(item.code)),
                                value: item.value
                            }, (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)());
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_TabPanel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().tab_panel),
                    value: tabData === null || tabData === void 0 ? void 0 : tabData.value,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().content),
                        dangerouslySetInnerHTML: {
                            __html: des
                        }
                    })
                }, (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)())
            ]
        })
    });
};


/***/ }),

/***/ 66926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_SearchProduct; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/index.js
var styles = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./src/components/mocules/SearchDropdownFeedback/styles.module.css
var styles_module = __webpack_require__(55166);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchDropdownFeedback/index.js






var SearchDropdownFeedback = function(props) {
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var data = props.data, keyword = props.keyword, onClickItem = props.onClickItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).searchDropdown,
        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                    className: (styles_module_default()).searchResults,
                    href: (0,Paths/* getPathProductBySlug */.hq)(item.sku.slug),
                    onClick: function(e) {
                        e.preventDefault();
                        if (onClickItem) onClickItem(item);
                    },
                    children: item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.name
                }, (0,v4/* default */.Z)());
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (styles_module_default()).searchResults,
            children: [
                translateCommon("nav_bar.no_product"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: keyword
                }),
                "\xa0\xa0",
                translateCommon("nav_bar.in"),
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    className: (styles_module_default()).textPrimary,
                    children: translateCommon("all_products")
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_SearchDropdownFeedback = (SearchDropdownFeedback);

// EXTERNAL MODULE: ./src/components/mocules/SearchProduct/styles.module.css
var SearchProduct_styles_module = __webpack_require__(70179);
var SearchProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchProduct_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchProduct/index.js

















var SearchProduct = /*#__PURE__*/ (0,react.memo)(function SearchProduct(_param) {
    var classCustom = _param.classCustom, text = _param.text, handleKeyDown = _param.handleKeyDown, onClickItem = _param.onClickItem, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "classCustom",
        "text",
        "handleKeyDown",
        "onClickItem"
    ]);
    var ref = (0,react.useState)([]), searchProduct = ref[0], setSearchProduct = ref[1];
    var ref1 = (0,react.useState)(text || ""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), hidden = ref2[0], setHidden = ref2[1];
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var handleSearchbox = function(e) {
        var val = e.target.value;
        setKeyword(val);
        setHidden(true);
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                clients/* SearchClient.searchKeywords */.w9.searchKeywords(val)
                            ];
                        case 1:
                            res = _state.sent();
                            setSearchProduct(res);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        (0,debounce/* debounceFunc200 */.dW)(fetchData);
    };
    var clickProduct = function(product) {
        onClickItem(product);
        setKeyword(product.product.name || text);
    };
    var handleKeyDownDefault = function(event) {
        if (event.keyCode === 13) {
            handleKeyDown({
                keyword: keyword
            });
            // router.push(`/products?text=${keyword}`);
            event.preventDefault();
            event.target.blur();
        }
    };
    var handleFocus = function(e) {
        var ref;
        var val = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if (val && val.length > 0) {
            setHidden(true);
            setKeyword(e.target.value);
        }
    };
    var handleBlur = function() {
        (0,debounce/* debounceFunc200 */.dW)(function() {
            return setHidden(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((SearchProduct_styles_module_default()).search_wrap, classCustom),
        onBlur: handleBlur,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    value: keyword
                }, restProps), {
                    classes: {
                        root: (SearchProduct_styles_module_default()).root_input
                    },
                    style: {
                        width: "100%"
                    },
                    async: true,
                    onChange: handleSearchbox,
                    onKeyDown: handleKeyDownDefault,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                style: {
                                    color: styles/* WEB_STYLES.COLORS.GREEN */.i.COLORS.GREEN
                                }
                            })
                        }),
                        placeholder: translateCommon("input_product_name"),
                        autoComplete: "off",
                        type: "search",
                        classes: {
                            focused: (SearchProduct_styles_module_default()).focus
                        }
                    },
                    onFocus: handleFocus
                }))
            }),
            hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchDropdownFeedback, {
                keyword: keyword,
                data: searchProduct,
                onClickItem: clickProduct
            })
        ]
    });
});
/* harmony default export */ var mocules_SearchProduct = (SearchProduct);


/***/ }),

/***/ 69200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53316);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71569);
/* harmony import */ var constants_flagship_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30984);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43004);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33436);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5233);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34588);
/* harmony import */ var zustand_lib_storeMobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35810);
/* eslint-disable react/destructuring-assignment */ 
















/*
 Internal Seller: 
- Có Hóa Đơn => "MedX"
- Không hóa đơn => Không hiện thị
External Seller:
- Doanh nghiệp => hiện tên doanh nghiệp
- Cá nhân => "Đối tác của thuocsi"



*/ var SellerInfo = function(props) {
    var ref = useTranslation("common"), translateCommon = ref.t;
    // const partnerName = translateCommon('partner_of_buymed').replace('{BRAND_NAME}', BRAND_NAME);
    // const getSellerByCode = useSellers((state) => state.getSellerByCode);
    var isMobileV2 = useMobileV2(function(state) {
        return state.isMobileV2();
    });
    // gọi tới cache chung lấy seller map
    var _seller = props.seller, seller = _seller === void 0 ? {} : _seller, _tags = props.tags, tags = _tags === void 0 ? [] : _tags, _isProductCard = props.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isWishlist = props.isWishlist, isWishlist = _isWishlist === void 0 ? false : _isWishlist, _isChat = props.isChat, isChat = _isChat === void 0 ? false : _isChat, containerClass = props.containerClass, _isWebView = props.isWebView, isWebView = _isWebView === void 0 ? false : _isWebView;
    var code = seller.code;
    var ref1 = useSetting(), _mapStoreActives = ref1.mapStoreActives, mapStoreActives = _mapStoreActives === void 0 ? new Map() : _mapStoreActives, getNameSeller = ref1.getNameSeller;
    var ref2 = getNameSeller({
        seller: seller,
        tags: tags
    }), fullNameSeller = ref2.fullNameSeller, isDisplayStore = ref2.isDisplayStore, linkSeller = ref2.linkSeller, linkStore = ref2.linkStore, tcode = ref2.tcode;
    var displayName = tcode !== "seller" ? translateCommon("seller.".concat(tcode)).replace("{BRAND_NAME}", BRAND_NAME) : fullNameSeller;
    // const isActiveStore = mapStoreActives?.get(code) || null;
    // hiển thị với seller là doanh nghiệp ngoài
    // hard code store
    var flagshipStore = getHardcodeStoreByTagList(tags);
    if (flagshipStore) {
        return /*#__PURE__*/ _jsx(Grid, {
            className: clsx(styles.supplierTitle, containerClass, _define_property({}, styles.supplierTitle_mv2, isMobileV2), isChat && styles.m0),
            item: true,
            xs: 12,
            container: true,
            justifyContent: "flex-start",
            direction: "row",
            children: /*#__PURE__*/ _jsx(Tooltip, {
                disableTouchListener: isMobileV2,
                title: flagshipStore.name,
                children: /*#__PURE__*/ _jsxs(Grid, {
                    className: isWishlist ? styles.supplier_title_v2 : styles.name,
                    item: true,
                    xs: 12,
                    container: true,
                    justifyContent: "flex-start",
                    direction: "row",
                    children: [
                        !isProductCard ? /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                translateCommon("provided_by"),
                                ": "
                            ]
                        }) : /*#__PURE__*/ _jsx(ImageFallbackStatic, {
                            width: "14",
                            height: "16",
                            src: COLOR_STORE,
                            alt: flagshipStore.name,
                            className: styles.image_logo
                        }),
                        /*#__PURE__*/ _jsx(_Fragment, {
                            children: isWebView ? /*#__PURE__*/ _jsx(Box, {
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                children: flagshipStore.name
                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                target: "_blank",
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                                stopProp: true,
                                style: {
                                    fontSize: !isChat && 12
                                },
                                href: flagshipStore.url,
                                children: flagshipStore.name
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(Grid, {
        className: clsx(styles.supplierTitle, _define_property({}, styles.supplierTitle_mv2, isMobileV2), isChat && styles.m0),
        item: true,
        xs: 12,
        container: true,
        justifyContent: "flex-start",
        direction: "row",
        children: displayName && /*#__PURE__*/ _jsx(Tooltip, {
            disableTouchListener: isMobileV2,
            title: displayName,
            children: /*#__PURE__*/ _jsxs(Grid, {
                className: isWishlist ? styles.supplier_title_v2 : styles.name,
                item: true,
                xs: 12,
                container: true,
                justifyContent: "flex-start",
                direction: "row",
                children: [
                    !isProductCard ? /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            translateCommon("provided_by"),
                            ": "
                        ]
                    }) : /*#__PURE__*/ _jsx(ImageFallbackStatic, {
                        width: "14",
                        height: "16",
                        src: COLOR_STORE,
                        alt: displayName,
                        className: styles.image_logo
                    }),
                    (mapStoreActives === null || mapStoreActives === void 0 ? void 0 : mapStoreActives.get(code)) ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: isWebView ? /*#__PURE__*/ _jsxs(Box, {
                            stopProp: true,
                            className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                            children: [
                                displayName,
                                !isProductCard && /*#__PURE__*/ _jsx(Tooltip, {
                                    title: translateCommon("view_store"),
                                    children: /*#__PURE__*/ _jsx(OpenInNewIcon, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(LinkComp, {
                            stopProp: true,
                            target: "_blank",
                            className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                            href: linkStore,
                            children: [
                                displayName,
                                !isProductCard && /*#__PURE__*/ _jsx(Tooltip, {
                                    title: translateCommon("view_store"),
                                    children: /*#__PURE__*/ _jsx(OpenInNewIcon, {
                                        style: {
                                            color: "#676F77",
                                            paddingTop: "10px",
                                            marginBottom: "-3px"
                                        }
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ _jsx(_Fragment, {
                        children: isDisplayStore ? /*#__PURE__*/ _jsx(_Fragment, {
                            children: isWebView ? /*#__PURE__*/ _jsx(Box, {
                                stopProp: true,
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                                children: displayName
                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                stopProp: true,
                                target: "_blank",
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, isChat && styles.sellerProduct),
                                href: linkSeller,
                                children: displayName
                            })
                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: isWebView ? /*#__PURE__*/ _jsx(Box, {
                                stopProp: true,
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, tcode === "seller_partner" && styles.text_tf_none, isChat && styles.sellerProduct),
                                children: displayName
                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                stopProp: true,
                                target: "_blank",
                                className: clsx(styles.link, _define_property({}, styles.link_mv2, isMobileV2), isWishlist && styles.supplier_title_v2, tcode === "seller_partner" && styles.text_tf_none, isChat && styles.sellerProduct),
                                href: linkSeller,
                                children: displayName
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(SellerInfo))));


/***/ }),

/***/ 33535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eD": function() { return /* reexport */ mocules_AlertRequestLogin; },
  "zS": function() { return /* reexport */ mocules_AlphabetFilter; },
  "bi": function() { return /* reexport */ BlockTitle; },
  "Pk": function() { return /* reexport */ CartNote/* default */.Z; },
  "iL": function() { return /* reexport */ mocules_CheckoutSticky; },
  "Fj": function() { return /* reexport */ mocules_CountdownTimer/* default */.Z; },
  "WD": function() { return /* reexport */ mocules_CountdownTimerDetail; },
  "P0": function() { return /* reexport */ mocules_CustomModal["default"]; },
  "Nf": function() { return /* reexport */ mocules_CustomNoRowsOverlay; },
  "l9": function() { return /* reexport */ mocules_DeliveryCardList; },
  "kU": function() { return /* reexport */ mocules_DeliveryInfoForm; },
  "Gl": function() { return /* reexport */ mocules_DeliveryMethod; },
  "I5": function() { return /* reexport */ mocules_EditOrderButton; },
  "su": function() { return /* reexport */ mocules_FloatSearch; },
  "St": function() { return /* reexport */ mocules_ForgetPasswordFormV2; },
  "NR": function() { return /* reexport */ mocules_InvoiceCheckout; },
  "Jn": function() { return /* reexport */ LineItem; },
  "$i": function() { return /* reexport */ mocules_MultiImageBoxV2; },
  "Ah": function() { return /* reexport */ mocules_NewAuthModal; },
  "Db": function() { return /* reexport */ mocules_NewChangePasswordForm; },
  "o2": function() { return /* reexport */ mocules_NewInvoiceModal; },
  "Sz": function() { return /* reexport */ mocules_NewRegisterGuestForm; },
  "ow": function() { return /* reexport */ NewRegisterOrderInvoiceForm/* default */.Z; },
  "SY": function() { return /* reexport */ mocules_NewSignInForm; },
  "_B": function() { return /* reexport */ mocules_NewSignUpForm; },
  "XL": function() { return /* reexport */ mocules_PaymentMethod; },
  "YG": function() { return /* reexport */ mocules_PrintInvoiceButton; },
  "vS": function() { return /* reexport */ ProductCardContent/* default */.Z; },
  "jF": function() { return /* reexport */ ProductCardInput/* default */.Z; },
  "kV": function() { return /* reexport */ ProductDetailTabs/* default */.Z; },
  "pI": function() { return /* reexport */ ProductDetailTabsV2; },
  "Py": function() { return /* reexport */ ProductHorizontal; },
  "mF": function() { return /* reexport */ mocules_PromotionDetailModal; },
  "sb": function() { return /* reexport */ mocules_SearchOrder; },
  "Ji": function() { return /* reexport */ SearchResultText; },
  "Uo": function() { return /* reexport */ mocules_SellerInfoProductDetail; },
  "mh": function() { return /* reexport */ mocules_TicketDetailModal; },
  "dp": function() { return /* reexport */ mocules_TicketFormModal; }
});

// UNUSED EXPORTS: AuthModal, CouponCardV2, ForgetPasswordForm, HeaderUser, InfoTabs, LuckyWheel, NewPasswordForm, OrderDetailInfo, OrderDetailProduct, OrderDetailStep, OrderInfoTabs, RegisterGuestForm, SearchInput, SellerInfo, SignInForm, SignUpForm, TicketButton

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid_Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 15 modules
var atoms = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
;// CONCATENATED MODULE: ./src/components/mocules/AlertRequestLogin/index.js





var AlertRequestLogin = function(param) {
    var bgColor = param.bgColor;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var ref1 = (0,context/* useAuth */.aC)(), toggleLogin = ref1.toggleLogin, toggleSignUp = ref1.toggleSignUp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        container: true,
        style: {
            background: bgColor || "#F7F8FB",
            maxWidth: "400",
            borderRadius: "5px",
            padding: "5px",
            fontSize: "14px"
        },
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: translateCommon("restrict_some_scope")
            }),
            translateCommon("message_please"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                style: {
                    color: "#0E1983",
                    cursor: "pointer",
                    fontSize: "14px"
                },
                href: "#",
                onClick: toggleLogin,
                children: translateCommon("header.login")
            }),
            "/",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                style: {
                    color: "#0E1983",
                    cursor: "pointer",
                    fontSize: "14px"
                },
                href: "#",
                onClick: toggleSignUp,
                children: translateCommon("header.signup")
            }),
            translateCommon("message_view_detail")
        ]
    });
};
/* harmony default export */ var mocules_AlertRequestLogin = (AlertRequestLogin);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/mocules/AlphabetFilter/styles.module.css
var styles_module = __webpack_require__(5177);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AlphabetFilter/index.js





var getAlphabets = function() {
    var arr = [];
    for(var i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i += 1)arr.push(String.fromCharCode(i));
    arr.push("#");
    return arr;
};
var AlphabetFilter = function(param) {
    var word = param.word, handleChangeWord = param.handleChangeWord, isMobile = param.isMobile;
    var characters = getAlphabets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((styles_module_default()).alphabetFilterWrapper, isMobile && (styles_module_default()).mobileAlphabetFilterWrapper),
        children: characters.map(function(character) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Fab */.Lg, {
                className: (0,clsx_m/* default */.Z)((styles_module_default()).alphabetFilterItem, (0,src_define_property/* default */.Z)({}, (styles_module_default()).alphabetFilterItemActive, character === word)),
                handleClick: handleChangeWord,
                children: character
            }, "fab-alphabet-".concat(character));
        })
    });
};
/* harmony default export */ var mocules_AlphabetFilter = (AlphabetFilter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton_IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./src/components/mocules/AuthModal/AuthModal.js








var AuthModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var onClose = props.onClose, visible = props.visible, children = props.children, title = props.title, className = props.className, restProps = props.restProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "auth-modal-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "auth-modal-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "auth-modal-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            "aria-label": "close",
                            className: "auth-modal-close",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                icon: free_solid_svg_icons_index_es.faTimes
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "auth-modal-body",
                    children: children
                })
            ]
        })
    }));
});
/* harmony default export */ var AuthModal_AuthModal = (AuthModal);

;// CONCATENATED MODULE: ./src/components/mocules/AuthModal/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .auth-modal {\n    &-content {\n      position: relative;\n      width: ",
        "px;\n      background: ",
        ";\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      box-shadow: theme.shadows[5];\n      border-radius: 1.25em;\n      outline: 0;\n      overflow: hidden;\n    }\n    &-header {\n      display: flex;\n      align-items: flex-start;\n      text-align: center;\n      justify-content: space-between;\n      border-bottom: 1px solid rgba(195, 204, 220, 0.4);\n    }\n    &-title {\n      padding: 1rem 2rem;\n      font-size: larger;\n      font-weight: 500;\n      margin-bottom: 0;\n      line-height: 1.5;\n      text-transform: capitalize;\n    }\n    &-close {\n      background-color: transparent;\n      border: 0;\n      color: #000;\n      opacity: 0.5;\n    }\n    &-body {\n      position: relative;\n      flex: 1 1 auto;\n      padding: 1rem;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .auth-modal {\n      &-header {\n        line-height: 32px;\n      }\n    }\n    .auth-modal-content {\n      overflow: hidden;\n    }\n    .auth-modal-body {\n      padding: 0;\n      height: calc(100% - 60px);\n      overflow: auto;\n    }\n    .auth-modal-body .form-control {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 450px) {\n    .auth-modal-content {\n      padding: 15px;\n      width: 100%;\n    }\n    .auth-modal-title {\n      padding-left: 5px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var mocules_AuthModal_AuthModal = (0,styled_components_browser_esm/* default */.ZP)(AuthModal_AuthModal).withConfig({
    componentId: "sc-1fb2d6bd-0"
})(_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 500 : _width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.modal.background;
});
/* harmony default export */ var mocules_AuthModal = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(mocules_AuthModal_AuthModal))));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box_Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography_Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton_Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/components/mocules/BlockTitle/styles.module.css
var BlockTitle_styles_module = __webpack_require__(78762);
var BlockTitle_styles_module_default = /*#__PURE__*/__webpack_require__.n(BlockTitle_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/BlockTitle/index.js









function BlockTitle(_param) {
    var icon = _param.icon, title = _param.title, total = _param.total, totalTitle = _param.totalTitle, loading = _param.loading, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "icon",
        "title",
        "total",
        "totalTitle",
        "loading"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            className: (BlockTitle_styles_module_default()).titleWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: 200,
                height: 50
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    className: (BlockTitle_styles_module_default()).titleWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (BlockTitle_styles_module_default()).title,
                            style: {
                                marginLeft: icon ? "12px" : "0"
                            },
                            children: title
                        })
                    ]
                }),
                total && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (BlockTitle_styles_module_default()).total,
                    children: [
                        (0,FormatNumber/* formatNumber */.uf)(total),
                        " ",
                        totalTitle
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./src/components/mocules/CartNote/index.js
var CartNote = __webpack_require__(86635);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider_Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel_FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper_Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip_Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocalOfferOutlined.js
var LocalOfferOutlined = __webpack_require__(25237);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(28428);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert_Alert = __webpack_require__(8936);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/clients/BotClient.js
var BotClient = __webpack_require__(33172);
// EXTERNAL MODULE: ./src/components-v2/mocules/CartPriceFluctuationModal/index.js + 1 modules
var CartPriceFluctuationModal = __webpack_require__(37566);
// EXTERNAL MODULE: ./src/components-v2/mocules/ErrorProductsPayment/index.js
var ErrorProductsPayment = __webpack_require__(17863);
// EXTERNAL MODULE: ./src/components-v2/mocules/ModalListProduct/index.js
var ModalListProduct = __webpack_require__(40907);
// EXTERNAL MODULE: ./src/components/mocules/CustomModal/index.js
var mocules_CustomModal = __webpack_require__(39542);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/hooks/index.js + 9 modules
var hooks = __webpack_require__(91866);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/index.js + 15 modules
var services = __webpack_require__(788);
// EXTERNAL MODULE: ./src/services/AddressService.js
var AddressService = __webpack_require__(84378);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/utils/fbpixel.js
var fbpixel = __webpack_require__(70627);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var utils_ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/utils/maac.js
var maac = __webpack_require__(36753);
// EXTERNAL MODULE: ./src/utils/tiktok.js
var tiktok = __webpack_require__(38901);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/components/mocules/CheckoutSticky/styles.module.css
var CheckoutSticky_styles_module = __webpack_require__(20430);
var CheckoutSticky_styles_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutSticky_styles_module);
// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceInfoModal/validateForm.js



var validateForm_validateForm = function(_param) {
    var companyName = _param.companyName, taxCode = _param.taxCode, mst = _param.mst, translateAlertAction = _param.translateAlertAction, onSetError = _param.onSetError, invoice = (0,src_object_without_properties/* default */.Z)(_param, [
        "companyName",
        "taxCode",
        "mst",
        "translateAlertAction",
        "onSetError"
    ]);
    var ref = invoice || {}, province = ref.province, district = ref.district, ward = ref.ward, isUseCustom = ref.isUseCustom, postCode = ref.postCode, streetAddress = ref.streetAddress;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty((0,StringUtils/* trimText */.rd)(companyName))) {
        var companyNameElement = document.getElementById("companyName");
        if (companyNameElement) {
            companyNameElement.focus();
        }
        onSetError("companyName", true);
        throw Error(translateAlertAction("message_empty_company_name"));
    }
    if ((0,StringUtils/* trimText */.rd)(companyName).length <= 2) throw Error(translateAlertAction("message_valid_company_name"));
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(taxCode || mst)) {
        var taxCodeElement = document.getElementById("taxCode");
        if (taxCodeElement) {
            taxCodeElement.focus();
        }
        onSetError("taxCode", true);
        throw Error(translateAlertAction("message_empty_tax_code"));
    }
    // if (!ValidateUtils.isNumber(mst)) throw Error('Mã số thuế sai định dạng');
    var mstError = utils/* ValidateUtils.validateMst */.IN.validateMst(taxCode || mst) || "";
    if (mstError) throw Error(translateAlertAction("".concat(mstError)));
    if (isUseCustom) {
        if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(streetAddress)) {
            onSetError("streetAddress", true);
            throw Error(translateAlertAction("message_empty_street_address"));
        } else if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(province)) {
            onSetError("province", true);
            throw Error(translateAlertAction("message_empty_province_city"));
        } else if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(district)) {
            onSetError("district", true);
            throw Error(translateAlertAction("message_empty_district"));
        } else if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(ward)) {
            onSetError("ward", true);
            throw Error(translateAlertAction("message_empty_ward"));
        }
    }
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(postCode)) {
        var postCodeElement = document.getElementById("postCode");
        if (postCodeElement) {
            postCodeElement.focus();
        }
        onSetError("postCode", true);
        throw Error(translateAlertAction("message_empty_post_code"));
    }
// Truong Phan confirm
// if (mst.length !== 10 && mst.length !== 14) throw Error('Mã số thuế phải có 10 hoặc 14 số');
};
/* harmony default export */ var InvoiceInfoModal_validateForm = (validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/CheckoutSticky/validateForm.js




var CheckoutSticky_validateForm_validateForm = function(param, onSetError, translateAlertAction) {
    var customerName = param.customerName, customerPhone = param.customerPhone, customerEmail = param.customerEmail, customerShippingAddress = param.customerShippingAddress, customerProvinceCode = param.customerProvinceCode, customerDistrictCode = param.customerDistrictCode, customerWardCode = param.customerWardCode, totalWard = param.totalWard, invoice = param.invoice;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerName)) {
        onSetError("name", true);
        throw new Error(translateAlertAction("message_not_input_name"));
    }
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerPhone)) {
        onSetError("phone", true);
        throw new Error(translateAlertAction("message_not_input_phone"));
    }
    if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(customerPhone)) {
        onSetError("phone", true);
        throw new Error(translateAlertAction("message_correct_phone_number_format"));
    }
    if (!utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerEmail) && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(customerEmail)) {
        onSetError("email", true);
        throw new Error(translateAlertAction("message_invalid_email"));
    }
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(customerShippingAddress)) {
        onSetError("address", true);
        throw new Error(translateAlertAction("message_not_input_address"));
    }
    if (customerProvinceCode === "0") {
        throw new Error(translateAlertAction("message_you_have_not_selected_province_City"));
    }
    if (customerDistrictCode === "0") {
        throw new Error(translateAlertAction("message_you_have_not_selected_the_district"));
    }
    if (customerWardCode === "0" && totalWard > 0) {
        throw new Error(translateAlertAction("message_you_have_not_selected_province_City"));
    }
    var ref = invoice || {}, invoiceRequest = ref.invoiceRequest, email = ref.email;
    // validate invoice
    if (invoiceRequest === undefined) {
        onSetError("invoiceRequest", true);
        throw Error(translateAlertAction("message_empty_is_invoice_request"));
    }
    if (invoice && invoiceRequest) {
        InvoiceInfoModal_validateForm((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
            translateAlertAction: translateAlertAction,
            onSetError: onSetError
        }));
        if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(email)) {
            var emailElement = document.getElementById("email");
            if (emailElement) {
                emailElement.focus();
            }
            onSetError("email", true);
            throw new Error(translateAlertAction("require_email_when_request_tax_invoice"));
        }
        if (!utils/* ValidateUtils.validateAsciiEmail */.IN.validateAsciiEmail(email)) {
            onSetError("email", true);
            throw new Error(translateAlertAction("message_invalid_email"));
        }
        if (!utils/* ValidateUtils.isDigits */.IN.isDigits(invoice.postCode)) {
            var postCodeElement = document.getElementById("postCode");
            if (postCodeElement) {
                postCodeElement.focus();
            }
            onSetError("postCode", true);
            throw new Error(translateAlertAction("message_post_code_must_be_entered"));
        }
        if (!utils/* ValidateUtils.validatePostcode */.IN.validatePostcode(invoice.postCode, 5)) {
            onSetError("postCode", true);
            throw new Error(translateAlertAction("message_post_code_invalid"));
        }
    }
};
/* harmony default export */ var CheckoutSticky_validateForm = (CheckoutSticky_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/CheckoutSticky/index.js



















































var ERROR_REDIRECT_TO_CART = [
    ErrorCart/* ERROR_CODE_CART.VOUCHER_CODE_INVALID */.M5.VOUCHER_CODE_INVALID,
    ErrorCart/* ERROR_CODE_CART.VOUCHER_NOT_MATCH */.M5.VOUCHER_NOT_MATCH,
    ErrorCart/* ERROR_CODE_CART.COMBO_INVALID */.M5.COMBO_INVALID,
    ErrorCart/* ERROR_CODE_CART.TYPE_INVALID */.M5.TYPE_INVALID,
    ErrorCart/* ERROR_CODE_CART.QUANTITY_INVALID */.M5.QUANTITY_INVALID,
    ErrorCart/* ERROR_CODE_CART.SKU_MISSING */.M5.SKU_MISSING,
    ErrorCart/* ERROR_CODE_CART.SKU_NOT_FOUND */.M5.SKU_NOT_FOUND,
    ErrorCart/* ERROR_CODE_CART.TOTAL_PRICE_NOT_MATCH */.M5.TOTAL_PRICE_NOT_MATCH,
    ErrorCart/* ERROR_CODE_CART.LIMIT_SKU */.M5.LIMIT_SKU, 
];
// comp thanh toán , sticky
var CheckoutSticky = function(param) {
    var data = param.data, dataCustomer = param.dataCustomer, onSetError = param.onSetError, isMobile = param.isMobile, onLoading = param.onLoading, isSaveInfo = param.isSaveInfo, user = param.user, invoice = param.invoice, _invoices = param.invoices, invoices = _invoices === void 0 ? [] : _invoices, cart = param.cart, currentAddress = param.currentAddress, deliveryLimitData = param.deliveryLimitData, translateCheckout = param.translateCheckout;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,context/* useCart */.jD)(), _redeemCode = ref1.redeemCode, redeemCode = _redeemCode === void 0 ? [] : _redeemCode, _price = ref1.price, price = _price === void 0 ? 0 : _price, _totalPrice = ref1.totalPrice, totalPrice = _totalPrice === void 0 ? 0 : _totalPrice, _deliveryMethodFee = ref1.deliveryMethodFee, deliveryMethodFee = _deliveryMethodFee === void 0 ? 0 : _deliveryMethodFee, _paymentMethodFee = ref1.paymentMethodFee, paymentMethodFee = _paymentMethodFee === void 0 ? 0 : _paymentMethodFee, _totalItemSelected = ref1.totalItemSelected, totalItemSelected = _totalItemSelected === void 0 ? 0 : _totalItemSelected, // discount = 0,
    updateCart = ref1.updateCart, _redeemApplyResult = ref1.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? [] : _redeemApplyResult, cartNo = ref1.cartNo, _extraFee = ref1.extraFee, extraFee = _extraFee === void 0 ? null : _extraFee, tmp = ref1.extraFeeNote, extraFeeNoteTh = tmp === void 0 ? null : tmp, _extraFeeNoteEn = ref1.extraFeeNoteEn, extraFeeNoteEn = _extraFeeNoteEn === void 0 ? null : _extraFeeNoteEn, isOverWeightOrVolume = ref1.isOverWeightOrVolume, cartItems = ref1.cartItems, _errProducts = ref1.// subPrice = 0,
    errProducts, errProducts = _errProducts === void 0 ? [] : _errProducts, removeCartItem = ref1.removeCartItem, selectCartItem = ref1.selectCartItem, removeImportant = ref1.removeImportant, _totalBuymedServiceFee = ref1.totalBuymedServiceFee, totalBuymedServiceFee = _totalBuymedServiceFee === void 0 ? 0 : _totalBuymedServiceFee, _totalWeightCalculateFee = ref1.// weightFee = 0,
    // weightFeeNote: weightFeeNoteTh = null,
    // weightFeeNoteEn,
    totalWeightCalculateFee, totalWeightCalculateFee = _totalWeightCalculateFee === void 0 ? 0 : _totalWeightCalculateFee, getState = ref1.getState, _cartFluctuates = ref1.cartFluctuates, cartFluctuates = _cartFluctuates === void 0 ? [] : _cartFluctuates, isOpenPriceFluctuationModal = ref1.isOpenPriceFluctuationModal, togglePriceFluctuationModal = ref1.togglePriceFluctuationModal, confirmPriceFluctuation = ref1.confirmPriceFluctuation, applyPriceFluctuationFromVerify = ref1.applyPriceFluctuationFromVerify;
    var locale = js_cookie_default().get("NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
    // multi voucher
    var redeemRs = redeemApplyResult && (redeemApplyResult === null || redeemApplyResult === void 0 ? void 0 : redeemApplyResult.filter(function(item) {
        return !(item === null || item === void 0 ? void 0 : item.autoApply);
    }));
    var autoRedeemRs = redeemApplyResult && (redeemApplyResult === null || redeemApplyResult === void 0 ? void 0 : redeemApplyResult.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.autoApply) && (item === null || item === void 0 ? void 0 : item.canUse) === true;
    }));
    // const { code, discountValue: discountValueManual = 0, gifts: giftsManual = null } = redeemRs || {};
    // const { discountValue: discountValueAuto = 0, gifts: giftsAuto = null } = autoRedeemRs || {};
    // const totalGiftManual = (giftsManual?.length > 0 && giftsManual.reduce((a, b) => a + b.quantity, 0)) || 0;
    // const totalGiftAuto = (giftsAuto?.length > 0 && giftsAuto.reduce((a, b) => a + b.quantity, 0)) || 0;
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var getSellerByCodeSync = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCodeSync;
    });
    var handleRedCustomer = (0,context/* useAuth */.aC)().handleRedCustomer;
    var debt = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.getDebt();
    });
    var appConfig = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.appConfig;
    });
    var setAppConfig = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.setAppConfig;
    });
    var beta = (0,storeMobile/* default */.Z)().beta;
    var clearMapProduct = (0,context/* useProduct */.iB)().clearMapProduct;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), showConfirmModal = ref2[0], toggleConfirm = ref2[1];
    var ref3 = (0,react.useState)(false), showMaintenanceModal = ref3[0], setShowMaintenanceModal = ref3[1];
    var ref4 = (0,react.useState)(""), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var ref5 = (0,react.useState)({
        checked: true
    }), checkCondition = ref5[0], setCheckCondition = ref5[1];
    var extraFeeNote = (0,react.useMemo)(function() {
        return locale === "th" ? extraFeeNoteTh : extraFeeNoteEn;
    }, [
        extraFeeNoteEn,
        extraFeeNoteTh,
        locale
    ]);
    // const weightFeeNote = useMemo(() => (locale === 'th' ? weightFeeNoteTh : weightFeeNoteEn), [weightFeeNoteEn, weightFeeNoteTh, locale]);
    var customerDeliveryInfo = (0,react.useMemo)(function() {
        var ref;
        return (dataCustomer === null || dataCustomer === void 0 ? void 0 : (ref = dataCustomer.deliveryMethods) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.code === (dataCustomer === null || dataCustomer === void 0 ? void 0 : dataCustomer.deliveryMethod);
        })) || null;
    }, [
        dataCustomer
    ]);
    var customerPaymentInfo = (0,react.useMemo)(function() {
        var ref;
        return (dataCustomer === null || dataCustomer === void 0 ? void 0 : (ref = dataCustomer.paymentMethods) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.code === (dataCustomer === null || dataCustomer === void 0 ? void 0 : dataCustomer.paymentMethod);
        })) || null;
    }, [
        dataCustomer
    ]);
    var ref6 = currentAddress || {}, district = ref6.district, province = ref6.province, ward = ref6.ward;
    var deliveryLimitMessage = "";
    var deliveryLimitCheck = false;
    // const needToBuy = () => {
    //   if (extraFee) {
    //     if (data.customerProvinceCode === '79' || data.customerProvinceCode === '01') return 1500000 - price;
    //     return 2000000 - price;
    //   }
    //   return 0;
    // };
    // Feature flag: chặn checkout khi hệ thống đang bảo trì (app config key ALLOW_CHECKOUT)
    // status === 0 => không cho checkout => hiển thị popup bảo trì.
    // status khác 0 (hoặc không tìm thấy config) => cho phép checkout bình thường.
    var getCheckoutBlockedFromConfig = function() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        try {
            var item = config === null || config === void 0 ? void 0 : config.find(function(cfg) {
                var ref;
                return (cfg === null || cfg === void 0 ? void 0 : (ref = cfg.value) === null || ref === void 0 ? void 0 : ref.key) === "ALLOW_CHECKOUT";
            });
            var status = ((item === null || item === void 0 ? void 0 : item.value) || {}).status;
            return status === 0;
        } catch (e) {
            return false;
        }
    };
    var handleCheckCondition = function(event) {
        setCheckCondition((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkCondition), (0,src_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    var GreenCheckbox = /*#__PURE__*/ react.memo(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,src_object_spread/* default */.Z)({
            classes: {
                root: (CheckoutSticky_styles_module_default()).checkbox
            },
            color: "default"
        }, props));
    });
    var GreenCheckBoxElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckbox, {
        checked: checkCondition.checked,
        onChange: handleCheckCondition,
        name: "checked",
        "data-test": "checkbox-checkout-terms-of-use"
    });
    var LabelConfirm = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (CheckoutSticky_styles_module_default()).check_agree_txt,
        children: [
            translateCheckout("i_agree_with"),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                href: Paths/* TERMS_URL */.qy,
                color: "#005C29",
                target: true,
                children: [
                    "\xa0",
                    translateCheckout("condition_of_use")
                ]
            })
        ]
    });
    var validateSubmit = function(formData) {
        try {
            CheckoutSticky_validateForm(formData, onSetError, translateAlertAction);
            return true;
        } catch (error) {
            utils/* NotifyUtils.error */.QP.error(error.message);
            return false;
        }
    };
    var handleVerify = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, formValue, _tmp, _tmp1, districts, isExistDistrict, dataValidate, _tmp2, _tmp3, validateRs, _tmp4, _tmp5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onLoading(true);
                        _tmp = {};
                        _tmp1 = {};
                        formValue = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, data, dataCustomer), (_tmp1.invoice = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
                            email: data.customerEmail || dataCustomer.customerEmail
                        }), _tmp1.cartNo = cartNo, _tmp1));
                        Object.keys(formValue).forEach(function(key) {
                            if (typeof formValue[key] === "string") formValue[key] = formValue[key].trim();
                        });
                        if (!validateSubmit(formValue)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!checkCondition.checked) {
                            onLoading(false);
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_agree_condition_of_use"));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(formValue.customerProvinceCode)
                        ];
                    case 1:
                        districts = _state.sent();
                        if (!districts) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        isExistDistrict = districts.find(function(item) {
                            return item.value === formValue.customerDistrictCode;
                        });
                        if (!isExistDistrict) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        _tmp2 = {};
                        _tmp3 = {};
                        dataValidate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp2, formValue), (_tmp3.totalPrice = totalPrice, _tmp3.voucherCode = redeemCode[0], _tmp3.skus = ((ref = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
                            return item.isSelected || item.type === "GIFT";
                        })) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var sku = param.sku, quantity = param.quantity, type = param.type;
                            return {
                                sku: sku,
                                type: type,
                                quantity: quantity
                            };
                        })) || [], _tmp3));
                        _tmp4 = {};
                        return [
                            4,
                            services/* CartService.validateCart */.Ni.validateCart((_tmp4.body = dataValidate, _tmp4))
                        ];
                    case 2:
                        validateRs = _state.sent();
                        utils/* NotifyUtils.success */.QP.success(JSON.stringify(validateRs));
                        _tmp5 = {};
                        BotClient/* default.sendMesageBotOrderTh */.Z.sendMesageBotOrderTh((_tmp5.message = "Test validate - ".concat((user === null || user === void 0 ? void 0 : user.phone) || "", " : ").concat(JSON.stringify(validateRs || {})), _tmp5));
                        onLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleVerify() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, formValue, _tmp, _tmp1, districts, isExistDistrict, ref2, tmp, latestTotalPrice, tmp1, latestCartItems, _tmp2, dataValidate, _tmp3, _tmp4, validateRs, _tmp5, ref3, _fluctuatedItems, fluctuatedItems, _tmp6, getErrorMessage, _tmp7, _tmp8, response, dataOrder, ref4, ref5, ref6, _tmp9, GATrackCart, _tmp10, _tmp11, maacVoucher, _tmp12, address, _tmp13, addressResp, _tmp14, resp, _tmp15, addressResp1, _tmp16, ref7, _orderId, orderId, _tmp17, paymentLinkRes, _tmp18, paymentUrl, _tmp19, _tmp20, _tmp21;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onLoading(true);
                        clearMapProduct();
                        _tmp = {};
                        _tmp1 = {};
                        formValue = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, data, dataCustomer), (_tmp1.invoice = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), {
                            email: invoice.email
                        }), _tmp1.cartNo = cartNo, _tmp1));
                        Object.keys(formValue).forEach(function(key) {
                            if (typeof formValue[key] === "string") formValue[key] = formValue[key].trim();
                        });
                        if (!validateSubmit(formValue)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!checkCondition.checked) {
                            onLoading(false);
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_agree_condition_of_use"));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(formValue.customerProvinceCode)
                        ];
                    case 1:
                        districts = _state.sent();
                        if (!districts) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        isExistDistrict = districts.find(function(item) {
                            return item.value === formValue.customerDistrictCode;
                        });
                        if (!isExistDistrict) {
                            utils/* NotifyUtils.error */.QP.error(translateCheckout("message_not_found_ward_district"));
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        _tmp2 = {};
                        ref2 = getState() || _tmp2, tmp = ref2.totalPrice, latestTotalPrice = tmp === void 0 ? totalPrice : tmp, tmp1 = ref2.cartItems, latestCartItems = tmp1 === void 0 ? cartItems : tmp1;
                        _tmp3 = {};
                        _tmp4 = {};
                        dataValidate = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp3, formValue), (_tmp4.totalPrice = latestTotalPrice, _tmp4.voucherCode = redeemCode[0], _tmp4.skus = ((ref = latestCartItems === null || latestCartItems === void 0 ? void 0 : latestCartItems.filter(function(item) {
                            return item.isSelected || item.type === "GIFT";
                        })) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var sku = param.sku, quantity = param.quantity, type = param.type;
                            return {
                                sku: sku,
                                type: type,
                                quantity: quantity
                            };
                        })) || [], _tmp4));
                        _tmp5 = {};
                        return [
                            4,
                            services/* CartService.validateCart */.Ni.validateCart((_tmp5.body = dataValidate, _tmp5))
                        ];
                    case 2:
                        validateRs = _state.sent();
                        _tmp6 = {};
                        ref3 = (0,clients/* getFirst */.Xi)(validateRs) || _tmp6, _fluctuatedItems = ref3.fluctuatedItems, fluctuatedItems = _fluctuatedItems === void 0 ? [] : _fluctuatedItems;
                        if (applyPriceFluctuationFromVerify(fluctuatedItems)) {
                            onLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!!(0,clients/* isValidWithoutData */.Wk)(validateRs)) return [
                            3,
                            5
                        ];
                        // nếu voucher, giỏ hàng lỗi sẽ tự động redirect về giỏ Hàng
                        // APO-1559
                        if (ERROR_REDIRECT_TO_CART.includes(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) {
                            router.replace(Paths/* CART_URL */.fh);
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_cart.".concat(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) || (validateRs === null || validateRs === void 0 ? void 0 : validateRs.message) || translateAlertAction("message_error_checkout"));
                            return [
                                2
                            ];
                        }
                        if ((validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                            return [
                                2
                            ];
                        }
                        if (!ErrorCart/* ERROR_PRODUCTS.includes */.L$.includes(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) return [
                            3,
                            4
                        ];
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_products_cart"));
                        onLoading(false);
                        return [
                            4,
                            updateCart()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        if ((validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode) === "ORDER_MIN_1MILION") {
                            getErrorMessage = function(errorData) {
                                var defaultMessage = translateAlertAction("message_error_cart.ORDER_MIN_1MILION");
                                try {
                                    var ref = errorData.data[0], message = ref.message, messageEN = ref.messageEN;
                                    if (locale === "th") {
                                        return message || defaultMessage;
                                    }
                                    return messageEN || defaultMessage;
                                } catch (e) {
                                    return defaultMessage;
                                }
                            };
                            utils/* NotifyUtils.error */.QP.error(getErrorMessage(validateRs));
                        } else {
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_cart.".concat(validateRs === null || validateRs === void 0 ? void 0 : validateRs.errorCode)) || (validateRs === null || validateRs === void 0 ? void 0 : validateRs.message) || translateAlertAction("message_error_checkout"));
                        }
                        onLoading(false);
                        _tmp7 = {};
                        BotClient/* default.sendMesageBotOrderTh */.Z.sendMesageBotOrderTh((_tmp7.message = "TS validate error - ".concat((user === null || user === void 0 ? void 0 : user.phone) || "", ": ").concat(JSON.stringify(validateRs || {})), _tmp7));
                        return [
                            2
                        ];
                    case 5:
                        if (!(invoices && invoices.length < 10 && invoice && invoice.invoiceRequest && invoices.findIndex(function(item) {
                            return item.code === invoice.code;
                        }) === -1 && ((ref1 = invoices.filter(function(param) {
                            var taxCode = param.taxCode, companyName = param.companyName, companyAddress = param.companyAddress;
                            return taxCode === invoice.taxCode && companyName === invoice.companyName && companyAddress === invoice.companyAddress;
                        })) === null || ref1 === void 0 ? void 0 : ref1.length) === 0)) return [
                            3,
                            7
                        ];
                        _tmp8 = {};
                        return [
                            4,
                            clients/* CustomerClient.createInvoiceInfo */.YP.createInvoiceInfo((_tmp8.body = invoice, _tmp8))
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            4,
                            services/* CartService.checkoutCart */.Ni.checkoutCart(formValue)
                        ];
                    case 8:
                        response = _state.sent();
                        if (!(0,clients/* isValid */.JY)(response)) return [
                            3,
                            21
                        ];
                        dataOrder = (0,clients/* getFirst */.Xi)(response);
                        if (!dataOrder) return [
                            3,
                            10
                        ];
                        _tmp9 = {};
                        fbpixel/* default.purchase */.ZP.purchase((_tmp9.value = dataOrder.totalPrice, _tmp9.num_items = dataOrder.totalQuantity, _tmp9));
                        tiktok/* default.purchase */.ZP.purchase(dataOrder);
                        tiktok/* default.completePayment */.ZP.completePayment(dataOrder);
                        _tmp10 = {};
                        _tmp11 = {};
                        GATrackCart = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp10, cart), (_tmp11.cartItems = (cart === null || cart === void 0 ? void 0 : (ref4 = cart.cartItems) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
                            return item.isSelected;
                        })) || [], _tmp11));
                        // load data seller nếu chưa có bằng hàm này
                        return [
                            4,
                            Promise.all(GATrackCart === null || GATrackCart === void 0 ? void 0 : (ref5 = GATrackCart.cartItems) === null || ref5 === void 0 ? void 0 : ref5.map(function(prd) {
                                return getSellerByCode({
                                    code: prd === null || prd === void 0 ? void 0 : prd.sellerCode
                                });
                            }))
                        ];
                    case 9:
                        _state.sent();
                        // lấy data seller từ store
                        // nếu từ cart / sp là combo thì retailPrice là 1000 -> cần lấy lại giá theo cartItem
                        GATrackCart.cartItems = (GATrackCart === null || GATrackCart === void 0 ? void 0 : (ref6 = GATrackCart.cartItems) === null || ref6 === void 0 ? void 0 : ref6.map(function(prd) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prd), {
                                sellerInfo: getSellerByCodeSync({
                                    code: prd === null || prd === void 0 ? void 0 : prd.sellerCode
                                }),
                                displayPrice: prd.price
                            });
                        })) || [];
                        utils/* gtag.purchase */.SX.purchase(GATrackCart);
                        maacVoucher = ((cart === null || cart === void 0 ? void 0 : cart.redeemApplyResult) || [])[0];
                        _tmp12 = {};
                        maac/* default.trackPurchase */.Z.trackPurchase((_tmp12.orderId = dataOrder === null || dataOrder === void 0 ? void 0 : dataOrder.orderId, _tmp12.revenue = dataOrder === null || dataOrder === void 0 ? void 0 : dataOrder.totalPrice, _tmp12.shipping = cart === null || cart === void 0 ? void 0 : cart.deliveryMethodFee, _tmp12.coupon = (maacVoucher === null || maacVoucher === void 0 ? void 0 : maacVoucher.canUse) ? maacVoucher === null || maacVoucher === void 0 ? void 0 : maacVoucher.code : "", _tmp12.// cartItems ở đây đã resolve sellerInfo + fix displayPrice cho sản phẩm combo
                        products = GATrackCart.cartItems, _tmp12));
                        _state.label = 10;
                    case 10:
                        if (!isSaveInfo) return [
                            3,
                            17
                        ];
                        _tmp13 = {};
                        address = (_tmp13.code = formValue.customerAddressCode, _tmp13.name = formValue.customerName, _tmp13.phone = formValue.customerPhone, _tmp13.email = formValue.customerEmail, _tmp13.address = formValue.customerShippingAddress, _tmp13.provinceCode = formValue.customerProvinceCode, _tmp13.districtCode = formValue.customerDistrictCode, _tmp13.wardCode = formValue.customerWardCode, _tmp13.regionCode = formValue.customerRegionCode, _tmp13);
                        if (!!formValue.customerAddressCode) return [
                            3,
                            12
                        ];
                        _tmp14 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp14.body = address, _tmp14))
                        ];
                    case 11:
                        addressResp = _state.sent();
                        if (!(0,clients/* isValid */.JY)(addressResp)) utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        return [
                            3,
                            17
                        ];
                    case 12:
                        _tmp15 = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddress */.YP.updateAddress((_tmp15.body = address, _tmp15))
                        ];
                    case 13:
                        resp = _state.sent();
                        if (!(0,clients/* isValid */.JY)(resp)) return [
                            3,
                            14
                        ];
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_save_address"));
                        return [
                            3,
                            17
                        ];
                    case 14:
                        if (!(resp && resp.status === Enums/* HTTP_STATUS.NotFound */.MG.NotFound)) return [
                            3,
                            16
                        ];
                        _tmp16 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp16.body = address, _tmp16))
                        ];
                    case 15:
                        addressResp1 = _state.sent();
                        if ((0,clients/* isValid */.JY)(addressResp1)) utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_save_address"));
                        else utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        return [
                            3,
                            17
                        ];
                    case 16:
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_failed_save_address"));
                        _state.label = 17;
                    case 17:
                        setTimeout(function() {
                            updateCart();
                        }, 1000);
                        // clear products
                        clearMapProduct();
                        _tmp17 = {};
                        ref7 = response.data[0] || _tmp17, _orderId = ref7.orderId, orderId = _orderId === void 0 ? "" : _orderId;
                        if (!Enums/* PAYMENT_METHOD_NEED_WAITING.includes */.IN.includes(formValue.paymentMethod)) return [
                            3,
                            18
                        ];
                        // redirect checkout to waiting payment page
                        router.push("".concat(Paths/* WAITING_PAYMENT */.a1, "/").concat(orderId));
                        return [
                            3,
                            20
                        ];
                    case 18:
                        _tmp18 = {};
                        return [
                            4,
                            services/* CartService.getPaymentLink */.Ni.getPaymentLink((_tmp18.orderId = orderId, _tmp18))
                        ];
                    case 19:
                        paymentLinkRes = _state.sent();
                        _tmp19 = {};
                        _tmp20 = {};
                        if ((0,clients/* isValid */.JY)(paymentLinkRes)) {
                            paymentUrl = (0,clients/* getFirst */.Xi)(paymentLinkRes).paymentUrl;
                            if (paymentUrl) {
                                router.push((_tmp19.pathname = router.pathname, _tmp19.query = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, router.query), {
                                    redirectToOrderDetail: true,
                                    orderId: orderId
                                }), _tmp19), undefined, (_tmp20.shallow = true, _tmp20));
                                window.location.href = paymentUrl;
                            }
                        } else {
                            router.push("".concat(Paths/* THANKYOU_URL */.NY, "/").concat(orderId));
                        }
                        _state.label = 20;
                    case 20:
                        onLoading(false);
                        return [
                            3,
                            22
                        ];
                    case 21:
                        if ((response === null || response === void 0 ? void 0 : response.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                            return [
                                2
                            ];
                        }
                        onLoading(false);
                        _tmp21 = {};
                        BotClient/* default.sendMesageBotOrderTh */.Z.sendMesageBotOrderTh((_tmp21.message = "TS checkout error - ".concat(user === null || user === void 0 ? void 0 : user.phone, ": ").concat(JSON.stringify(response || {})), _tmp21));
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error_cart.".concat(response === null || response === void 0 ? void 0 : response.errorCode)) || (response === null || response === void 0 ? void 0 : response.message) || translateAlertAction("message_error_checkout"));
                        setErrorMessage("".concat(translateAlertAction("message__failed_payment"), ": ").concat(translateAlertAction("message_error_cart.".concat(response === null || response === void 0 ? void 0 : response.errorCode)) || response.message || translateAlertAction("message_system_error")));
                        updateCart();
                        _state.label = 22;
                    case 22:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    // Lấy trạng thái cờ ALLOW_CHECKOUT mới nhất ngay tại thời điểm bấm checkout.
    // Tránh dùng appConfig đã cache từ SSR (có thể bị stale nếu admin vừa đổi status).
    // Nếu request lỗi => fallback về giá trị đã cache trong store để không chặn nhầm toàn bộ khách.
    var fetchCheckoutBlockedLatest = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var res, _tmp, freshConfig, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            clients/* ConfigManagerClient.getAppValueByCode */.WO.getAppValueByCode((_tmp.appCode = sysconfig/* APP_CONFIG_CODE */.pC, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,clients/* isValid */.JY)(res)) {
                            freshConfig = (0,clients/* getData */.Yu)(res) || [];
                            setAppConfig(freshConfig);
                            return [
                                2,
                                getCheckoutBlockedFromConfig(freshConfig)
                            ];
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            getCheckoutBlockedFromConfig(appConfig)
                        ];
                }
            });
        });
        return function fetchCheckoutBlockedLatest() {
            return _ref.apply(this, arguments);
        };
    }();
    var proceedCheckout = function() {
        if (extraFee) {
            toggleConfirm();
        } else {
            handleSubmit();
        }
    };
    // Bọc hành động checkout: nếu cờ chặn đang bật thì mở popup bảo trì thay vì tiếp tục thanh toán.
    // Gate biến động giá KHÔNG nằm ở đây mà nằm trong handleSubmit, ngay sau validateCart:
    // vừa dùng lại được request verify sẵn có (không phải load lại giỏ), vừa phủ luôn nhánh
    // đi qua modal xác nhận phụ thu (proceedCheckout -> toggleConfirm -> handleSubmit).
    var handleCheckoutClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var blocked;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onLoading(true);
                        return [
                            4,
                            fetchCheckoutBlockedLatest()
                        ];
                    case 1:
                        blocked = _state.sent();
                        onLoading(false);
                        if (blocked) {
                            setShowMaintenanceModal(true);
                            return [
                                2
                            ];
                        }
                        proceedCheckout();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckoutClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Khách chấp nhận giá mới: chốt giá rồi đặt hàng luôn, không bắt bấm lại nút thanh toán.
    var handleConfirmPriceFluctuation = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            confirmPriceFluctuation()
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) return [
                            2
                        ];
                        togglePriceFluctuationModal(false);
                        proceedCheckout();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmPriceFluctuation() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBackToCart = function() {
        togglePriceFluctuationModal(false);
        router.push(Paths/* CART_URL */.fh);
    };
    if (deliveryLimitData) {
        deliveryLimitData === null || deliveryLimitData === void 0 ? void 0 : deliveryLimitData.forEach(function(item) {
            var ref, ref1, ref2;
            if ((item === null || item === void 0 ? void 0 : (ref = item.wardCodes) === null || ref === void 0 ? void 0 : ref.indexOf(ward)) >= 0 || (item === null || item === void 0 ? void 0 : (ref1 = item.districtCodes) === null || ref1 === void 0 ? void 0 : ref1.indexOf(district)) >= 0 || (item === null || item === void 0 ? void 0 : (ref2 = item.provinceCodes) === null || ref2 === void 0 ? void 0 : ref2.indexOf(province)) >= 0) {
                deliveryLimitMessage = item === null || item === void 0 ? void 0 : item.message;
                deliveryLimitCheck = true;
            }
        });
    }
    var DisplayPrice = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CheckoutSticky_styles_module_default()).total,
            children: utils/* FormatNumber.formatCurrency */.AV.formatCurrency(Math.max(Math.max(totalPrice, 0), 0))
        });
    };
    var DisplayPriceMobileNew = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CheckoutSticky_styles_module_default()).totalM,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: translateCheckout("total_money")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: utils/* FormatNumber.formatCurrency */.AV.formatCurrency(Math.max(totalPrice, 0))
                })
            ]
        });
    };
    // del err items in cart
    var ref7 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openErrItems = ref7[0], toggleErrItems = ref7[1];
    // card lỗi nằm dưới cùng cột thanh toán, khách không cuộn xuống sẽ không thấy
    // -> tự cuộn tới khi có sản phẩm lỗi
    var isShowErrCard = (errProducts === null || errProducts === void 0 ? void 0 : errProducts.length) > 0 && !isMobile;
    var errCardRef = (0,hooks/* useScrollIntoViewOnShow */.aT)(isShowErrCard);
    var handleDeleteErrProducts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            errProducts === null || errProducts === void 0 ? void 0 : errProducts.forEach(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(item) {
                                    var _tmp, _tmp1;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (Enums/* ARR_REMOVE_PRODUCT.indexOf */.mJ.indexOf(item === null || item === void 0 ? void 0 : item.errorCode) >= 0) {
                                                    removeCartItem(item);
                                                }
                                                if (!((item === null || item === void 0 ? void 0 : item.errorCode) === "MAX_QUANTITY")) return [
                                                    3,
                                                    3
                                                ];
                                                if (!(item === null || item === void 0 ? void 0 : item.isImportant)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    removeImportant(item)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                _tmp = {};
                                                _tmp1 = {};
                                                selectCartItem((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, item), (_tmp1.isSelected = !item.isSelected, _tmp1)));
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_remove_all_error"));
                        toggleErrItems();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(error.message || translateAlertAction("message_remove_all_error_fail"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        router.reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteErrProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // translate
    // const MapExtraFee = {
    //   // need to translate to Vi
    //   vi: () => (
    //     <>
    //       <Typography>
    //         Với đơn hàng dưới 1.5 triệu đồng (TP HCM và Hà Nội) hoặc dưới 2 triệu đồng (các tỉnh khác) sẽ bị phụ phí
    //         <b> {formatCurrency(50000)}</b>.
    //       </Typography>
    //       <Typography>
    //         Bạn còn cần <b>{formatCurrency(needToBuy())}</b> để được không bị tính phụ phí. Bạn muốn tiếp tục chứ?
    //       </Typography>
    //     </>
    //   ),
    //   // need to translate to Thai
    // };
    // multi voucher
    var getTotalDiscount = function() {
        var autoRedeem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], redeem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], buymedServiceFee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var total = 0;
        var validDiscounts = {
            auto: autoRedeem === null || autoRedeem === void 0 ? void 0 : autoRedeem.filter(function(child) {
                return child.discountValue && typeof +child.discountValue === "number";
            }),
            redeem: redeem === null || redeem === void 0 ? void 0 : redeem.filter(function(child) {
                return child.discountValue && typeof +child.discountValue === "number";
            })
        };
        if (validDiscounts.auto && validDiscounts.redeem) {
            var ref, ref1;
            total = ((ref = validDiscounts.auto) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, cur) {
                return acc + cur.discountValue;
            }, 0)) + ((ref1 = validDiscounts.redeem) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, cur) {
                return acc + cur.discountValue;
            }, 0));
        } else {
            // eslint-disable-next-line no-lonely-if
            if (validDiscounts.auto) {
                var ref2;
                total = (ref2 = validDiscounts.auto) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(acc, cur) {
                    return acc + cur.discountValue;
                }, 0);
            } else if (validDiscounts.redeem) {
                var ref3;
                total = (ref3 = validDiscounts.redeem) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, cur) {
                    return acc + cur.discountValue;
                }, 0);
            } else {
                total = 0;
            }
        }
        if (buymedServiceFee > 0) {
            total += buymedServiceFee;
        }
        return total > 0 ? "-".concat((0,FormatNumber/* formatCurrency */.xG)(total)) : (0,FormatNumber/* formatCurrency */.xG)(total);
    };
    var methodSubTitle = function() {
        var ref;
        var content = "";
        if ([
            Enums/* PAYMENT_METHOD.TRANSFER */.hL.TRANSFER,
            Enums/* PAYMENT_METHOD.COD */.hL.COD,
            Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT,
            Enums/* PAYMENT_METHOD.QR_BEAM */.hL.QR_BEAM, 
        ].includes(customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.code)) {
            var ref1;
            if ((customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : (ref1 = customerPaymentInfo.subTitle) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                var ref2;
                content = customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : (ref2 = customerPaymentInfo.subTitle) === null || ref2 === void 0 ? void 0 : ref2.replace("{percentage}%", (customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.additionFeeText) || "");
            }
        } else if ((customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : (ref = customerPaymentInfo.additionFeeText) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            content = translateCheckout("addition_fee_text", {
                text: (customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.additionFeeText) || ""
            });
        }
        return content.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CheckoutSticky_styles_module_default()).d_flex,
            style: {
                paddingTop: 0,
                maxWidth: "60%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                children: content
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CheckoutSticky_styles_module_default()).checkout_sticky,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
                className: (CheckoutSticky_styles_module_default()).root,
                elevation: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("order_information")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "outlined",
                                    color: "primary",
                                    "data-test": "btn-checkout-edit",
                                    className: (CheckoutSticky_styles_module_default()).btn,
                                    onClick: function() {
                                        return router.push("/cart");
                                    },
                                    children: translateCheckout("edit")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("total_products")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (0,FormatNumber/* formatNumber */.uf)(totalItemSelected)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("estimated_total")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: (0,FormatNumber/* formatCurrency */.xG)(price)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        className: (CheckoutSticky_styles_module_default()).dividerCustom
                    }),
                    (debt === null || debt === void 0 ? void 0 : debt.isActive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                children: translateCheckout("debt_remain")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_content,
                                children: debt.balanceFormated
                            })
                        ]
                    }),
                    customerDeliveryInfo && deliveryMethodFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label,
                                        children: (customerDeliveryInfo === null || customerDeliveryInfo === void 0 ? void 0 : customerDeliveryInfo.name) || translateCheckout("delivery_fee")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: (0,FormatNumber/* formatCurrency */.xG)(deliveryMethodFee)
                                    })
                                ]
                            }),
                            (customerDeliveryInfo === null || customerDeliveryInfo === void 0 ? void 0 : customerDeliveryInfo.subTitleDelivery) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                style: {
                                    paddingTop: 0,
                                    maxWidth: "60%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                    children: customerDeliveryInfo.subTitleDelivery
                                })
                            })
                        ]
                    }),
                    customerPaymentInfo && paymentMethodFee !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label,
                                        children: (customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.name) || translateCheckout("checkout_fee")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: (customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.code) !== Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT && (0,FormatNumber/* formatCurrency */.xG)(paymentMethodFee)
                                    })
                                ]
                            }),
                            (customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.subTitlePayment) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                style: {
                                    paddingTop: 0,
                                    maxWidth: "60%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                    children: customerPaymentInfo === null || customerPaymentInfo === void 0 ? void 0 : customerPaymentInfo.subTitlePayment
                                })
                            }),
                            methodSubTitle()
                        ]
                    }),
                    extraFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label,
                                        children: translateCheckout("surcharge")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: (0,FormatNumber/* formatCurrency */.xG)(extraFee)
                                    })
                                ]
                            }),
                            (extraFeeNote === null || extraFeeNote === void 0 ? void 0 : extraFeeNote.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                style: {
                                    paddingTop: 0,
                                    maxWidth: "60%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutSticky_styles_module_default()).checkout_label_second,
                                    children: extraFeeNote
                                })
                            })
                        ]
                    }),
                    ((redeemRs === null || redeemRs === void 0 ? void 0 : redeemRs.length) > 0 || (autoRedeemRs === null || autoRedeemRs === void 0 ? void 0 : autoRedeemRs.length) > 0 || totalBuymedServiceFee > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((CheckoutSticky_styles_module_default()).total_redeems, "  ").concat((CheckoutSticky_styles_module_default()).d_flex),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (CheckoutSticky_styles_module_default()).checkout_label,
                                        children: translateCheckout("total_discount")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: getTotalDiscount(autoRedeemRs, redeemRs, totalBuymedServiceFee)
                                    })
                                ]
                            }),
                            autoRedeemRs && autoRedeemRs.length > 0 && (autoRedeemRs === null || autoRedeemRs === void 0 ? void 0 : autoRedeemRs.map(function(child) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (CheckoutSticky_styles_module_default()).d_flex,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                            display: "flex",
                                            gridGap: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        color: "#A2A0A0",
                                                        marginLeft: "4px",
                                                        fontSize: "14px",
                                                        maxWidth: "70%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: child === null || child === void 0 ? void 0 : child.code
                                                })
                                            ]
                                        }),
                                        (child === null || child === void 0 ? void 0 : child.discountValue) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).checkout_content, (CheckoutSticky_styles_module_default()).break_line),
                                            children: [
                                                "-",
                                                (0,FormatNumber/* formatCurrency */.xG)(child.discountValue)
                                            ]
                                        }),
                                        ((ref = child.gifts) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        fontFamily: "ggsm",
                                                        marginRight: 5,
                                                        color: "#000"
                                                    },
                                                    children: [
                                                        "x",
                                                        ((ref2 = (ref1 = child.gifts) === null || ref1 === void 0 ? void 0 : ref1.flat()) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(accmulator, currentChild) {
                                                            return accmulator + (currentChild === null || currentChild === void 0 ? void 0 : currentChild.quantity);
                                                        }, 0)) || 0
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* CART_NEW_GIFT_ICON */.rQw,
                                                    alt: "icon gift",
                                                    height: "19",
                                                    width: "19"
                                                })
                                            ]
                                        })
                                    ]
                                }, child.code);
                            })),
                            redeemRs && redeemRs.length > 0 && redeemRs.map(function(child) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).d_flex, (CheckoutSticky_styles_module_default()).checkout_promo_code),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: "#A2A0A0",
                                                        marginLeft: "4px",
                                                        fontSize: "14px",
                                                        maxWidth: "70%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: child.code
                                                })
                                            ]
                                        }),
                                        child.discountValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).checkout_content, (CheckoutSticky_styles_module_default()).break_line),
                                            children: "-".concat((0,FormatNumber/* formatCurrency */.xG)(child.discountValue))
                                        }),
                                        ((ref = child.gifts) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    style: {
                                                        fontFamily: "ggsm",
                                                        marginRight: 5,
                                                        color: "#000"
                                                    },
                                                    children: [
                                                        "x",
                                                        ((ref2 = (ref1 = child.gifts) === null || ref1 === void 0 ? void 0 : ref1.flat()) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(accmulator, currentChild) {
                                                            return accmulator + (currentChild === null || currentChild === void 0 ? void 0 : currentChild.quantity);
                                                        }, 0)) || 0
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* CART_NEW_GIFT_ICON */.rQw,
                                                    alt: "icon gift",
                                                    height: "19",
                                                    width: "19"
                                                })
                                            ]
                                        })
                                    ]
                                }, child.code);
                            }),
                            totalBuymedServiceFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).d_flex,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalOfferOutlined/* default */.Z, {
                                                fontSize: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "#A2A0A0",
                                                    marginLeft: "4px",
                                                    fontSize: "14px"
                                                },
                                                children: translateCheckout("buymed_payment_discount")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CheckoutSticky_styles_module_default()).checkout_content,
                                        children: "-".concat((0,FormatNumber/* formatCurrency */.xG)(totalBuymedServiceFee))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        className: (CheckoutSticky_styles_module_default()).dividerCustom
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: "12px 0"
                        },
                        className: (CheckoutSticky_styles_module_default()).d_flex,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).checkout_label,
                                style: {
                                    fontSize: 16
                                },
                                children: translateCheckout("total_money")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CheckoutSticky_styles_module_default()).total,
                                children: (0,FormatNumber/* formatCurrency */.xG)(Math.max(0, totalPrice))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        className: (CheckoutSticky_styles_module_default()).dividerCustom
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    padding: "8px 16px",
                                    color: "#000"
                                },
                                children: translateCheckout("check_info_alert")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CheckoutSticky_styles_module_default()).condition,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                        style: {
                                            padding: "8px 16px"
                                        },
                                        control: GreenCheckBoxElement,
                                        label: LabelConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (CheckoutSticky_styles_module_default()).list_note,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "1.",
                                                    translateCheckout("alert_cancel").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "2.",
                                                    translateCheckout("alert_wrong_quantity")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: "0 16px",
                            color: "#000"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                            title: checkCondition.checked && translateCheckout("agree_with_condition"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                                disabled: !checkCondition.checked || deliveryLimitCheck || isOverWeightOrVolume || debt && debt.debtBalance <= 0,
                                className: (0,clsx_m/* default */.Z)("payment_button", (CheckoutSticky_styles_module_default()).continue_btn),
                                onClick: handleCheckoutClick,
                                "data-test": "btn-checkout-payment",
                                children: translateCheckout("checkout")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CheckoutSticky_styles_module_default()).text_right,
                children: [
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: errorMessage
                        })
                    }),
                    deliveryLimitMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: deliveryLimitMessage
                        })
                    }),
                    (debt === null || debt === void 0 ? void 0 : debt.balance) <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CheckoutSticky_styles_module_default()).condition,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                            severity: "error",
                            style: {
                                marginTop: "10px",
                                borderRadius: "8px"
                            },
                            children: debt === null || debt === void 0 ? void 0 : debt.balanceMessageError
                        })
                    }),
                    sysconfig/* FEATURE_SHOW_BUTTON_VERIFY_CART */.LU && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                        btnType: "success",
                        className: (CheckoutSticky_styles_module_default()).checkout_btn,
                        onClick: handleVerify,
                        children: translateCheckout("check")
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)((CheckoutSticky_styles_module_default()).sticky_checkout_bar_mobile, beta && (CheckoutSticky_styles_module_default()).sticky_checkout_bar_mobileNew),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CheckoutSticky_styles_module_default()).fwc_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CheckoutSticky_styles_module_default()).flex_price,
                                    children: beta ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayPriceMobileNew, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayPrice, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                                        disabled: !checkCondition.checked || user.isQuest || deliveryLimitCheck || isOverWeightOrVolume || debt && debt.balance <= 0,
                                        btnType: beta ? "primary" : "warning",
                                        onClick: handleCheckoutClick,
                                        classes: {
                                            label: (CheckoutSticky_styles_module_default()).label,
                                            outlined: (CheckoutSticky_styles_module_default()).outlined,
                                            root: beta ? (CheckoutSticky_styles_module_default()).mobileRoot_btn : (CheckoutSticky_styles_module_default()).root_btn
                                        },
                                        children: translateCheckout("checkout")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isShowErrCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CheckoutSticky_styles_module_default()).card_err_container,
                ref: errCardRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        className: (CheckoutSticky_styles_module_default()).text_err_notification,
                        children: [
                            translateCheckout("message_error_products_in_cart"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                className: (CheckoutSticky_styles_module_default()).delete_text,
                                role: "presentation",
                                onClick: toggleErrItems,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                        fontSize: "small"
                                    }),
                                    " ",
                                    translateCheckout("click_here_to_delete")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorProductsPayment/* default */.Z, {})
                ]
            }),
            openErrItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalListProduct/* default */.Z, {
                products: errProducts,
                isShowPopupConfirm: openErrItems,
                handleClosePopup: toggleErrItems,
                handleClick: handleDeleteErrProducts,
                title: translateCheckout("confirmation"),
                content: // eslint-disable-next-line react/jsx-wrap-multilines
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (CheckoutSticky_styles_module_default()).text_content_modal,
                            style: {
                                fontWeight: "700",
                                marginTop: "15px"
                            },
                            children: translateCheckout("message_delete_all_error_products")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (CheckoutSticky_styles_module_default()).text_content_modal,
                            style: {
                                marginTop: "20px"
                            },
                            children: translateCheckout("message_exceed_back")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CustomModal["default"], {
                visible: showConfirmModal,
                onClose: toggleConfirm,
                title: translateCheckout("confirmation"),
                btnOk: translateCheckout("confirm"),
                onClickOk: handleSubmit,
                btnOnClose: translateCheckout("check_cart")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPriceFluctuationModal/* default */.Z, {
                visible: isOpenPriceFluctuationModal,
                onClose: function() {
                    return togglePriceFluctuationModal(false);
                },
                onBack: handleBackToCart,
                onConfirm: handleConfirmPriceFluctuation,
                products: cartFluctuates,
                isMobile: isMobile,
                isFromCheckout: true
            }),
            showMaintenanceModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CustomModal["default"], {
                visible: showMaintenanceModal,
                onClose: function() {
                    return setShowMaintenanceModal(false);
                },
                icon: false,
                title: translateCheckout("maintenance_title"),
                content: translateCheckout("maintenance_message"),
                btnOkRender: false,
                btnCloseRender: false,
                customBtnRender: // eslint-disable-next-line react/jsx-wrap-multilines
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonDefault */.t, {
                        btnType: "primary",
                        className: (CheckoutSticky_styles_module_default()).checkout_btn,
                        onClick: function() {
                            return setShowMaintenanceModal(false);
                        },
                        children: translateCheckout("maintenance_understand")
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    my: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 48,
                        thickness: 4,
                        style: {
                            color: "#005C29"
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_CheckoutSticky = (CheckoutSticky);

// EXTERNAL MODULE: ./src/components/mocules/CountdownTimer/index.js
var mocules_CountdownTimer = __webpack_require__(72640);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(58769);
;// CONCATENATED MODULE: ./src/components/mocules/CountdownTimerDetail/index.js







// thuannc
// TODO:
// MUST FIX
function CountdownTimerDetail(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, translateProductDetail = _param.translateProductDetail, otherProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "prefix",
        "dealEndDay",
        "translateProductDetail"
    ]);
    var ref = (0,react.useState)((0,utils/* calculateTimeLeft */.VZ)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,utils/* calculateTimeLeft */.VZ)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        if (!timeLeft[interval]) {
            return;
        }
        timerComponents.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                timeLeft[interval],
                interval === "days" ? " : " : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, otherProps), {
            children: timerComponents.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: timerComponents
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: translateProductDetail("promotion_ended")
            })
        }))
    });
}
/* harmony default export */ var mocules_CountdownTimerDetail = (CountdownTimerDetail);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
;// CONCATENATED MODULE: ./src/components/mocules/CouponDetailModal/index.js









var CouponDetailModal_CouponDetailModal = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function(param) {
    var children = param.children, onClose = param.onClose, onClickOk = param.onClickOk, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, content = param.content, btnOk = param.btnOk, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2, _btnOkRender = param.btnOkRender, btnOkRender = _btnOkRender === void 0 ? /*#__PURE__*/ _jsx(ModalButton, {
        className: styles.yes_btn,
        onClick: onClickOk,
        children: btnOk
    }) : _btnOkRender;
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "".concat(styles.confirm_modal_wrap, "  ").concat(title && content && styles.fixed_width_wrapper, " ").concat(isMobileV2 && styles.confirm_modal_wrap_mv2),
            children: [
                /*#__PURE__*/ _jsx(CloseIcon, {
                    className: styles.closeIcon,
                    onClick: onClose
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        title && /*#__PURE__*/ _jsx(Typography, {
                            className: styles.modal_title,
                            children: title
                        }),
                        content && /*#__PURE__*/ _jsx("div", {
                            className: styles.modal_content,
                            children: content
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.children,
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.btn_container,
                    children: btnOk && btnOkRender
                })
            ]
        })
    }));
})));
/* harmony default export */ var mocules_CouponDetailModal = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(CouponDetailModal_CouponDetailModal))));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var utils_DateTimeUtils = __webpack_require__(33213);
;// CONCATENATED MODULE: ./src/components/mocules/CouponCardV2/index.js

























var BorderLinearProgress = (0,styled_components_browser_esm/* default */.ZP)(LinearProgress/* default */.Z).withConfig({
    componentId: "sc-8a76e84f-0"
})(function() {
    return {
        height: 10,
        borderRadius: 10,
        margin: "0 5px",
        maxWidth: "120px",
        minWidth: "80px",
        backgroundColor: "#e9e9e9",
        ".MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#DC5C00"
        }
    };
});
var CouponCardV2 = function(props) {
    var ref;
    var _code = props.code, code = _code === void 0 ? "" : _code, tmp = props.endTime, expiredDate = tmp === void 0 ? new Date(Date.now()) : tmp, _voucher = props.voucher, voucher = _voucher === void 0 ? {} : _voucher, _promotionName = props.promotionName, promotionName = _promotionName === void 0 ? "" : _promotionName, _description = props.description, description = _description === void 0 ? "" : _description, _conditionDescription = props.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, isMobile = props.isMobile, _maxUsage = props.maxUsage, maxUsage = _maxUsage === void 0 ? 0 : _maxUsage, _usageTotal = props.usageTotal, usageTotal = _usageTotal === void 0 ? 0 : _usageTotal;
    var ref1 = useTranslation("common"), translateCommon = ref1.t;
    var _conditions = voucher.conditions, conditions = _conditions === void 0 ? [] : _conditions, _rewards = voucher.rewards, rewards = _rewards === void 0 ? [] : _rewards;
    var ref2 = _sliced_to_array(useModal(false), 2), toggleModal = ref2[0], setToggleModal = ref2[1];
    var isMobileV2 = useMobileV2(function(state) {
        return state.isMobileV2();
    });
    var router = useRouter();
    // check tooltip with ... css
    var ref3 = _sliced_to_array(useOverflowTooltip(), 2), isOverflowed = ref3[0], textElementRef = ref3[1];
    var ref4 = useState(false), isHoverTooltip = ref4[0], setIsHoverTooltip = ref4[1];
    var maxDiscountValue = 0;
    var discountValue = 0;
    var percent = 0;
    var minOrderValue = 0;
    var type = ((ref = conditions[0]) === null || ref === void 0 ? void 0 : ref.type) || PROMO_TYPE.COMBO;
    if (rewards.length !== 0) {
        var ref5, ref6, ref7;
        maxDiscountValue = ((ref5 = rewards[0]) === null || ref5 === void 0 ? void 0 : ref5.maxDiscount) || 0;
        discountValue = ((ref6 = rewards[0]) === null || ref6 === void 0 ? void 0 : ref6.absoluteDiscount) || 0;
        percent = ((ref7 = rewards[0]) === null || ref7 === void 0 ? void 0 : ref7.percentageDiscount) || 0;
    }
    // conditions is an array contains condition of voucher
    if (conditions.length !== 0) {
        var ref8;
        minOrderValue = ((ref8 = conditions[0]) === null || ref8 === void 0 ? void 0 : ref8.minOrderValue) || 0;
    }
    // check timer coutdown
    var checkTimeCountDown = function() {
        var oneDay = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
        var endVoucher = new Date(expiredDate).getTime();
        return expiredDate && oneDay > endVoucher ? /*#__PURE__*/ _jsxs("div", {
            style: {
                margin: "5px 0"
            },
            children: [
                translateCommon("voucher.HSD"),
                ":",
                " ",
                /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: "#D4323B"
                    },
                    children: /*#__PURE__*/ _jsx(CountdownTimer, {
                        prefix: "",
                        dealEndDay: expiredDate,
                        style: {
                            display: "inline-block"
                        },
                        translateCommon: translateCommon
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsxs(Typography, {
            className: styles.expiredDate,
            children: [
                translateCommon("voucher.HSD"),
                ":",
                /*#__PURE__*/ _jsx("span", {
                    children: DateTimeUtils.getFormattedWithDate(new Date(expiredDate), translateCommon, "DD/MM/YYYY")
                })
            ]
        });
    };
    var getTitle = function() {
        if (type === PROMO_TYPE.COMBO || type === PROMO_TYPE.GIFT || type === PROMO_TYPE.ABSOLUTE || type === PROMO_TYPE.POINT) return description || promotionName;
        if (type === PROMO_TYPE.ABSOLUTE) return "".concat(translateCommon("voucher.HSD"), " ").concat(formatCurrency(discountValue));
        if (type === PROMO_TYPE.PERCENTAGE) return "".concat(translateCommon("voucher.HSD"), " ").concat(percent, "% ").concat(translateCommon("voucher.max"), " ").concat(formatCurrency(maxDiscountValue));
        return "";
    };
    var CouponDetail = function(couponCode, expiryDate, open) {
        var ref = useState(false), isCoppied = ref[0], setIsCoppied = ref[1];
        var handleCopied = function() {
            setIsCoppied(true);
        };
        useEffect(function() {
            if (!open) {
                setIsCoppied(false);
            }
        }, [
            !open
        ]);
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    direction: "row",
                    className: styles.couponDetailRow,
                    children: [
                        /*#__PURE__*/ _jsxs(Grid, {
                            item: true,
                            xs: 5,
                            sm: 6,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: styles.couponDetailLabel,
                                    children: translateCommon("voucher.discount_code")
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 7,
                            sm: 6,
                            className: styles.wrapInfoCode,
                            alignItems: "center",
                            container: true,
                            children: /*#__PURE__*/ _jsxs(Grid, {
                                className: styles.couponDetailValue,
                                style: {
                                    color: "#005C29",
                                    position: "relative",
                                    bottom: "5px"
                                },
                                children: [
                                    couponCode,
                                    /*#__PURE__*/ _jsxs("span", {
                                        style: {
                                            display: "inline-flex",
                                            flexWrap: "nowrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(CopyToClipboard, {
                                                text: couponCode,
                                                onCopy: handleCopied,
                                                children: /*#__PURE__*/ _jsx(FileCopyOutlinedIcon, {
                                                    className: styles.iconCopy
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                style: {
                                                    display: !isCoppied && "none"
                                                },
                                                children: isCoppied ? /*#__PURE__*/ _jsx(DoneIcon, {
                                                    className: styles.iconCopyDone
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    direction: "row",
                    className: styles.couponDetailRow,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 5,
                            sm: 6,
                            children: /*#__PURE__*/ _jsxs("span", {
                                className: styles.couponDetailLabel,
                                children: [
                                    translateCommon("voucher.expiry"),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 7,
                            sm: 6,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: styles.couponDetailValue,
                                style: {
                                    position: "relative",
                                    bottom: "4px"
                                },
                                children: expiryDate()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.condition,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.couponDetailLabel,
                            children: translateCommon("voucher.condition_of_use")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.conditionContent,
                            children: conditionDescription ? /*#__PURE__*/ _jsx("div", {
                                dangerouslySetInnerHTML: {
                                    __html: conditionDescription
                                }
                            }) : /*#__PURE__*/ _jsx("p", {
                                children: translateCommon("voucher.applies_all_order")
                            })
                        })
                    ]
                })
            ]
        });
    };
    var handleClickInfoVoucher = function() {
        setToggleModal(true);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CouponDetailModal, {
                visible: toggleModal,
                onClose: function() {
                    setToggleModal(false);
                },
                title: translateCommon("voucher.discount_code"),
                content: CouponDetail(code, checkTimeCountDown, toggleModal),
                btnOk: translateCommon("btn.apply"),
                onClickOk: function() {
                    router.push("/cart");
                },
                isMobileV2: isMobileV2,
                btnOnClose: translateCommon("no")
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.couponBoxMargin,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.couponBox,
                    children: /*#__PURE__*/ _jsx(Box, {
                        className: styles.borderBox,
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            container: true,
                            direction: "row",
                            spacing: 3,
                            style: {
                                margin: 0,
                                height: "100%"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(Grid, {
                                    item: true,
                                    xs: 4,
                                    className: styles.flexCenter,
                                    children: [
                                        /*#__PURE__*/ _jsx(Image, {
                                            className: styles.logo,
                                            href: "/",
                                            src: NEW_LOGO || "/images/logo_thuocsi_new.png",
                                            width: 108,
                                            height: 19
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.halfCircle
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.line
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            component: "span",
                                            className: styles.halfCircleBottom
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 8,
                                    children: /*#__PURE__*/ _jsxs(Box, {
                                        className: styles.couponInfo,
                                        children: [
                                            /*#__PURE__*/ _jsx(Tooltip, {
                                                title: description || promotionName,
                                                arrow: true,
                                                open: isMobile ? isHoverTooltip : isOverflowed && isHoverTooltip,
                                                enterTouchDelay: 0,
                                                disableHoverListener: isMobile ? null : !isOverflowed,
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    ref: textElementRef,
                                                    onClick: function() {
                                                        return setIsHoverTooltip(true);
                                                    },
                                                    onMouseOver: function() {
                                                        return setIsHoverTooltip(true);
                                                    },
                                                    onMouseLeave: function() {
                                                        return setIsHoverTooltip(false);
                                                    },
                                                    className: styles.promotionTitle,
                                                    role: "presentation",
                                                    children: getTitle()
                                                })
                                            }),
                                            type === PROMO_TYPE.VOUCHERCODE && /*#__PURE__*/ _jsx("p", {
                                                children: "".concat(translateCommon("voucher.for_minimun_order_from"), " ").concat(formatCurrency(String(minOrderValue)))
                                            }),
                                            maxUsage > 0 && /*#__PURE__*/ _jsxs("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            translateCommon("voucher.used"),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(BorderLinearProgress, {
                                                        variant: "determinate",
                                                        value: Math.floor((usageTotal || 0) * 100 / maxUsage) || 0
                                                    }),
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        style: {
                                                            color: "#DC5C00",
                                                            fontWeight: "bold"
                                                        },
                                                        children: [
                                                            Math.floor((usageTotal || 0) * 100 / maxUsage) || 0,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            checkTimeCountDown(),
                                            /*#__PURE__*/ _jsx(InfoIconOutlined, {
                                                className: styles.infoIcon,
                                                onClick: handleClickInfoVoucher
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_CouponCardV2 = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CouponCardV2))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js + 6 modules
var createTheme = __webpack_require__(73690);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/data-grid/dist/index-esm.js
var index_esm = __webpack_require__(96084);
;// CONCATENATED MODULE: ./src/components/mocules/CustomNoRowsOverlay/index.js



var defaultTheme = (0,createTheme/* default */.Z)();
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            padding: 20,
            flexDirection: "column",
            "& .ant-empty-img-1": {
                fill: theme.palette.type === "light" ? "#aeb8c2" : "#262626"
            },
            "& .ant-empty-img-2": {
                fill: theme.palette.type === "light" ? "#f5f5f7" : "#595959"
            },
            "& .ant-empty-img-3": {
                fill: theme.palette.type === "light" ? "#dce0e6" : "#434343"
            },
            "& .ant-empty-img-4": {
                fill: theme.palette.type === "light" ? "#fff" : "#1c1c1c"
            },
            "& .ant-empty-img-5": {
                fillOpacity: theme.palette.type === "light" ? "0.8" : "0.08",
                fill: theme.palette.type === "light" ? "#f5f5f5" : "#fff"
            }
        },
        label: {
            marginTop: theme.spacing(1)
        }
    };
}, {
    defaultTheme: defaultTheme
});
function CustomNoRowsOverlay(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridOverlay */.nik, {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "120",
                height: "100",
                viewBox: "0 0 184 152",
                "aria-hidden": true,
                focusable: "false",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(24 31.67)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    className: "ant-empty-img-5",
                                    cx: "67.797",
                                    cy: "106.89",
                                    rx: "67.797",
                                    ry: "12.668"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-1",
                                    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-2",
                                    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "ant-empty-img-3",
                                    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            className: "ant-empty-img-3",
                            d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            className: "ant-empty-img-4",
                            transform: "translate(149.65 15.383)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    cx: "20.654",
                                    cy: "3.167",
                                    rx: "2.849",
                                    ry: "2.815"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.label,
                children: text
            })
        ]
    });
}
/* harmony default export */ var mocules_CustomNoRowsOverlay = (CustomNoRowsOverlay);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card_Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AddCircle.js
var AddCircle = __webpack_require__(76220);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(94697);
// EXTERNAL MODULE: ./src/components/mocules/DeleteAddressModal/index.js
var DeleteAddressModal = __webpack_require__(40174);
// EXTERNAL MODULE: ./src/components/mocules/AddressCard/styles.module.css
var AddressCard_styles_module = __webpack_require__(96584);
var AddressCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddressCard_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AddressCard/index.js

















var CardComp = function(param) {
    var isSelect = param.isSelect, address = param.address, handleOnSelect = param.handleOnSelect, handleReloadData = param.handleReloadData, handleEdit = param.handleEdit, selectAddressCode = param.selectAddressCode;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("myAccount"), translateMyAccount = ref1.t;
    var _name = address.name, name = _name === void 0 ? "" : _name, _phone = address.phone, phone = _phone === void 0 ? "" : _phone, _isDefault = address.isDefault, isDefault = _isDefault === void 0 ? false : _isDefault, _masterAddress = address.masterAddress, masterAddress = _masterAddress === void 0 ? "" : _masterAddress, _code = address.code, code = _code === void 0 ? "" : _code;
    var ref2 = (0,context/* useAuth */.aC)(), customerID = ref2.user.customerID;
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), open = ref3[0], toggle = ref3[1];
    var handleDelete = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            clients/* CustomerClient.deleteAddress */.YP.deleteAddress((_tmp.code = code, _tmp.customerID = customerID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_delete_address_fail"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_delete_address_success"));
                        handleReloadData();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetDefault = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddressDefault */.YP.updateAddressDefault((_tmp.code = code, _tmp.customerID = customerID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_failed_update_default_address"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_update_default_address"));
                        handleReloadData();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetDefault() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        item: true,
        xs: 12,
        md: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                className: isSelect && selectAddressCode === address.code ? (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).card_selected, (AddressCard_styles_module_default()).card) : (AddressCard_styles_module_default()).card,
                "data-test": "card-address",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                        action: isDefault ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AddressCard_styles_module_default()).default_tag,
                            children: [
                                " ",
                                translateMyAccount("default")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        title: name,
                        subheader: "".concat(translateMyAccount("phone_number"), ": ").concat(phone)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AddressCard_styles_module_default()).float_bottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (AddressCard_styles_module_default()).ellipsis_2_line,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    " ",
                                                    translateMyAccount("address"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            masterAddress
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (AddressCard_styles_module_default()).group_button,
                                    children: [
                                        isSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "contained",
                                            className: (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).important_action_button),
                                            onClick: function() {
                                                handleOnSelect(address);
                                            },
                                            "data-test": "btn-select-address",
                                            children: translateMyAccount("deliver_to_this_address")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: isSelect ? (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).defaull_button) : (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).important_action_button),
                                            onClick: function() {
                                                return handleEdit(address);
                                            },
                                            children: translateMyAccount("edit")
                                        }),
                                        !isDefault && !isSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: (0,clsx_m/* default */.Z)((AddressCard_styles_module_default()).action_button, (AddressCard_styles_module_default()).defaull_button),
                                            onClick: handleSetDefault,
                                            children: translateMyAccount("default")
                                        }),
                                        !isDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            className: (AddressCard_styles_module_default()).action_button,
                                            onClick: toggle,
                                            "data-test": "btn-delete-address-card",
                                            children: translateMyAccount("remove")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteAddressModal/* default */.Z, {
                visible: open,
                onClose: toggle,
                onClickOk: handleDelete
            })
        ]
    });
};
/* harmony default export */ var AddressCard = (CardComp);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(66856);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(66083);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(75445);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./src/components/mocules/InfoInput/index.js
var mocules_InfoInput = __webpack_require__(42150);
;// CONCATENATED MODULE: ./src/components/mocules/AddressSelect/index.js




function AddressSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .MuiNativeSelect-select {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  & .MuiNativeSelect-icon {\n    right: 5px !important;\n    color: #005c29 !important;\n  }\n  &.MuiOutlinedInput-root {\n    height: 2.4em !important;\n  }\n  & .MuiNativeSelect-select:focus {\n    background-color: transparent !important;\n  }\n"
    ]);
    AddressSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AddressSelect = function(_param) /*#__PURE__*/ {
    var label = _param.label, id = _param.id, _options = _param.options, options = _options === void 0 ? [] : _options, onChange = _param.onChange, _value = _param.value, value = _value === void 0 ? "0" : _value, disabled = _param.disabled, className = _param.className, error = _param.error, dataTest = _param.dataTest, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "label",
        "id",
        "options",
        "onChange",
        "value",
        "disabled",
        "className",
        "error",
        "dataTest"
    ]);
    return (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xs: 12,
        md: 4,
        label: label,
        htmlFor: id
    }, restProps), {
        isRequired: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
            id: id,
            input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                error: error
            }),
            IconComponent: ExpandMore/* default */.Z,
            value: value,
            onChange: onChange,
            className: className,
            disabled: disabled,
            "data-test": dataTest,
            children: options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: option.value,
                    children: option.label
                }, (0,v4/* default */.Z)());
            })
        })
    }));
};
var StyledAddressSelect = (0,styled_components_browser_esm/* default */.ZP)(AddressSelect).withConfig({
    componentId: "sc-6bbfe1d7-0"
})(AddressSelect_templateObject());
/* harmony default export */ var mocules_AddressSelect = (StyledAddressSelect);

// EXTERNAL MODULE: ./src/components/mocules/GroupAddressSelect/styles.module.css
var GroupAddressSelect_styles_module = __webpack_require__(81966);
var GroupAddressSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(GroupAddressSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/GroupAddressSelect/index.js















var GroupAddressSelect = function(_param) {
    var _setTotalWard = _param.setTotalWard, setTotalWard = _setTotalWard === void 0 ? null : _setTotalWard, _error = _param.error, error = _error === void 0 ? {} : _error, _type = _param.type, type = _type === void 0 ? Enums/* GROUP_ADDRESS_TYPE.HORIZONTAL */.$O.HORIZONTAL : _type, currentAddress = _param.currentAddress, handleSetCurrentAddress = _param.handleSetCurrentAddress, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "setTotalWard",
        "error",
        "type",
        "currentAddress",
        "handleSetCurrentAddress"
    ]);
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var DEFAULT_PROVINCE = {
        label: translateCommon("enter_province"),
        value: "0"
    };
    var DEFAULT_DISTRICT = {
        label: translateCommon("enter_district"),
        value: "0"
    };
    var DEFAULT_WARD = {
        label: translateCommon("enter_ward"),
        value: "0"
    };
    // const { itemCount } = useCart();
    var ref1 = (0,react.useState)({
        provinces: [
            DEFAULT_PROVINCE
        ],
        districts: [
            DEFAULT_DISTRICT
        ],
        wards: [
            DEFAULT_WARD
        ]
    }), address = ref1[0], setAddress = ref1[1];
    var getProvinces = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var provinces;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getProvinces */.Z.getProvinces()
                        ];
                    case 1:
                        provinces = _state.sent();
                        return [
                            2,
                            [
                                DEFAULT_PROVINCE
                            ].concat((0,_to_consumable_array/* default */.Z)(provinces))
                        ];
                }
            });
        });
        return function getProvinces() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDistricts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prv) {
            var dists;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(prv)
                        ];
                    case 1:
                        dists = _state.sent();
                        return [
                            2,
                            [
                                DEFAULT_DISTRICT
                            ].concat((0,_to_consumable_array/* default */.Z)(dists))
                        ];
                }
            });
        });
        return function getDistricts(prv) {
            return _ref.apply(this, arguments);
        };
    }();
    var getWards = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(dist) {
            var wards;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AddressService/* default.getWardsByDistrict */.Z.getWardsByDistrict(dist)
                        ];
                    case 1:
                        wards = _state.sent();
                        if (setTotalWard) {
                            setTotalWard(wards.length);
                        }
                        return [
                            2,
                            [
                                DEFAULT_WARD
                            ].concat((0,_to_consumable_array/* default */.Z)(wards))
                        ];
                }
            });
        });
        return function getWards(dist) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProvinceMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var provinces, addressinfo, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getProvinces()
                        ];
                    case 1:
                        provinces = _state.sent();
                        _tmp = {};
                        addressinfo = (_tmp.provinces = provinces, _tmp.districts = [
                            DEFAULT_DISTRICT
                        ], _tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.province !== DEFAULT_PROVINCE.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getDistricts(currentAddress.province)
                        ];
                    case 2:
                        addressinfo.districts = _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 4:
                        addressinfo.wards = _state.sent();
                        _state.label = 5;
                    case 5:
                        setAddress(addressinfo);
                        return [
                            2
                        ];
                }
            });
        });
        return function getProvinceMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDistrictMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var addressinfo, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        addressinfo = (_tmp.districts = [
                            DEFAULT_DISTRICT
                        ], _tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.province !== DEFAULT_PROVINCE.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getDistricts(currentAddress.province)
                        ];
                    case 1:
                        addressinfo.districts = _state.sent();
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 2:
                        addressinfo.wards = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp1 = {};
                        setAddress((0,src_object_spread/* default */.Z)(_tmp1, address, addressinfo));
                        return [
                            2
                        ];
                }
            });
        });
        return function getDistrictMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getWardMasterData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var addressinfo, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        addressinfo = (_tmp.wards = [
                            DEFAULT_WARD
                        ], _tmp);
                        if (!(currentAddress.district !== DEFAULT_DISTRICT.value)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getWards(currentAddress.district)
                        ];
                    case 1:
                        addressinfo.wards = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp1 = {};
                        setAddress((0,src_object_spread/* default */.Z)(_tmp1, address, addressinfo));
                        return [
                            2
                        ];
                }
            });
        });
        return function getWardMasterData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED) {
            getProvinceMasterData();
        }
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.PROVINCE_CHANGE */.Ei.PROVINCE_CHANGE) {
            getDistrictMasterData();
        }
        if (currentAddress.changeType === Enums/* ADDRESS_CHANGE_TYPE.DISTRICT_CHANGE */.Ei.DISTRICT_CHANGE) {
            getWardMasterData();
        }
    }, [
        currentAddress
    ]);
    var handleChangeProvince = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var prv, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                prv = e.target.value;
                _tmp = {};
                _tmp1 = {};
                if (prv !== currentAddress.province) handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.province = prv, _tmp1.district = DEFAULT_DISTRICT.value, _tmp1.ward = DEFAULT_WARD.value, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.PROVINCE_CHANGE */.Ei.PROVINCE_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        // } else NotifyUtils.error('Bạn không được thay đổi tỉnh/thành phố khi đang có sản phẩm trong giỏ hàng.');
        });
        return function handleChangeProvince(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeDistrict = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var dist, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                dist = e.target.value;
                _tmp = {};
                _tmp1 = {};
                if (dist !== currentAddress.district) handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.district = dist, _tmp1.ward = DEFAULT_WARD.value, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.DISTRICT_CHANGE */.Ei.DISTRICT_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        });
        return function handleChangeDistrict(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeWard = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var war, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                war = e.target.value;
                _tmp = {};
                _tmp1 = {};
                handleSetCurrentAddress((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, currentAddress), (_tmp1.ward = war, _tmp1.changeType = Enums/* ADDRESS_CHANGE_TYPE.WARD_CHANGE */.Ei.WARD_CHANGE, _tmp1)));
                return [
                    2
                ];
            });
        });
        return function handleChangeWard(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: (GroupAddressSelect_styles_module_default()).address_field,
        container: true,
        spacing: 3,
        style: {
            marginTop: "10px"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("province")
                }),
                id: (0,v4/* default */.Z)(),
                value: currentAddress.province || 0,
                onChange: handleChangeProvince,
                options: address.provinces,
                error: error.province,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-city"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                id: (0,v4/* default */.Z)(),
                value: currentAddress.district || 0,
                onChange: handleChangeDistrict,
                options: address.districts,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("district")
                }),
                disabled: address.districts.length === 1,
                error: error.district,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-district"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressSelect, {
                id: (0,v4/* default */.Z)(),
                value: currentAddress.ward || 0,
                onChange: handleChangeWard,
                options: address.wards,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (GroupAddressSelect_styles_module_default()).fw500,
                    children: translateCommon("ward")
                }),
                disabled: address.wards.length === 1,
                error: error.ward,
                md: type === Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL ? 12 : 4,
                dataTest: "select-address-ward"
            })
        ]
    }));
};
/* harmony default export */ var mocules_GroupAddressSelect = (GroupAddressSelect);

// EXTERNAL MODULE: ./src/components/mocules/AddressModal/styles.module.css
var AddressModal_styles_module = __webpack_require__(56889);
var AddressModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddressModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/AddressModal/validateForm.js

var AddressModal_validateForm_validateForm = function(param) {
    var name = param.name, phone = param.phone, email = param.email, address = param.address, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(name)) throw Error("message_empty_name");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(phone)) throw Error("message_empty_phone");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(address)) throw Error("message_empty_address");
    if (provinceCode === "0") throw Error("message_empty_province_city");
    if (districtCode === "0") throw Error("message_empty_district");
    if (wardCode === "0") throw Error("message_empty_ward");
    if (!utils/* ValidateUtils.isEmpty */.IN.isEmpty(email) && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_invalid_email");
    if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
};
/* harmony default export */ var AddressModal_validateForm = (AddressModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/AddressModal/index.js























var AddressModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref1.t;
    var onClose = props.onClose, visible = props.visible, _address = props.address, address = _address === void 0 ? {} : _address, handleReloadData = props.handleReloadData, customerID = props.customerID;
    var ref2 = (0,react.useState)(address), val = ref2[0], setVal = ref2[1];
    var ref3 = (0,react.useState)(address), addressSelected = ref3[0], setAddressSelected = ref3[1];
    var isEdit = address.code;
    var handleChangeValue = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var handleSetAddress = function(addressInfo) {
        setAddressSelected(addressInfo);
    };
    (0,react.useEffect)(function() {
        setVal(address);
        setAddressSelected(address);
    }, [
        address
    ]);
    var handleClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var formData, _tmp, _tmp1, result, _tmp2, result1, _tmp3, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        formData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, val), (_tmp1.wardCode = addressSelected.ward, _tmp1.districtCode = addressSelected.district, _tmp1.provinceCode = addressSelected.province, _tmp1.customerID = customerID, _tmp1));
                        delete formData.isDefault;
                        Object.keys(formData).forEach(function(key) {
                            if (typeof formData[key] === "string") {
                                formData[key] = formData[key].trim();
                            }
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        AddressModal_validateForm(formData);
                        if (!isEdit) return [
                            3,
                            3
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            clients/* CustomerClient.updateAddress */.YP.updateAddress((_tmp2.body = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
                                code: address.code
                            }), _tmp2))
                        ];
                    case 2:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) throw Error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message__failed_update_addres"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_edit_address"));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _tmp3 = {};
                        return [
                            4,
                            clients/* CustomerClient.createAddress */.YP.createAddress((_tmp3.body = formData, _tmp3))
                        ];
                    case 4:
                        result1 = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result1)) throw Error((result1 === null || result1 === void 0 ? void 0 : result1.message) || translateAlertAction("message_failed_create_new_address"));
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_create_address"));
                        _state.label = 5;
                    case 5:
                        onClose();
                        handleReloadData();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction(error.message));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddressModal_styles_module_default()).address_dialog,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            onClose: onClose,
            "aria-labelledby": "customized-dialog-title",
            open: visible,
            className: (AddressModal_styles_module_default()).address_dialog,
            "data-test": "modal-add-address",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
                    id: "customized-dialog-title",
                    onClose: onClose,
                    style: {
                        width: "100%"
                    },
                    children: [
                        isEdit ? translatePopupAction("popup-address.edit_address") : translatePopupAction("popup-address.add_address"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            "aria-label": "close",
                            className: (AddressModal_styles_module_default()).close_button,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                    dividers: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                container: true,
                                direction: "row",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.name"),
                                        htmlFor: "name",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "name",
                                            value: (val === null || val === void 0 ? void 0 : val.name) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("name", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.enterName"),
                                            "data-test": "input-address-name-modal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.mobile_number"),
                                        htmlFor: "phone",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "phone",
                                            value: (val === null || val === void 0 ? void 0 : val.phone) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("phone", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.enterPhone"),
                                            "data-test": "input-address-phone-modal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        label: translatePopupAction("popup-address.address"),
                                        htmlFor: "address",
                                        isRequired: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "address",
                                            value: (val === null || val === void 0 ? void 0 : val.address) || "",
                                            onChange: function(e) {
                                                return handleChangeValue("address", e.target.value);
                                            },
                                            placeholder: translatePopupAction("popup-address.address"),
                                            "data-test": "input-address-place-modal"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                                currentAddress: addressSelected,
                                handleSetCurrentAddress: handleSetAddress,
                                type: Enums/* GROUP_ADDRESS_TYPE.VERTICAL */.$O.VERTICAL
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        autoFocus: true,
                        color: "primary",
                        variant: "contained",
                        className: "my-order__button--secondary",
                        style: {
                            borderRadius: "30px",
                            padding: "5px 40px"
                        },
                        onClick: handleClick,
                        "data-test": "btn-address-add-modal",
                        children: isEdit ? translatePopupAction("popup-address.edit") : translatePopupAction("popup-address.add")
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_AddressModal = (AddressModal);

// EXTERNAL MODULE: ./src/components/mocules/DeliveryCardList/styles.module.css
var DeliveryCardList_styles_module = __webpack_require__(37838);
var DeliveryCardList_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryCardList_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryCardList/index.js

















var DeliveryCardList = function(param) {
    var _isSelect = param.isSelect, isSelect = _isSelect === void 0 ? false : _isSelect, addresses = param.addresses, handleOnSelect = param.handleOnSelect, handleReloadData = param.handleReloadData, selectAddressCode = param.selectAddressCode, customerID = param.customerID;
    var ref = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref.t;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openAddressModal = ref1[0], toggleAddressModal = ref1[1];
    var ref2 = (0,react.useState)({
        name: "",
        phone: "",
        changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
        province: "0",
        district: "0",
        ward: "0"
    }), value = ref2[0], setValue = ref2[1];
    var handleEdit = function(address) {
        setValue((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
            changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
            province: address.provinceCode,
            district: address.districtCode,
            ward: address.wardCode
        }));
        toggleAddressModal();
    };
    var handleNew = function() {
        setValue({
            changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
            province: "0",
            district: "0",
            ward: "0"
        });
        toggleAddressModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                spacing: 2,
                children: [
                    addresses.map(function(address) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard, {
                            address: address,
                            isSelect: isSelect,
                            handleReloadData: handleReloadData,
                            handleEdit: handleEdit,
                            handleOnSelect: handleOnSelect,
                            selectAddressCode: selectAddressCode
                        }, (0,v4/* default */.Z)());
                    }),
                    addresses.length <= 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                            className: (DeliveryCardList_styles_module_default()).card,
                            onClick: handleNew,
                            "data-test": "btn-add-new-address",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (DeliveryCardList_styles_module_default()).add_icon_column,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (DeliveryCardList_styles_module_default()).add_icon_row,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCircle/* default */.Z, {
                                                    size: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: translatePopupAction("add_address")
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AddressModal, {
                visible: openAddressModal,
                onClose: toggleAddressModal,
                address: value,
                handleReloadData: handleReloadData,
                customerID: customerID
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryCardList = (DeliveryCardList);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery_useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./src/components/atoms/InfoFormControl/index.js
var atoms_InfoFormControl = __webpack_require__(96317);
// EXTERNAL MODULE: ./src/components/mocules/DeliveryInfoForm/styles.module.css
var DeliveryInfoForm_styles_module = __webpack_require__(54773);
var DeliveryInfoForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryInfoForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryInfoForm/index.js













var GreenCheckbox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,src_object_spread/* default */.Z)({
        classes: {
            root: (DeliveryInfoForm_styles_module_default()).checkbox
        },
        color: "default"
    }, props));
};
var DeliveryInfoForm = function(param) {
    var handleSetValue = param.handleSetValue, name = param.name, phone = param.phone, address = param.address, setTotalWard = param.setTotalWard, handleChangeCheckbox = param.handleChangeCheckbox, setError = param.setError, manageAddressModalToggle = param.manageAddressModalToggle, customerName = param.customerName, customerEmail = param.customerEmail, customerPhone = param.customerPhone, customerShippingAddress = param.customerShippingAddress, currentAddress = param.currentAddress, handleSetCurrentAddress = param.handleSetCurrentAddress, _isChecked = param.isChecked, isChecked = _isChecked === void 0 ? false : _isChecked, translateCheckout = param.translateCheckout;
    var maxWidthScope = (0,useMediaQuery_useMediaQuery/* default */.Z)("(max-width:600px)");
    // STATUS: PENDING
    var checkBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckbox, {
        checked: isChecked,
        onChange: function(e) {
            return handleChangeCheckbox(e);
        },
        name: "saveInfoShipping"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (DeliveryInfoForm_styles_module_default()).root,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: (DeliveryInfoForm_styles_module_default()).title,
                children: [
                    translateCheckout("shipping_info"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        className: (DeliveryInfoForm_styles_module_default()).add_new_button,
                        onClick: manageAddressModalToggle,
                        "data-test": "btn-checkout-change-address",
                        children: translateCheckout("change_address")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                        xs: 12,
                        isRequired: true,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (DeliveryInfoForm_styles_module_default()).fw500,
                            children: translateCheckout("full_name")
                        }),
                        htmlFor: "customerName",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                            error: name,
                            id: "customerName",
                            placeholder: translateCheckout("first_and_lastname"),
                            value: customerName || "",
                            onChange: function(e) {
                                if (e.target.value !== "") {
                                    setError(true);
                                }
                                handleSetValue("customerName", e.target.value);
                            },
                            "data-test": "input-checkout-customer-name"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        className: (DeliveryInfoForm_styles_module_default()).grid_fix,
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                                xs: maxWidthScope ? 12 : 3,
                                isRequired: true,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (DeliveryInfoForm_styles_module_default()).fw500,
                                    children: translateCheckout("phone_number")
                                }),
                                htmlFor: "customerPhone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    error: phone,
                                    id: "customerPhone",
                                    placeholder: translateCheckout("phone_number"),
                                    value: customerPhone || "",
                                    onChange: function(e) {
                                        return handleSetValue("customerPhone", e.target.value);
                                    },
                                    "data-test": "input-checkout-cusomter-phone"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                                xs: maxWidthScope ? 12 : 9,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (DeliveryInfoForm_styles_module_default()).fw500,
                                    children: translateCheckout("email")
                                }),
                                htmlFor: "customerEmail",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "customerEmail",
                                    placeholder: translateCheckout("email"),
                                    value: customerEmail || "",
                                    onChange: function(e) {
                                        return handleSetValue("customerEmail", e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InfoFormControl/* default */.Z, {
                        xs: 12,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (DeliveryInfoForm_styles_module_default()).fw500,
                            children: translateCheckout("address")
                        }),
                        isRequired: true,
                        htmlFor: "customerShippingAddress",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                            error: address,
                            id: "customerShippingAddress",
                            placeholder: translateCheckout("address"),
                            value: customerShippingAddress || "",
                            onChange: function(e) {
                                if (e.target.value !== "") {
                                    setError(true);
                                }
                                handleSetValue("customerShippingAddress", e.target.value);
                            },
                            "data-test": "input-checkout-customer-address"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                        id: (0,v4/* default */.Z)(),
                        setTotalWard: setTotalWard,
                        currentAddress: currentAddress,
                        handleSetCurrentAddress: handleSetCurrentAddress,
                        style: {
                            margonTop: 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                            control: checkBox,
                            className: (DeliveryInfoForm_styles_module_default()).save_info_cb,
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (DeliveryInfoForm_styles_module_default()).fw500,
                                children: translateCheckout("save_my_info")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryInfoForm = (DeliveryInfoForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl_FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 3 modules
var Radio_Radio = __webpack_require__(79324);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js
var RadioGroup_RadioGroup = __webpack_require__(52541);
// EXTERNAL MODULE: ./src/components/mocules/DeliveryMethod/styles.module.css
var DeliveryMethod_styles_module = __webpack_require__(91618);
var DeliveryMethod_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryMethod_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/DeliveryMethod/index.js
/* eslint-disable react/no-danger */ 













var currentDate = utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(), "YYYYMMDD");
var renderDeliveryMethod = function(param) {
    var item = param.item, addressSelect = param.addressSelect, _totalPrice = param.totalPrice, totalPrice = _totalPrice === void 0 ? 0 : _totalPrice, _productItems = param.productItems, productItems = _productItems === void 0 ? [] : _productItems, _provinces = param.provinces, provinces = _provinces === void 0 ? [] : _provinces, translateCheckout = param.translateCheckout;
    var ref;
    var description = item.description, code = item.code, name = item.name, _condition = item.condition, condition = _condition === void 0 ? {} : _condition, subTitle = item.subTitle, _status = item.status, status = _status === void 0 ? "ON" : _status, _mapLocationFee = item.mapLocationFee, mapLocationFee = _mapLocationFee === void 0 ? {} : _mapLocationFee;
    var _customerDistrictCode = addressSelect.customerDistrictCode, customerDistrictCode = _customerDistrictCode === void 0 ? "0" : _customerDistrictCode, _customerProvinceCode = addressSelect.customerProvinceCode, customerProvinceCode = _customerProvinceCode === void 0 ? "0" : _customerProvinceCode, _customerWardCode = addressSelect.customerWardCode, customerWardCode = _customerWardCode === void 0 ? "0" : _customerWardCode;
    var regionCode = ((ref = provinces.find(function(province) {
        return province.value === customerProvinceCode;
    })) === null || ref === void 0 ? void 0 : ref.regionCode) || "";
    var disable = status !== "ON";
    var message = "";
    var isDisableByDeliveryLocation = false;
    // info
    var isFullLocation = !!mapLocationFee["00"];
    var defaultValue = mapLocationFee["00"] || null;
    var feeValue = mapLocationFee[customerDistrictCode] || mapLocationFee[customerProvinceCode] || mapLocationFee[regionCode] || defaultValue;
    if (isDisableByDeliveryLocation && !isFullLocation) {
        message = translateCheckout("not_in_deliver_region");
        disable = true;
    }
    var label = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                className: (DeliveryMethod_styles_module_default()).fw500,
                children: name
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: subTitle
            }),
            feeValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0(",
                    translateCheckout("plus_more"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                        className: (DeliveryMethod_styles_module_default()).fw500,
                        children: [
                            (0,FormatNumber/* formatCurrency */.xG)(feeValue),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
    // check status
    var maxPrice = condition.maxPrice, minPrice = condition.minPrice, _notSupportYYYYMMDDs = condition.notSupportYYYYMMDDs, notSupportYYYYMMDDs = _notSupportYYYYMMDDs === void 0 ? null : _notSupportYYYYMMDDs, _notSupportLocationCodes = condition.notSupportLocationCodes, notSupportLocationCodes = _notSupportLocationCodes === void 0 ? null : _notSupportLocationCodes, _tags = condition.tags, tags = _tags === void 0 ? null : _tags;
    if (!disable && notSupportYYYYMMDDs && notSupportYYYYMMDDs.indexOf(currentDate) >= 0) {
        disable = true;
        message = translateCheckout("not_support_this_day");
    }
    if (!disable && tags && tags.length > 0 && productItems) {
        productItems.forEach(function(product) {
            if (!disable) {
                disable = !(product.tags && tags.every(function(t) {
                    return product.tags.indexOf(t) >= 0;
                }));
            }
        });
    }
    if (!disable && maxPrice && maxPrice > 0 && totalPrice > maxPrice) {
        disable = true;
        message = translateCheckout("exceeded_allowable_value");
    }
    if (!disable && minPrice && minPrice > 0 && totalPrice < minPrice) {
        message = translateCheckout("lower_than_alloweable_value");
        disable = true;
    }
    if (!disable && notSupportLocationCodes && notSupportLocationCodes.length > 0 && (notSupportLocationCodes.indexOf(regionCode) !== -1 || notSupportLocationCodes.indexOf(customerProvinceCode) !== -1 || notSupportLocationCodes.indexOf(customerDistrictCode) !== -1 || notSupportLocationCodes.indexOf(customerWardCode) !== -1)) {
        message = translateCheckout("not_support_this_area");
        disable = true;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                title: message,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                    value: code,
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                        classes: {
                            root: (0,clsx_m/* default */.Z)((DeliveryMethod_styles_module_default()).checkbox, (DeliveryMethod_styles_module_default()).checkbox_color)
                        },
                        "data-test": "radio-checkout-delivery"
                    }),
                    label: label,
                    disabled: disable
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                className: (DeliveryMethod_styles_module_default()).checkout_description,
                icon: false,
                severity: "info",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DeliveryMethod_styles_module_default()).content,
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                })
            })
        ]
    }, (0,v4/* default */.Z)());
};
var DeliveryMethod = function(param) {
    var handleChange = param.handleChange, deliveryMethods = param.deliveryMethods, selectedValue = param.selectedValue, addressSelect = param.addressSelect, totalPrice = param.totalPrice, productItems = param.productItems, provinces = param.provinces, translateCheckout = param.translateCheckout;
    var ref;
    var selectedVal = selectedValue || ((ref = deliveryMethods[0]) === null || ref === void 0 ? void 0 : ref.code);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (DeliveryMethod_styles_module_default()).root,
        elevation: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (DeliveryMethod_styles_module_default()).title,
                children: translateCheckout("shipping_method")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                component: "fieldset",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
                    value: selectedVal,
                    onChange: handleChange,
                    children: deliveryMethods && deliveryMethods.map(function(item) {
                        return renderDeliveryMethod({
                            item: item,
                            addressSelect: addressSelect,
                            totalPrice: totalPrice,
                            productItems: productItems,
                            provinces: provinces,
                            translateCheckout: translateCheckout
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_DeliveryMethod = (DeliveryMethod);

// EXTERNAL MODULE: ./src/components-v2/atoms/ButtonV2/index.js
var ButtonV2 = __webpack_require__(47554);
// EXTERNAL MODULE: ./src/components/mocules/EditOrderModal/index.js
var EditOrderModal = __webpack_require__(59784);
// EXTERNAL MODULE: ./src/components/mocules/EditOrderButton/styles.module.css
var EditOrderButton_styles_module = __webpack_require__(92929);
var EditOrderButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(EditOrderButton_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/EditOrderButton/index.js




















var EditOrderButton_EditOrderButton = function(param) {
    var orderId = param.orderId, canEdit = param.canEdit, _btnStyle = param.btnStyle, btnStyle = _btnStyle === void 0 ? false : _btnStyle, btnText = param.btnText, _newUI = param.newUI, newUI = _newUI === void 0 ? false : _newUI, _activeBtnStyle = param.activeBtnStyle, activeBtnStyle = _activeBtnStyle === void 0 ? "" : _activeBtnStyle, _disableBtnStyle = param.disableBtnStyle, disableBtnStyle = _disableBtnStyle === void 0 ? "" : _disableBtnStyle;
    var ref = (0,esm/* useTranslation */.$G)("myOrder"), translateMyOrder = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref1.t;
    var ref2 = (0,react.useState)(false), val = ref2[0], setVal = ref2[1];
    var router = (0,next_router.useRouter)();
    var updateCart = (0,context/* useCart */.jD)().updateCart;
    var user = (0,context/* useAuth */.aC)().user;
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var getSellerByCodeSync = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCodeSync;
    });
    var handleChangeVal = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setVal(!val);
    };
    var handleClickOk = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, orderRes, _tmp, orderDetail, res, _tmp1, promiseAllSellerInfo, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        _tmp = {};
                        return [
                            4,
                            services/* OrderService.getOrderDetail */.px.getOrderDetail((_tmp.orderId = orderId, _tmp.getCombo = false, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp))
                        ];
                    case 1:
                        orderRes = _state.sent();
                        if (!(0,clients/* isValid */.JY)(orderRes)) {
                            return [
                                2
                            ];
                        }
                        orderDetail = (0,clients/* getFirst */.Xi)(orderRes);
                        _tmp1 = {};
                        return [
                            4,
                            services/* OrderService.deleteOrder */.px.deleteOrder((_tmp1.orderId = orderId, _tmp1))
                        ];
                    case 2:
                        res = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(res)) {
                            utils/* NotifyUtils.error */.QP.error((res === null || res === void 0 ? void 0 : res.message) || translateAlertAction("message_error_try_again"));
                            return [
                                2
                            ];
                        }
                        promiseAllSellerInfo = orderDetail === null || orderDetail === void 0 ? void 0 : (ref = orderDetail.products) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var productInfo = param.productInfo;
                            return getSellerByCode({
                                code: productInfo === null || productInfo === void 0 ? void 0 : productInfo.sellerCode
                            });
                        });
                        return [
                            4,
                            Promise.all(promiseAllSellerInfo)
                        ];
                    case 3:
                        _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        utils/* gtag.refund */.SX.refund((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp2, orderDetail), (_tmp3.products = (orderDetail === null || orderDetail === void 0 ? void 0 : (ref1 = orderDetail.products) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                            var _productInfo = param.productInfo, productInfo = _productInfo === void 0 ? {} : _productInfo, _price = param.price, price = _price === void 0 ? 0 : _price, _quantity = param.quantity, quantity = _quantity === void 0 ? 0 : _quantity;
                            return {
                                name: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.name) || "",
                                displayPrice: price || 0,
                                productId: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productId) || 0,
                                quantity: quantity,
                                sellerInfo: getSellerByCodeSync({
                                    code: productInfo === null || productInfo === void 0 ? void 0 : productInfo.sellerCode
                                })
                            };
                        })) || [], _tmp3)));
                        updateCart();
                        if ((orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.paymentMethod) === Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT) {
                            setTimeout(function() {
                                router.push(Paths/* CART_URL */.fh);
                            }, 2000);
                        } else {
                            router.push(Paths/* CART_URL */.fh);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickOk(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // const classNameBtn = canEdit ? "my-order__button my-order__button--green" : "my-order__button my-order__button--green"
    if (newUI) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    className: canEdit ? activeBtnStyle : disableBtnStyle,
                    onClick: handleChangeVal,
                    disabled: !canEdit,
                    "data-test": "btn-edit-order",
                    children: btnText || translateMyOrder("btn_edit_order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOrderModal/* default */.Z, {
                    visible: val,
                    onClose: handleChangeVal,
                    onClickOk: handleClickOk
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            btnStyle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                className: canEdit ? (EditOrderButton_styles_module_default()).editBtn : (EditOrderButton_styles_module_default()).disableBtn,
                onClick: handleChangeVal,
                disabled: !canEdit,
                "data-test": "btn-edit-order",
                children: btnText || translateMyOrder("btn_edit_order")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonV2/* default */.Z, {
                className: btnStyle ? (EditOrderButton_styles_module_default()).editBtn : (EditOrderButton_styles_module_default()).order_edit_btn,
                onClick: handleChangeVal,
                disabled: !canEdit,
                "data-test": "btn-edit-order",
                children: btnText || translateMyOrder("btn_edit_order")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOrderModal/* default */.Z, {
                visible: val,
                onClose: handleChangeVal,
                onClickOk: handleClickOk
            })
        ]
    });
};
/* harmony default export */ var mocules_EditOrderButton = (/*#__PURE__*/react.memo(EditOrderButton_EditOrderButton));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment_InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem_MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 1 modules
var Select = __webpack_require__(55296);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var icons_Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./src/components/mocules/FloatSearch/styles.module.css
var FloatSearch_styles_module = __webpack_require__(90124);
var FloatSearch_styles_module_default = /*#__PURE__*/__webpack_require__.n(FloatSearch_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/FloatSearch/index.js



function FloatSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: 40px !important;\n  background: #ffffff;\n  color: #606060;\n  z-index: 1;\n  border-radius: 8px 0px 0px 8px;\n  margin: 0;\n  border-right: 1.2px solid #e8e9f8;\n  &.Mui-focused {\n    z-index: 4;\n    border-right: 1.2px solid #e8e9f8 !important;\n    border-color: transparent;\n  }\n"
    ]);
    FloatSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: 40px !important;\n  background: #ffffff;\n  color: #606060;\n  z-index: 1;\n  border-radius: 0px 8px 8px 0px;\n  margin: 0;\n  width: 100%;\n  border: none;\n  & .MuiSelect-select {\n    padding-left: 5px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var IngredientInput = function(_param) /*#__PURE__*/ {
    var className = _param.className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
        className: className
    }, rest));
};
var StyledIngredientInput = (0,styled_components_browser_esm/* default */.ZP)(IngredientInput).withConfig({
    componentId: "sc-81cc0e0e-0"
})(FloatSearch_templateObject());
var StyledMedicineTypeSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-81cc0e0e-1"
})(_templateObject1());
var CloseButton = function(param) {
    var handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
        onClick: handleClose
    });
};
var FloatSearch = function(param) {
    var value = param.value, handleChangeValue = param.handleChangeValue, handleClose = param.handleClose, placeholder = param.placeholder, isMobile = param.isMobile;
    var ref;
    var ref1 = (0,esm/* useTranslation */.$G)("ingredients"), translateIngredients = ref1.t;
    var router = (0,next_router.useRouter)();
    var handleKeyPress = function(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            event.target.blur();
        }
    };
    var medicineTypes = [
        {
            label: translateIngredients("medicine"),
            value: "medicine"
        },
        {
            label: translateIngredients("non_medicine"),
            value: "notmedicine"
        }, 
    ];
    var handleChangeType = function(e) {
        router.push("".concat(router.pathname, "?type=").concat(e.target.value));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((FloatSearch_styles_module_default()).searchBox, isMobile && (FloatSearch_styles_module_default()).mobileSearchBox),
        container: true,
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                item: true,
                xs: 9,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIngredientInput, {
                    fullWidth: true,
                    placeholder: placeholder,
                    value: value,
                    onChange: handleChangeValue,
                    onKeyPress: handleKeyPress,
                    endAdornment: value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        handleClose: handleClose
                    }) : null,
                    startAdornment: // eslint-disable-next-line react/jsx-wrap-multilines
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
                        position: "start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {})
                    }),
                    className: (FloatSearch_styles_module_default()).searchInput
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                item: true,
                xs: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedicineTypeSelect, {
                    labelId: "demo-simple-select-label",
                    id: "demo-simple-select",
                    value: (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.type) || medicineTypes[0].value,
                    onChange: handleChangeType,
                    disableUnderline: true,
                    children: medicineTypes.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                            value: option.value,
                            children: option.label
                        }, option.value);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_FloatSearch = (FloatSearch);

// EXTERNAL MODULE: ./src/components/mocules/ForgetPasswordForm/styles.module.css
var ForgetPasswordForm_styles_module = __webpack_require__(52200);
var ForgetPasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(ForgetPasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordForm/ForgetPasswordForm.js








var ForgetPasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickPhoneForm = param.onClickPhoneForm, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, onTimeout = param.onTimeout, isTimeOut = param.isTimeOut, setIsTimeOut = param.setIsTimeOut, toggleResend = param.toggleResend, onClose = param.onClose;
    var toggleLogin = (0,context/* useAuth */.aC)().toggleLogin;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var regExpOpt = /^.{6,6}$/;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var SECOND_TIMEOUT = 180;
    var ref = (0,react.useState)(false), phoneValue = ref[0], setPhoneValue = ref[1];
    var ref1 = (0,react.useState)(false), errorPhone = ref1[0], setErrorPhone = ref1[1];
    var ref2 = (0,react.useState)(""), errorPhoneMessage = ref2[0], setErrorPhoneMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorOtp = ref3[0], setErrorOtp = ref3[1];
    var ref4 = (0,react.useState)(""), errorOtpMessage = ref4[0], setErrorOtpMessage = ref4[1];
    var ref5 = (0,react.useState)(""), pwValue = ref5[0], setPwValue = ref5[1];
    var ref6 = (0,react.useState)(false), errorPw = ref6[0], setErrorPw = ref6[1];
    var ref7 = (0,react.useState)(""), errorPwMessage = ref7[0], setErrorPwMessage = ref7[1];
    var ref8 = (0,react.useState)(false), errorPwConfirm = ref8[0], setErrorPwConfirm = ref8[1];
    var ref9 = (0,react.useState)(""), errorPwConfirmMessage = ref9[0], setErrorPwConfirmMessage = ref9[1];
    var ref10 = (0,react.useState)(-1), second = ref10[0], setSecond = ref10[1];
    var handleLoginFunc = function() {
        onClose();
        toggleLogin();
    };
    // handle validate
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    var validateOtp = function(data) {
        setErrorOtp(false);
        if (data === "") {
            setErrorOtp(true);
            setErrorOtpMessage("Vui l\xf2ng nhập m\xe3 OTP");
            return false;
        }
        if (!data.match(regExpOpt)) {
            setErrorOtp(true);
            setErrorOtpMessage("M\xe3 OTP gồm 6 chữ số");
            return false;
        }
        return true;
    };
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage("Bạn chưa điền mật khẩu");
            return false;
        }
        if (data.length > 30 || data.length < 2) {
            setErrorPw(true);
            setErrorPwMessage("Mật khẩu tối thiểu 2 v\xe0 tối đa 30 k\xed tự");
            return false;
        }
        return true;
    };
    var validatePwConfirm = function(data) {
        setErrorPwConfirm(false);
        if (data === "") {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage("Bạn chưa điền mật khẩu x\xe1c nhận");
            return false;
        }
        if (data !== pwValue) {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage("Mật khẩu x\xe1c nhận kh\xf4ng khớp");
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitPhoneForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        setPhoneValue(data.phoneNumber);
        if (!validatePhone(data.phoneNumber)) {
            return;
        }
        // data type is customer on web
        data.type = "CUSTOMER";
        onClickPhoneForm(data);
    };
    var onSubmitNewPasswordForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        if (!validateOtp(data.token)) {
            return;
        }
        if (!validatePw(data.newPassword) || !validatePwConfirm(data.confirmPassword)) {
            return;
        }
        delete data.confirmPassword;
        // data type is customer on web
        data.type = "CUSTOMER";
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePhone = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    var handleOnChangeOpt = function(e) {
        e.preventDefault();
        validateOtp(e.target.value);
    };
    var handleOnChangePw = function(e) {
        e.preventDefault();
        setPwValue(e.target.value);
        validatePw(e.target.value);
    };
    var handleOnChangePwConfirm = function(e) {
        e.preventDefault();
        validatePwConfirm(e.target.value);
    };
    var startCoundown = function(time) {
        setSecond(time);
        setIsTimeOut(false);
    };
    var onResend = function() {
        startCoundown(SECOND_TIMEOUT);
        onClickPhoneForm({
            phoneNumber: phoneValue,
            type: "CUSTOMER"
        });
    };
    (0,react.useEffect)(function() {
        if (step === 2) {
            startCoundown(SECOND_TIMEOUT);
        }
    }, [
        toggleResend
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (second > 0 && second !== -1) {
                setSecond(second - 1);
            // setMinute(Math.floor(second / 60));
            }
            if (second === 0) {
                onTimeout();
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return function() {
            return clearTimeout(timer);
        };
    }, [
        second
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "Nhập số điện thoại cần kh\xf4i phục"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "form-forget-password ".concat(className),
                        onSubmit: onSubmitPhoneForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "phoneNumber",
                                        name: "phoneNumber",
                                        type: "number",
                                        placeholder: "Nhập số điện thoại",
                                        variant: "outlined",
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        error: errorPhone,
                                        onChange: handleOnChangePhone
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPhone && errorPhoneMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: "btnForgetPassword",
                                    color: "white",
                                    children: "Gửi"
                                })
                            })
                        ]
                    })
                ]
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc",
                        children: "Nhập m\xe3 OTP v\xe0 mật khẩu mới"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "form-forget-password ".concat(className),
                        onSubmit: onSubmitNewPasswordForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "phoneNumber",
                                    name: "phoneNumber",
                                    type: "number",
                                    placeholder: "Nhập số điện thoại",
                                    variant: "outlined",
                                    className: [
                                        (ForgetPasswordForm_styles_module_default()).input,
                                        (ForgetPasswordForm_styles_module_default()).disabled
                                    ],
                                    value: phoneValue,
                                    inputProps: {
                                        readOnly: true
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).custom_field,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                                className: (ForgetPasswordForm_styles_module_default()).input,
                                                id: "token",
                                                name: "token",
                                                text: "text",
                                                placeholder: "Nhập m\xe3 OTP",
                                                variant: "outlined",
                                                error: errorOtp,
                                                onChange: handleOnChangeOpt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ForgetPasswordForm_styles_module_default()).right_c,
                                                children: !isTimeOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ForgetPasswordForm_styles_module_default()).remaining,
                                                    children: second
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                    className: "btnForgetPassword",
                                                    color: "white",
                                                    onClick: onResend,
                                                    children: "Gửi lại"
                                                })
                                            })
                                        ]
                                    }),
                                    errorOtp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorOtpMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "newPassword",
                                        name: "newPassword",
                                        type: "password",
                                        placeholder: "Nhập mật khẩu mới",
                                        variant: "outlined",
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        error: errorPw,
                                        onChange: handleOnChangePw
                                    }),
                                    errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPwMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "confirmPassword",
                                        name: "confirmPassword",
                                        type: "password",
                                        placeholder: "X\xe1c nhận lại mật khẩu",
                                        variant: "outlined",
                                        error: errorPwConfirm,
                                        className: (ForgetPasswordForm_styles_module_default()).input,
                                        onChange: handleOnChangePwConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordForm_styles_module_default()).error,
                                        children: errorPwConfirm && errorPwConfirmMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "action",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: "btnForgetPassword",
                                    color: "white",
                                    children: "Gửi"
                                })
                            })
                        ]
                    })
                ]
            }),
            (step === 3 || step === 4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ForgetPasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (ForgetPasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (ForgetPasswordForm_styles_module_default()).modal_title,
                                    children: "Thay đổi mật khẩu th\xe0nh c\xf4ng"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordForm_styles_module_default()).btngroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonHeader */.X9, {
                            variant: "contained",
                            btnType: "primary",
                            onClick: handleLoginFunc,
                            children: "Đăng nhập"
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var ForgetPasswordForm_ForgetPasswordForm = (ForgetPasswordForm);

;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordForm/index.js

function ForgetPasswordForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .form-forget-password {\n    margin-top: 10px;\n  }\n\n  .form-control {\n    width: ",
        "px;\n    margin-bottom: 10px;\n  }\n\n  .btnForgetPassword {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    border-radius: 50px;\n  }\n  .action {\n    margin-top: 10px;\n    max-width: 200px;\n    width: 100%;\n  }\n  .desc {\n    font-size: 16px;\n    margin: 15px auto;\n    max-width: 450px;\n  }\n  .forget-password {\n    width: 100%;\n  }\n"
    ]);
    ForgetPasswordForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var styledForgetPasswordForm = (0,styled_components_browser_esm/* default */.ZP)(ForgetPasswordForm_ForgetPasswordForm).withConfig({
    componentId: "sc-c146e701-0"
})(ForgetPasswordForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 450 : _width;
    return width;
});
/* harmony default export */ var mocules_ForgetPasswordForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(styledForgetPasswordForm))));

// EXTERNAL MODULE: ./src/components-v2/atoms/PasswordWarningText/index.js
var PasswordWarningText = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/react-countdown-circle-timer/lib/index.js
var react_countdown_circle_timer_lib = __webpack_require__(7907);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/components/mocules/CircleTimer/styles.module.css
var CircleTimer_styles_module = __webpack_require__(7867);
var CircleTimer_styles_module_default = /*#__PURE__*/__webpack_require__.n(CircleTimer_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/CircleTimer/index.js




var RenderTime = function(param) {
    var remainingTime = param.remainingTime;
    var t = (0,es/* useTranslation */.$G)("common").t;
    if (remainingTime === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CircleTimer_styles_module_default()).timer,
            children: t("expire")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CircleTimer_styles_module_default()).timer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CircleTimer_styles_module_default()).value,
            children: remainingTime
        })
    });
};
var CircleTimer = function(param) {
    var duration = param.duration;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_countdown_circle_timer_lib.CountdownCircleTimer, {
        isPlaying: true,
        duration: duration,
        size: 80,
        strokeWidth: 8,
        colors: [
            [
                "#005C29",
                0.4
            ],
            [
                "#3cb56b",
                0.35
            ],
            [
                "#9ac100",
                0.25
            ], 
        ],
        children: RenderTime
    });
};
/* harmony default export */ var mocules_CircleTimer = (CircleTimer);

// EXTERNAL MODULE: ./src/components/mocules/ForgetPasswordFormV2/styles.module.css
var ForgetPasswordFormV2_styles_module = __webpack_require__(69470);
var ForgetPasswordFormV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(ForgetPasswordFormV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ForgetPasswordFormV2/index.js











var ForgetPasswordFormV2 = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickPhoneForm = param.onClickPhoneForm, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, onTimeout = param.onTimeout, isTimeOut = param.isTimeOut, setIsTimeOut = param.setIsTimeOut, toggleResend = param.toggleResend, onClose = param.onClose, translatePopupAction = param.translatePopupAction;
    var toggleLogin = (0,context/* useAuth */.aC)().toggleLogin;
    var regExp = /^([0-9]{6,10})\b/;
    var regExpOpt = /^.{6,6}$/;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var SECOND_TIMEOUT = 60 * 3; // 5 minutes -> change to 3 minutes
    var ref = (0,react.useState)(false), phoneValue = ref[0], setPhoneValue = ref[1];
    var ref1 = (0,react.useState)(false), errorPhone = ref1[0], setErrorPhone = ref1[1];
    var ref2 = (0,react.useState)(""), errorPhoneMessage = ref2[0], setErrorPhoneMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorOtp = ref3[0], setErrorOtp = ref3[1];
    var ref4 = (0,react.useState)(""), errorOtpMessage = ref4[0], setErrorOtpMessage = ref4[1];
    var ref5 = (0,react.useState)(""), pwValue = ref5[0], setPwValue = ref5[1];
    var ref6 = (0,react.useState)(false), errorPw = ref6[0], setErrorPw = ref6[1];
    var ref7 = (0,react.useState)(""), errorPwMessage = ref7[0], setErrorPwMessage = ref7[1];
    var ref8 = (0,react.useState)(false), errorPwConfirm = ref8[0], setErrorPwConfirm = ref8[1];
    var ref9 = (0,react.useState)(""), errorPwConfirmMessage = ref9[0], setErrorPwConfirmMessage = ref9[1];
    var ref10 = (0,react.useState)(0), second = ref10[0], setSecond = ref10[1];
    var handleLoginFunc = function() {
        onClose();
        toggleLogin();
    };
    // handle validate
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage(translatePopupAction("forgetpassword_step2.entered_numberPhone"));
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage(translatePopupAction("popup-trial-account.error_wrong_format_phone_number"));
            return false;
        }
        return true;
    };
    var validateOtp = function(data) {
        setErrorOtp(false);
        if (data === "") {
            setErrorOtp(true);
            setErrorOtpMessage(translatePopupAction("forgetpassword_step2.enter_otp"));
            return false;
        }
        if (!data.match(regExpOpt)) {
            setErrorOtp(true);
            setErrorOtpMessage(translatePopupAction("forgetpassword_step2.opt_have_6_num"));
            return false;
        }
        return true;
    };
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup_login.validate_password_empty"));
            return false;
        }
        if (data.length > 30 || data.length < 8) {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.password_must_be_entered_min2_and_max30_character"));
            return false;
        }
        return true;
    };
    var validatePwConfirm = function(data) {
        setErrorPwConfirm(false);
        if (data === "") {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage(translatePopupAction("forgetpassword_step2.enter_confirm_password"));
            return false;
        }
        if (data !== pwValue) {
            setErrorPwConfirm(true);
            setErrorPwConfirmMessage(translatePopupAction("forgetpassword_step2.wrong_confirm_password"));
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitPhoneForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        setPhoneValue(data.phoneNumber);
        if (!validatePhone(data.phoneNumber)) {
            return;
        }
        // data type is customer on web
        data.type = "CUSTOMER";
        data.setErrorPhone = function() {
            return setErrorPhone(true);
        };
        data.setErrorPhoneMessage = function() {
            return setErrorPhoneMessage(translatePopupAction("popup-trial-account.error_wrong_format_phone_number"));
        };
        onClickPhoneForm(data);
    };
    var onSubmitNewPasswordForm = function(e) {
        e.preventDefault();
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        if (!validateOtp(data.token)) {
            return;
        }
        if (!validatePw(data.newPassword) || !validatePwConfirm(data.confirmPassword)) {
            return;
        }
        delete data.confirmPassword;
        // data type is customer on web
        data.type = "CUSTOMER";
        data.setErrorOtp = function() {
            return setErrorOtp(true);
        };
        data.setErrorOtpMessage = function() {
            return setErrorOtpMessage(translatePopupAction("change-password.err_entered_OTP"));
        };
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePhone = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    var handleOnChangeOpt = function(e) {
        e.preventDefault();
        validateOtp(e.target.value);
    };
    var handleOnChangePw = function(e) {
        e.preventDefault();
        setPwValue(e.target.value);
        validatePw(e.target.value);
    };
    var handleOnChangePwConfirm = function(e) {
        e.preventDefault();
        validatePwConfirm(e.target.value);
    };
    var startCoundown = function(time) {
        setSecond(time);
        setIsTimeOut(false);
    };
    var onResend = function() {
        startCoundown(SECOND_TIMEOUT);
        onClickPhoneForm({
            phoneNumber: phoneValue,
            type: "CUSTOMER"
        });
    };
    (0,react.useEffect)(function() {
        if (step === 2) {
            startCoundown(SECOND_TIMEOUT);
        }
    }, [
        toggleResend
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (second > 0) {
                setSecond(second - 1);
            // setMinute(Math.floor(second / 60));
            }
            if (second === 0) {
                onTimeout();
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return function() {
            return clearTimeout(timer);
        };
    }, [
        second
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).desc,
                        children: translatePopupAction("forgetpassword.sub_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: className,
                        onSubmit: onSubmitPhoneForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "phoneNumber",
                                        name: "phoneNumber",
                                        placeholder: translatePopupAction("forgetpassword.description"),
                                        variant: "outlined",
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        error: errorPhone,
                                        onChange: handleOnChangePhone
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPhone && errorPhoneMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordWarningText/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).mb_10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    children: translatePopupAction("forgetpassword.send")
                                })
                            })
                        ]
                    })
                ]
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).desc,
                        children: translatePopupAction("forgetpassword_step2.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: className,
                        onSubmit: onSubmitNewPasswordForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ForgetPasswordFormV2_styles_module_default()).timing_wrapper,
                                children: !isTimeOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CircleTimer, {
                                        duration: second
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    onClick: onResend,
                                    children: translatePopupAction("forgetpassword_step2.send")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "phoneNumber",
                                    name: "phoneNumber",
                                    type: "number",
                                    placeholder: translatePopupAction("forgetpassword_step2.entered_numberPhone"),
                                    variant: "outlined",
                                    className: [
                                        (ForgetPasswordFormV2_styles_module_default()).input,
                                        (ForgetPasswordFormV2_styles_module_default()).disabled
                                    ],
                                    value: phoneValue,
                                    inputProps: {
                                        readOnly: true
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        id: "token",
                                        name: "token",
                                        text: "text",
                                        placeholder: translatePopupAction("forgetpassword_step2.enter_otp"),
                                        variant: "outlined",
                                        error: errorOtp,
                                        onChange: handleOnChangeOpt
                                    }),
                                    errorOtp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorOtpMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "newPassword",
                                        name: "newPassword",
                                        type: "password",
                                        placeholder: translatePopupAction("forgetpassword_step2.enter_new_password"),
                                        variant: "outlined",
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        error: errorPw,
                                        onChange: handleOnChangePw
                                    }),
                                    errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPwMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                        id: "confirmPassword",
                                        name: "confirmPassword",
                                        type: "password",
                                        placeholder: translatePopupAction("forgetpassword_step2.confirm_password"),
                                        variant: "outlined",
                                        error: errorPwConfirm,
                                        className: (ForgetPasswordFormV2_styles_module_default()).input,
                                        onChange: handleOnChangePwConfirm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ForgetPasswordFormV2_styles_module_default()).error,
                                        children: errorPwConfirm && errorPwConfirmMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (ForgetPasswordFormV2_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    className: (ForgetPasswordFormV2_styles_module_default()).btn,
                                    children: translatePopupAction("forgetpassword.confirm_reset_password")
                                })
                            })
                        ]
                    })
                ]
            }),
            (step === 3 || step === 4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ForgetPasswordFormV2_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ForgetPasswordFormV2_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (ForgetPasswordFormV2_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (ForgetPasswordFormV2_styles_module_default()).modal_title,
                                    children: translatePopupAction("forgetpassword_step3.changePassword_success")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        className: (ForgetPasswordFormV2_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            className: (ForgetPasswordFormV2_styles_module_default()).btn,
                            onClick: handleLoginFunc,
                            children: translatePopupAction("forgetpassword_step3.login")
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_ForgetPasswordFormV2 = (ForgetPasswordFormV2);

;// CONCATENATED MODULE: ./src/components/mocules/HeaderUser/HeaderUser.js






var HeaderUser = /*#__PURE__*/ react.memo(function(props) {
    var user = props.user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "header_user",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header_user_name",
                children: (user === null || user === void 0 ? void 0 : user.name) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header_user_avatar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                    href: Paths/* MY_ACCOUNT */.RX,
                    padding: "0px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.ZP, {
                        title: "Th\xf4ng tin t\xe0i khoản",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "header_user_avatar_image",
                                src: "/images/avatar/user_avatar_default.svg",
                                width: 39,
                                height: 39
                            })
                        })
                    })
                })
            })
        ]
    });
});
/* harmony default export */ var HeaderUser_HeaderUser = (HeaderUser);

;// CONCATENATED MODULE: ./src/components/mocules/HeaderUser/index.js

function HeaderUser_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    HeaderUser_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledHeaderUser = (0,styled_components_browser_esm/* default */.ZP)(HeaderUser_HeaderUser).withConfig({
    componentId: "sc-b8e0454c-0"
})(HeaderUser_templateObject());
/* harmony default export */ var mocules_HeaderUser = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(StyledHeaderUser))));

// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
;// CONCATENATED MODULE: ./src/components/mocules/InfoTabs/index.js













var InfoTabs = function(param) {
    var value = param.value, name = param.name;
    var ref;
    var ref1 = useTranslation("common"), translateCommon = ref1.t;
    var tabs = [
        {
            label: translateCommon("tab_menu.my_account"),
            icon: /*#__PURE__*/ _jsx(USER, {}),
            id: 1,
            link: "/my-account",
            enable: true
        },
        // { label: 'Thông tin cấp bậc', icon: <LEVEL />, id: 2, link: '/user/level', enable: FEATURE_LEVEL },
        {
            label: translateCommon("tab_menu.my_points"),
            icon: /*#__PURE__*/ _jsx(POINTS, {}),
            id: 8,
            link: "/users/loyalty_points",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_orders"),
            icon: /*#__PURE__*/ _jsx(ORDER, {}),
            id: 3,
            link: "/my-order",
            enable: true
        },
        {
            label: translateCommon("tab_menu.statistics"),
            icon: /*#__PURE__*/ _jsx(STATISTICAL, {}),
            id: 4,
            link: "/user/dashboard",
            enable: true
        },
        {
            label: translateCommon("tab_menu.refer_friends"),
            icon: /*#__PURE__*/ _jsx(REFER, {}),
            id: 5,
            link: "/users/referrals",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_discount"),
            icon: /*#__PURE__*/ _jsx(VOUCHER, {}),
            id: 6,
            link: "/users/user-promo-codes",
            enable: true
        },
        {
            label: translateCommon("tab_menu.my_feedback"),
            icon: /*#__PURE__*/ _jsx(FEEDBACK, {}),
            id: 7,
            link: "/users/my-ticket",
            enable: true
        },
        {
            label: translateCommon("tab_menu.bill_of_lading_lookup"),
            icon: /*#__PURE__*/ _jsx(BILL, {}),
            id: 9,
            link: "https://tracuu.thuocsi.vn",
            enable: ENV_COUNTRY === "vn"
        },
        {
            label: translateCommon("tab_menu.qr_code_lookup"),
            icon: /*#__PURE__*/ _jsx(QR, {}),
            id: 10,
            link: "/qr",
            enable: true
        },
        {
            label: translateCommon("interested_products"),
            icon: /*#__PURE__*/ _jsx(WISHLIST, {}),
            id: 11,
            link: "/user/wishlist",
            enable: true
        },
        {
            label: translateCommon("viewed_products"),
            icon: /*#__PURE__*/ _jsx(VIEWED, {}),
            id: 12,
            link: "/productviewed",
            enable: true
        }, 
    ];
    var user = useAuth().user;
    var ref2 = user || {}, _level = ref2.level, level = _level === void 0 ? "" : _level;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.tab_box,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.account_name,
                children: [
                    translateCommon("tab_menu.account_of"),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        className: styles.name,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuList, {
                children: (ref = tabs === null || tabs === void 0 ? void 0 : tabs.filter(function(item) {
                    return item.enable;
                })) === null || ref === void 0 ? void 0 : ref.map(function(tab) {
                    return (level !== "LEVEL_BLACKLIST" || tab.id !== 2) && /*#__PURE__*/ _jsx(LinkComp, {
                        href: tab.link,
                        prefetch: false,
                        children: /*#__PURE__*/ _jsxs(MenuItem, {
                            button: false,
                            classes: {
                                root: value === tab.id ? styles.tab_active : styles.tab_inactive
                            },
                            value: tab.id,
                            onClick: function() {
                                if ((tab === null || tab === void 0 ? void 0 : tab.link) === "https://tracuu.thuocsi.vn") {
                                    gtag.clickTrackingOrder();
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx(ListItemIcon, {
                                    children: tab.icon
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "inherit",
                                    children: tab.label
                                })
                            ]
                        })
                    }, "tab-".concat(uuidv4()));
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_InfoTabs = ((/* unused pure expression or super */ null && (InfoTabs)));

// EXTERNAL MODULE: ./src/components/mocules/InvoiceCheckout/styles.module.css
var InvoiceCheckout_styles_module = __webpack_require__(91066);
var InvoiceCheckout_styles_module_default = /*#__PURE__*/__webpack_require__.n(InvoiceCheckout_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/InvoiceCheckout/index.js
/* eslint-disable react/jsx-wrap-multilines */ 























var DEFAULT_INVOICE_INFO = {
    code: "",
    companyName: "",
    companyAddress: "",
    taxCode: "",
    postCode: "",
    province: "",
    district: "",
    ward: "",
    streetAddress: ""
};
var invoiceInfoOtherID = (0,v4/* default */.Z)();
var InvoiceCheckout = function(param) {
    var _invoiceInfoList = param.invoiceInfoList, invoiceInfoList = _invoiceInfoList === void 0 ? [] : _invoiceInfoList, handleSetAllInvoice = param.handleSetAllInvoice, _invoice = param.invoice, invoice = _invoice === void 0 ? {} : _invoice, translateCheckout = param.translateCheckout, currentAddress = param.currentAddress, cart = param.cart, customerShippingAddress = param.customerShippingAddress, error = param.error, setError = param.setError;
    var ref = invoice || {}, _companyAddress = ref.companyAddress, companyAddress = _companyAddress === void 0 ? "" : _companyAddress, _companyName = ref.companyName, companyName = _companyName === void 0 ? "" : _companyName, _mst = ref.mst, mst = _mst === void 0 ? "" : _mst, _taxCode = ref.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode; // invoice from cart info
    var invoiceInfoDefault = invoiceInfoList && invoiceInfoList[0] && invoiceInfoList[0].code || invoiceInfoOtherID;
    var ref1 = (0,react.useState)({
        province: "",
        district: "",
        ward: "",
        changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED
    }), invoiceAddress = ref1[0], setInvoiceAddress = ref1[1];
    var ref2 = (0,react.useState)(invoiceInfoDefault), invoiceInfoSelected = ref2[0], setInvoiceInfoSelected = ref2[1];
    var ref3 = (0,react.useState)(false), isCheckedRequestInvoice = ref3[0], setIsCheckedRequestInvoice = ref3[1];
    var ref4 = (0,react.useState)(false), showInvoiceInfo = ref4[0], setShowInvoiceInfo = ref4[1];
    var isInvoiceInfoOther = invoiceInfoSelected === invoiceInfoOtherID;
    var customerInfo = (0,context/* useAuth */.aC)().customerInfo;
    var email = (customerInfo || {}).email;
    (0,react.useEffect)(function() {
        // Find invoice base on invoice cart info
        var invoiceInfo = invoiceInfoList.find(function(item) {
            return item.companyAddress === companyAddress && item.companyName === companyName && (mst || taxCode) === item.taxCode;
        });
        if (invoiceInfo && invoiceInfo.code) {
            setInvoiceInfoSelected(invoiceInfo.code);
        } else {
            setInvoiceInfoSelected(invoiceInfoOtherID);
        }
    }, []);
    // The saved invoice info owns its post code. The cart's post code only fills in when
    // that invoice info has none and it is the one the cart is using.
    var getInvoicePostCode = function(info) {
        if (info === null || info === void 0 ? void 0 : info.postCode) return info.postCode;
        var cartInvoice = (cart === null || cart === void 0 ? void 0 : cart.invoice) || {};
        var isCartInvoice = (info === null || info === void 0 ? void 0 : info.companyAddress) === cartInvoice.companyAddress && (info === null || info === void 0 ? void 0 : info.companyName) === cartInvoice.companyName && (cartInvoice.mst || cartInvoice.taxCode) === (info === null || info === void 0 ? void 0 : info.taxCode);
        return isCartInvoice && cartInvoice.postCode || "";
    };
    var handleChangeInvoiceInfoSelected = function(e) {
        var _target = e.target, _value = _target.value, value = _value === void 0 ? invoiceInfoOtherID : _value;
        setInvoiceInfoSelected(value);
        if (value !== invoiceInfoOtherID) {
            var info = invoiceInfoList.find(function(item) {
                return item.code === value;
            });
            handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                invoiceRequest: true,
                isUseCustom: false
            }, info), {
                postCode: getInvoicePostCode(info)
            }));
        } else {
            handleSetAllInvoice((0,src_object_spread/* default */.Z)({
                invoiceRequest: true,
                isUseCustom: true
            }, DEFAULT_INVOICE_INFO));
        }
    };
    // {} === {} -> false || new Set array like obj with JSON.
    var uniqueInvoiceList = (0,_to_consumable_array/* default */.Z)(new Set(invoiceInfoList === null || invoiceInfoList === void 0 ? void 0 : invoiceInfoList.map(JSON.stringify))).map(JSON.parse);
    var handleChangeCheckboxRequestInvoice = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            var isRequestInvoice, resFullAddress, _tmp, newFullAddress, _tmp1, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRequestInvoice = event.target.value === "true";
                        setIsCheckedRequestInvoice(event.target.value);
                        setShowInvoiceInfo(isRequestInvoice);
                        setInvoiceInfoSelected(null);
                        setError("invoiceRequest", false);
                        _tmp = {};
                        return [
                            4,
                            AddressService/* default.getMasterAddressObject */.Z.getMasterAddressObject((_tmp.ctx = null, _tmp.provinceCode = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.province, _tmp.districtCode = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.district, _tmp.wardCode = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.ward, _tmp))
                        ];
                    case 1:
                        resFullAddress = _state.sent();
                        newFullAddress = "".concat(customerShippingAddress, ", ").concat(resFullAddress.ward, ", ").concat(resFullAddress.district, ", ").concat(resFullAddress.province);
                        _tmp1 = {};
                        _tmp2 = {};
                        _tmp3 = {};
                        if (!isRequestInvoice) {
                            handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp1, DEFAULT_INVOICE_INFO), (_tmp2.invoiceRequest = false, _tmp2.companyName = cart === null || cart === void 0 ? void 0 : cart.customerName, _tmp2.companyAddress = newFullAddress, _tmp2)));
                        } else {
                            handleChangeInvoiceInfoSelected((_tmp3.target = {
                                value: invoiceInfoDefault
                            }, _tmp3));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeCheckboxRequestInvoice(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetCurrentAddress = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(address) {
            var _tmp, _tmp1, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6, _tmp7, _tmp8, _tmp9, res, _tmp10, newFullAddress, _tmp11, _tmp12;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setInvoiceAddress(address);
                        _tmp = {};
                        _tmp1 = {};
                        _tmp2 = {};
                        _tmp3 = {};
                        if (address.changeType === Enums/* ADDRESS_CHANGE_TYPE.PROVINCE_CHANGE */.Ei.PROVINCE_CHANGE) {
                            if (address.province === "0") {
                                handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, invoice), (_tmp1.province = "", _tmp1.district = "", _tmp1.ward = "", _tmp1)));
                            } else {
                                handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp2, invoice), (_tmp3.province = address.province, _tmp3)));
                            }
                            setError("province", false);
                        }
                        _tmp4 = {};
                        _tmp5 = {};
                        _tmp6 = {};
                        _tmp7 = {};
                        if (address.changeType === Enums/* ADDRESS_CHANGE_TYPE.DISTRICT_CHANGE */.Ei.DISTRICT_CHANGE) {
                            if (address.district === "0") {
                                handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp4, invoice), (_tmp5.district = "", _tmp5.ward = "", _tmp5)));
                            } else {
                                handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp6, invoice), (_tmp7.district = address.district, _tmp7)));
                            }
                            setError("district", false);
                        }
                        if (!(address.changeType === Enums/* ADDRESS_CHANGE_TYPE.WARD_CHANGE */.Ei.WARD_CHANGE)) return [
                            3,
                            4
                        ];
                        if (!(address.ward === "0")) return [
                            3,
                            1
                        ];
                        _tmp8 = {};
                        _tmp9 = {};
                        handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp8, invoice), (_tmp9.ward = "", _tmp9)));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        _tmp10 = {};
                        return [
                            4,
                            AddressService/* default.getMasterAddressObject */.Z.getMasterAddressObject((_tmp10.ctx = null, _tmp10.provinceCode = address === null || address === void 0 ? void 0 : address.province, _tmp10.districtCode = address === null || address === void 0 ? void 0 : address.district, _tmp10.wardCode = address === null || address === void 0 ? void 0 : address.ward, _tmp10))
                        ];
                    case 2:
                        res = _state.sent();
                        newFullAddress = "".concat(invoice.streetAddress, ", ").concat(res.ward, ", ").concat(res.district, ", ").concat(res.province);
                        _tmp11 = {};
                        _tmp12 = {};
                        handleSetAllInvoice((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp11, invoice), (_tmp12.companyAddress = newFullAddress, _tmp12.ward = address.ward, _tmp12)));
                        _state.label = 3;
                    case 3:
                        setError("ward", false);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetCurrentAddress(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeInvoice = function(key, newValue) {
        var newdataInvoice = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, invoice), (0,src_define_property/* default */.Z)({}, key, newValue));
        handleSetAllInvoice(newdataInvoice);
        setError(key, false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper_Paper/* default */.Z, {
        elevation: 4,
        className: (0,clsx_m/* default */.Z)((InvoiceCheckout_styles_module_default()).paperroot, (0,src_define_property/* default */.Z)({}, (InvoiceCheckout_styles_module_default()).error, !!error.invoiceRequest)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
            container: true,
            "data-test": "list-invoice-container",
            className: (InvoiceCheckout_styles_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: (InvoiceCheckout_styles_module_default()).title,
                    children: [
                        translateCheckout("export_invoice_info"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            style: {
                                color: "#FF0000"
                            },
                            children: "*"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup_RadioGroup/* default */.Z, {
                            "aria-label": "isCheckedRequestInvoice",
                            name: "isCheckedRequestInvoice",
                            value: isCheckedRequestInvoice,
                            onChange: handleChangeCheckboxRequestInvoice,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                    value: "false",
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {}),
                                    label: translateCheckout("do_not_request_tax_invoice")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                    value: "true",
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {}),
                                    label: translateCheckout("request_tax_invoice_via_email")
                                })
                            ]
                        }),
                        showInvoiceInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                            xs: 12,
                            isRequired: true,
                            label: translateCheckout("email"),
                            htmlFor: "email",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                id: "email",
                                // placeholder={translateCheckout('at_least_2_character')}
                                onBlur: function(e) {
                                    return handleChangeInvoice("email", e.target.value);
                                },
                                defaultValue: email || invoice.email,
                                required: true,
                                name: "email",
                                className: (InvoiceCheckout_styles_module_default()).inputInvoice
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    className: (InvoiceCheckout_styles_module_default()).invoiceList,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup_RadioGroup/* default */.Z, {
                            "aria-label": "gender",
                            name: "gender1",
                            value: invoiceInfoSelected,
                            onChange: handleChangeInvoiceInfoSelected,
                            children: [
                                showInvoiceInfo && uniqueInvoiceList.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                                    name: "checkedC",
                                                    value: item.code
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                            children: [
                                                                " ",
                                                                item.companyName
                                                            ]
                                                        }),
                                                        " -",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                " ",
                                                                item.taxCode,
                                                                " "
                                                            ]
                                                        }),
                                                        " (",
                                                        item.companyAddress,
                                                        ")"
                                                    ]
                                                })
                                            }, item.code),
                                            item.code === invoiceInfoSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                                xs: 12,
                                                isRequired: true,
                                                label: translateCheckout("post_code"),
                                                htmlFor: "postCode",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                                    id: "postCode",
                                                    placeholder: translateCheckout("post_code"),
                                                    onBlur: function(e) {
                                                        return handleChangeInvoice("postCode", e.target.value);
                                                    },
                                                    defaultValue: getInvoicePostCode(item),
                                                    required: true,
                                                    name: "postCode",
                                                    className: (InvoiceCheckout_styles_module_default()).inputInvoice
                                                })
                                            })
                                        ]
                                    });
                                }),
                                showInvoiceInfo && (!invoiceInfoList || invoiceInfoList.length < 10) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                                        name: "checkedC",
                                        value: invoiceInfoOtherID
                                    }),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: translateCheckout("other")
                                        })
                                    })
                                })
                            ]
                        }),
                        isInvoiceInfoOther && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 12,
                                    isRequired: true,
                                    label: translateCheckout("company_name"),
                                    htmlFor: "companyName",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "companyName",
                                        placeholder: translateCheckout("at_least_2_character"),
                                        onBlur: function(e) {
                                            return handleChangeInvoice("companyName", e.target.value);
                                        },
                                        // defaultValue={companyName}
                                        required: true,
                                        name: "companyName",
                                        error: !!error.companyName
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 12,
                                    isRequired: true,
                                    label: translateCheckout("tax_code"),
                                    htmlFor: "taxCode",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "taxCode",
                                        placeholder: translateCheckout("tax_code"),
                                        onBlur: function(e) {
                                            return handleChangeInvoice("taxCode", e.target.value);
                                        },
                                        required: true,
                                        name: "taxCode",
                                        error: !!error.taxCode
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 12,
                                    isRequired: true,
                                    label: translateCheckout("enter_company_address_label"),
                                    htmlFor: "address",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "streetAddress",
                                        type: "text",
                                        name: "streetAddress",
                                        variant: "outlined",
                                        "aria-label": "streetAddress",
                                        placeholder: translateCheckout("enter_company_address"),
                                        onBlur: function(e) {
                                            return handleChangeInvoice("streetAddress", e.target.value);
                                        },
                                        required: true,
                                        error: !!error.streetAddress
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                                    id: (0,v4/* default */.Z)(),
                                    currentAddress: invoiceAddress,
                                    handleSetCurrentAddress: handleSetCurrentAddress,
                                    style: {
                                        margonTop: 0
                                    },
                                    error: {
                                        province: error === null || error === void 0 ? void 0 : error.province,
                                        district: error === null || error === void 0 ? void 0 : error.district,
                                        ward: error === null || error === void 0 ? void 0 : error.ward
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 12,
                                    isRequired: true,
                                    label: translateCheckout("post_code"),
                                    htmlFor: "postCode",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "postCode",
                                        type: "number",
                                        placeholder: translateCheckout("post_code"),
                                        onBlur: function(e) {
                                            return handleChangeInvoice("postCode", e.target.value);
                                        },
                                        required: true,
                                        name: "postCode",
                                        error: !!error.postCode
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (InvoiceCheckout_styles_module_default()).helper_text,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                        className: (InvoiceCheckout_styles_module_default()).text_muted,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                                icon: free_solid_svg_icons_index_es.faInfoCircle,
                                                className: (InvoiceCheckout_styles_module_default()).icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (InvoiceCheckout_styles_module_default()).fw500,
                                                children: [
                                                    translateCheckout("notice"),
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (InvoiceCheckout_styles_module_default()).notifi_list,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: translateCheckout("fill_correct_invoice_info_1")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: translateCheckout("fill_correct_invoice_info_2")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_InvoiceCheckout = (InvoiceCheckout);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./src/components-v2/mocules/PopupMultilImage/index.tsx
var PopupMultilImage = __webpack_require__(53371);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/hooks/useMultiImageBox.js
var useMultiImageBox = __webpack_require__(66621);
// EXTERNAL MODULE: ./src/hooks/useToggle.js
var useToggle = __webpack_require__(53376);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
// EXTERNAL MODULE: ./src/components/mocules/MultiImageBoxV2/styles.module.css
var MultiImageBoxV2_styles_module = __webpack_require__(73330);
var MultiImageBoxV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(MultiImageBoxV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/MultiImageBoxV2/index.js






















var MultiImageBoxV2 = function(param) {
    var loading = param.loading, _images = param.images, images = _images === void 0 ? null : _images, _title = param.title, title = _title === void 0 ? "" : _title, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _imageName = param.imageName, imageName = _imageName === void 0 ? "" : _imageName, translateProductDetail = param.translateProductDetail, nameLabel = param.nameLabel, product = param.product, link = param.link;
    var ref = (0,useMultiImageBox/* default */.Z)({
        images: images
    }), selectedImage = ref.selectedImage, handleHoverImage = ref.handleHoverImage, handleImageSelection = ref.handleImageSelection, handlePrevious = ref.handlePrevious, handleNext = ref.handleNext;
    var ref1 = (0,useToggle/* default */.Z)(), open = ref1.open, handleOpen = ref1.handleOpen, handleClose = ref1.handleClose;
    var ref2 = (0,react.useState)(null), mainImg = ref2[0], setMainImg = ref2[1];
    var handleOpenImageModal = function() {
        setMainImg(images[selectedImage]);
        handleOpen();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MultiImageBoxV2_styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MultiImageBoxV2_styles_module_default()).wrapperImg,
                        children: [
                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rect",
                                classes: {
                                    root: (MultiImageBoxV2_styles_module_default()).imageMain
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: images && images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    onClick: handleOpenImageModal,
                                    className: "openImg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        width: 295,
                                        height: 295,
                                        alt: title,
                                        // fallbackSrc={images[selectedImage]}
                                        fallbackSrc: (0,ImageUtils/* getLinkProxyCDNFallback */.F4)(images[selectedImage]),
                                        className: (MultiImageBoxV2_styles_module_default()).imageMain,
                                        src: "".concat(open ? (0,ImageUtils/* getLinkGCS */.jA)(mainImg) : (0,ImageUtils/* getLinkGCS */.jA)(images[selectedImage])),
                                        quality: 100
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 295,
                                    height: 295,
                                    alt: "Image Not Found",
                                    loader: utils/* myLoader */.tQ,
                                    className: (MultiImageBoxV2_styles_module_default()).imageNotFound,
                                    src: Images/* MISSING_IMAGE */.g_W
                                })
                            }),
                            nameLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: nameLabel,
                                className: (MultiImageBoxV2_styles_module_default()).product_tag
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: (MultiImageBoxV2_styles_module_default()).slider
                    }, data/* settingsMultiImageBoxV2 */.bZ), {
                        children: images && images.map(function(src, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MultiImageBoxV2_styles_module_default()).thumbnail,
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rect",
                                    classes: {
                                        root: (MultiImageBoxV2_styles_module_default()).thumbnailImage
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    onClick: handleOpenImageModal,
                                    onMouseOver: function() {
                                        return handleHoverImage(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        width: 60,
                                        height: 60,
                                        alt: title,
                                        className: (0,clsx_m/* default */.Z)((MultiImageBoxV2_styles_module_default()).thumbnailImage, (0,src_define_property/* default */.Z)({}, (MultiImageBoxV2_styles_module_default()).thumbnailSelected, index === selectedImage)),
                                        src: (0,ImageUtils/* getLinkGCS */.jA)(src),
                                        fallbackSrc: (0,ImageUtils/* getLinkGCS */.jA)(src),
                                        quality: 100
                                    })
                                })
                            }, (0,v4/* default */.Z)());
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        className: (MultiImageBoxV2_styles_module_default()).descImg,
                        children: [
                            "*",
                            translateProductDetail("images_may_change_overtime")
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultilImage/* default */.Z, {
                isMobile: isMobile,
                images: images,
                open: open,
                handleClose: handleClose,
                imageName: imageName,
                selectedImage: selectedImage,
                handleClickImage: handleImageSelection,
                handlePrevious: handlePrevious,
                handleNext: handleNext
            })
        ]
    });
};
/* harmony default export */ var mocules_MultiImageBoxV2 = (MultiImageBoxV2);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CloseOutlined.js
var CloseOutlined = __webpack_require__(31863);
// EXTERNAL MODULE: ./src/components/mocules/NewAuthModal/styles.module.css
var NewAuthModal_styles_module = __webpack_require__(99148);
var NewAuthModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewAuthModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewAuthModal/index.js









var NewAuthModal = /*#__PURE__*/ react.memo(function(props) {
    var width = props.width, onClose = props.onClose, visible = props.visible, children = props.children, title = props.title, className = props.className, restProps = props.restProps, height = props.height, _isShowCloseBtn = props.isShowCloseBtn, isShowCloseBtn = _isShowCloseBtn === void 0 ? true : _isShowCloseBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NewAuthModal_styles_module_default()).auth_modal_content,
            style: {
                width: "".concat(width),
                height: "".concat(height)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (NewAuthModal_styles_module_default()).auth_modal_header,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: isShowCloseBtn ? 10 : 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                "data-test": "modal-title",
                                className: (NewAuthModal_styles_module_default()).auth_modal_title,
                                children: title
                            })
                        }),
                        isShowCloseBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                "data-test": "signup-close",
                                "aria-label": "close",
                                className: (NewAuthModal_styles_module_default()).auth_modal_close,
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewAuthModal_styles_module_default()).auth_modal_body,
                    children: children
                })
            ]
        })
    }));
});
/* harmony default export */ var mocules_NewAuthModal = (NewAuthModal);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LockOutlined.js
var LockOutlined = __webpack_require__(62267);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./src/components/mocules/NewChangePasswordForm/styles.module.css
var NewChangePasswordForm_styles_module = __webpack_require__(6911);
var NewChangePasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewChangePasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewChangePasswordForm/index.js












var NewChangePasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, toggleModalAndSignout = param.toggleModalAndSignout, translatePopupAction = param.translatePopupAction;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorPw = ref1[0], setErrorPw = ref1[1];
    var ref2 = (0,react.useState)(""), errorPwMessage = ref2[0], setErrorPwMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorNewPassword = ref3[0], setErrorNewPassword = ref3[1];
    var ref4 = (0,react.useState)(""), errorNewPasswordMessage = ref4[0], setErrorNewPasswordMessage = ref4[1];
    var ref5 = (0,react.useState)(""), currentPassword = ref5[0], setCurrentPassword = ref5[1];
    var ref6 = (0,react.useState)(""), newPassword = ref6[0], setNewPassword = ref6[1];
    // handle validate
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.not_entered_your_password"));
            return false;
        }
        if (data.length > 50) {
            setErrorPw(true);
            setErrorPwMessage(translatePopupAction("popup-validateUntil.password_too_long"));
            return false;
        }
        // if (!data.match(regExpPw)) {
        //   setErrorPw(true);
        //   setErrorPwMessage(
        //     'Mật khẩu phải ít nhất 8 ký tự và không quá 20 ký tự. Có chứa ít nhất 1 chữ thường, 1 chữ hoa, và 1 số',
        //   );
        //   return false;
        // }
        return true;
    };
    var validateNewPassword = function(data, oldPassword) {
        setErrorNewPassword(false);
        if (data === "") {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage(translatePopupAction("popup-validateUntil.you_have_not_entered_a_new_password"));
            return false;
        }
        if (data.length > 30 || data.length < 2) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage(translatePopupAction("popup-validateUntil.password_minimum_maximum_characters"));
            return false;
        }
        if (oldPassword === data) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("");
            // setErrorNewPasswordMessage('Mật khẩu mới không được trùng với mật khẩu gần nhất.');
            utils/* NotifyUtils.error */.QP.error(translatePopupAction("popup-validateUntil.new_password_not_same_latest_password"));
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitNewPasswordForm = function() {
        var data = {
            password: currentPassword,
            newPassword: newPassword
        };
        if (!validateNewPassword(data.newPassword, currentPassword)) {
            return;
        }
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePw = function(e) {
        e.preventDefault();
        validatePw(e.target.value);
        setCurrentPassword(e.target.value);
    };
    var handleOnChangeNewPassword = function(e) {
        e.preventDefault();
        validateNewPassword(e.target.value);
        setNewPassword(e.target.value);
    };
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewChangePasswordForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewChangePasswordForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NewChangePasswordForm_styles_module_default()).forget_password,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "".concat((NewChangePasswordForm_styles_module_default()).form_forget_password, " ").concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            fullWidth: true,
                            className: (NewChangePasswordForm_styles_module_default()).form_control,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    placeholder: translatePopupAction("popup-validateUntil.please_enter_your_current_password"),
                                    variant: "outlined",
                                    className: (NewChangePasswordForm_styles_module_default()).input,
                                    error: errorPw,
                                    onChange: handleOnChangePw
                                }),
                                errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).error,
                                    children: errorPwMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            fullWidth: true,
                            className: (NewChangePasswordForm_styles_module_default()).form_control,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "newPassword",
                                    name: "newPassword",
                                    type: showPassword ? "text" : "password",
                                    startAdornment: IconPassword,
                                    endAdornment: IconEndPassword,
                                    placeholder: translatePopupAction("popup-validateUntil.please_enter_a_new_password"),
                                    variant: "outlined",
                                    error: errorNewPassword,
                                    className: (NewChangePasswordForm_styles_module_default()).input,
                                    onChange: handleOnChangeNewPassword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).error,
                                    children: errorNewPassword && errorNewPasswordMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewChangePasswordForm_styles_module_default()).center,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: (NewChangePasswordForm_styles_module_default()).btn,
                                onClick: onSubmitNewPasswordForm,
                                children: translatePopupAction("change-password.send")
                            })
                        })
                    ]
                })
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewChangePasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NewChangePasswordForm_styles_module_default()).center,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewChangePasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (NewChangePasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    className: (NewChangePasswordForm_styles_module_default()).modal_title,
                                    children: [
                                        " ",
                                        translatePopupAction("change-password.success")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewChangePasswordForm_styles_module_default()).modal_title,
                                    children: translatePopupAction("change-password.re-login-finish")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewChangePasswordForm_styles_module_default()).center,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            className: (NewChangePasswordForm_styles_module_default()).btn,
                            onClick: toggleModalAndSignout,
                            children: translatePopupAction("change-password.login")
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_NewChangePasswordForm = (NewChangePasswordForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var icons_ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./src/components/mocules/NewInvoiceModal/styles.module.css
var NewInvoiceModal_styles_module = __webpack_require__(77827);
var NewInvoiceModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewInvoiceModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewInvoiceModal/index.js













var NewInvoiceModal = function(param) {
    var className = param.className, visible = param.visible, onClose = param.onClose, restProps = param.restProps, width = param.width, title = param.title, children = param.children, isAdding = param.isAdding, step = param.step, getStepInvoiceSubtract = param.getStepInvoiceSubtract, check = param.check, setCheck = param.setCheck;
    var ref = (0,esm/* useTranslation */.$G)("detailOrders"), translateDetailOrder = ref.t;
    var handleBackStepInvoice = function() {
        getStepInvoiceSubtract();
        setCheck(false);
    };
    var renderTitle = function() {
        if (step === 2 && !check) return translateDetailOrder("add_new_invoice_information");
        if (step === 2 && check) return translateDetailOrder("edit_invoice_information");
        return title;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NewInvoiceModal_styles_module_default()).auth_modal_content,
            style: {
                width: "".concat(width)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (NewInvoiceModal_styles_module_default()).auth_modal_header,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        onClick: handleBackStepInvoice,
                                        className: isAdding ? (NewInvoiceModal_styles_module_default()).hiddenClose : (NewInvoiceModal_styles_module_default()).iconBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowBackIos/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                        className: (NewInvoiceModal_styles_module_default()).auth_modal_title,
                                        children: renderTitle()
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                "aria-label": "close",
                                className: (NewInvoiceModal_styles_module_default()).auth_modal_close,
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((NewInvoiceModal_styles_module_default()).auth_modal_body, (NewInvoiceModal_styles_module_default()).slideRight),
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ var mocules_NewInvoiceModal = (/*#__PURE__*/react.memo(NewInvoiceModal));

// EXTERNAL MODULE: ./src/components/mocules/NewPasswordForm/styles.module.css
var NewPasswordForm_styles_module = __webpack_require__(31312);
var NewPasswordForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewPasswordForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewPasswordForm/NewPasswordForm.js











var NewPasswordForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickNewPasswordForm = param.onClickNewPasswordForm, step = param.step, toggleModalAndSignout = param.toggleModalAndSignout;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorPw = ref1[0], setErrorPw = ref1[1];
    var ref2 = (0,react.useState)(""), errorPwMessage = ref2[0], setErrorPwMessage = ref2[1];
    var ref3 = (0,react.useState)(false), errorNewPassword = ref3[0], setErrorNewPassword = ref3[1];
    var ref4 = (0,react.useState)(""), errorNewPasswordMessage = ref4[0], setErrorNewPasswordMessage = ref4[1];
    var ref5 = (0,react.useState)(""), currentPassword = ref5[0], setCurrentPassword = ref5[1];
    var ref6 = (0,react.useState)(""), newPassword = ref6[0], setNewPassword = ref6[1];
    // handle validate
    var validatePw = function(data) {
        setErrorPw(false);
        if (data === "") {
            setErrorPw(true);
            setErrorPwMessage("Bạn chưa nhập mật khẩu");
            return false;
        }
        if (data.length > 50) {
            setErrorPw(true);
            setErrorPwMessage("Mật khẩu qu\xe1 d\xe0i");
            return false;
        }
        // if (!data.match(regExpPw)) {
        //   setErrorPw(true);
        //   setErrorPwMessage(
        //     'Mật khẩu phải ít nhất 8 ký tự và không quá 20 ký tự. Có chứa ít nhất 1 chữ thường, 1 chữ hoa, và 1 số',
        //   );
        //   return false;
        // }
        return true;
    };
    var validateNewPassword = function(data) {
        setErrorNewPassword(false);
        if (data === "") {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("Bạn chưa nhập mật khẩu mới");
            return false;
        }
        if (data.length > 30 || data.length < 2) {
            setErrorNewPassword(true);
            setErrorNewPasswordMessage("Mật khẩu tối thiểu 2 v\xe0 tối đa 30 k\xed tự");
            return false;
        }
        return true;
    };
    // handle submit form
    var onSubmitNewPasswordForm = function() {
        var data = {
            password: currentPassword,
            newPassword: newPassword
        };
        if (!validateNewPassword(data.newPassword)) {
            return;
        }
        onClickNewPasswordForm(data);
    };
    // handle input
    var handleOnChangePw = function(e) {
        e.preventDefault();
        validatePw(e.target.value);
        setCurrentPassword(e.target.value);
    };
    var handleOnChangeNewPassword = function(e) {
        e.preventDefault();
        validateNewPassword(e.target.value);
        setNewPassword(e.target.value);
    };
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "forget-password",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "form-forget-password ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    placeholder: "Mật khẩu hiện tại",
                                    variant: "outlined",
                                    className: (NewPasswordForm_styles_module_default()).input,
                                    error: errorPw,
                                    onChange: handleOnChangePw
                                }),
                                errorPw && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).error,
                                    children: errorPwMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                                    id: "newPassword",
                                    name: "newPassword",
                                    type: showPassword ? "text" : "password",
                                    startAdornment: IconPassword,
                                    endAdornment: IconEndPassword,
                                    placeholder: "Mật khẩu mới",
                                    variant: "outlined",
                                    error: errorNewPassword,
                                    className: (NewPasswordForm_styles_module_default()).input,
                                    onChange: handleOnChangeNewPassword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).error,
                                    children: errorNewPassword && errorNewPasswordMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "action",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: "btnForgetPassword",
                                color: "white",
                                onClick: onSubmitNewPasswordForm,
                                children: "Gửi"
                            })
                        })
                    ]
                })
            }),
            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "forget-password",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewPasswordForm_styles_module_default()).confirm_modal_wrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (NewPasswordForm_styles_module_default()).warning_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (NewPasswordForm_styles_module_default()).text_icon,
                                        children: "✓"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewPasswordForm_styles_module_default()).modal_title,
                                    children: "Th\xe0nh c\xf4ng"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    className: (NewPasswordForm_styles_module_default()).modal_title,
                                    children: "Đăng nhập lại để ho\xe0n tất!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewPasswordForm_styles_module_default()).btngroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* ButtonHeader */.X9, {
                            variant: "contained",
                            btnType: "primary",
                            onClick: toggleModalAndSignout,
                            children: "Đăng nhập lại"
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var NewPasswordForm_NewPasswordForm = (NewPasswordForm);

;// CONCATENATED MODULE: ./src/components/mocules/NewPasswordForm/index.js

function NewPasswordForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .form-forget-password {\n    margin-top: 10px;\n  }\n\n  .form-control {\n    width: ",
        "px;\n    margin-bottom: 10px;\n  }\n\n  .btnForgetPassword {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    border-radius: 50px;\n  }\n  .action {\n    margin-top: 10px;\n    max-width: 200px;\n    width: 100%;\n  }\n  .desc {\n    font-size: 16px;\n    margin: 15px auto;\n    max-width: 450px;\n  }\n  .forget-password {\n    width: 100%;\n  }\n"
    ]);
    NewPasswordForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var styledNewPasswordForm = (0,styled_components_browser_esm/* default */.ZP)(NewPasswordForm_NewPasswordForm).withConfig({
    componentId: "sc-ecad00cd-0"
})(NewPasswordForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 450 : _width;
    return width;
});
/* harmony default export */ var mocules_NewPasswordForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(styledNewPasswordForm))));

// EXTERNAL MODULE: ./src/components/mocules/NewRegisterGuestForm/styles.module.css
var NewRegisterGuestForm_styles_module = __webpack_require__(74689);
var NewRegisterGuestForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewRegisterGuestForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewRegisterGuestForm/index.js






// outdate
var NewRegisterGuestForm = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, onClickRegister = param.onClickRegister;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var ref = (0,react.useState)(false), errorPhone = ref[0], setErrorPhone = ref[1];
    var ref1 = (0,react.useState)(""), errorPhoneMessage = ref1[0], setErrorPhoneMessage = ref1[1];
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại v\xe0 bắt đầu bằng số 0");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    // handle login with data
    var handleRegisterGuest = function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        if (!validatePhone(data.phone)) {
            return;
        }
        onClickRegister(data);
    };
    var handleOnChange = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NewRegisterGuestForm_styles_module_default()).form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleRegisterGuest,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: (NewRegisterGuestForm_styles_module_default()).title,
                    children: [
                        "Vui l\xf2ng nhập số điện thoại ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " trước khi d\xf9ng thử"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            id: "phone",
                            name: "phone",
                            type: "number",
                            placeholder: "Nhập số điện thoại",
                            variant: "outlined",
                            error: errorPhone,
                            onChange: handleOnChange,
                            className: (NewRegisterGuestForm_styles_module_default()).input
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewRegisterGuestForm_styles_module_default()).error,
                            children: errorPhone && errorPhoneMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewRegisterGuestForm_styles_module_default()).bottom_text,
                    children: "M\xe3 giảm gi\xe1 100k d\xe0nh cho nh\xe0 thuốc mới đăng k\xfd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewRegisterGuestForm_styles_module_default()).btn_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        className: (NewRegisterGuestForm_styles_module_default()).btn,
                        color: "white",
                        type: "submit",
                        children: "Đăng K\xfd"
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_NewRegisterGuestForm = (NewRegisterGuestForm);

// EXTERNAL MODULE: ./src/components/mocules/NewRegisterOrderInvoiceForm/index.js
var NewRegisterOrderInvoiceForm = __webpack_require__(27733);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(60737);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ErrorOutlined.js
var ErrorOutlined = __webpack_require__(64839);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOffOutlined.js
var VisibilityOffOutlined = __webpack_require__(31138);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOutlined.js
var VisibilityOutlined = __webpack_require__(97246);
// EXTERNAL MODULE: ./src/components-v2/atoms/MobileBadge/index.js
var MobileBadge = __webpack_require__(48748);
// EXTERNAL MODULE: ./src/components-v3/atoms/DeleteAccountMessage/styles.module.css
var DeleteAccountMessage_styles_module = __webpack_require__(79250);
var DeleteAccountMessage_styles_module_default = /*#__PURE__*/__webpack_require__.n(DeleteAccountMessage_styles_module);
;// CONCATENATED MODULE: ./src/components-v3/atoms/DeleteAccountMessage/index.js







function DeleteAccountMessage(_param) {
    var className = _param.className, translateMyAccount = _param.translateMyAccount, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "className",
        "translateMyAccount"
    ]);
    var code = props.code;
    var message = (0,react.useMemo)(function() {
        switch(code){
            case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_DELETED_NO_ORDER_60_DAYS */.E8.CUSTOMER_DELETED_NO_ORDER_60_DAYS:
                return translateMyAccount("customer_delete_because_no_order_60_days");
            case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_DELETED_NO_ORDER_90_DAYS */.E8.CUSTOMER_DELETED_NO_ORDER_90_DAYS:
                return translateMyAccount("customer_delete_because_no_order_90_days");
            default:
                return "";
        }
    }, [
        code
    ]);
    if (!message) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        className: (DeleteAccountMessage_styles_module_default()).text_warning,
        children: message
    });
}
/* harmony default export */ var atoms_DeleteAccountMessage = (DeleteAccountMessage);

// EXTERNAL MODULE: ./src/constants/Images/mobile/Icons/index.js
var mobile_Icons = __webpack_require__(76726);
// EXTERNAL MODULE: ./src/constants/data/mobile.js
var mobile = __webpack_require__(76412);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/mocules/NewSignUpForm/styles.module.css
var NewSignUpForm_styles_module = __webpack_require__(9992);
var NewSignUpForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(NewSignUpForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/NewSignInForm/index.js































var NewSignInForm = function(param) {
    var className = param.className, onClickForget = param.onClickForget, onClickLogin = param.onClickLogin, onClickSignUp = param.onClickSignUp, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _page = param.page, page = _page === void 0 ? null : _page, _setPage = param.setPage, setPage = _setPage === void 0 ? null : _setPage, user = param.user, translatePopupAction = param.translatePopupAction, translateMyAccount = param.translateMyAccount;
    var ref;
    var schema = yup_es/* object */.Ry({
        username: yup_es/* string */.Z_().required(translatePopupAction("popup_login.validate_phone_number_email_empty")),
        password: yup_es/* string */.Z_().required(translatePopupAction("popup_login.validate_password_empty"))
    }).required();
    var ref1 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), errors = ref1.formState.errors, control = ref1.control, handleSubmit = ref1.handleSubmit;
    var ref2 = (0,context/* useAuth */.aC)(), isShowLogin = ref2.isShowLogin, isShowSignUp = ref2.isShowSignUp, isShowDeleteAccountMess = ref2.isShowDeleteAccountMess, toggleShowDeleteAccountMess = ref2.toggleShowDeleteAccountMess, toggleLogin = ref2.toggleLogin, toggleSignUp = ref2.toggleSignUp, getValResponseDeleteAccountMess = ref2.getValResponseDeleteAccountMess;
    var ref3 = (0,react.useState)(false), showPassword = ref3[0], setShowPassword = ref3[1];
    var router = (0,next_router.useRouter)();
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    // handle login with data
    var handleLogin = function(data) {
        onClickLogin(data);
    };
    // handle forget password
    var handleClickForget = (0,react.useCallback)(function(e) {
        if (isMobileV2 && beta) {
            e.preventDefault();
            router.push("/?forgetpass=true");
            setPage(page + 2);
        } else {
            e.preventDefault();
            onClickForget();
        }
    }, [
        onClickForget,
        page,
        isMobileV2
    ]);
    var handleClickSignUp = (0,react.useCallback)(function(e) {
        if (isMobileV2 && beta) {
            e.preventDefault();
            router.push("/?register=true");
            setPage(page + 1);
        } else {
            e.preventDefault();
            onClickSignUp();
        }
    }, [
        onClickSignUp,
        page,
        isMobileV2
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var handleOpenChat = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var supportCenter, ref, supportCenterIcon;
            return (0,tslib_es6.__generator)(this, function(_state) {
                toggleLogin();
                supportCenter = document === null || document === void 0 ? void 0 : document.getElementById("support-center");
                if (supportCenter) {
                    ;
                    supportCenterIcon = supportCenter === null || supportCenter === void 0 ? void 0 : supportCenter.getElementsByTagName("img");
                    (ref = supportCenterIcon[0]) === null || ref === void 0 ? void 0 : ref.click();
                    if (!isMobileV2) {
                        setTimeout(function() {
                            var chat = document === null || document === void 0 ? void 0 : document.getElementById("open-chat");
                            if (chat) {
                                var ref;
                                var chatIcon = chat === null || chat === void 0 ? void 0 : chat.getElementsByTagName("img");
                                (ref = chatIcon[0]) === null || ref === void 0 ? void 0 : ref.click();
                            }
                        }, 250);
                    }
                }
                toggleShowDeleteAccountMess();
                return [
                    2
                ];
            });
        });
        return function handleOpenChat() {
            return _ref.apply(this, arguments);
        };
    }();
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircleOutlined/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOffOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOutlined/* default */.Z, {})
        })
    });
    var mapButtonForgetPassword = {
        vn: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "/",
            className: (NewSignUpForm_styles_module_default()).link_login,
            onClick: handleClickForget,
            children: translatePopupAction("popup_login.forgot_your_password")
        }),
        cam: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: mobile/* LINK_DIRECT_TO_TELE */.z8,
            target: "_blank",
            className: (NewSignUpForm_styles_module_default()).link_login,
            rel: "noreferrer",
            children: translatePopupAction("popup_login.forgot_your_password")
        }),
        th: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "/",
            onClick: handleClickForget,
            className: (NewSignUpForm_styles_module_default()).link_login,
            children: translatePopupAction("popup_login.forgot_your_password")
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            beta && isMobileV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NewSignUpForm_styles_module_default()).wrapperTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        marginBottom: "100px",
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* MOBILE_LOGO */.ge, {
                                    className: (NewSignUpForm_styles_module_default()).logo
                                })
                            }),
                            isShowLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBadge/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((NewSignUpForm_styles_module_default()).badge, (NewSignUpForm_styles_module_default()).greenIcon),
                                onClick: toggleLogin,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* ICON_MOBILE_ICON_HOME */.cE, {})
                            }),
                            isShowSignUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBadge/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((NewSignUpForm_styles_module_default()).badge, (NewSignUpForm_styles_module_default()).greenIcon),
                                onClick: toggleSignUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_Icons/* ICON_MOBILE_ICON_HOME */.cE, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "title",
                        children: [
                            translatePopupAction("popup_login.greeting"),
                            " ",
                            Enums/* BRAND_NAME */.RS
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "desc",
                        children: translatePopupAction("popup_login.sub_title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: className,
                onSubmit: handleSubmit(function(data) {
                    return handleLogin(data);
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "username",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        error: !!errors.username,
                                        startAdornment: IconAccount,
                                        placeholder: translatePopupAction("popup_login.placeholder_username"),
                                        variant: "outlined",
                                        className: (NewSignUpForm_styles_module_default()).input
                                    }, field), {
                                        "data-test": "signin-username"
                                    })),
                                    ((ref = errors.username) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signin-err-username",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.username) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "password",
                        defaultValue: "",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        error: !!errors.password,
                                        type: showPassword ? "text" : "password",
                                        startAdornment: IconPassword,
                                        endAdornment: IconEndPassword,
                                        placeholder: translatePopupAction("popup_login.password"),
                                        autoComplete: "password",
                                        variant: "outlined",
                                        className: (NewSignUpForm_styles_module_default()).input
                                    }, field), {
                                        "data-test": "signin-password"
                                    })),
                                    ((ref = errors.password) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (NewSignUpForm_styles_module_default()).text_error,
                                        "data-test": "signin-err-password",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlined/* default */.Z, {}),
                                            " ",
                                            (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                        name: "rememberMe",
                        defaultValue: true,
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (NewSignUpForm_styles_module_default()).agree_term,
                                style: {
                                    padding: "0 0 1rem 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, (0,src_object_spread/* default */.Z)({
                                    "data-test": "signin-rememberMe",
                                    label: translatePopupAction("popup_login.keep_me_signed_in"),
                                    onChange: function(e) {
                                        return field.onChange(e.target.checked);
                                    },
                                    isChecked: field.value
                                }, field))
                            });
                        }
                    }),
                    isShowDeleteAccountMess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_DeleteAccountMessage, {
                                code: ((ref = getValResponseDeleteAccountMess()) === null || ref === void 0 ? void 0 : ref.errorCode) || "",
                                translateMyAccount: translateMyAccount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (NewSignUpForm_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    color: "warning",
                                    className: (NewSignUpForm_styles_module_default()).btn_call_to_action,
                                    onClick: handleOpenChat,
                                    children: translatePopupAction("contact_directly")
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center),
                                children: mapButtonForgetPassword[sysconfig/* ENV_COUNTRY */.ng]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                className: (NewSignUpForm_styles_module_default()).center,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    type: "submit",
                                    className: (NewSignUpForm_styles_module_default()).btn_register,
                                    disabled: isLoading,
                                    "data-test": "signin-submit",
                                    children: translatePopupAction("popup_login.sign_in")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        translatePopupAction("popup_login.get_deal_member"),
                                        ",\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#top",
                                            className: (NewSignUpForm_styles_module_default()).link_login,
                                            onClick: handleClickSignUp,
                                            children: translatePopupAction("popup_login.register_member")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_NewSignInForm = (NewSignInForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/EditOutlined.js
var EditOutlined = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/EmailOutlined.js
var EmailOutlined = __webpack_require__(14662);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocalHospital.js
var LocalHospital = __webpack_require__(2742);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOn.js
var LocationOn = __webpack_require__(59832);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PeopleOutlined.js
var PeopleOutlined = __webpack_require__(803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PhoneOutlined.js
var PhoneOutlined = __webpack_require__(93218);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/StoreOutlined.js
var StoreOutlined = __webpack_require__(16267);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CampaignOutlined.js
var CampaignOutlined = __webpack_require__(97397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/mocules/SearchableSelect/styles.module.css
var SearchableSelect_styles_module = __webpack_require__(46639);
var SearchableSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchableSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchableSelect/index.js
/*
 * SearchableSelect: single-value dropdown with a search box (register form: business type,
 * "How did you find us").
 * This file and styles.module.css are kept byte-identical between `web` (TH) and `kh_web` (KH):
 * change one repo, copy the files to the other.
 *
 * Props:
 * - id: base id for the listbox / option ids (a11y), e.g. "signup-scope"
 * - value, onChange(value, option), onBlur(): controlled value (react-hook-form `field`)
 * - options: [{ value, label }]
 * - placeholder, searchPlaceholder, noResultsText: translated texts from the caller
 * - startIcon: icon element shown at the start of the trigger
 * - error: red border; disabled; className: root wrapper class
 * - ref: forwarded to the trigger button (react-hook-form focuses it on validation error)
 * - other props (data-test, aria-*) go to the trigger button (aria-label defaults to placeholder)
 * - each option <li> has data-value={option.value} (QA automation)
 *
 * The panel is an MUI Popover (portal to document.body, z-index above MUI Dialog), so it is never
 * clipped by the dialog / scroll container overflow. Popover is a Modal: while open it is the top
 * modal, so the focus trap of the surrounding Dialog pauses and the search box can keep focus
 * (a plain Popper portal inside a Dialog would get its focus stolen back by the Dialog).
 */ 











var PANEL_Z_INDEX = 1400; // above MUI Modal / Dialog (theme.zIndex.modal = 1300)
var PANEL_GAP = 6; // px between trigger and panel
var VIEWPORT_MARGIN = 16; // Popover marginThreshold
var LIST_MAX_HEIGHT = 300;
var LIST_MIN_HEIGHT = 120;
var OPTION_HEIGHT = 36; // keep in sync with .option min-height
var PANEL_CHROME_HEIGHT = 72; // .panel padding (2 x 12) + .search height (40) + .list margin-top (8)
var isEmptyValue = function(value) {
    return value === undefined || value === null || value === "";
};
// Latin combining diacritics only (U+0300-U+036F). Do not use \p{M}: it would also strip Thai / Khmer
// vowel signs and tone marks.
var LATIN_DIACRITICS = /[\u0300-\u036f]/g;
// Search key: lower case, trimmed, Latin accents removed ("Nhà thuốc" -> "nha thuoc", "đ" -> "d").
// Thai / Khmer text is unchanged.
var normalizeText = function(text) {
    var str = String(text || "").toLowerCase().trim();
    var stripped = typeof str.normalize === "function" ? str.normalize("NFD").replace(LATIN_DIACRITICS, "") : str;
    return stripped.replace(/đ/g, "d");
};
// Visible area in layout-viewport coordinates. visualViewport excludes the iOS virtual keyboard,
// which changes neither window.innerHeight nor fires window resize.
var getVisibleArea = function() {
    var vv = window.visualViewport;
    if (vv && vv.height > 0) return {
        top: vv.offsetTop,
        bottom: vv.offsetTop + vv.height
    };
    return {
        top: 0,
        bottom: window.innerHeight
    };
};
var isSameLayout = function(a, b) {
    return a.width === b.width && a.placeAbove === b.placeAbove && a.listMaxHeight === b.listMaxHeight;
};
// No search autofocus on touch devices (would pop up the virtual keyboard). `isMobile` misses
// iPadOS (desktop UA), hence also `(pointer: coarse)`.
var shouldAutoFocusSearch = function() {
    if (dist_lib/* isMobile */.tq) return false;
    if ( true && typeof window.matchMedia === "function") {
        return !window.matchMedia("(pointer: coarse)").matches;
    }
    return true;
};
var SearchableSelect = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var id = props.id, name = props.name, value = props.value, _options = props.options, options = _options === void 0 ? [] : _options, onChange = props.onChange, onBlur = props.onBlur, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _searchPlaceholder = props.searchPlaceholder, searchPlaceholder = _searchPlaceholder === void 0 ? "" : _searchPlaceholder, _noResultsText = props.noResultsText, noResultsText = _noResultsText === void 0 ? "" : _noResultsText, _startIcon = props.startIcon, startIcon = _startIcon === void 0 ? null : _startIcon, _error = props.error, error = _error === void 0 ? false : _error, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, className = props.className, rest = (0,src_object_without_properties/* default */.Z)(props, [
        "id",
        "name",
        "value",
        "options",
        "onChange",
        "onBlur",
        "placeholder",
        "searchPlaceholder",
        "noResultsText",
        "startIcon",
        "error",
        "disabled",
        "className"
    ]);
    var baseId = id || name || "searchable-select";
    var listboxId = "".concat(baseId, "-listbox");
    var getOptionId = function(index) {
        return "".concat(baseId, "-option-").concat(index);
    };
    var triggerRef = (0,react.useRef)(null);
    var searchRef = (0,react.useRef)(null);
    var listRef = (0,react.useRef)(null);
    var popoverActionRef = (0,react.useRef)(null);
    var openRef = (0,react.useRef)(false);
    var restoreFocusRef = (0,react.useRef)(false);
    var keyboardNavRef = (0,react.useRef)(false);
    var _$ref = (0,react.useState)(false), open = _$ref[0], setOpen = _$ref[1];
    var _$ref1 = (0,react.useState)(""), query = _$ref1[0], setQuery = _$ref1[1];
    var _$ref2 = (0,react.useState)(-1), activeIndex = _$ref2[0], setActiveIndex = _$ref2[1];
    var _$ref3 = (0,react.useState)({
        width: 0,
        placeAbove: false,
        listMaxHeight: LIST_MAX_HEIGHT
    }), layout = _$ref3[0], setLayout = _$ref3[1];
    openRef.current = open;
    var selectedOption = options.find(function(option) {
        return option.value === value;
    });
    var hasValue = !isEmptyValue(value);
    var displayText = selectedOption && selectedOption.label || value;
    var filteredOptions = (0,react.useMemo)(function() {
        var keyword = normalizeText(query);
        if (!keyword) return options;
        return options.filter(function(option) {
            return normalizeText(option.label).includes(keyword);
        });
    }, [
        options,
        query
    ]);
    var activeOption = open ? filteredOptions[activeIndex] : undefined;
    // aria-controls only while the listbox is rendered
    var listboxControls = open && filteredOptions.length > 0 ? listboxId : undefined;
    var setTriggerRef = (0,react.useCallback)(function(node) {
        triggerRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
    }, [
        ref
    ]);
    // Panel width = trigger width; open below the trigger, flip above when there is not enough space
    var computeLayout = (0,react.useCallback)(function() {
        var node = triggerRef.current;
        if (!node || "object" === "undefined") return null;
        var rect = node.getBoundingClientRect();
        var visible = getVisibleArea();
        var spaceBelow = visible.bottom - rect.bottom - VIEWPORT_MARGIN - PANEL_GAP;
        var spaceAbove = rect.top - visible.top - VIEWPORT_MARGIN - PANEL_GAP;
        var listHeight = Math.min(LIST_MAX_HEIGHT, Math.max(options.length, 1) * OPTION_HEIGHT);
        var placeAbove = spaceBelow < listHeight + PANEL_CHROME_HEIGHT && spaceAbove > spaceBelow;
        var space = placeAbove ? spaceAbove : spaceBelow;
        return {
            width: rect.width,
            placeAbove: placeAbove,
            listMaxHeight: Math.max(LIST_MIN_HEIGHT, Math.min(LIST_MAX_HEIGHT, space - PANEL_CHROME_HEIGHT))
        };
    }, [
        options.length
    ]);
    var scrollOptionIntoView = function(index, center) {
        var list = listRef.current;
        var optionNode = list && index >= 0 ? list.querySelector('[data-option-index="'.concat(index, '"]')) : null;
        if (!optionNode) return;
        if (center) {
            list.scrollTop = optionNode.offsetTop - (list.clientHeight - optionNode.offsetHeight) / 2;
            return;
        }
        if (optionNode.offsetTop < list.scrollTop) {
            list.scrollTop = optionNode.offsetTop;
        } else if (optionNode.offsetTop + optionNode.offsetHeight > list.scrollTop + list.clientHeight) {
            list.scrollTop = optionNode.offsetTop + optionNode.offsetHeight - list.clientHeight;
        }
    };
    var openPanel = function() {
        if (disabled || openRef.current) return;
        var nextLayout = computeLayout();
        if (nextLayout) setLayout(nextLayout);
        setQuery("");
        setActiveIndex(options.findIndex(function(option) {
            return option.value === value;
        }));
        setOpen(true);
    };
    var closePanel = function(restoreFocus) {
        if (!openRef.current) return;
        restoreFocusRef.current = !!restoreFocus;
        setOpen(false);
        if (onBlur) onBlur();
    };
    var handleSelect = function(option) {
        if (!option) return;
        if (onChange) onChange(option.value, option);
        closePanel(true);
    };
    var moveActive = function(step) {
        var count = filteredOptions.length;
        if (!count) return;
        keyboardNavRef.current = true;
        setActiveIndex(function(prev) {
            if (prev < 0 || prev >= count) return step > 0 ? 0 : count - 1;
            return Math.min(count - 1, Math.max(0, prev + step));
        });
    };
    var handleTriggerKeyDown = function(event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            openPanel();
        }
    };
    // Safari does not focus a <button> on click: focus it so MUI restores focus to the trigger
    // when the panel is closed by an outside click.
    var handleTriggerMouseDown = function() {
        if (!disabled && triggerRef.current) triggerRef.current.focus({
            preventScroll: true
        });
    };
    var handleTriggerBlur = function() {
        // focus moving into the open panel is not a blur of the field
        if (!openRef.current && onBlur) onBlur();
    };
    var handlePanelKeyDown = function(event) {
        if (event.nativeEvent && event.nativeEvent.isComposing) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                moveActive(1);
                break;
            case "ArrowUp":
                event.preventDefault();
                moveActive(-1);
                break;
            case "Enter":
                event.preventDefault();
                handleSelect(filteredOptions[activeIndex]);
                break;
            case "Escape":
                // stop here so the surrounding Dialog does not close too
                event.preventDefault();
                event.stopPropagation();
                closePanel(true);
                break;
            case "Tab":
                event.preventDefault();
                closePanel(true);
                break;
            default:
                break;
        }
    };
    var handleQueryChange = function(event) {
        var nextQuery = event.target.value;
        setQuery(nextQuery);
        setActiveIndex(normalizeText(nextQuery) ? 0 : options.findIndex(function(option) {
            return option.value === value;
        }));
        if (listRef.current) listRef.current.scrollTop = 0;
    };
    var handleEntering = function() {
        scrollOptionIntoView(options.findIndex(function(option) {
            return option.value === value;
        }), true);
        if (shouldAutoFocusSearch() && searchRef.current) {
            searchRef.current.focus({
                preventScroll: true
            });
        }
    };
    var handleExited = function() {
        setQuery("");
        setActiveIndex(-1);
        var trigger = triggerRef.current;
        if (restoreFocusRef.current && trigger && document.activeElement !== trigger) {
            trigger.focus({
                preventScroll: true
            });
        }
        restoreFocusRef.current = false;
    };
    var handlePopoverClose = function(event, reason) {
        closePanel(reason === "escapeKeyDown");
    };
    // keyboard navigation keeps the active option visible
    (0,react.useEffect)(function() {
        if (!open || !keyboardNavRef.current) return;
        keyboardNavRef.current = false;
        scrollOptionIntoView(activeIndex, false);
    }, [
        open,
        activeIndex
    ]);
    // panel height changes while filtering: re-anchor (matters when the panel is flipped above)
    (0,react.useEffect)(function() {
        if (open && popoverActionRef.current) popoverActionRef.current.updatePosition();
    }, [
        open,
        filteredOptions.length,
        layout
    ]);
    // Re-fit the panel when the visible area changes: window resize, and visualViewport resize/scroll
    // (iOS virtual keyboard opening while typing in the search box).
    (0,react.useEffect)(function() {
        if (!open) return undefined;
        var vv = window.visualViewport;
        var frame = null;
        var handleViewportChange = function() {
            if (frame !== null) return;
            frame = window.requestAnimationFrame(function() {
                frame = null;
                var nextLayout = computeLayout();
                if (nextLayout) setLayout(function(prev) {
                    return isSameLayout(prev, nextLayout) ? prev : nextLayout;
                });
                if (popoverActionRef.current) popoverActionRef.current.updatePosition();
            });
        };
        window.addEventListener("resize", handleViewportChange);
        if (vv) {
            vv.addEventListener("resize", handleViewportChange);
            vv.addEventListener("scroll", handleViewportChange);
        }
        return function() {
            if (frame !== null) window.cancelAnimationFrame(frame);
            window.removeEventListener("resize", handleViewportChange);
            if (vv) {
                vv.removeEventListener("resize", handleViewportChange);
                vv.removeEventListener("scroll", handleViewportChange);
            }
        };
    }, [
        open,
        computeLayout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                "aria-label": placeholder || undefined
            }, rest), {
                ref: setTriggerRef,
                type: "button",
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listboxControls,
                "aria-invalid": error || undefined,
                disabled: disabled,
                className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).trigger, open && (SearchableSelect_styles_module_default()).trigger_open, error && (SearchableSelect_styles_module_default()).trigger_error),
                onMouseDown: handleTriggerMouseDown,
                onClick: openPanel,
                onKeyDown: handleTriggerKeyDown,
                onBlur: handleTriggerBlur,
                children: [
                    startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SearchableSelect_styles_module_default()).start_icon,
                        children: startIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).value, !hasValue && (SearchableSelect_styles_module_default()).placeholder),
                        children: hasValue ? displayText : placeholder
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        className: (SearchableSelect_styles_module_default()).chevron
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                open: open,
                anchorEl: triggerRef.current,
                onClose: handlePopoverClose,
                anchorOrigin: {
                    vertical: layout.placeAbove ? "top" : "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: layout.placeAbove ? "bottom" : "top",
                    horizontal: "left"
                },
                marginThreshold: VIEWPORT_MARGIN,
                action: popoverActionRef,
                style: {
                    zIndex: PANEL_Z_INDEX
                },
                TransitionProps: {
                    onEntering: handleEntering,
                    onExited: handleExited
                },
                PaperProps: {
                    className: (SearchableSelect_styles_module_default()).paper,
                    style: {
                        width: layout.width || undefined,
                        marginTop: layout.placeAbove ? -PANEL_GAP : PANEL_GAP
                    },
                    onKeyDown: handlePanelKeyDown
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SearchableSelect_styles_module_default()).panel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchableSelect_styles_module_default()).search,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {
                                    className: (SearchableSelect_styles_module_default()).search_icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ref: searchRef,
                                    type: "text",
                                    className: (SearchableSelect_styles_module_default()).search_input,
                                    value: query,
                                    onChange: handleQueryChange,
                                    placeholder: searchPlaceholder,
                                    "aria-label": searchPlaceholder,
                                    "aria-controls": listboxControls,
                                    "aria-autocomplete": "list",
                                    "aria-activedescendant": activeOption ? getOptionId(activeIndex) : undefined,
                                    autoComplete: "off"
                                })
                            ]
                        }),
                        filteredOptions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            ref: listRef,
                            id: listboxId,
                            role: "listbox",
                            "aria-label": placeholder,
                            className: (SearchableSelect_styles_module_default()).list,
                            style: {
                                maxHeight: layout.listMaxHeight
                            },
                            children: filteredOptions.map(function(option, index) {
                                var isSelected = option.value === value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    id: getOptionId(index),
                                    role: "option",
                                    "aria-selected": isSelected,
                                    "data-option-index": index,
                                    "data-value": option.value,
                                    className: (0,clsx_m/* default */.Z)((SearchableSelect_styles_module_default()).option, index === activeIndex && (SearchableSelect_styles_module_default()).option_active, isSelected && (SearchableSelect_styles_module_default()).option_selected),
                                    onMouseMove: function() {
                                        if (activeIndex !== index) setActiveIndex(index);
                                    },
                                    onClick: function() {
                                        return handleSelect(option);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchableSelect_styles_module_default()).option_label,
                                            children: option.label
                                        }),
                                        isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                            className: (SearchableSelect_styles_module_default()).option_check
                                        })
                                    ]
                                }, option.value);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchableSelect_styles_module_default()).empty,
                            role: "status",
                            children: noResultsText
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var mocules_SearchableSelect = (SearchableSelect);

// EXTERNAL MODULE: ./src/clients/CustomerClient.js
var clients_CustomerClient = __webpack_require__(59261);
;// CONCATENATED MODULE: ./src/hooks/useLeadSources.js





// Fetch the active lead sources ("How did you find us?") for the sign-up form.
// Any failure (error, non-OK, empty list) resolves to an empty list so the caller can hide the field
// and never block registration.
var useLeadSources = function() {
    var ref = (0,react.useState)([]), leadSources = ref[0], setLeadSources = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        var isMounted = true;
        var fetchLeadSources = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var res, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0,clients_CustomerClient/* getLeadSources */.mA)()
                            ];
                        case 1:
                            res = _state.sent();
                            if (!isMounted) return [
                                2
                            ];
                            if ((res === null || res === void 0 ? void 0 : res.status) !== Enums/* HTTP_STATUS.Ok */.MG.Ok || !Array.isArray(res === null || res === void 0 ? void 0 : res.data)) {
                                setLeadSources([]);
                                return [
                                    2
                                ];
                            }
                            setLeadSources(res.data.filter(function(item) {
                                return item === null || item === void 0 ? void 0 : item.value;
                            }));
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            if (isMounted) setLeadSources([]);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (isMounted) setLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLeadSources() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLeadSources();
        return function() {
            isMounted = false;
        };
    }, []);
    return {
        leadSources: leadSources,
        loading: loading
    };
};
/* harmony default export */ var hooks_useLeadSources = (useLeadSources);

// EXTERNAL MODULE: ./src/utils/registerURL.js
var registerURL = __webpack_require__(15563);
// EXTERNAL MODULE: ./src/components-v2/mocules/SelectArea/styles.module.css
var SelectArea_styles_module = __webpack_require__(8928);
var SelectArea_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectArea_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/SelectArea/index.js
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable react/jsx-indent-props */ /* eslint-disable react/jsx-indent */ 








var TABS = [
    "จังหวัด",
    "อำเภอ/เขต",
    "ตำบล/แขวง"
];
function SelectArea_AddressSelect(props) {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(0), activeTab = ref1[0], setActiveTab = ref1[1];
    var ref2 = (0,react.useState)({
        province: "",
        district: "",
        ward: ""
    }), selected = ref2[0], setSelected = ref2[1];
    var ref3 = (0,react.useState)(""), search = ref3[0], setSearch = ref3[1];
    var ref4 = (0,react.useState)([]), districts = ref4[0], setDistricts = ref4[1];
    var ref5 = (0,react.useState)([]), wards = ref5[0], setWards = ref5[1];
    var ref6 = (0,react.useState)(""), fullAddress = ref6[0], setFullAddress = ref6[1];
    var containerRef = (0,react.useRef)(null);
    var _provinces = props.provinces, provinces = _provinces === void 0 ? [] : _provinces, setValue = props.setValue, error = props.error, icon = props.icon, placeholder = props.placeholder;
    var handleClickOutside = function(e) {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var getDistricts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var prvCode, districtsRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        prvCode = selected.province.value;
                        if (!prvCode) return [
                            2
                        ];
                        return [
                            4,
                            AddressService/* default.getDistrictsByProvince */.Z.getDistrictsByProvince(prvCode)
                        ];
                    case 1:
                        districtsRes = _state.sent();
                        setDistricts(districtsRes);
                        return [
                            2
                        ];
                }
            });
        });
        return function getDistricts() {
            return _ref.apply(this, arguments);
        };
    }();
    var getWards = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var distCode, wardsRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        distCode = selected.district.value;
                        if (!distCode) return [
                            2
                        ];
                        return [
                            4,
                            AddressService/* default.getWardsByDistrict */.Z.getWardsByDistrict(distCode)
                        ];
                    case 1:
                        wardsRes = _state.sent();
                        setWards(wardsRes);
                        return [
                            2
                        ];
                }
            });
        });
        return function getWards() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getDistricts();
        getWards();
    }, [
        selected.province,
        selected.district,
        selected.ward
    ]);
    // useEffect(() => {
    // 	if (!selected.province || !selected.district || !selected.ward) return;
    // 	setFullAddress(`${selected.ward.label || "--"}/${selected.district.label || "--"}/${selected.province.label || "--"}`);
    // }, [selected]);
    var handleSelect = function(value) {
        if (activeTab === 0) {
            var newSelected = {
                province: value,
                district: "",
                ward: ""
            };
            setSelected(newSelected);
            setValue("provinceCode", value.value);
            setActiveTab(1);
        } else if (activeTab === 1) {
            var newSelected1 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, selected), {
                district: value,
                ward: ""
            });
            setSelected(newSelected1);
            setValue("districtCode", value.value);
            setActiveTab(2);
        } else {
            var newSelected2 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, selected), {
                ward: value
            });
            setSelected(newSelected2);
            setValue("wardCode", value.value);
            setFullAddress("".concat(value.label || "--", "/").concat(selected.district.label || "--", "/").concat(selected.province.label || "--"));
            setIsOpen(false);
        }
        setSearch("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                startAdornment: icon,
                placeholder: placeholder,
                type: "text",
                readOnly: true,
                className: (SelectArea_styles_module_default()).input,
                value: fullAddress,
                error: error,
                onClick: function() {
                    return setIsOpen(!isOpen);
                }
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute z-10 top-full mt-1 bg-white border rounded-lg w-full shadow-lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex border-b",
                        children: TABS.map(function(label, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setActiveTab(index);
                                },
                                className: "flex-1 text-sm p-2 text-center ".concat(activeTab === index ? "text-[#005c29] border-b-2 border-[#005c29]" : "text-gray-500"),
                                children: label
                            }, label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-2 border-b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            placeholder: "ค้นหา",
                            className: "w-full border rounded px-2 py-1 text-sm",
                            value: search,
                            onChange: function(e) {
                                return setSearch(e.target.value);
                            }
                        })
                    }),
                    activeTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "max-h-60 overflow-y-auto p-2 space-y-1 text-sm",
                        children: provinces.filter(function(item) {
                            return item.label.includes(search);
                        }).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "cursor-pointer px-2 py-1 hover:bg-gray-100 rounded",
                                onClick: function() {
                                    return handleSelect(item);
                                },
                                children: item.label
                            }, item.value);
                        })
                    }),
                    activeTab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "max-h-60 overflow-y-auto p-2 space-y-1 text-sm",
                        children: districts.filter(function(item) {
                            return item.label.includes(search);
                        }).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "cursor-pointer px-2 py-1 hover:bg-gray-100 rounded",
                                onClick: function() {
                                    return handleSelect(item);
                                },
                                children: item.label
                            }, item.value);
                        })
                    }),
                    activeTab === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "max-h-60 overflow-y-auto p-2 space-y-1 text-sm",
                        children: wards.filter(function(item) {
                            return item.label.includes(search);
                        }).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "cursor-pointer px-2 py-1 hover:bg-gray-100 rounded",
                                onClick: function() {
                                    return handleSelect(item);
                                },
                                children: item.label
                            }, item.value);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/mocules/NewSignUpForm/index.js














































var NewSignUpForm_isEmpty = utils/* ValidateUtils.isEmpty */.IN.isEmpty, validatePhone = utils/* ValidateUtils.validatePhone */.IN.validatePhone;
// update to zustand for country
var EMAIL_REGEX = utils/* regUtils.EMAIL_REGEX */.d7.EMAIL_REGEX;
var LIST_PROVINCE_CODE_NEED_FILL_DISTRICT_WARD = (/* unused pure expression or super */ null && ([
    "10"
]));
var EMAIL_MIN_LENGTH = 6;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 30;
// Lead source option whose selection shows the free-text `otherSourceDetail` input
var LEAD_SOURCE_OTHER = "other";
var NewSignUpForm = /*#__PURE__*/ react.memo(function(props) {
    var ref, ref1;
    var ref2 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref2.t, i18n = ref2.i18n;
    var ref3 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref3.t;
    var ref4 = (0,react.useState)(false), showPassword = ref4[0], setShowPassword = ref4[1];
    var className = props.className, onClickSignIn = props.onClickSignIn, onClickSignUp = props.onClickSignUp, referCode = props.referCode, page = props.page, setPage = props.setPage, handleScrollTop = props.handleScrollTop, variant = props.variant;
    // Layout theo variant (thứ tự field giống nhau ở mọi chế độ: tên, email, SĐT, mật khẩu, địa chỉ,
    // tên doanh nghiệp, loại hình, "How did you find us", (ô "Khác"), mã giới thiệu):
    // - variant="hero": 1 cột theo design homepage banner (SectionHero), vùng field cuộn được + footer CTA cố định.
    // - variant="fullscreen": popup full màn hình trên mobile web (PopupFullScreen), luôn 1 cột kể cả tablet.
    // - mặc định (NewSignUpModal): lưới 2 cột từ md trở lên, 1 cột dưới md.
    var isHero = variant === "hero";
    var isSingleColumn = isHero || variant === "fullscreen";
    var colFull = isSingleColumn ? "col-span-1" : "col-span-1 md:col-span-2";
    var colHalf = "col-span-1";
    var ref5 = (0,react.useState)([]), provinces = ref5[0], setProvinces = ref5[1];
    var ref6 = (0,react.useState)([]), districts = ref6[0], setDistricts = ref6[1];
    var ref7 = (0,react.useState)([]), wards = ref7[0], setWards = ref7[1];
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var router = (0,next_router.useRouter)();
    var formRef = (0,react.useRef)(null);
    // Lead source ("How did you find us"): optional. Only rendered when the API returns a non-empty list;
    // while loading / on error / non-OK / empty list the field is hidden and never blocks registration.
    var leadSources = hooks_useLeadSources().leadSources;
    var hasLeadSources = leadSources.length > 0;
    var currentLocale = (i18n === null || i18n === void 0 ? void 0 : i18n.language) || (router === null || router === void 0 ? void 0 : router.locale) || sysconfig/* LANG_DEFAULT */.YY;
    var getLeadSourceLabel = function(source) {
        var ref;
        return (source === null || source === void 0 ? void 0 : (ref = source.labels) === null || ref === void 0 ? void 0 : ref[currentLocale]) || (source === null || source === void 0 ? void 0 : source.label);
    };
    var leadSourceOptions = (0,react.useMemo)(function() {
        return leadSources.map(function(source) {
            return {
                value: source.value,
                label: getLeadSourceLabel(source)
            };
        });
    }, [
        leadSources,
        currentLocale
    ]);
    var scopeOptions = (0,react.useMemo)(function() {
        return Object.keys(Enums/* ENUM_SCOPE */.hD).filter(function(item) {
            return item !== "NEW_CUSTOMER";
        }).map(function(item) {
            return {
                value: item,
                label: translateCommon("scope.".concat(item))
            };
        });
    }, [
        translateCommon
    ]);
    var schema = yup_es/* object */.Ry({
        name: yup_es/* string */.Z_().required(translatePopupAction("popup_register.validate_require_username")).min(2, translatePopupAction("popup_register.validate_username_min_2_word")),
        businessName: yup_es/* string */.Z_().trim().required(translatePopupAction("popup_register.MISSING_BUSINESS_NAME")).max(255, translatePopupAction("popup_register.validate_business_name_max")).matches(RegExp("^[\\p{L}\\p{M}\\p{N}\\s]+$", "u"), translatePopupAction("popup_register.validate_business_name_format")),
        password: yup_es/* string */.Z_().required(translatePopupAction("popup_register.validate_password_empty")).min(PASSWORD_MIN_LENGTH, translatePopupAction("popup_register.password_must_be_entered_min2_and_max30_character")).max(PASSWORD_MAX_LENGTH, translatePopupAction("popup_register.password_must_be_entered_min2_and_max30_character")),
        phone: yup_es/* string */.Z_().required(translatePopupAction("popup_register.not_entered_your_phoneNumber"))// dùng chung rule với ValidateUtils.validatePhone để chỉ có 1 nguồn sự thật theo ENV_COUNTRY
        .test("phone-format", translatePopupAction("popup_register.phone_not_correct_format"), function(value) {
            return NewSignUpForm_isEmpty(value) || validatePhone(value);
        }),
        // email là field optional: bỏ trống thì bỏ qua, có nhập thì mới check format
        email: yup_es/* string */.Z_().test("email-format", translatePopupAction("popup_register.email_not_correct_format"), function(value) {
            return NewSignUpForm_isEmpty(value) || value.length >= EMAIL_MIN_LENGTH && EMAIL_REGEX.test(value);
        }),
        // dob: yup.date().required(translatePopupAction('popup_register.not_entered_your_dob')), // because optional field
        provinceCode: yup_es/* string */.Z_().required(translatePopupAction("popup_register.not_entered_your_address")),
        // districtCode: yup.string().required(translatePopupAction('popup_register.not_entered_your_dob')),
        // wardCode: yup.string().required(translatePopupAction('popup_register.not_entered_your_dob')),
        scope: yup_es/* string */.Z_().required(translatePopupAction("popup_register.not_entered_your_business_type")),
        isCheckAgree: yup_es/* bool */.Xg().required(translatePopupAction("popup_register.message_agree_terms")).oneOf([
            true
        ], translatePopupAction("popup_register.message_agree_terms"))
    }).required();
    var ref8 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        defaultValues: {
            name: "",
            businessName: "",
            phone: "",
            email: "",
            password: "",
            scope: "",
            isCheckAgree: false,
            provinceCode: "",
            leadSource: "",
            otherSourceDetail: ""
        }
    }), errors = ref8.formState.errors, control = ref8.control, handleSubmit = ref8.handleSubmit, setValue = ref8.setValue, watch = ref8.watch, getValues = ref8.getValues;
    var selectedLeadSource = watch("leadSource");
    (0,react.useEffect)(function() {
        var getListProvince = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var provinceResult, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                AddressService/* default.getProvinces */.Z.getProvinces()
                            ];
                        case 1:
                            provinceResult = _state.sent();
                            setProvinces(provinceResult);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            utils/* NotifyUtils.error */.QP.error("Can not get list province");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListProvince() {
                return _ref.apply(this, arguments);
            };
        }();
        getListProvince();
    }, []);
    // useEffect(() => {
    //   if (LIST_PROVINCE_CODE_NEED_FILL_DISTRICT_WARD.includes(watch('provinceCode'))) {
    //     const getListDistrict = async () => {
    //       try {
    //         const districtResult = await AddressService.getDistrictsByProvince(watch('provinceCode'));
    //         setDistricts(districtResult);
    //         setValue('districtCode', '');
    //         setValue('wardCode', '');
    //       } catch (error) {
    //         NotifyUtils.error('Can not get list district');
    //       }
    //     };
    //     getListDistrict();
    //   }
    // }, [watch('provinceCode')]);
    // useEffect(() => {
    //   if (watch('districtCode')) {
    //     console.log('call get ward');
    //     const getListWard = async () => {
    //       try {
    //         const wardResult = await AddressService.getWardsByDistrict(watch('districtCode'));
    //         setWards(wardResult);
    //         setValue('wardCode', '');
    //       } catch (error) {
    //         NotifyUtils.error('Can not get list ward');
    //       }
    //     };
    //     getListWard();
    //   }
    // }, [watch('districtCode')]);
    // toàn bộ rule validate đã nằm trong yup schema, tới được đây là data đã hợp lệ
    var handleSubmitSignUp = (0,react.useCallback)(function(data) {
        // Lead tracking: registerURL is always sent (backend reads UTM from it; last UTM landing URL
        // of the session when the current URL has no UTM, see utils/registerURL);
        // leadSource only when the customer picked one (optional field),
        // otherSourceDetail only when leadSource is "other" and the detail is not blank.
        var leadSource = data.leadSource, otherSourceDetail = data.otherSourceDetail, restData = (0,src_object_without_properties/* default */.Z)(data, [
            "leadSource",
            "otherSourceDetail"
        ]);
        var signUpData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restData), {
            registerURL: (0,registerURL/* getRegisterURL */.RQ)()
        });
        if (hasLeadSources && leadSource) {
            signUpData.leadSource = leadSource;
            var trimmedDetail = (otherSourceDetail || "").trim();
            if (leadSource === LEAD_SOURCE_OTHER && trimmedDetail) {
                signUpData.otherSourceDetail = trimmedDetail;
            }
        }
        onClickSignUp(signUpData);
    }, [
        onClickSignUp,
        hasLeadSources
    ]);
    // scroll tới field lỗi đầu tiên theo thứ tự nhìn thấy trên màn hình.
    // dựa vào vị trí thực tế (getBoundingClientRect) thay vì thứ tự DOM/thứ tự key trong errors,
    // vì popup desktop sắp lại ô otherSourceDetail bằng CSS order và key trong errors không đảm bảo thứ tự.
    var scrollToFirstError = (0,react.useCallback)(function() {
        window.requestAnimationFrame(function() {
            var form = formRef.current;
            if (!form) return;
            var errorNodes = Array.from(form.querySelectorAll(".".concat((NewSignUpForm_styles_module_default()).text_error)));
            if (errorNodes.length === 0) return;
            var firstErrorNode = errorNodes.reduce(function(topNode, node) {
                return node.getBoundingClientRect().top < topNode.getBoundingClientRect().top ? node : topNode;
            });
            var fieldNode = firstErrorNode.closest(".MuiFormControl-root") || firstErrorNode;
            fieldNode.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            // [role="combobox"]: trigger của SearchableSelect (loại hình kinh doanh)
            var focusableNode = fieldNode.querySelector('input:not([type="hidden"]), textarea, [role="combobox"]');
            if (focusableNode) focusableNode.focus({
                preventScroll: true
            });
        });
    }, []);
    var handleSetAddressValue = (0,react.useCallback)(function(name, value) {
        setValue(name, value, {
            shouldValidate: true
        });
    }, [
        setValue
    ]);
    var handleClickSignIn = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignIn();
    }, [
        onClickSignIn
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var handleClickTerms = (0,react.useCallback)(function(e) {
        e.preventDefault();
        router.push("/?terms=true");
        setPage(page + 2);
        handleScrollTop();
    }, [
        page
    ]);
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircleOutlined/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconOtherSource = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {})
    });
    var IconPhone = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneOutlined/* default */.Z, {})
    });
    var IconLocation = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: !showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOffOutlined/* default */.Z, {})
        })
    });
    var IconInviter = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleOutlined/* default */.Z, {})
    });
    var IconEmail = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {})
    });
    var IconStore = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        className: (NewSignUpForm_styles_module_default()).input_icon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOutlined/* default */.Z, {})
    });
    var labelAgree = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            translatePopupAction("popup_register.agree_policy"),
            "\xa0",
            beta && dist_lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                component: "a",
                onClick: handleClickTerms,
                style: {
                    color: "#005C29"
                },
                children: translatePopupAction("popup_register.policy")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/terms-and-condition",
                target: "_blank",
                rel: "noreferrer",
                style: {
                    color: "#005C29"
                },
                children: translatePopupAction("popup_register.policy")
            })
        ]
    });
    var isInvalidForm = Object.keys(errors).length > 0;
    (0,react.useEffect)(function() {
        if (referCode) {
            setValue("referCode", referCode);
        }
    }, [
        referCode,
        setValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(className, (NewSignUpForm_styles_module_default()).form_sign_up, isHero && (NewSignUpForm_styles_module_default()).form_hero),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex items-center", isHero ? "flex-wrap px-4 pt-4 lg:pt-6 mb-4" : "mb-5"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)("mr-2", isHero ? "text-xl font-medium" : "text-base md:text-xl"),
                        children: translatePopupAction("popup_register.sign_up_today_for")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)("text-[#FF9E1F]", isHero ? "text-xl font-semibold" : "text-base md:text-2xl font-bold"),
                        children: translatePopupAction("popup_register.exclusive_discount")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                ref: formRef,
                className: (0,clsx_m/* default */.Z)(className, isHero && (NewSignUpForm_styles_module_default()).form_hero_body),
                onSubmit: handleSubmit(handleSubmitSignUp, scrollToFirstError),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(isHero && (NewSignUpForm_styles_module_default()).fields_area),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("grid", isSingleColumn ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2", isInvalidForm ? "gap-2" : "gap-4"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "name",
                                            control: control,
                                            className: (NewSignUpForm_styles_module_default()).form_control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                            startAdornment: IconAccount,
                                                            placeholder: translatePopupAction("popup_register.username"),
                                                            variant: "outlined",
                                                            error: !!errors.name || false,
                                                            className: (NewSignUpForm_styles_module_default()).input,
                                                            "data-test": "signup-username"
                                                        }, field)),
                                                        ((ref = errors.name) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-username",
                                                            children: (ref1 = errors.name) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "email",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                            startAdornment: IconEmail,
                                                            placeholder: translatePopupAction("popup_register.email"),
                                                            variant: "outlined",
                                                            error: !!errors.email || false,
                                                            className: (NewSignUpForm_styles_module_default()).input,
                                                            "data-test": "signup-email"
                                                        }, field)),
                                                        ((ref = errors.email) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-email",
                                                            children: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "phone",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                            startAdornment: IconPhone,
                                                            placeholder: translatePopupAction("popup_register.phone_number"),
                                                            variant: "outlined",
                                                            error: !!errors.phone || false,
                                                            className: (NewSignUpForm_styles_module_default()).input,
                                                            "data-test": "signup-phone"
                                                        }, field)),
                                                        ((ref = errors.phone) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-phone",
                                                            children: (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "password",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                            type: showPassword ? "text" : "password",
                                                            autoComplete: "password",
                                                            startAdornment: IconPassword,
                                                            endAdornment: IconEndPassword,
                                                            placeholder: translatePopupAction("popup_register.password"),
                                                            variant: "outlined",
                                                            error: !!errors.password || false,
                                                            className: (NewSignUpForm_styles_module_default()).input,
                                                            "data-test": "signup-password"
                                                        }, field)),
                                                        ((ref = errors.password) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-password",
                                                            children: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colFull,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                            margin: "none",
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectArea_AddressSelect, {
                                                    error: errors.provinceCode || false,
                                                    // validate lại ngay khi chọn địa chỉ để xoá text lỗi đang hiển thị
                                                    setValue: handleSetAddressValue,
                                                    className: (NewSignUpForm_styles_module_default()).form_control,
                                                    placeholder: translatePopupAction("popup_register.address"),
                                                    "data-test": "signup-address",
                                                    classNameInput: (NewSignUpForm_styles_module_default()).input,
                                                    icon: IconLocation,
                                                    provinces: provinces
                                                }),
                                                ((ref = errors.provinceCode) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (NewSignUpForm_styles_module_default()).text_error,
                                                    "data-test": "signup-err-address",
                                                    children: (ref1 = errors.provinceCode) === null || ref1 === void 0 ? void 0 : ref1.message
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "businessName",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                            startAdornment: IconStore,
                                                            placeholder: translatePopupAction("popup_register.business_name"),
                                                            variant: "outlined",
                                                            error: !!errors.businessName || false,
                                                            className: (NewSignUpForm_styles_module_default()).input,
                                                            inputProps: {
                                                                maxLength: 255
                                                            },
                                                            "data-test": "signup-businessName"
                                                        }, field)),
                                                        ((ref = errors.businessName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-businessName",
                                                            children: (ref1 = errors.businessName) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "scope",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                var ref, ref1;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchableSelect, {
                                                            ref: field.ref,
                                                            id: "signup-scope",
                                                            name: field.name,
                                                            value: field.value,
                                                            onChange: field.onChange,
                                                            onBlur: field.onBlur,
                                                            options: scopeOptions,
                                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalHospital/* default */.Z, {}),
                                                            placeholder: translatePopupAction("popup_register.choose_your_business_type"),
                                                            searchPlaceholder: translatePopupAction("popup_register.search_business_type"),
                                                            noResultsText: translatePopupAction("popup_register.no_results"),
                                                            error: !!errors.scope,
                                                            "data-test": "signup-scope"
                                                        }),
                                                        ((ref = errors.scope) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (NewSignUpForm_styles_module_default()).text_error,
                                                            "data-test": "signup-err-scope",
                                                            children: (ref1 = errors.scope) === null || ref1 === void 0 ? void 0 : ref1.message
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    }),
                                    hasLeadSources && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: colHalf,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "leadSource",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchableSelect, {
                                                        ref: field.ref,
                                                        id: "signup-leadSource",
                                                        name: field.name,
                                                        value: field.value,
                                                        onChange: field.onChange,
                                                        onBlur: field.onBlur,
                                                        options: leadSourceOptions,
                                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignOutlined/* default */.Z, {}),
                                                        placeholder: translatePopupAction("popup_register.lead_source_placeholder", {
                                                            brandname: Enums/* BRAND_NAME */.RS
                                                        }),
                                                        searchPlaceholder: translatePopupAction("popup_register.search_lead_source"),
                                                        noResultsText: translatePopupAction("popup_register.no_results"),
                                                        "data-test": "signup-leadSource"
                                                    })
                                                });
                                            }
                                        })
                                    }),
                                    hasLeadSources && selectedLeadSource === LEAD_SOURCE_OTHER && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)(colFull, !isSingleColumn && "md:order-last"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "otherSourceDetail",
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                        startAdornment: IconOtherSource,
                                                        placeholder: translatePopupAction("popup_register.other_source_detail_placeholder"),
                                                        variant: "outlined",
                                                        className: (NewSignUpForm_styles_module_default()).input,
                                                        "data-test": "signup-otherSourceDetail"
                                                    }, field))
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: hasLeadSources ? colHalf : colFull,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                            name: "referCode",
                                            defaultValue: referCode,
                                            control: control,
                                            render: function(param) {
                                                var field = param.field;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, (0,src_object_spread/* default */.Z)({
                                                        startAdornment: IconInviter,
                                                        value: referCode,
                                                        placeholder: translatePopupAction("popup_register.referral_number"),
                                                        variant: "outlined",
                                                        // disabled={!!referCode}
                                                        className: (NewSignUpForm_styles_module_default()).input,
                                                        "data-test": "signup-referCode"
                                                    }, field))
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                                    name: "isCheckAgree",
                                    defaultValue: false,
                                    control: control,
                                    render: function(param) {
                                        var field = param.field;
                                        var ref, ref1;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (NewSignUpForm_styles_module_default()).agree_term,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, (0,src_object_spread/* default */.Z)({
                                                        "data-test": "signup-isCheckAgree",
                                                        label: labelAgree
                                                    }, field))
                                                }),
                                                ((ref = errors.isCheckAgree) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (NewSignUpForm_styles_module_default()).text_error,
                                                    "data-test": "signup-err-isCheckAgree",
                                                    children: (ref1 = errors.isCheckAgree) === null || ref1 === void 0 ? void 0 : ref1.message
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(isHero && (NewSignUpForm_styles_module_default()).footer_hero),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    className: (NewSignUpForm_styles_module_default()).center,
                                    style: {
                                        whiteSpace: "nowrap"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        className: (NewSignUpForm_styles_module_default()).btn_register,
                                        type: "submit",
                                        "data-test": "signup-submit",
                                        children: translatePopupAction("popup_register.create_account")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((NewSignUpForm_styles_module_default()).link_login_wrapper, " ").concat((NewSignUpForm_styles_module_default()).center, " col-span-3"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        translatePopupAction("popup_register.have_account"),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#top",
                                            className: (NewSignUpForm_styles_module_default()).link_login,
                                            onClick: handleClickSignIn,
                                            children: translatePopupAction("popup_register.login")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var mocules_NewSignUpForm = (NewSignUpForm);

;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailInfo/index.js











var NOT_YET = "(Chưa c\xf3)";
var OrderDetailInfo_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            flexGrow: 1
        },
        paper: {
            padding: theme.spacing(2)
        }
    };
});
var OrderDetailInfo = function(param) {
    var customerName = param.customerName, masterAddress = param.masterAddress, customerEmail = param.customerEmail, customerPhone = param.customerPhone, note = param.note, deliveryTrackingNumber = param.deliveryTrackingNumber, deliveryDate = param.deliveryDate, deliveryCarrier = param.deliveryCarrier, deliveryMethodName = param.deliveryMethodName, paymentMethod = param.paymentMethod, _invoice = param.invoice, invoice = _invoice === void 0 ? {} : _invoice;
    var ref = useTranslation("common"), translateCommon = ref.t;
    var ref1 = useTranslation("detailOrders"), translateOrderDetail = ref1.t;
    var classes = OrderDetailInfo_useStyles();
    var _invoiceRequest = invoice.invoiceRequest, invoiceRequest = _invoiceRequest === void 0 ? false : _invoiceRequest, companyName = invoice.companyName, companyAddress = invoice.companyAddress, taxCode = invoice.taxCode, mst = invoice.mst, email = invoice.email;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.info,
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            spacing: 2,
            className: styles.info_inner_grid,
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 5,
                    className: styles.info_adress,
                    children: /*#__PURE__*/ _jsxs(Paper, {
                        className: classes.paper,
                        elevation: 3,
                        classes: {
                            root: styles.info_left_paper
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("receiver_name")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_1_line),
                                children: customerName
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("receiver_address")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_2_line),
                                children: masterAddress
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: translateOrderDetail("phone_number")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: styles.info_value,
                                children: customerPhone
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: "Email"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: clsx(styles.info_value, styles.ellipsis_1_line),
                                children: customerEmail || NOT_YET
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    item: true,
                    xs: 7,
                    container: true,
                    spacing: 2,
                    direction: "column",
                    className: styles.info_container,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Grid, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Typography, {
                                                display: "inline",
                                                variant: "h5",
                                                className: styles.info_label,
                                                children: [
                                                    translateOrderDetail("payment_method"),
                                                    ":"
                                                ]
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Typography, {
                                                display: "inline",
                                                variant: "h6",
                                                className: styles.info_value,
                                                children: translateCommon(paymentMethod)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        children: paymentMethod !== "PAYMENT_METHOD_NORMAL" && /*#__PURE__*/ _jsxs(Alert, {
                                            className: styles.bank_info,
                                            icon: false,
                                            severity: "info",
                                            children: [
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Chủ t\xe0i khoản \xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "C\xf4ng Ty TNHH Buymed"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Số t\xe0i khoản \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "1913 45430 30020"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Ng\xe2n h\xe0ng \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "Ng\xe2n h\xe0ng Techcombank - Chi nh\xe1nh Bắc Hải"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Nội dung \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                        }),
                                                        "M\xe3 đơn h\xe0ng - T\xean nh\xe0 thuốc"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("delivery_method"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryMethodName,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("shipping_unit"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryCarrier || NOT_YET,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("date"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsx("span", {
                                                children: deliveryDate ? DateTimeUtils.getFormattedWithDate(new Date(deliveryDate), translateCommon) : NOT_YET
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("order_number"),
                                            ":\xa0",
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    deliveryTrackingNumber || NOT_YET,
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            className: styles.info_container,
                            children: /*#__PURE__*/ _jsxs(Paper, {
                                className: classes.paper,
                                elevation: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h5",
                                        className: styles.info_label,
                                        children: [
                                            translateOrderDetail("note"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h6",
                                        className: styles.info_value,
                                        children: note || NOT_YET
                                    })
                                ]
                            })
                        })
                    ]
                }),
                invoiceRequest && /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    className: styles.info_address,
                    children: /*#__PURE__*/ _jsxs(Paper, {
                        className: classes.paper,
                        elevation: 3,
                        classes: {
                            root: styles.info_left_paper
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h4",
                                className: styles.info_title,
                                children: translateOrderDetail("export_invoice_info")
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                className: clsx(styles.info_label),
                                children: /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        translateOrderDetail("company_name"),
                                        ":\xa0",
                                        /*#__PURE__*/ _jsx("span", {
                                            children: companyName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: clsx(styles.info_label),
                                children: [
                                    translateOrderDetail("tax_code"),
                                    ":\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: taxCode || mst
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: [
                                    translateOrderDetail("address_export_invoice"),
                                    ":\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: styles.break_down,
                                        children: companyAddress
                                    })
                                ]
                            }),
                            email && /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                className: styles.info_label,
                                children: [
                                    "Email:\xa0",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: styles.break_down,
                                        children: email
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_OrderDetailInfo = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(OrderDetailInfo))));

// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var utils_ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfo/index.js
var SellerInfo = __webpack_require__(69200);
// EXTERNAL MODULE: ./src/components/mocules/TagType/index.js + 1 modules
var mocules_TagType = __webpack_require__(85201);
;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailProduct/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable no-shadow */ /* react/self-closing-comp */ 










































var STATUS_CHECK_DELIVER = (/* unused pure expression or super */ null && ([
    "WAIT_TO_DELIVER",
    "DELIVERING",
    "DELIVERED",
    "COMPLETED"
]));
var OrderDetailProduct = function(param) {
    var products = param.products, promoName = param.promoName, totalDiscount = param.totalDiscount, totalPriceAll = param.totalPrice, paymentMethodFee = param.paymentMethodFee, deliveryMethodFee = param.deliveryMethodFee, price = param.price, _extraFee = param.extraFee, extraFee = _extraFee === void 0 ? 0 : _extraFee, status = param.status, orderItems = param.orderItems, _point = param.point, point = _point === void 0 ? null : _point;
    var ref = _sliced_to_array(useModal(), 2), isShowOutBoundInfo = ref[0], toggle = ref[1];
    var ref1 = _sliced_to_array(useModal(), 2), isShowPopupConfirm = ref1[0], togglePopupConfirm = ref1[1];
    var totalReturnedPrice = 0;
    var productsReturn = [];
    var totalUndeliverablePrice = 0;
    var undeliverableProducts = [];
    var ref2 = useCart(), updateCartItem = ref2.updateCartItem, updateCart = ref2.updateCart, cartItems = ref2.cartItems;
    // kiểm tra có có sản phẩm xuất kho chưa
    var checkOutbondProducts = !!(products === null || products === void 0 ? void 0 : products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.outboundQuantity) >= 0 && (product === null || product === void 0 ? void 0 : product.outboundInfos);
    }));
    var isShowOutboundUndeliverable = !!products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.outboundQuantity) > 0;
    });
    // kiểm tra có sản phẩm nào không giao
    var checkUndeliverableProducts = !!products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0;
    });
    if (STATUS_CHECK_DELIVER.indexOf(status) >= 0 && checkUndeliverableProducts) {
        var ref3;
        undeliverableProducts = (ref3 = products.filter(function(product) {
            return (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0;
        })) === null || ref3 === void 0 ? void 0 : ref3.map(function(product, index) {
            var tmp = product.price, salePrice = tmp === void 0 ? 0 : tmp, quantity = product.quantity, _outboundQuantity = product.outboundQuantity, outboundQuantity = _outboundQuantity === void 0 ? 0 : _outboundQuantity;
            var undeliverableQuantity = quantity - outboundQuantity;
            var undeliverablePrice = undeliverableQuantity * salePrice;
            totalUndeliverablePrice += undeliverablePrice;
            return _object_spread_props(_object_spread({}, product), {
                index: index,
                undeliverableQuantity: undeliverableQuantity,
                undeliverablePrice: undeliverablePrice
            });
        });
    }
    // kiểm tra có sản phẩm nào trả lại hay không
    var checkReturnProducts = !!(products === null || products === void 0 ? void 0 : products.find(function(product) {
        return (product === null || product === void 0 ? void 0 : product.returnedQuantity) > 0;
    }));
    if (checkReturnProducts) {
        var ref4;
        productsReturn = (ref4 = products.filter(function(product) {
            return (product === null || product === void 0 ? void 0 : product.returnedQuantity) > 0;
        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(product, index) {
            var tmp = product.price, salePrice = tmp === void 0 ? 0 : tmp, returnedQuantity = product.returnedQuantity;
            var productPrice = salePrice * returnedQuantity;
            totalReturnedPrice += productPrice;
            return _object_spread_props(_object_spread({}, product), {
                index: index,
                productPrice: productPrice
            });
        });
    }
    var handleReOrder = function() {
        if (!isShowPopupConfirm) {
            togglePopupConfirm();
        }
    };
    var handleClosePopup = function() {
        togglePopupConfirm();
    };
    // thêm sản phẩm không giao vào giỏ hàng
    var updateUndeliverableProductsCart = function() {
        var _ref = _async_to_generator(function() {
            var isReload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var item, ref, product, _tmp, cartQuantity, _tmp1;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        item = _step.value;
                                        _tmp = {};
                                        product = (_tmp.isDeal = item.productInfo.isDeal, _tmp.name = item.productInfo.name, _tmp.price = item.price, _tmp.quantity = item.undeliverableQuantity, _tmp.sku = item.productInfo.sku, _tmp.type = item.type, _tmp);
                                        cartQuantity = ((ref = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartProduct) {
                                            return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.productId) === (item === null || item === void 0 ? void 0 : item.productID);
                                        })) === null || ref === void 0 ? void 0 : ref.quantity) || 0;
                                        _tmp1 = {};
                                        // eslint-disable-next-line no-await-in-loop
                                        return [
                                            4,
                                            updateCartItem((_tmp1.product = product, _tmp1.q = cartQuantity + item.undeliverableQuantity, _tmp1), isReload)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = undeliverableProducts[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            _ts_values(_loop())
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            4,
                            updateCart()
                        ];
                    case 9:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateUndeliverableProductsCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            STATUS_CHECK_DELIVER.indexOf(status) >= 0 && checkUndeliverableProducts && isShowOutboundUndeliverable ? /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsxs(Grid, {
                        container: true,
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: styles.title_list,
                                    children: "Danh s\xe1ch sản phẩm kh\xf4ng giao"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Grid, {
                                item: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        title: "Th\xeam lại sản phẩm v\xe0o giỏ h\xe0ng",
                                        children: /*#__PURE__*/ _jsx(IconButton, {
                                            size: "small",
                                            className: styles.btn,
                                            onClick: handleReOrder,
                                            children: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                className: styles.icon
                                            })
                                        })
                                    }),
                                    isShowPopupConfirm && /*#__PURE__*/ _jsx(CustomModal, {
                                        icon: false,
                                        visible: isShowPopupConfirm,
                                        onClose: handleClosePopup,
                                        title: "Đặt h\xe0ng lại",
                                        content: "Bạn c\xf3 muốn th\xeam ".concat(undeliverableProducts.length, " sản phẩm kh\xf4ng giao được trong đơn h\xe0ng v\xe0o giỏ h\xe0ng hiện tại?"),
                                        btnOk: "Th\xeam v\xe0o giỏ h\xe0ng",
                                        onClickOk: updateUndeliverableProductsCart
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            children: "STT"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Số lượng kh\xf4ng giao"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    undeliverableProducts.map(function(product) {
                                        var salePrice = product.price, index = product.index, undeliverableQuantity = product.undeliverableQuantity, undeliverablePrice = product.undeliverablePrice;
                                        var ref = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _name = ref.name, name = _name === void 0 ? "" : _name, slug = ref.slug;
                                        return /*#__PURE__*/ _jsx(React.Fragment, {
                                            children: (product === null || product === void 0 ? void 0 : product.quantity) - ((product === null || product === void 0 ? void 0 : product.outboundQuantity) || 0) > 0 ? /*#__PURE__*/ _jsx(_Fragment, {
                                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "left",
                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                variant: "h5",
                                                                className: styles.product_name,
                                                                href: "/product/".concat(slug || ""),
                                                                prefetch: false,
                                                                padding: "0px",
                                                                children: name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(undeliverableQuantity || 0)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(salePrice)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: formatNumber(undeliverablePrice)
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: "Tổng Cộng"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: formatCurrency(totalUndeliverablePrice)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title_list,
                        children: "Danh s\xe1ch sản phẩm đ\xe3 đặt"
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: checkOutbondProducts && /*#__PURE__*/ _jsx(Button, {
                                                onClick: toggle,
                                                className: styles.toggle_button,
                                                children: isShowOutBoundInfo ? /*#__PURE__*/ _jsx(ExpandMoreIcon, {}) : /*#__PURE__*/ _jsx(ExpandLessIcon, {})
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {}),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            colSpan: status !== "COMPLETED" ? "2" : "1",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "L\xf4/ HSD"
                                        }),
                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(Tooltip, {
                                            title: "Điểm t\xedch lũy của từng sản phẩm được l\xe0m tr\xf2n xuống, t\xednh đến số thập ph\xe2n số 2",
                                            children: /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "center",
                                                children: [
                                                    "Tổng điểm t\xedch lũy",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: styles.icon_point,
                                                        children: /*#__PURE__*/ _jsx(ErrorRoundedIcon, {})
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Số lượng"
                                        }),
                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Số lượng thực nhận"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "center",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    products && products.map(function(product) {
                                        var ref, ref1;
                                        var salePrice = product.price, totalPrice = product.totalPrice, quantity = product.quantity, isImportant = product.isImportant, _comboList = product.comboList, comboList = _comboList === void 0 ? [] : _comboList, outboundInfos = product.outboundInfos, outboundQuantity = product.outboundQuantity, type = product.type, skuProduct = product.sku, _totalPoint = product.totalPoint, totalPoint = _totalPoint === void 0 ? null : _totalPoint;
                                        var ref2 = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _imagesProxy = ref2.imagesProxy, imagesProxy = _imagesProxy === void 0 ? [] : _imagesProxy, _name = ref2.name, name = _name === void 0 ? "" : _name, _slug = ref2.slug, slug = _slug === void 0 ? "" : _slug, isGift = ref2.isGift, tags = ref2.tags, statusData = ref2.statusData, requireGPPMessage = ref2.requireGPPMessage;
                                        return /*#__PURE__*/ _jsxs(React.Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs(TableRow, {
                                                    className: clsx(styles.product_row, (comboList === null || comboList === void 0 ? void 0 : comboList.length) > 0 ? styles.has_combo : ""),
                                                    children: [
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "center",
                                                            children: /*#__PURE__*/ _jsx(StarIcon, {
                                                                style: {
                                                                    color: isImportant ? "#f9b514" : ""
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                href: "/product/".concat(slug || ""),
                                                                children: /*#__PURE__*/ _jsx(Image, {
                                                                    loader: myLoader,
                                                                    src: !isEmpty(imagesProxy) ? getLinkGCS("".concat(imagesProxy[0])) : getLinkGCS(MISSING_IMAGE),
                                                                    alt: name,
                                                                    width: 120,
                                                                    height: 80
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs(TableCell, {
                                                            align: "left",
                                                            className: styles.product_table_name,
                                                            colSpan: status !== "COMPLETED" ? "2" : "1",
                                                            children: [
                                                                isGift ? name : /*#__PURE__*/ _jsxs(_Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(LinkComp, {
                                                                            variant: "h5",
                                                                            href: "/product/".concat(slug || ""),
                                                                            className: styles.product_name,
                                                                            padding: "0px",
                                                                            children: name
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: styles.product_tags,
                                                                            children: [
                                                                                (type === "DEAL" || type === "CAMPAIGN") && tags.indexOf("CAMPAIGN") === -1 && tags.indexOf("DEAL") === -1 && /*#__PURE__*/ _jsx(Link, {
                                                                                    href: "/deals",
                                                                                    prefetch: false,
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: styles.discount_flag,
                                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                                            className: styles.discount_flag_text,
                                                                                            children: "Khuyến m\xe3i"
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                orderItems && ((ref = orderItems === null || orderItems === void 0 ? void 0 : orderItems.find(function(param) {
                                                                                    var sku = param.sku;
                                                                                    return sku === skuProduct;
                                                                                })) === null || ref === void 0 ? void 0 : (ref1 = ref.tags) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                                                                    /*#__PURE__*/ return _jsx(TagType, {
                                                                                        item: item,
                                                                                        exp: (statusData === null || statusData === void 0 ? void 0 : statusData.date) || null
                                                                                    }, uuidV4());
                                                                                })) || "",
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: orderItems && (orderItems === null || orderItems === void 0 ? void 0 : orderItems.find(function(param) {
                                                                                        var sku = param.sku;
                                                                                        return sku === skuProduct;
                                                                                    }).type) === "DEAL" && tags.indexOf("DEAL") > -1 && /*#__PURE__*/ _jsx(TagType, {
                                                                                        item: "DEAL",
                                                                                        exp: (statusData === null || statusData === void 0 ? void 0 : statusData.date) || null
                                                                                    }, uuidV4())
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                isGift && /*#__PURE__*/ _jsx("div", {
                                                                    className: styles.product_tags,
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: styles.gift_flag,
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            className: styles.gift_flag_text,
                                                                            children: "Qu\xe0 tặng"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(_Fragment, {
                                                                    children: requireGPPMessage && /*#__PURE__*/ _jsx(Typography, {
                                                                        className: styles.text_danger,
                                                                        children: requireGPPMessage
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right"
                                                        }),
                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatFloatNumber(totalPoint) || 0
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatNumber(quantity)
                                                        }),
                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: formatNumber(product === null || product === void 0 ? void 0 : product.completedQuantity)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            className: styles.product_price,
                                                            children: isGift ? "-" : formatNumber(salePrice)
                                                        }),
                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                            align: "right",
                                                            children: isGift ? "-" : formatNumber(totalPrice)
                                                        })
                                                    ]
                                                }, uuidV4()),
                                                (comboList === null || comboList === void 0 ? void 0 : comboList.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(TableRow, {
                                                            className: styles.combo_head,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    colSpan: "4",
                                                                    children: "Mua combo bao gồm"
                                                                })
                                                            ]
                                                        }),
                                                        comboList === null || comboList === void 0 ? void 0 : comboList.map(function(item, key) {
                                                            var ref;
                                                            var name = item.name, slug = item.slug, isGift = item.isGift, price = item.price, tags = item.tags, _quantity = item.quantity, quantity = _quantity === void 0 ? 0 : _quantity, totalPrice = item.totalPrice, productId = item.productId;
                                                            return /*#__PURE__*/ _jsxs(TableRow, {
                                                                className: clsx(styles.combo_row, comboList.length - 1 === key ? styles.last : ""),
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(TableCell, {
                                                                        align: "left",
                                                                        className: styles.product_table_name,
                                                                        children: [
                                                                            isGift ? /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: name
                                                                            }) : /*#__PURE__*/ _jsx(LinkComp, {
                                                                                className: styles.cb_link,
                                                                                href: "/product/".concat(slug),
                                                                                prefetch: false,
                                                                                children: name
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: styles.product_tags,
                                                                                children: tags && ((ref = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
                                                                                    return tag === ENUM_TAG_CODES.HOADONNHANH || tag === TAG_HANG_DAT_TRUOC;
                                                                                })) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                                                                                    return /*#__PURE__*/ _jsx(TagType, {
                                                                                        item: tag
                                                                                    }, uuidV4());
                                                                                }))
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        className: styles.product_price,
                                                                        children: formatNumber(quantity)
                                                                    }),
                                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        className: styles.product_price,
                                                                        children: isGift ? "-" : formatNumber(price)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        children: isGift ? "Qu\xe0 Tặng" : formatNumber(totalPrice)
                                                                    })
                                                                ]
                                                            }, productId);
                                                        })
                                                    ]
                                                }),
                                                isShowOutBoundInfo && outboundQuantity >= 0 && outboundInfos ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(TableRow, {
                                                            className: styles.combo_head,
                                                            style: {
                                                                background: " rgba(224, 224, 224, 1)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    colSpan: "4",
                                                                    style: {
                                                                        paddingTop: "15px"
                                                                    },
                                                                    children: "Danh s\xe1ch sản phẩm xuất kho"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                })
                                                            ]
                                                        }),
                                                        outboundInfos === null || outboundInfos === void 0 ? void 0 : outboundInfos.map(function(info) {
                                                            /*#__PURE__*/ return _jsxs(TableRow, {
                                                                style: {
                                                                    background: " rgba(246, 246, 247, 1)"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "left",
                                                                        children: /*#__PURE__*/ _jsxs(LinkComp, {
                                                                            variant: "h5",
                                                                            className: styles.product_name,
                                                                            href: "/product/".concat(slug || ""),
                                                                            prefetch: false,
                                                                            padding: "0px",
                                                                            children: [
                                                                                name,
                                                                                "h"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(TableCell, {
                                                                        align: "center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: info === null || info === void 0 ? void 0 : info.lot
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                                className: styles.cb_unlink,
                                                                                children: info === null || info === void 0 ? void 0 : info.expDate
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right",
                                                                        children: info.quantity
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    }),
                                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                        align: "right"
                                                                    })
                                                                ]
                                                            }, uuidV4());
                                                        }),
                                                        comboList && (comboList === null || comboList === void 0 ? void 0 : comboList.map(function(item) {
                                                            var ref;
                                                            return item === null || item === void 0 ? void 0 : (ref = item.outboundInfos) === null || ref === void 0 ? void 0 : ref.map(function(info) {
                                                                /*#__PURE__*/ return _jsxs(TableRow, {
                                                                    style: {
                                                                        background: " rgba(246, 246, 247, 1)"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "left",
                                                                            children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                                variant: "h5",
                                                                                className: styles.product_name,
                                                                                href: "/product/".concat(slug || ""),
                                                                                prefetch: false,
                                                                                padding: "0px",
                                                                                children: item.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs(TableCell, {
                                                                            align: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                                    className: styles.cb_unlink,
                                                                                    children: info === null || info === void 0 ? void 0 : info.lot
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Typography, {
                                                                                    className: styles.cb_unlink,
                                                                                    children: info === null || info === void 0 ? void 0 : info.expDate
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right",
                                                                            children: info.quantity
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        }),
                                                                        status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {
                                                                            align: "right"
                                                                        })
                                                                    ]
                                                                }, uuidV4());
                                                            });
                                                        }))
                                                    ]
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                            ]
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        className: styles.product_row,
                                        children: [
                                            status === "COMPLETED" && /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right"
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right"
                                            }),
                                            /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "right",
                                                colSpan: "5",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Tạm t\xednh :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Ph\xed theo h\xecnh thức thanh to\xe1n :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Ph\xed vận chuyển :"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: "Phụ ph\xed:"
                                                    }),
                                                    !isEmpty(promoName) && /*#__PURE__*/ _jsxs("div", {
                                                        className: styles.total_bottom,
                                                        children: [
                                                            "M\xe3 giảm gi\xe1 ",
                                                            /*#__PURE__*/ _jsxs("strong", {
                                                                children: [
                                                                    promoName,
                                                                    " :"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        style: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: "Tổng điểm t\xedch lũy:"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(TableCell, {
                                                align: "right",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(price)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(paymentMethodFee)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(deliveryMethodFee)
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(extraFee)
                                                    }),
                                                    !isEmpty(promoName) && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        children: formatNumber(-totalDiscount)
                                                    }),
                                                    status === "COMPLETED" && /*#__PURE__*/ _jsx("div", {
                                                        className: styles.total_bottom,
                                                        style: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: formatFloatNumber(point)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, uuidV4())
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Grid, {
                        className: styles.total_price,
                        container: true,
                        justifyContent: "flex-end",
                        style: {
                            padding: " 0px 15px 30px 15px"
                        },
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.price_label,
                                children: /*#__PURE__*/ _jsx("b", {
                                    children: "Tổng cộng"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.price,
                                children: formatCurrency(totalPriceAll)
                            })
                        ]
                    })
                ]
            }),
            (status === "DELIVERED" || status === "COMPLETED") && checkReturnProducts ? /*#__PURE__*/ _jsxs(TableContainer, {
                component: Paper,
                className: styles.table,
                elevation: 4,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.title_list,
                        children: "Danh s\xe1ch sản phẩm trả h\xe0ng"
                    }),
                    /*#__PURE__*/ _jsxs(Table, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHead, {
                                children: /*#__PURE__*/ _jsxs(TableRow, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            children: "STT"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "Sản phẩm"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "left",
                                            children: "L\xf4/ HSD"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Số lượng trả"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Gi\xe1 (đ)"
                                        }),
                                        /*#__PURE__*/ _jsx(TableCell, {
                                            align: "right",
                                            children: "Tổng cộng (đ)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(TableBody, {
                                children: [
                                    productsReturn.map(function(product) {
                                        var ref, ref1;
                                        var salePrice = product.price, _returnInfos = product.returnInfos, returnInfos = _returnInfos === void 0 ? [] : _returnInfos, returnedQuantity = product.returnedQuantity, index = product.index, productPrice = product.productPrice;
                                        var ref2 = (product === null || product === void 0 ? void 0 : product.productInfo) || {}, _name = ref2.name, name = _name === void 0 ? "" : _name, slug = ref2.slug;
                                        return /*#__PURE__*/ _jsx(React.Fragment, {
                                            children: returnedQuantity > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs(TableRow, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                children: index + 1
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "left",
                                                                children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                    variant: "h5",
                                                                    className: styles.product_name,
                                                                    href: "/product/".concat(slug || ""),
                                                                    prefetch: false,
                                                                    padding: "0px",
                                                                    children: name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "left",
                                                                children: returnInfos.length === 1 ? "".concat(((ref = returnInfos[0]) === null || ref === void 0 ? void 0 : ref.lot) || "", "/ ").concat(((ref1 = returnInfos[0]) === null || ref1 === void 0 ? void 0 : ref1.expDate) || "") : "-"
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(returnedQuantity)
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(salePrice)
                                                            }),
                                                            /*#__PURE__*/ _jsx(TableCell, {
                                                                align: "right",
                                                                children: formatNumber(productPrice)
                                                            })
                                                        ]
                                                    }),
                                                    returnInfos.length > 1 && returnInfos.map(function(returnInfo) {
                                                        /*#__PURE__*/ return _jsxs(TableRow, {
                                                            style: {
                                                                background: " rgba(246, 246, 247, 1)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TableCell, {}),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    children: /*#__PURE__*/ _jsx(LinkComp, {
                                                                        variant: "h5",
                                                                        className: styles.product_name,
                                                                        href: "/product/".concat(slug || ""),
                                                                        prefetch: false,
                                                                        padding: "0px",
                                                                        children: name
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "left",
                                                                    children: "".concat((returnInfo === null || returnInfo === void 0 ? void 0 : returnInfo.lot) || "", "/ ").concat((returnInfo === null || returnInfo === void 0 ? void 0 : returnInfo.expDate) || "")
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right",
                                                                    children: formatNumber(returnInfo.quantity)
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                }),
                                                                /*#__PURE__*/ _jsx(TableCell, {
                                                                    align: "right"
                                                                })
                                                            ]
                                                        }, uuidV4());
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        }, uuidV4());
                                    }),
                                    /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {}),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: "Tổng Cộng"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                align: "right",
                                                children: /*#__PURE__*/ _jsx("b", {
                                                    children: formatCurrency(totalReturnedPrice)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(_Fragment, {})
        ]
    });
};
/* harmony default export */ var mocules_OrderDetailProduct = ((/* unused pure expression or super */ null && (OrderDetailProduct)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/StepConnector/StepConnector.js
var StepConnector = __webpack_require__(18530);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
;// CONCATENATED MODULE: ./src/components/mocules/OrderDetailStep/index.js

















var ColorlibConnector = (0,withStyles/* default */.Z)({
    alternativeLabel: {
        top: 40
    },
    active: {
        "& $line": {
            backgroundColor: "#005C29!important"
        }
    },
    completed: {
        "& $line": {
            backgroundColor: "#005C29!important"
        }
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: "#eaeaf0",
        borderRadius: 1
    }
})(StepConnector/* default */.Z);
var useColorlibStepIconStyles = (0,makeStyles/* default */.Z)({
    root: {
        backgroundColor: "white",
        border: "4px solid #ced4da",
        zIndex: 1,
        color: "#ced4da",
        width: 80,
        height: 80,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center"
    },
    active: {
        border: "4px solid #005C29",
        background: "white",
        color: "#005C29"
    },
    completed: {
        border: "4px solid #005C29",
        background: "white",
        color: "#005C29"
    }
});
function ColorlibStepIcon(param) {
    var icon = param.icon, active = param.active, completed = param.completed;
    var classes = useColorlibStepIconStyles();
    var icons = {
        1: /*#__PURE__*/ _jsx(AssignmentIcon, {
            fontSize: "large"
        }),
        2: /*#__PURE__*/ _jsx(AssignmentTurnedInIcon, {
            fontSize: "large"
        }),
        3: /*#__PURE__*/ _jsx(BusinessCenterIcon, {
            fontSize: "large"
        }),
        4: /*#__PURE__*/ _jsx(AirportShuttleIcon, {
            fontSize: "large"
        }),
        5: /*#__PURE__*/ _jsx(EventAvailableIcon, {
            fontSize: "large"
        }),
        6: /*#__PURE__*/ _jsx(CheckIcon, {
            fontSize: "large"
        })
    };
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(classes.root, (_obj = {}, _define_property(_obj, classes.active, active), _define_property(_obj, classes.completed, completed), _obj)),
        children: icons[String(icon)]
    });
}
var steps = (/* unused pure expression or super */ null && ([
    "Chờ x\xe1c nhận",
    "Đ\xe3 x\xe1c nhận",
    "Đang xử l\xfd",
    "Đang trung chuyển",
    "Đang giao h\xe0ng",
    "Đ\xe3 giao",
    "Ho\xe0n tất", 
]));
var _obj;
var MappingStep = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM, 0), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.CONFIRMED */.TJ.CONFIRMED, 1), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.PROCESSING */.TJ.PROCESSING, 2), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.WAIT_TO_DELIVER */.TJ.WAIT_TO_DELIVER, 2), // forbidden
(0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.DELIVERING */.TJ.DELIVERING, 3), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.DELIVERED */.TJ.DELIVERED, 4), (0,src_define_property/* default */.Z)(_obj, Enums/* ENUM_ORDER_STATUS.COMPLETED */.TJ.COMPLETED, 5), _obj);
var OrderDetailStep = function(param) {
    var _status = param.status, status = _status === void 0 ? 1 : _status;
    return /*#__PURE__*/ _jsx(Stepper, {
        className: styles.step,
        alternativeLabel: true,
        activeStep: status !== "CANCEL" ? MappingStep[status] : -1,
        connector: /*#__PURE__*/ _jsx(ColorlibConnector, {}),
        children: steps.map(function(label) {
            return /*#__PURE__*/ _jsx(Step, {
                children: /*#__PURE__*/ _jsx(StepLabel, {
                    StepIconComponent: ColorlibStepIcon,
                    children: label
                })
            }, uuidv4());
        })
    });
};
/* harmony default export */ var mocules_OrderDetailStep = ((/* unused pure expression or super */ null && (OrderDetailStep)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./src/components/organisms/ExportDataOrderDetail/index.js










// import dynamic from 'next/dynamic';




// const XLSX = dynamic(() => import('xlsx'), { ssr: false });
var ExportDataOrderDetail_ExportDataOrderDetail = function(param) {
    var orderId = param.orderId;
    var getStyleBySlugOfTag = useStore(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var user = useAuth().user;
    var productList = function() {
        var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var list = [];
        products.forEach(function(item, index) {
            var ref = (item === null || item === void 0 ? void 0 : item.productInfo) || {}, _tags = ref.tags, tags = _tags === void 0 ? null : _tags, _isGift = ref.isGift, isGift = _isGift === void 0 ? false : _isGift;
            var tagList = [];
            if (isGift) tagList.push("QU\xc0 TẶNG");
            else if (tags) {
                tags.forEach(function(tag) {
                    var ref;
                    if (tag !== "GIFT") tagList.push((ref = getStyleBySlugOfTag(tag)) === null || ref === void 0 ? void 0 : ref.name);
                });
            }
            var tagNameString = tagList.toString();
            list.push({
                order: index + 1,
                name: item.productInfo.name,
                quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                tags: tagNameString,
                totalPrice: item.totalPrice
            });
        });
        return list;
    };
    var downloadFileOrderDetail = function() {
        var _ref = _async_to_generator(function(orderID) {
            var XLSX, orderRes, _tmp, order, _tmp1, productsInfo, totalItem, totalQuantity, totalPrice, createdTime, deliveryDate, paymentMethod, redeemCode, totalDiscount, customerName, customerPhone, extraFee, deliveryMethodFee, fileType, fileExtension, fileName, sheetName, wb, wsData, ws, _tmp2, _tmp3, _tmp4, excelBuffer, _tmp5, data, _tmp6, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2599), __webpack_require__.e(4849), __webpack_require__.e(3524), __webpack_require__.e(139)]).then(__webpack_require__.t.bind(__webpack_require__, 7869, 23))
                        ];
                    case 1:
                        XLSX = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            OrderService.getOrderDetail((_tmp.orderId = Number(orderID), _tmp.getCombo = false, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp))
                        ];
                    case 2:
                        orderRes = _state.sent();
                        if (!isValid(orderRes)) {
                            throw Error((orderRes === null || orderRes === void 0 ? void 0 : orderRes.message) || "Xuất đơn h\xe0ng kh\xf4ng th\xe0nh c\xf4ng");
                        }
                        _tmp1 = {};
                        order = getFirst(orderRes, _tmp1);
                        productsInfo = productList(order.products);
                        totalItem = order.totalItem, totalQuantity = order.totalQuantity, totalPrice = order.totalPrice, createdTime = order.createdTime, deliveryDate = order.deliveryDate, paymentMethod = order.paymentMethod, redeemCode = order.redeemCode, totalDiscount = order.totalDiscount, customerName = order.customerName, customerPhone = order.customerPhone, extraFee = order.extraFee, deliveryMethodFee = order.deliveryMethodFee;
                        fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                        fileExtension = ".xlsx";
                        fileName = "Th\xf4ng tin chi tiết đơn h\xe0ng ".concat(orderId, " - ").concat(customerName, " - ").concat(customerPhone, " - ").concat(BRAND_NAME);
                        sheetName = "".concat(orderId);
                        wb = XLSX.utils.book_new();
                        wb.SheetNames.push(sheetName);
                        wsData = [
                            [
                                "M\xe3 đơn",
                                orderId
                            ],
                            [],
                            [
                                "Sản phẩm",
                                totalItem
                            ],
                            [
                                "Tổng số lượng",
                                totalQuantity
                            ],
                            [
                                "Tổng gi\xe1 tiền",
                                totalPrice
                            ],
                            [
                                "Ng\xe0y mua",
                                new Date(createdTime)
                            ],
                            [
                                "Ng\xe0y giao dự kiến",
                                new Date(deliveryDate)
                            ],
                            [
                                "H\xecnh thức thanh to\xe1n",
                                PAYMENT_METHOD_NAME[paymentMethod]
                            ],
                            [
                                "Ph\xed giao h\xe0ng",
                                deliveryMethodFee
                            ],
                            [
                                "Phụ ph\xed",
                                extraFee
                            ],
                            redeemCode && redeemCode.length > 0 && [
                                "M\xe3 giảm gi\xe1",
                                redeemCode[0]
                            ],
                            totalDiscount && totalDiscount > 0 && [
                                "Số tiền được giảm",
                                totalDiscount
                            ]
                        ];
                        ws = XLSX.utils.aoa_to_sheet(wsData);
                        _tmp2 = {};
                        _tmp3 = {};
                        XLSX.utils.sheet_add_json(ws, [
                            (_tmp2.A = "Số thứ tự", _tmp2.B = "T\xean sản phẩm", _tmp2.C = "Số lượng", _tmp2.D = "Tags", _tmp2.E = "Tổng tiền", _tmp2)
                        ], (_tmp3.skipHeader = true, _tmp3.origin = "A15", _tmp3));
                        _tmp4 = {};
                        XLSX.utils.sheet_add_json(ws, productsInfo, (_tmp4.skipHeader = true, _tmp4.origin = "A16", _tmp4));
                        wb.Sheets[sheetName] = ws;
                        _tmp5 = {};
                        excelBuffer = XLSX.write(wb, (_tmp5.bookType = "xlsx", _tmp5.type = "array", _tmp5));
                        _tmp6 = {};
                        data = new Blob([
                            excelBuffer
                        ], (_tmp6.type = fileType, _tmp6));
                        FileSaver.saveAs(data, fileName + fileExtension);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        NotifyUtils.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadFileOrderDetail(orderID) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: "Xuất th\xf4ng tin chi tiết đơn h\xe0ng",
        children: /*#__PURE__*/ _jsx(IconButton, {
            size: "small",
            className: styles.btn,
            onClick: function() {
                return downloadFileOrderDetail(orderId);
            },
            children: /*#__PURE__*/ _jsx(CloudDownloadIcon, {
                className: styles.icon
            })
        })
    });
};
/* harmony default export */ var organisms_ExportDataOrderDetail = ((/* unused pure expression or super */ null && (ExportDataOrderDetail_ExportDataOrderDetail)));

;// CONCATENATED MODULE: ./src/components/organisms/InvoiceList/index.js














var InvoiceList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        expand: {
            transform: "rotate(-90deg)",
            marginLeft: "auto",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shortest
            })
        },
        expandOpen: {
            transform: "rotate(0deg)"
        },
        root: {
            padding: "12px !important",
            borderRadius: "50% !important"
        }
    };
});
var InvoiceList_InvoiceList = function(param) {
    var tmp = param.invoiceData, invoiceObject = tmp === void 0 ? {} : tmp, orderId = param.orderId;
    var classes = InvoiceList_useStyles();
    var ref = useState(false), expanded = ref[0], setExpanded = ref[1];
    if (!invoiceObject) {
        return null;
    }
    var _invoiceData = invoiceObject.invoiceData, invoiceData = _invoiceData === void 0 ? [] : _invoiceData, _source = invoiceObject.source, source = _source === void 0 ? "" : _source, _vatType = invoiceObject.vatType, vatType = _vatType === void 0 ? "" : _vatType;
    var fileList = [];
    invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.forEach(function(item) {
        if (item === null || item === void 0 ? void 0 : item.pdfUrl) fileList.push(item === null || item === void 0 ? void 0 : item.pdfUrl);
    });
    var name = "Chứng Từ H\xf3a Đơn";
    if (vatType === "VAT_ALL") {
        name += " MedX 5%,8%,10%";
    } else if (source === "MEDX") {
        name += " MedX 5%,10%";
    } else if (source === "MEDX-8") {
        name += " MedX 8%";
    }
    var handleExpandClick = function() {
        setExpanded(!expanded);
    };
    return (fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.head_popup,
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: styles.title_popup,
                        children: [
                            fileList.length,
                            " ",
                            name,
                            " "
                        ]
                    }),
                    fileList.length > 0 && /*#__PURE__*/ _jsx(IconButton, {
                        className: clsx(classes.root, classes.expand, _define_property({}, classes.expandOpen, expanded)),
                        onClick: handleExpandClick,
                        "aria-expanded": expanded,
                        "aria-label": "show more",
                        children: /*#__PURE__*/ _jsx(ExpandMoreIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: fileList.map(function(file, i) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: styles.item,
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                className: styles.fileName,
                                children: [
                                    "VAT - ",
                                    orderId,
                                    " - ",
                                    i + 1
                                ]
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: file,
                                target: "blank",
                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                    title: "Xem v\xe0 tải xuống",
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        className: classes.root,
                                        "aria-label": "pdf",
                                        children: /*#__PURE__*/ _jsx(CloudDownloadIcon, {})
                                    })
                                })
                            })
                        ]
                    }, uuidv4());
                })
            })
        ]
    });
};
/* harmony default export */ var organisms_InvoiceList = ((/* unused pure expression or super */ null && (InvoiceList_InvoiceList)));

// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var utils_NotifyUtils = __webpack_require__(25872);
;// CONCATENATED MODULE: ./src/components/mocules/ButtonReOrder/index.js




















var ButtonReOrder_ButtonReOrder = function(param) {
    var orderId = param.orderId;
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var ref1 = useTranslation("tooltip-action"), translateTooltipAction = ref1.t;
    var ref2 = useTranslation("myOrder"), translateMyOrder = ref2.t;
    // const router = useRouter();
    var user = useAuth().user;
    var reOrderById = useCart().reOrderById;
    var ref3 = _sliced_to_array(useModal(), 2), isShowPopupConfirm = ref3[0], togglePopupConfirm = ref3[1];
    var ref4 = useState([]), items = ref4[0], setItems = ref4[1];
    var handleShowInfo = function() {
        var _ref = _async_to_generator(function() {
            var orderInfoRes, _tmp, orderInfo;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            OrderService.getOrderDetail((_tmp.orderId = orderId, _tmp.locationCode = user === null || user === void 0 ? void 0 : user.provinceCode, _tmp.customerLevel = user === null || user === void 0 ? void 0 : user.level, _tmp.getCombo = false, _tmp))
                        ];
                    case 1:
                        orderInfoRes = _state.sent();
                        orderInfo = getFirst(orderInfoRes);
                        if (!orderInfo) {
                            NotifyUtils.warn(translateAlertAction("message_not_found_order"));
                            return [
                                2
                            ];
                        }
                        setItems((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.products) || []);
                        gtag.reOrderShowPopup();
                        togglePopupConfirm();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShowInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClosePopup = function() {
        togglePopupConfirm();
        gtag.reOrderClickCancel();
    };
    var handleReOrder = function() {
        var _ref = _async_to_generator(function() {
            var result, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            reOrderById((_tmp.orderId = orderId, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        // const { products = [] } = orderInfo;
                        // const promiseAddProduct = [];
                        // products.forEach((item) => {
                        //   promiseAddProduct.push(updateCartItem({ product: item, q: item.quantity || 1 }));
                        // });
                        // await Promise.any(promiseAddProduct);
                        // update delivery info
                        // await updateCartInfo(orderInfo);
                        if (isShowPopupConfirm) {
                            togglePopupConfirm();
                        }
                        gtag.reOrderClickOk();
                        // const response = await CartService.checkoutCart(orderInfo);
                        if (isValid(result)) {
                            NotifyUtils.success(translateAlertAction("message_add_to_cart"));
                        } else {
                            NotifyUtils.error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_error_try_again"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                title: translateTooltipAction("tooltip_re-order"),
                arrow: true,
                children: /*#__PURE__*/ _jsx(ButtonDefault, {
                    onClick: handleShowInfo,
                    className: "my-order__button my-order__button--secondary",
                    children: translateMyOrder("my-order.re_order")
                })
            }),
            isShowPopupConfirm && /*#__PURE__*/ _jsx(CustomModal, {
                icon: false,
                visible: isShowPopupConfirm,
                onClose: handleClosePopup,
                title: translateMyOrder("my-order.re_buy"),
                content: translateMyOrder("my-order.do_you_want_to_re_add_product", {
                    numberProducts: items.length,
                    orderId: orderId
                }),
                btnOk: translateMyOrder("my-order.addCart"),
                onClickOk: handleReOrder,
                children: /*#__PURE__*/ _jsx(Grid, {
                    style: {
                        overflowY: "auto",
                        maxHeight: "400px"
                    },
                    children: items && items.length > 0 && items.map(function(param) {
                        var productInfo = param.productInfo, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity;
                        var ref = productInfo || {}, defaultImage = ref.defaultImage, name = ref.name, salePrice = ref.salePrice;
                        return /*#__PURE__*/ _jsxs(Card, {
                            className: styles.remove_item,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.remove_item_image,
                                    children: /*#__PURE__*/ _jsx(ImageFallbackProductImage, {
                                        className: styles.remove_item_image,
                                        src: defaultImage && "".concat(defaultImage, "?size=200"),
                                        fallbackSrc: defaultImage,
                                        width: 80,
                                        height: 80,
                                        alt: name && name
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.remove_item_content,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.remove_item_cart_name,
                                            children: name && name
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: styles.remove_item_cart_price,
                                            children: [
                                                quantity,
                                                " x",
                                                salePrice && formatCurrency(salePrice)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, uuidv4());
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_ButtonReOrder = ((/* unused pure expression or super */ null && (ButtonReOrder_ButtonReOrder)));

;// CONCATENATED MODULE: ./src/components/mocules/ButtonReturnOrder/index.js



















function ButtonReturnOrder_ButtonReturnOrder(param) {
    var disabled = param.disabled, orderId = param.orderId, className = param.className, V2style = param.V2style;
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var ref1 = useTranslation("detailOrders"), translateDetailOrders = ref1.t;
    var router = useRouter();
    var ref2 = _sliced_to_array(React.useState([]), 2), ticketReturn = ref2[0], setTicketReturn = ref2[1];
    var token = Cookies.get(ACCESS_TOKEN);
    var returnOrderRes = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        TicketClient.getTicketReturn(orderId)
                    ];
                case 1:
                    res = _state.sent();
                    setTicketReturn(getData(res));
                    return [
                        2
                    ];
            }
        });
    }), [
        orderId
    ]);
    React.useEffect(function() {
        returnOrderRes();
    }, []);
    var handleRedirectPOS = function() {
        var _ref = _async_to_generator(function() {
            var statusRes;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TicketClient.getVerifyTickerReturn(orderId)
                        ];
                    case 1:
                        statusRes = _state.sent();
                        if (isValidWithoutData(statusRes)) {
                            router.push("".concat(RETURN_ORDER_DOMAIN, "?token=").concat(token, "&orderId=").concat(orderId));
                        } else {
                            NotifyUtils.error(translateAlertAction("message_import_order_so_request_can_not_completed"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRedirectPOS() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(Grid, {
        className: styles.wrapBtn,
        children: ticketReturn.length > 0 ? ticketReturn === null || ticketReturn === void 0 ? void 0 : ticketReturn.map(function(param) {
            var code = param.code, ticketId = param.ticketId;
            return /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                alignItems: "center",
                justifyContent: "center",
                className: clsx(styles.wrapTicketId, className),
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: styles.ticketCode,
                        children: [
                            translateDetailOrders("detail-orders.return_request_form"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(LinkComp, {
                        style: {
                            color: "#2360d8",
                            cursor: "pointer",
                            fontSize: "16px"
                        },
                        href: "".concat(RETURN_ORDER_DOMAIN_TICKETID, "?ticketId=").concat(ticketId, "&token=").concat(token),
                        "aria-hidden": "true",
                        className: styles.redirectLink,
                        children: ticketId
                    })
                ]
            }, code);
        }) : /*#__PURE__*/ _jsx(Button, {
            style: {
                display: V2style ? "none" : ""
            },
            disabled: disabled,
            onClick: handleRedirectPOS,
            startIcon: /*#__PURE__*/ _jsx(Image, {
                src: ReturnOrderIcon,
                width: 29,
                height: 29
            }),
            className: styles.btnReturn,
            children: translateDetailOrders("detail-orders.request_return")
        })
    });
}
/* harmony default export */ var mocules_ButtonReturnOrder = ((/* unused pure expression or super */ null && (ButtonReturnOrder_ButtonReturnOrder)));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceButton/index.js








var RequestInvoiceButton_RequestInvoiceButton = function(param) {
    var handleOpenModal = param.handleOpenModal, invoice = param.invoice, _numberOfSellerMEDX = param.numberOfSellerMEDX, numberOfSellerMEDX = _numberOfSellerMEDX === void 0 ? 0 : _numberOfSellerMEDX, _numberProduct = param.numberProduct, numberProduct = _numberProduct === void 0 ? 0 : _numberProduct, status = param.status, numberOfUpdates = param.numberOfUpdates, enable = param.enable;
    var handleOnClick = function() {
        handleOpenModal();
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? [
            !enable ? "Kh\xf4ng thể chỉnh sửa do đơn h\xe0ng kh\xf4ng c\xf3 sản phẩm của nh\xe0 cung cấp MEDX hoặc kh\xf4ng nằm trong thời gian cho ph\xe9p." : [
                (status === ENUM_ORDER_STATUS.DELIVERED || status === ENUM_ORDER_STATUS.COMPLETED) && numberOfUpdates === 0 ? "Bạn chỉ được cập nhật đ\xfang 1 lần nữa trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao." : [
                    numberOfSellerMEDX === numberProduct ? "Chỉ nhận th\xf4ng tin trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng." : "Chỉ nhận th\xf4ng tin trong v\xf2ng 14 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng. \xc1p dụng cho sản phẩm của nh\xe0 cung cấp MEDX", 
                ], 
            ], 
        ] : [
            !enable ? "Kh\xf4ng thể chỉnh sửa do đ\xe3 qu\xe1 thời gian cho ph\xe9p." : "Chỉ nhận th\xf4ng tin trong v\xf2ng 7 ng\xe0y kể từ ng\xe0y giao h\xe0ng th\xe0nh c\xf4ng.", 
        ],
        leaveTouchDelay: 1000,
        enterTouchDelay: 150,
        children: /*#__PURE__*/ _jsx(Button, {
            disabled: !enable,
            startIcon: /*#__PURE__*/ _jsx(ReceiptIcon, {}),
            className: clsx("my-order__button my-order__button--orange", styles.btn),
            onClick: handleOnClick,
            children: (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? "Chỉnh sửa th\xf4ng tin xuất h\xf3a đơn" : "Y\xeau cầu xuất h\xf3a đơn"
        })
    });
};
/* harmony default export */ var mocules_RequestInvoiceButton = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(RequestInvoiceButton_RequestInvoiceButton))));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceFormModal/validateForm.js

var RequestInvoiceFormModal_validateForm_validateForm = function(param) {
    var companyName = param.companyName, taxCode = param.taxCode, email = param.email, companyAddress = param.companyAddress;
    if (ValidateUtils.isEmpty(companyName.trim())) throw Error("message_must_enter_company_name_invoice_document");
    else if (companyName.length < 2) throw Error("message_company_at_least_2characters");
    else if (ValidateUtils.isEmpty(taxCode)) throw Error("message_must_enter_the_tax_code_invoice_document");
    else if (!ValidateUtils.isEmpty(email) && !ValidateUtils.validateEmail(email)) throw Error("message_invalid_email");
    else if (ValidateUtils.isEmpty(companyAddress.trim())) throw Error("message_you_must_enter_your_address_invoice document");
    else if (!ValidateUtils.isNumber(taxCode) || !(taxCode.length === 10 || taxCode.length === 14)) throw Error("message_tax_code_wrong_format");
};
/* harmony default export */ var RequestInvoiceFormModal_validateForm = ((/* unused pure expression or super */ null && (RequestInvoiceFormModal_validateForm_validateForm)));

;// CONCATENATED MODULE: ./src/components/mocules/RequestInvoiceFormModal/index.js
/* eslint-disable react/jsx-wrap-multilines */ 


























var RequestInvoiceFormModal_RequestInvoiceModal = function(props) {
    var ref = useTranslation("alert-action"), translateAlertAction = ref.t;
    var visible = props.visible, onClose = props.onClose, orderId = props.orderId, listInvoiceInfo = props.listInvoiceInfo, customerEmail = props.customerEmail, invoice = props.invoice, isMobile = props.isMobile;
    // const [disable, setDisable] = useState(true);
    var router = useRouter();
    var initVal = {
        companyName: (invoice === null || invoice === void 0 ? void 0 : invoice.companyName) || "",
        taxCode: (invoice === null || invoice === void 0 ? void 0 : invoice.taxCode) || "",
        email: (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "",
        companyAddress: (invoice === null || invoice === void 0 ? void 0 : invoice.companyAddress) || ""
    };
    var ref1 = useState(initVal), val = ref1[0], setVal = ref1[1];
    // useEffect(() => {
    //   if (
    //     val.companyName === initVal.companyName &&
    //     val.taxCode === initVal.taxCode &&
    //     val.email === initVal.email &&
    //     val.companyAddress === initVal.companyAddress
    //   )
    //     setDisable(true);
    //   else setDisable(false);
    // }, [val]);
    var handleChangeValue = function(key, value) {
        setVal(_object_spread_props(_object_spread({}, val), _define_property({}, key, value)));
    };
    var onSubmit = function() {
        var _ref = _async_to_generator(function() {
            var data, _tmp, _tmp1, requestInvoiceResult, message, errorCode, _tmp2, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = _object_spread_props(_object_spread(_tmp, val), (_tmp1.orderId = orderId, _tmp1.invoiceRequest = true, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        validateForm(val);
                        return [
                            4,
                            CustomerClient.updateInvoiceInfoOrder(data)
                        ];
                    case 2:
                        requestInvoiceResult = _state.sent();
                        if (!isValidWithoutData(requestInvoiceResult)) {
                            message = "";
                            errorCode = requestInvoiceResult.errorCode;
                            switch(errorCode){
                                case "ERR_UPDATE_MANUALLY_EXPORTED_INVOICE":
                                    message = " Đơn h\xe0ng kh\xf4ng thể giao th\xe0nh c\xf4ng cho qu\xfd kh\xe1ch. Vui l\xf2ng kh\xf4ng cập nhật th\xf4ng tin cho h\xf3a đơn của đơn h\xe0ng n\xe0y";
                                    break;
                                case "ERR_UPDATE_MANUALLY_IMPORTED_INVOICE":
                                    message = "Vui l\xf2ng kh\xf4ng cập nhật th\xf4ng tin cho h\xf3a đơn của đơn h\xe0ng n\xe0y";
                                    break;
                                case "ERR_UPDATE_INVOICE_MULTIPLE_TIMES":
                                    message = "Đơn h\xe0ng y\xeau cầu thay đổi th\xf4ng tin h\xf3a đơn > 1 lần";
                                    break;
                                case "ERR_INVALID_CHANGE_REQUEST_TIME":
                                    message = "Kh\xf4ng thể y\xeau cầu xuất h\xf3a đơn sau 7 ng\xe0y.";
                                    break;
                                case "ERR_INVALID_CHANGE_INVOICE_INFO_TIME":
                                    message = "Kh\xf4ng thể thay đổi th\xf4ng tin xuất h\xf3a đơn sau 14 ng\xe0y.";
                                    break;
                                default:
                                    message = requestInvoiceResult.message || "Gửi cập nhật th\xf4ng tin h\xf3a đơn thất bại";
                            }
                            throw new Error(message);
                        }
                        NotifyUtils.success("Gửi cập nhật th\xf4ng tin h\xf3a đơn th\xe0nh c\xf4ng");
                        // clear
                        onClose();
                        _tmp2 = {};
                        setVal(_tmp2);
                        gtag.requestInvoice();
                        router.push(window.location.href);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        NotifyUtils.error(translateAlertAction(error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = useState(""), invoiceInfoSelected = ref2[0], setInvoiceInfoSelected = ref2[1];
    var handleChangeInvoiceInfoSelected = function(e) {
        var value = e.target.value;
        setInvoiceInfoSelected(value);
        var choosenItem = listInvoiceInfo.find(function(item) {
            return item.code === value;
        });
        setVal(_object_spread_props(_object_spread({}, val), {
            email: (invoice === null || invoice === void 0 ? void 0 : invoice.email) || customerEmail || "",
            companyName: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.companyName) || "",
            companyAddress: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.companyAddress) || "",
            taxCode: (choosenItem === null || choosenItem === void 0 ? void 0 : choosenItem.taxCode) || ""
        }));
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: visible,
        onClose: onClose,
        className: styles.modal,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.wrap,
            children: [
                isMobile && /*#__PURE__*/ _jsx("div", {
                    style: {
                        position: "sticky",
                        top: "0px",
                        zIndex: 999
                    },
                    children: /*#__PURE__*/ _jsx(CancelIcon, {
                        style: {
                            float: "right",
                            margin: "5px"
                        },
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx(styles.title, isMobile && styles.titleMobile),
                    children: !(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) ? "Y\xeau cầu xuất h\xf3a đơn" : "Chỉnh sửa th\xf4ng tin xuất h\xf3a đơn"
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    container: true,
                    className: styles.container,
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Th\xf4ng tin xuất h\xf3a đơn"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Grid, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ _jsxs(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    htmlFor: "companyName",
                                    label: "T\xean c\xf4ng ty",
                                    isRequired: true,
                                    children: [
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx(TextField, {
                                            id: "companyName",
                                            multiline: true,
                                            variant: "outlined",
                                            minRows: 2,
                                            style: {
                                                background: "#fff"
                                            },
                                            value: val.companyName,
                                            placeholder: "\xcdt nhất 2 k\xed tự",
                                            onChange: function(e) {
                                                return handleChangeValue("companyName", e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    label: "M\xe3 số thuế",
                                    htmlFor: "taxCode",
                                    isRequired: true,
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "taxCode",
                                        placeholder: "M\xe3 số thuế",
                                        value: val.taxCode,
                                        onChange: function(e) {
                                            return handleChangeValue("taxCode", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(InfoFormControl, {
                                    xs: 12,
                                    label: "Địa chỉ",
                                    htmlFor: "companyAddress",
                                    isRequired: true,
                                    children: [
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx(TextField, {
                                            multiline: true,
                                            minRows: 4,
                                            variant: "outlined",
                                            id: "companyAddress",
                                            placeholder: "Nhập địa chỉ xuất h\xf3a đơn (bao gồm Phường/X\xe3, Quận/Huyện, Tỉnh/Th\xe0nh phố nếu c\xf3)",
                                            value: val.companyAddress,
                                            onChange: function(e) {
                                                return handleChangeValue("companyAddress", e.target.value);
                                            },
                                            style: {
                                                background: "#fff"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(InfoFormControl, {
                                    xs: 12,
                                    md: 12,
                                    label: "Email",
                                    htmlFor: "email",
                                    children: /*#__PURE__*/ _jsx(InfoInput, {
                                        id: "email",
                                        placeholder: "Email",
                                        value: val.email,
                                        onChange: function(e) {
                                            return handleChangeValue("email", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.helper_text,
                                    children: /*#__PURE__*/ _jsxs("small", {
                                        className: styles.text_muted,
                                        children: [
                                            /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faInfoCircle,
                                                className: styles.icon
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: styles.fw500,
                                                children: "Lưu \xfd:"
                                            }),
                                            /*#__PURE__*/ _jsxs("ul", {
                                                className: styles.notifi_list,
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: "Phải điền ch\xednh x\xe1c th\xf4ng tin xuất h\xf3a đơn"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("li", {
                                                        children: [
                                                            "H\xf3a đơn đối t\xe1c",
                                                            BRAND_NAME,
                                                            " sẽ xuất từ 8-10 ng\xe0y sau khi đơn h\xe0ng được giao th\xe0nh c\xf4ng"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        listInvoiceInfo.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: "Hoặc chọn: "
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsx(RadioGroup, {
                                        "aria-label": "gender",
                                        name: "gender1",
                                        value: invoiceInfoSelected,
                                        onClick: handleChangeInvoiceInfoSelected,
                                        children: listInvoiceInfo.map(function(item) {
                                            return /*#__PURE__*/ _jsx(FormControlLabel, {
                                                control: /*#__PURE__*/ _jsx(Radio, {
                                                    name: "checkedC",
                                                    classes: {
                                                        root: styles.checkbox
                                                    },
                                                    value: item.code
                                                }),
                                                label: /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("i", {
                                                            style: {
                                                                textTransform: "capitalize"
                                                            },
                                                            children: [
                                                                " ",
                                                                item.companyName
                                                            ]
                                                        }),
                                                        " -",
                                                        /*#__PURE__*/ _jsxs("b", {
                                                            children: [
                                                                " ",
                                                                item.taxCode,
                                                                " "
                                                            ]
                                                        }),
                                                        " (",
                                                        item.companyAddress,
                                                        ")"
                                                    ]
                                                })
                                            }, item.code);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            className: styles.textarea,
                            item: true,
                            container: true,
                            justifyContent: "center",
                            xs: 12,
                            spacing: 1,
                            children: /*#__PURE__*/ _jsx(Button, {
                                className: "payment_button",
                                onClick: onSubmit,
                                children: "Gửi y\xeau cầu"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RequestInvoiceFormModal = ((/* unused pure expression or super */ null && (RequestInvoiceFormModal_RequestInvoiceModal)));

;// CONCATENATED MODULE: ./src/components/mocules/TicketButton/index.js




var TicketButton_TicketButton = function(param) {
    var order = param.order, handleChangeOrderTicket = param.handleChangeOrderTicket, handleOpenModal = param.handleOpenModal;
    var handleOnClick = function() {
        handleChangeOrderTicket(order);
        handleOpenModal();
    };
    return /*#__PURE__*/ _jsx(Button, {
        startIcon: /*#__PURE__*/ _jsx(InsertCommentIcon, {}),
        className: "my-order__button my-order__button--blue",
        onClick: handleOnClick,
        children: "Gửi phản hồi"
    });
};
/* harmony default export */ var mocules_TicketButton = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(TicketButton_TicketButton))));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField_TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/mocules/SearchProduct/index.js + 1 modules
var SearchProduct = __webpack_require__(66926);
// EXTERNAL MODULE: ./src/components/mocules/UploadImages/index.js + 14 modules
var UploadImages = __webpack_require__(55478);
// EXTERNAL MODULE: ./src/components/mocules/TicketFormModal/style.module.css
var style_module = __webpack_require__(81330);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TicketFormModal/validateForm.js

var TicketFormModal_validateForm_validateForm = function(param) {
    var type = param.type, phone = param.phone, orderId = param.orderId, orderDetail = param.orderDetail, sku = param.sku, email = param.email;
    // if (ValidateUtils.isEmpty(feedbackContent)) throw Error('message_feedback_empty');
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(type)) throw Error("message_not_choose_feedback_type");
    if (email && !utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_wrong_email");
    switch(type){
        case "PRODUCT":
            {
                if (!sku || utils/* ValidateUtils.isEmpty */.IN.isEmpty(sku)) throw Error("message_not_choose_product");
                if (orderId && !orderDetail) throw Error("message_wrong_order_code");
                if (phone && !utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
                break;
            }
        case "ORDER":
            {
                if (!orderId || utils/* ValidateUtils.isEmpty */.IN.isEmpty(orderId)) throw Error("message_empty_order_info");
                if (!orderDetail) throw Error("message_wrong_order_code");
                break;
            }
        case "ACCOUNT":
        case "OTHER ":
            {
                if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(phone)) throw Error("message_not_input_phone");
                if (!utils/* ValidateUtils.validatePhone */.IN.validatePhone(phone)) throw Error("message_invalid_phone");
                break;
            }
        default:
            {
                break;
            }
    }
};
/* harmony default export */ var TicketFormModal_validateForm = (TicketFormModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/TicketFormModal/index.js



































var TicketFormModal_TicketFormModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var visible = props.visible, onClose = props.onClose, _orderId = props.orderId, orderId = _orderId === void 0 ? 0 : _orderId, productName = props.productName, productId = props.productId, sku = props.sku, orderCode = props.orderCode, customerCode = props.customerCode, customerId = props.customerId, _ticketType = props.ticketType, ticketType = _ticketType === void 0 ? "ORDER_CANCELLATION" : _ticketType, _user = props.user, user = _user === void 0 ? null : _user, reloadFunc = props.reloadFunc, optionSelected = props.optionSelected, handleCancelRequestOrder = props.handleCancelRequestOrder, statusOrder = props.status;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var currentLang = (i18n === null || i18n === void 0 ? void 0 : i18n.language) || "th";
    var ref6 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref6.t;
    var ref7 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref7.t;
    var ref8 = (0,esm/* useTranslation */.$G)("myTicket"), translateMyTicket = ref8.t;
    var ref9 = (0,react.useState)(ticketType), curType = ref9[0], setCurType = ref9[1];
    var ref10 = (0,context/* useAuth */.aC)(), customerInfo = ref10.customerInfo, handleRedCustomer = ref10.handleRedCustomer;
    var ref11 = (0,context/* useSetting */.yu)(), reasonsTicket = ref11.reasonsTicket, provinces = ref11.provinces;
    var reasonsByType = (reasonsTicket === null || reasonsTicket === void 0 ? void 0 : reasonsTicket.filter(function(item) {
        return item.status === "ACTIVE" && item.ticketType === curType;
    })) || [];
    var listTicketTypes = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.isActive) ? Enums/* EnumsTicket.TicketTypes */.t7.TicketTypes : Enums/* EnumsTicket.TicketTypesNotActive */.t7.TicketTypesNotActive;
    var ref12 = (0,react.useState)(reasonsByType), listReasons = ref12[0], setListReasons = ref12[1];
    var ref13 = (0,react.useState)(optionSelected && reasonsByType.find(function(item) {
        return item.code === optionSelected;
    }) || reasonsByType && reasonsByType[0] || null), curReason = ref13[0], setCurReason = ref13[1];
    var ref14 = (0,react.useState)({}), orderDetail = ref14[0], setOrderDetail = ref14[1];
    var handleChangeType = function(e) {
        var ticketTypeSelected = e.target.value;
        setCurType(ticketTypeSelected);
    };
    (0,react.useEffect)(function() {
        var reasons = (reasonsTicket === null || reasonsTicket === void 0 ? void 0 : reasonsTicket.filter(function(item) {
            return item.status === "ACTIVE" && item.ticketType === curType;
        })) || [];
        if (orderDetail) {
            var status = orderDetail.status;
            if (status) {
                reasons = reasons.filter(function(item) {
                    var ref;
                    return item && ((item === null || item === void 0 ? void 0 : item.orderStatuses) === null || (item === null || item === void 0 ? void 0 : (ref = item.orderStatuses) === null || ref === void 0 ? void 0 : ref.indexOf(status)) >= 0);
                });
            }
        }
        setListReasons(reasons);
        setCurReason(optionSelected && reasonsByType.find(function(item) {
            return item.code === optionSelected;
        }) || reasons[0] || null);
    }, [
        curType,
        orderDetail,
        reasonsTicket
    ]);
    // const [reason, setReason] = useState(curReason?.name);
    var ref15 = (0,react.useState)({
        bankCode: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref = customerInfo.bank) === null || ref === void 0 ? void 0 : ref.bankCode) || "",
        bankName: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref1 = customerInfo.bank) === null || ref1 === void 0 ? void 0 : ref1.bankName) || "",
        bankBranch: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref2 = customerInfo.bank) === null || ref2 === void 0 ? void 0 : ref2.bankBranch) || "",
        bankAccountName: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref3 = customerInfo.bank) === null || ref3 === void 0 ? void 0 : ref3.bankAccountName) || "",
        bankAccountCode: (customerInfo === null || customerInfo === void 0 ? void 0 : (ref4 = customerInfo.bank) === null || ref4 === void 0 ? void 0 : ref4.code) || "",
        feedbackContent: "",
        imageUrls: [],
        productId: productId,
        orderId: orderId,
        sku: sku,
        productName: productName,
        phone: (user === null || user === void 0 ? void 0 : user.phone) || (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.phone) || "",
        email: (user === null || user === void 0 ? void 0 : user.email) || (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.email) || "",
        ticketType: curType,
        isDisableSubmit: false
    }), val = ref15[0], setVal = ref15[1];
    var handleChangeValue = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var disableSubmit = function() {
        handleChangeValue("isDisableSubmit", true);
    };
    var ref16 = (0,react.useState)(null), productSearch = ref16[0], setProductSearch = ref16[1];
    var handleLoadOrderDetail = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(id) {
            var orderResult, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!id) return [
                            3,
                            2
                        ];
                        if (!([
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.ORDER_CANCELLATION */.t7.TicketEnums.ORDER_CANCELLATION,
                            Enums/* EnumsTicket.TicketEnums.CLAIM_PRODUCT */.t7.TicketEnums.CLAIM_PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.DELIVERY_INQUIRY */.t7.TicketEnums.DELIVERY_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.PAYMENT_INQUIRY */.t7.TicketEnums.PAYMENT_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.COMPLAINT */.t7.TicketEnums.COMPLAINT,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION
                        ].indexOf(curType) >= 0)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            services/* OrderService.getOrderById */.px.getOrderById((_tmp.orderId = id, _tmp))
                        ];
                    case 1:
                        orderResult = _state.sent();
                        setOrderDetail((0,clients/* getFirst */.Xi)(orderResult));
                        if (!(0,clients/* isValid */.JY)(orderResult)) {
                            utils_NotifyUtils/* default.error */.Z.error(translateAlertAction("message_incorrect_valid_order_number"));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        curType
    ]);
    var handleChangeOrderId = function(orderIdCur) {
        try {
            // const orderIdCur = parseInt(id, 10);
            if (orderIdCur) {
                handleLoadOrderDetail(orderIdCur);
            }
            handleChangeValue("orderId", Number(orderIdCur));
        } catch (error) {
            utils_NotifyUtils/* default.warn */.Z.warn(translateAlertAction("message_incorrect_format_order_number"));
        }
    };
    (0,react.useEffect)(function() {
        handleLoadOrderDetail(val.orderId);
    }, [
        handleLoadOrderDetail,
        val.orderId
    ]);
    var handleOnChangeReason = function(e) {
        var reasonCode = e.target.value;
        var reason = reasonsByType.find(function(item) {
            return item.code === reasonCode;
        });
        setCurReason(reason);
    };
    var handleSearchProduct = function(product) {
        var ref, ref1, ref2;
        handleChangeValue("productName", product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.name);
        handleChangeValue("productId", product === null || product === void 0 ? void 0 : (ref1 = product.product) === null || ref1 === void 0 ? void 0 : ref1.productID);
        handleChangeValue("sku", product === null || product === void 0 ? void 0 : (ref2 = product.sku) === null || ref2 === void 0 ? void 0 : ref2.code);
        setProductSearch(product);
    };
    // const handleChangeReasons =(reasonId) => {
    // }
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var data, _tmp, _tmp1, feedbackResult, _tmp2, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (optionSelected) {
                            handleCancelRequestOrder();
                        }
                        if (optionSelected && (statusOrder === "COMPLETED" || statusOrder === "DELIVERED" || statusOrder === "DELIVERING")) {
                            onClose();
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        _tmp1 = {};
                        data = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)(_tmp, val), (_tmp1.orderCode = orderCode, _tmp1.customerId = customerId, _tmp1.customerCode = customerCode, _tmp1.reasonName = (curReason === null || curReason === void 0 ? void 0 : curReason.name) || "", _tmp1.reasonCodes = [
                            (curReason === null || curReason === void 0 ? void 0 : curReason.code) || ""
                        ], _tmp1.type = curType, _tmp1.ticketType = curType, _tmp1.source = "WEB", _tmp1.orderDetail = orderDetail, _tmp1));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // validate form data
                        TicketFormModal_validateForm(data);
                        if (data.orderId && orderDetail) {
                            data.orderId = Number(data.orderId);
                        }
                        switch(data.type){
                            case Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT:
                            case Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER:
                                delete data.reasonCodes;
                                delete data.orderId;
                                delete data.productId;
                                delete data.sku;
                                break;
                            default:
                                break;
                        }
                        if (!(curReason === null || curReason === void 0 ? void 0 : curReason.showBankAccount) || [
                            Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER
                        ].indexOf(data.ticketType) >= 0) {
                            delete data.bankCode;
                            delete data.bankName;
                            delete data.bankBranch;
                            delete data.bankAccountCode;
                        }
                        return [
                            4,
                            clients/* TicketClient.createFeedback */.ZX.createFeedback(data)
                        ];
                    case 2:
                        feedbackResult = _state.sent();
                        if (!(0,clients/* isValid */.JY)(feedbackResult)) {
                            if ((feedbackResult === null || feedbackResult === void 0 ? void 0 : feedbackResult.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                                return [
                                    2
                                ];
                            }
                            throw new Error(feedbackResult.message || translateAlertAction("message_send_feedback_fail"));
                        }
                        utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_send_feedback"));
                        // clear
                        onClose();
                        if (reloadFunc) {
                            reloadFunc();
                        }
                        _tmp2 = {};
                        setVal(_tmp2);
                        utils/* gtag.sendFeedback */.SX.sendFeedback();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils/* default.error */.Z.error(translateAlertAction(error.message));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnChangeImages = function() {
        var imgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        setTimeout(function() {
            setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), {
                isDisableSubmit: false,
                imageUrls: (0,_to_consumable_array/* default */.Z)((val === null || val === void 0 ? void 0 : val.imageUrls) || []).concat((0,_to_consumable_array/* default */.Z)(imgs))
            }));
        }, 1500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).feedback_order,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).title,
                    children: translatePopupAction("popup-ticket.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    className: (style_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).info_group,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: 12,
                                className: (style_module_default()).text_body,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: [
                                        translatePopupAction("popup-ticket.subtitle"),
                                        " ",
                                        customerInfo.name,
                                        "!"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.help_problem"),
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                    input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                    IconComponent: ExpandMore/* default */.Z,
                                    value: curType,
                                    onChange: handleChangeType,
                                    className: (style_module_default()).reason_select,
                                    children: listTicketTypes === null || listTicketTypes === void 0 ? void 0 : listTicketTypes.map(function(type) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: type,
                                            children: translateMyTicket((ref = Enums/* EnumsTicket.TicketLabelEnums */.t7.TicketLabelEnums[type]) === null || ref === void 0 ? void 0 : ref.code)
                                        }, "ticket-type-".concat(type));
                                    })
                                })
                            })
                        }),
                        (curType === Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT || curType === Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.What_product_do_you_want_to_support"),
                                htmlFor: "productId",
                                isRequired: true,
                                children: productName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "productId",
                                    placeholder: translatePopupAction("popup-ticket.What_product_do_you_want_to_support"),
                                    defaultValue: productName || ""
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProduct/* default */.Z, {
                                            handleKeyDown: function() {},
                                            onClickItem: handleSearchProduct,
                                            id: "productId",
                                            placeholder: translatePopupAction("popup-ticket.What_product_do_you_want_to_support")
                                        }),
                                        productSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    style: {
                                                        fontWeight: 400,
                                                        fontSize: "14px"
                                                    },
                                                    children: [
                                                        translatePopupAction("popup-ticket.selected_product"),
                                                        " :"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                                                    severity: "info",
                                                    icon: false,
                                                    style: {
                                                        borderRadius: "8px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            " ",
                                                            (productSearch === null || productSearch === void 0 ? void 0 : (ref5 = productSearch.product) === null || ref5 === void 0 ? void 0 : ref5.name) || ""
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.enter_order_number"),
                                htmlFor: "orderId",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "orderId",
                                    placeholder: translatePopupAction("popup-ticket.enter_order_number"),
                                    type: "number",
                                    defaultValue: (val === null || val === void 0 ? void 0 : val.orderId) || "",
                                    onBlur: function(e) {
                                        var ref;
                                        return handleChangeOrderId((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                                    }
                                })
                            })
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.ORDER_CANCELLATION */.t7.TicketEnums.ORDER_CANCELLATION,
                            Enums/* EnumsTicket.TicketEnums.CLAIM_PRODUCT */.t7.TicketEnums.CLAIM_PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.DELIVERY_INQUIRY */.t7.TicketEnums.DELIVERY_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.PAYMENT_INQUIRY */.t7.TicketEnums.PAYMENT_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.COMPLAINT */.t7.TicketEnums.COMPLAINT,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.enter_order_number"),
                                    htmlFor: "orderId",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "orderId",
                                        placeholder: translatePopupAction("popup-ticket.enter_order_number"),
                                        type: "number",
                                        disabled: !!orderId,
                                        defaultValue: (val === null || val === void 0 ? void 0 : val.orderId) || "",
                                        onBlur: function(e) {
                                            var ref;
                                            return handleChangeOrderId((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || 0);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.order_status"),
                                    htmlFor: "orderStatus",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "orderStatus",
                                        placeholder: translatePopupAction("popup-ticket.order_status"),
                                        value: translateMyTicket("".concat((orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.status) || (orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.orderStatus) || "")),
                                        disabled: true
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION,
                            Enums/* EnumsTicket.TicketEnums.ACCOUNT */.t7.TicketEnums.ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.BUYMED_ACCOUNT */.t7.TicketEnums.BUYMED_ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.OTHER */.t7.TicketEnums.OTHER, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: translatePopupAction("popup-ticket.phoneNumber"),
                                    htmlFor: "phone",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "phone",
                                        placeholder: translatePopupAction("popup-ticket.phoneNumber"),
                                        value: val.phone,
                                        onChange: function(e) {
                                            return handleChangeValue("phone", e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    xs: 6,
                                    md: 6,
                                    label: "Email",
                                    htmlFor: "email",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                        id: "email",
                                        placeholder: "Email",
                                        value: val.email,
                                        onChange: function(e) {
                                            return handleChangeValue("email", e.target.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PROMOTION */.t7.TicketEnums.PROMOTION,
                            Enums/* EnumsTicket.TicketEnums.PROMOTION_AND_REWARD */.t7.TicketEnums.PROMOTION_AND_REWARD, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            xs: 6,
                                            md: 6,
                                            label: translatePopupAction("popup-ticket.phoneNumber"),
                                            htmlFor: "phone",
                                            isRequired: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                                disabled: true,
                                                id: "phone",
                                                placeholder: translatePopupAction("popup-ticket.phoneNumber"),
                                                value: val.phone,
                                                onChange: function(e) {
                                                    return handleChangeValue("phone", e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            xs: 6,
                                            md: 6,
                                            label: translatePopupAction("popup-ticket.your_area"),
                                            htmlFor: "provine",
                                            disabled: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                                input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                                IconComponent: ExpandMore/* default */.Z,
                                                value: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode,
                                                className: (style_module_default()).reason_select,
                                                disabled: true,
                                                children: provinces === null || provinces === void 0 ? void 0 : provinces.map(function(province) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: province.value,
                                                        children: province.label
                                                    }, "provinces-".concat((0,v4/* default */.Z)()));
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    spacing: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                        xs: 12,
                                        md: 12,
                                        label: translatePopupAction("popup-ticket.name_store"),
                                        htmlFor: "scope",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                            id: "scope",
                                            placeholder: translatePopupAction("popup-ticket.name_store"),
                                            value: (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.businessName) || "",
                                            disabled: true
                                        })
                                    })
                                })
                            ]
                        }),
                        [
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.PROMOTION */.t7.TicketEnums.PROMOTION,
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.ORDER_INQUIRY */.t7.TicketEnums.ORDER_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.ORDER_CANCELLATION */.t7.TicketEnums.ORDER_CANCELLATION,
                            Enums/* EnumsTicket.TicketEnums.CLAIM_PRODUCT */.t7.TicketEnums.CLAIM_PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.DELIVERY_INQUIRY */.t7.TicketEnums.DELIVERY_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.PAYMENT_INQUIRY */.t7.TicketEnums.PAYMENT_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.COMPLAINT */.t7.TicketEnums.COMPLAINT,
                            Enums/* EnumsTicket.TicketEnums.BUYMED_ACCOUNT */.t7.TicketEnums.BUYMED_ACCOUNT,
                            Enums/* EnumsTicket.TicketEnums.PROMOTION_AND_REWARD */.t7.TicketEnums.PROMOTION_AND_REWARD,
                            Enums/* EnumsTicket.TicketEnums.PRICE_RECOMMENDATION */.t7.TicketEnums.PRICE_RECOMMENDATION,
                            Enums/* EnumsTicket.TicketEnums.TECHNICAL */.t7.TicketEnums.TECHNICAL, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                md: 12,
                                label: translatePopupAction("popup-ticket.sup_reasons"),
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                    input: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {}),
                                    IconComponent: ExpandMore/* default */.Z,
                                    value: curReason === null || curReason === void 0 ? void 0 : curReason.code,
                                    onChange: handleOnChangeReason,
                                    className: (style_module_default()).reason_select,
                                    disabled: !!optionSelected,
                                    children: listReasons === null || listReasons === void 0 ? void 0 : listReasons.map(function(reasonE) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: reasonE.code,
                                            children: currentLang === "th" ? reasonE.name : reasonE.nameEn
                                        }, "key-reason-".concat((0,v4/* default */.Z)()));
                                    })
                                })
                            })
                        }),
                        (curReason === null || curReason === void 0 ? void 0 : curReason.showBankAccount) && [
                            Enums/* EnumsTicket.TicketEnums.ORDER */.t7.TicketEnums.ORDER,
                            Enums/* EnumsTicket.TicketEnums.ORDER_CANCELLATION */.t7.TicketEnums.ORDER_CANCELLATION,
                            Enums/* EnumsTicket.TicketEnums.CLAIM_PRODUCT */.t7.TicketEnums.CLAIM_PRODUCT,
                            Enums/* EnumsTicket.TicketEnums.DELIVERY_INQUIRY */.t7.TicketEnums.DELIVERY_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.PAYMENT_INQUIRY */.t7.TicketEnums.PAYMENT_INQUIRY,
                            Enums/* EnumsTicket.TicketEnums.COMPLAINT */.t7.TicketEnums.COMPLAINT,
                            Enums/* EnumsTicket.TicketEnums.PRODUCT */.t7.TicketEnums.PRODUCT, 
                        ].indexOf(curType) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "flex-start",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    style: {
                                        fontWeight: 500,
                                        paddingLeft: "4px"
                                    },
                                    children: translatePopupAction("popup-ticket.bank_info")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                                container: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.acc_holder"),
                                                                ":",
                                                                val.bankAccountName
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.acc_number"),
                                                                ":",
                                                                val.bankCode
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.bank"),
                                                                ":",
                                                                val.bankName
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.branch_bank"),
                                                                ":",
                                                                val.bankBranch
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    container: true,
                                    alignContent: "flex-start",
                                    direction: "row",
                                    style: {
                                        paddingTop: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            style: {
                                                fontWeight: 500,
                                                paddingTop: 3,
                                                paddingLeft: 4
                                            },
                                            children: (val === null || val === void 0 ? void 0 : val.bankCode) ? translatePopupAction("popup-ticket.change_bank") : translatePopupAction("popup-ticket.have_bank")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                            href: "".concat(Paths/* MY_ACCOUNT */.RX, "?tab=4"),
                                            target: "_blank",
                                            style: {
                                                color: "green"
                                            },
                                            variant: "body2",
                                            children: (val === null || val === void 0 ? void 0 : val.bankCode) ? translatePopupAction("popup-ticket.click_here") : translatePopupAction("popup-ticket.add_bank")
                                        })
                                    ]
                                })
                            ]
                        }),
                        sysconfig/* REASON_VOUCHER_BIRTHDAY */.xE === (curReason === null || curReason === void 0 ? void 0 : curReason.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).imagesField,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    className: (style_module_default()).imagesField,
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            label: translatePopupAction("popup-ticket.image_front_of_citizen_identification"),
                                            xs: 12,
                                            className: (style_module_default()).customText,
                                            isRequired: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                            onChange: handleOnChangeImages,
                                            setLoading: disableSubmit,
                                            isOnlyOneImage: true,
                                            limit: 1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    className: (style_module_default()).imagesField,
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    container: true,
                                    justifyContent: "space-evenly",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                            label: translatePopupAction("popup-ticket.image_back_of_citizen_identification"),
                                            xs: 12,
                                            className: (style_module_default()).customText,
                                            isRequired: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                            onChange: handleOnChangeImages,
                                            setLoading: disableSubmit,
                                            isOnlyOneImage: true,
                                            limit: 1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    style: {
                                        color: "red",
                                        fontFamily: "ggsr",
                                        fontSize: "13px"
                                    },
                                    children: [
                                        "*",
                                        translatePopupAction("popup-ticket.message_alert_citizen_identification")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).textarea,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* InfoFormControl */.iD, {
                                label: translatePopupAction("popup-ticket.feedback"),
                                xs: 12,
                                htmlFor: "description",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                        id: "feedbackContent",
                                        multiline: true,
                                        minRows: 4,
                                        variant: "outlined",
                                        placeholder: translatePopupAction("popup-ticket.entered_feedback_content"),
                                        value: val === null || val === void 0 ? void 0 : val.note,
                                        onChange: function(e) {
                                            return handleChangeValue("feedbackContent", e.target.value);
                                        },
                                        style: {
                                            background: "#fff"
                                        }
                                    })
                                ]
                            })
                        }),
                        sysconfig/* REASON_VOUCHER_BIRTHDAY */.xE !== (curReason === null || curReason === void 0 ? void 0 : curReason.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).imagesField,
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                    label: translatePopupAction("popup-ticket.images"),
                                    xs: 12,
                                    className: (style_module_default()).customText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                    onChange: handleOnChangeImages,
                                    setLoading: disableSubmit
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginTop: "18px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordWarningText/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (style_module_default()).textarea,
                            item: true,
                            container: true,
                            justifyContent: "center",
                            xs: 12,
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                className: "payment_button",
                                onClick: onSubmit,
                                disabled: val.isDisableSubmit,
                                children: translatePopupAction("popup-ticket.send_request")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
TicketFormModal_TicketFormModal.propsTypes = {
    visible: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func,
    orderId: (prop_types_default()).number,
    productName: (prop_types_default()).string,
    productId: (prop_types_default()).number,
    phone: (prop_types_default()).string,
    orderTime: (prop_types_default()).string,
    orderCode: (prop_types_default()).string,
    bankInfo: (prop_types_default()).object,
    customerCode: (prop_types_default()).string,
    customerId: (prop_types_default()).number,
    ticketType: (prop_types_default()).string.isRequired
};
/* harmony default export */ var mocules_TicketFormModal = (TicketFormModal_TicketFormModal);

// EXTERNAL MODULE: ./src/components/mocules/OrderInfoTabs/OrderStatusButton.js
var OrderInfoTabs_OrderStatusButton = __webpack_require__(32181);
;// CONCATENATED MODULE: ./src/components/mocules/OrderInfoTabs/OrderRow.js





































var MyOrderDetail = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? null : _amount, createdTime = param.createdTime, _deliveryDate = param.deliveryDate, deliveryDate = _deliveryDate === void 0 ? null : _deliveryDate, _totalQuantity = param.totalQuantity, totalQuantity = _totalQuantity === void 0 ? null : _totalQuantity, _redeemCode = param.redeemCode, redeemCode = _redeemCode === void 0 ? null : _redeemCode, _totalDiscount = param.totalDiscount, totalDiscount = _totalDiscount === void 0 ? 0 : _totalDiscount, paymentMethod = param.paymentMethod;
    var ref = useTranslation("common"), translateCommon = ref.t;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            overflowX: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                item: true,
                xs: 12,
                lg: 4,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Sản phẩm: "
                            }),
                            " ",
                            amount && formatNumber(amount)
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Tổng số lượng: "
                            }),
                            " ",
                            totalQuantity && formatNumber(totalQuantity)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                item: true,
                xs: 12,
                lg: 8,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Ng\xe0y mua: "
                            }),
                            DateTimeUtils.getFormattedDate(new Date(createdTime), translateCommon, "DD/MM/YYYY HH:mm:ss")
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "H\xecnh thức thanh to\xe1n: "
                            }),
                            PAYMENT_METHOD_NAME_SHORT[paymentMethod]
                        ]
                    }),
                    deliveryDate && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: " Dự kiến giao ng\xe0y: "
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: DateTimeUtils.getFormattedWithDate(new Date(deliveryDate), translateCommon)
                            })
                        ]
                    }),
                    redeemCode && redeemCode.length > 0 && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "M\xe3 giảm gi\xe1: "
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: redeemCode[0]
                            })
                        ]
                    }),
                    totalDiscount > 0 && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.order_detail_label,
                                children: "Giảm gi\xe1: "
                            }),
                            " ",
                            formatCurrency(totalDiscount)
                        ]
                    })
                ]
            })
        ]
    });
};
var OrderRow_OrderRow = function(param) {
    var orderId = param.orderId, orderCode = param.orderCode, createdTime = param.createdTime, deliveryDate = param.deliveryDate, customerName = param.customerName, customerPhone = param.customerPhone, customerId = param.customerId, customerCode = param.customerCode, customerEmail = param.customerEmail, status = param.status, totalPrice = param.totalPrice, handleSetOrderStatus = param.handleSetOrderStatus, bankInfo = param.bankInfo, reasonsList = param.reasonsList, totalItem = param.totalItem, totalQuantity = param.totalQuantity, canEdit = param.canEdit, invoiceInfo = param.invoiceInfo, redeemCode = param.redeemCode, totalDiscount = param.totalDiscount, paymentMethod = param.paymentMethod, listInvoiceInfo = param.listInvoiceInfo, invoice = param.invoice, isMobile = param.isMobile, products = param.products, completedTime = param.completedTime;
    var ref = useTranslation("common"), translateCommon = ref.t;
    var router = useRouter();
    var ref1 = useState({}), orderTicket = ref1[0], setOrderTicket = ref1[1];
    var ref2 = _sliced_to_array(useModal(), 2), open = ref2[0], toggleOpen = ref2[1];
    var ref3 = _sliced_to_array(useModal(), 2), openCancelOrder = ref3[0], toggleOpenCancelOrder = ref3[1];
    var _reconcileTime = invoiceInfo.reconcileTime, reconcileTime = _reconcileTime === void 0 ? null : _reconcileTime, _numberOfUpdates = invoiceInfo.// arisingInvoiceTime = null,
    numberOfUpdates, numberOfUpdates = _numberOfUpdates === void 0 ? 0 : _numberOfUpdates;
    var now = +new Date();
    // thời gian giao thành công
    var deliveredTime = reconcileTime && +new Date(reconcileTime) || 0;
    // thời gian xuất hóa đơn
    // const arasingInvoice = (arisingInvoiceTime && +new Date(arisingInvoiceTime)) || 0;
    var invoices = (invoiceInfo === null || invoiceInfo === void 0 ? void 0 : invoiceInfo.invoices) || [];
    var ref4 = useSetting(), _mapSeller = ref4.mapSeller, mapSeller = _mapSeller === void 0 ? new Map() : _mapSeller;
    var numberOfSellerMEDX = products.filter(function(param) {
        var sellerCode = param.sellerCode, tags = param.tags;
        var sellerInfo = (mapSeller === null || mapSeller === void 0 ? void 0 : mapSeller.get(sellerCode)) || null;
        var isVAT = (tags === null || tags === void 0 ? void 0 : tags.indexOf("HOADONNHANH")) >= 0 || false;
        return (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isInternal) && isVAT;
    }).length;
    // const displayInvoiceBtn = () => {
    //   switch (status) {
    //     case ENUM_ORDER_STATUS.CANCEL:
    //       return false;
    //     case ENUM_ORDER_STATUS.DELIVERED:
    //     case ENUM_ORDER_STATUS.COMPLETED:
    //       // nếu có yêu cầu xuất hoá đơn
    //       if (invoice?.invoiceRequest) {
    //         // trong trường hợp có yêu cầu xuất hoá đơn
    //         // nếu có đã có hoá đơn thì sẽ dc cập nhập 1 lần - nếu quá thì ko dc
    //         if (numberOfUpdates > 0 && numberOfSellerMEDX === 0) {
    //           // numberOfUpdate chỉ dc đếm khi sau khi có hoá đơn
    //           return false;
    //         }
    //         // trong vòng 14 ngày thì vẫn hiện nút
    //         return arasingInvoice !== 0 && remainTime(now, arasingInvoice) <= 14 && numberOfSellerMEDX > 0;
    //       }
    //       // không yêu cầu xuất hoá đơn , thì sẽ tính 7 ngày từ ngày giao thành công để ẩn nút ( mặc định là hiện )
    //       // trong vòng 7 ngày thì sẽ hiện nút
    //       return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 7;
    //     default:
    //       return true;
    //   }
    // };
    var enableBtn = function() {
        switch(status){
            case ENUM_ORDER_STATUS.CANCEL:
                return false;
            case ENUM_ORDER_STATUS.DELIVERING:
                return !(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest);
            case ENUM_ORDER_STATUS.DELIVERED:
            case ENUM_ORDER_STATUS.COMPLETED:
                if (!(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest)) return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 7;
                return deliveredTime !== 0 && remainTime(now, deliveredTime) <= 14 && numberOfUpdates === 0;
            default:
                return true;
        }
    };
    var checkTime30days = completedTime !== 0 && remainTime(now, +new Date(completedTime)) >= 30;
    var ref5 = _sliced_to_array(useModal(), 2), openModalInvoice = ref5[0], toggleOpenModalInvoice = ref5[1];
    var handleChangeOrderTicket = function(value) {
        setOrderTicket(value);
    };
    var handleCancel = function() {
        var _ref = _async_to_generator(function() {
            var result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            OrderClient.cancelOrder(orderId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!isValid(result)) {
                            if ((result === null || result === void 0 ? void 0 : result.errorCode) === "INTERNAL_SERVICE_ERROR") throw new Error("Đ\xe3 c\xf3 lỗi xảy ra, vui l\xf2ng thử lại");
                            else throw new Error((result === null || result === void 0 ? void 0 : result.message) || "Gửi y\xeau cầu giữ đơn thất bại");
                        }
                        NotifyUtils.success("Gửi y\xeau cầu hủy đơn th\xe0nh c\xf4ng");
                        toggleOpenCancelOrder();
                        router.push(window.location.href);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        NotifyUtils.error(error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var maxWidth = useMediaQuery("(max-width:715px)");
    return /*#__PURE__*/ _jsxs(Paper, {
        square: !maxWidth,
        className: clsx(styles.paper, invoices.length > 0 && styles.paper_popup),
        elevation: 0,
        children: [
            /*#__PURE__*/ _jsxs(Grid, {
                container: true,
                children: [
                    /*#__PURE__*/ _jsxs(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 5,
                        container: true,
                        direction: "row",
                        justifyContent: maxWidth ? "space-between" : "flex-start",
                        className: styles.grid,
                        children: [
                            /*#__PURE__*/ _jsxs(Grid, {
                                item: true,
                                container: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Grid, {
                                        itemScope: true,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "".concat(MY_ORDER_URL, "/").concat(orderId),
                                            prefetch: false,
                                            children: /*#__PURE__*/ _jsxs("h4", {
                                                className: styles.order_id,
                                                children: [
                                                    "#",
                                                    orderId,
                                                    " \xa0"
                                                ]
                                            })
                                        }, "order-row-".concat(uuidv4()))
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        className: styles.order_status,
                                        item: true,
                                        style: {
                                            paddingTop: "5px"
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: styles.status_export,
                                            children: [
                                                /*#__PURE__*/ _jsx(OrderStatusButton, {
                                                    status: status,
                                                    handleSetOrderStatus: handleSetOrderStatus
                                                }),
                                                /*#__PURE__*/ _jsx(ExportDataOrderDetail, {
                                                    orderId: orderId
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(MyOrderDetail, {
                                amount: totalItem,
                                totalQuantity: totalQuantity,
                                createdTime: createdTime,
                                redeemCode: redeemCode,
                                deliveryDate: deliveryDate,
                                totalDiscount: totalDiscount,
                                paymentMethod: paymentMethod,
                                maxWidth: maxWidth
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 2,
                        container: true,
                        direction: "row",
                        justifyContent: "space-between",
                        className: clsx(styles.grid),
                        children: /*#__PURE__*/ _jsx(Grid, {
                            className: clsx(maxWidth ? styles.price_small_screen : styles.price),
                            item: true,
                            children: formatCurrency(totalPrice)
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Grid, {
                        item: true,
                        xs: maxWidth ? 12 : 5,
                        container: true,
                        direction: maxWidth ? "row" : "column",
                        justifyContent: "center",
                        className: styles.grid,
                        children: [
                            status === ENUM_ORDER_STATUS.WAIT_TO_CONFIRM && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: canEdit && /*#__PURE__*/ _jsx(EditOrderButton, {
                                    orderId: orderId,
                                    canEdit: canEdit
                                })
                            }),
                            FEATURE_RE_ORDER && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(ButtonReOrder, {
                                    orderId: orderId
                                })
                            }),
                            /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(TicketButton, {
                                    order: {
                                        orderId: orderId,
                                        orderCode: orderCode,
                                        orderTime: createdTime,
                                        deliveryDate: deliveryDate,
                                        name: customerName,
                                        phone: customerPhone,
                                        orderStatus: status
                                    },
                                    handleChangeOrderTicket: handleChangeOrderTicket,
                                    handleOpenModal: toggleOpen
                                })
                            }),
                            status === ENUM_ORDER_STATUS.DELIVERED || status === ENUM_ORDER_STATUS.COMPLETED ? /*#__PURE__*/ _jsx(ButtonReturnOrder, {
                                orderId: orderId,
                                disabled: status === ENUM_ORDER_STATUS.DELIVERED ? false : checkTime30days
                            }) : null,
                            status !== ENUM_ORDER_STATUS.CANCEL && /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                className: styles.gridBtn,
                                children: /*#__PURE__*/ _jsx(RequestInvoiceButton, {
                                    invoice: invoice,
                                    handleOpenModal: toggleOpenModalInvoice,
                                    numberOfSellerMEDX: numberOfSellerMEDX,
                                    numberProduct: (products === null || products === void 0 ? void 0 : products.length) || 0,
                                    status: status,
                                    numberOfUpdates: numberOfSellerMEDX,
                                    enable: enableBtn()
                                })
                            })
                        ]
                    })
                ]
            }),
            (invoice === null || invoice === void 0 ? void 0 : invoice.invoiceRequest) && (invoices === null || invoices === void 0 ? void 0 : invoices.map(function(invoiceData) {
                return /*#__PURE__*/ _jsx(InvoiceList, {
                    invoiceData: invoiceData,
                    orderId: orderId
                }, uuidv4());
            })),
            open && /*#__PURE__*/ _jsx(TicketFormModal, _object_spread_props(_object_spread({}, orderTicket), {
                bankInfo: bankInfo,
                reasonsList: reasonsList,
                customerId: customerId,
                customerCode: customerCode,
                visible: open,
                onClose: toggleOpen,
                ticketType: "ORDER_CANCELLATION"
            })),
            openCancelOrder && /*#__PURE__*/ _jsx(CustomModal, {
                visible: openCancelOrder,
                onClose: toggleOpenCancelOrder,
                title: "Xin x\xe1c nhận",
                content: "Qu\xfd kh\xe1ch c\xf3 muốn hủy đơn h\xe0ng kh\xf4ng.",
                onClickOk: handleCancel,
                btnOnClose: "T\xf4i xem lại",
                btnOk: "Đồng \xfd"
            }),
            openModalInvoice && /*#__PURE__*/ _jsx(RequestInvoiceModal, {
                listInvoiceInfo: listInvoiceInfo,
                visible: openModalInvoice,
                onClose: toggleOpenModalInvoice,
                orderId: orderId,
                customerEmail: customerEmail,
                invoice: invoice,
                isMobile: isMobile
            })
        ]
    });
};
/* harmony default export */ var OrderInfoTabs_OrderRow = ((/* unused pure expression or super */ null && (OrderRow_OrderRow)));

;// CONCATENATED MODULE: ./src/components/mocules/OrderInfoTabs/index.js



function OrderInfoTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff !important;\n  background-color: #005c29 !important;\n  border-color: #005c29 !important;\n  border: 1px solid transparent !important;\n  padding: 0.375rem 0.75rem !important;\n  font-size: 1rem !important;\n  line-height: 1.5 !important;\n  border-radius: 50px !important;\n  text-transform: none !important;\n"
    ]);
    OrderInfoTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var CustomTab = (0,withStyles/* default */.Z)({
    root: {
        textTransform: "none",
        minWidth: 130
    },
    selected: {
        color: "#005C29!important",
        fontWeight: "bold"
    }
})(Tab/* default */.Z);
var ComeHomeButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-98bcad17-0"
})(OrderInfoTabs_templateObject());
var tabs = [
    {
        label: "Tất cả",
        value: Enums/* ENUM_ORDER_STATUS.ALL */.TJ.ALL
    },
    {
        label: "Chờ X\xe1c Nhận",
        value: Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM
    },
    {
        label: "Đ\xe3 X\xe1c Nhận",
        value: Enums/* ENUM_ORDER_STATUS.CONFIRMED */.TJ.CONFIRMED
    },
    {
        label: "Đang Xử L\xfd",
        value: Enums/* ENUM_ORDER_STATUS.PROCESSING */.TJ.PROCESSING
    },
    {
        label: "Đang Giao",
        value: Enums/* ENUM_ORDER_STATUS.DELIVERING */.TJ.DELIVERING
    },
    {
        label: "Đ\xe3 Giao",
        value: Enums/* ENUM_ORDER_STATUS.DELIVERED */.TJ.DELIVERED
    },
    {
        label: "Ho\xe0n Tất",
        value: Enums/* ENUM_ORDER_STATUS.COMPLETED */.TJ.COMPLETED
    },
    {
        label: "Huỷ",
        value: Enums/* ENUM_ORDER_STATUS.CANCEL */.TJ.CANCEL
    }, 
];
var limit = clients/* LIMIT_DEFAULT */.J0;
function OrderInfoTabs(param) {
    var user = param.user, orders = param.orders, status = param.status, bankInfo = param.bankInfo, reasonsList = param.reasonsList, pageSize = param.pageSize, listInvoiceInfo = param.listInvoiceInfo, isMobile = param.isMobile;
    var router = useRouter();
    var ref = (router === null || router === void 0 ? void 0 : router.query) || {}, _offset = ref.offset, offset = _offset === void 0 ? 0 : _offset;
    var ref1 = useState((+offset + limit) / limit), numPage = ref1[0], setNumpage = ref1[1];
    var handleChangeOrderStatus = function(statusR) {
        router.push({
            pathname: router.pathname,
            query: {
                status: statusR
            }
        });
        setNumpage(1);
    };
    var handleComehome = function() {
        router.push("/");
    };
    var handleChangePage = function(_, page) {
        var offsetByPage = (page - 1) * limit;
        setNumpage(page);
        router.push({
            pathname: router.pathname,
            query: {
                offset: offsetByPage,
                limit: limit,
                status: status
            }
        });
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        container: true,
        spacing: 1,
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                className: styles.tabs,
                children: /*#__PURE__*/ _jsx(Paper, {
                    elevation: 0,
                    children: /*#__PURE__*/ _jsx(Tabs, {
                        value: status,
                        textColor: "primary",
                        centered: true,
                        classes: {
                            indicator: styles.indicator
                        },
                        children: tabs && tabs.map(function(param) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ _jsx(CustomTab, {
                                label: label,
                                disableFocusRipple: true,
                                disableRipple: true,
                                onClick: function() {
                                    return handleChangeOrderStatus(value);
                                },
                                value: value
                            }, uuidV4());
                        })
                    })
                })
            }),
            orders.length === 0 ? /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.not_order_container,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.not_order_title,
                            children: "Kh\xf4ng c\xf3 đơn h\xe0ng"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(ComeHomeButton, {
                                onClick: handleComehome,
                                children: " Đến trang đặt h\xe0ng nhanh "
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: orders && orders.map(function(order) {
                    return /*#__PURE__*/ _createElement(OrderRow, _object_spread_props(_object_spread({}, order), {
                        key: uuidV4(),
                        user: user,
                        handleSetOrderStatus: handleChangeOrderStatus,
                        bankInfo: bankInfo,
                        reasonsList: reasonsList,
                        listInvoiceInfo: listInvoiceInfo,
                        isMobile: isMobile
                    }));
                })
            }),
            orders.length > 0 && /*#__PURE__*/ _jsx(Grid, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.justify_center,
                    children: /*#__PURE__*/ _jsx(Pagination, {
                        defaultPage: numPage,
                        count: pageSize,
                        onChange: handleChangePage,
                        page: numPage
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js
var FormGroup_FormGroup = __webpack_require__(6562);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js
var material_Skeleton_Skeleton = __webpack_require__(22054);
// EXTERNAL MODULE: ./src/constants/Images/payment/index.js
var payment = __webpack_require__(63574);
// EXTERNAL MODULE: ./src/components/mocules/PaymentMethod/styles.module.css
var PaymentMethod_styles_module = __webpack_require__(5397);
var PaymentMethod_styles_module_default = /*#__PURE__*/__webpack_require__.n(PaymentMethod_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/PaymentMethod/index.js
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable react/jsx-wrap-multilines */ 























var PaymentMethodsTab = function(param) {
    var _openTab = param.openTab, openTab = _openTab === void 0 ? true : _openTab, _setOpenTab = param.setOpenTab, setOpenTab = _setOpenTab === void 0 ? function() {} : _setOpenTab, _translateCheckout = param.translateCheckout, translateCheckout = _translateCheckout === void 0 ? function() {} : _translateCheckout, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, _selectedVal = param.selectedVal, selectedVal = _selectedVal === void 0 ? "" : _selectedVal, handleChange = param.handleChange;
    var ref = useState(selectedVal), paymentMethodSelected = ref[0], setPaymentMethodSelected = ref[1];
    var handleChangePaymentMethodOption = function(e) {
        setPaymentMethodSelected(e.target.value);
    };
    var handleClose = function() {
        setOpenTab(false);
    };
    var handleSubmitPaymentMethod = function() {
        var e = {
            target: {
                value: paymentMethodSelected
            }
        };
        handleChange(e);
        setOpenTab(false);
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: openTab,
        handleClose: handleClose,
        fullScreen: true,
        fullWidth: true,
        style: {
            backgroundColor: "#fff",
            position: "fixed",
            zIndex: "1300",
            inset: "0px"
        },
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            direction: "column",
            className: styles.containerModal,
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    onClick: handleClose,
                    className: styles.headerBack,
                    children: /*#__PURE__*/ _jsxs(Button, {
                        className: styles.iconBackButton,
                        children: [
                            /*#__PURE__*/ _jsx(ArrowBackIos, {
                                style: {
                                    width: "16px",
                                    height: "16px"
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: styles.titleBackButton,
                                children: translateCheckout("payment_method")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    className: styles.listItemsBox,
                    children: /*#__PURE__*/ _jsxs(Grid, {
                        container: true,
                        direction: "column",
                        style: {
                            height: "100%",
                            flexWrap: "unset"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.listItems,
                                children: /*#__PURE__*/ _jsx(FormControl, {
                                    component: "fieldset",
                                    style: {
                                        width: "100%",
                                        height: "85%",
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ _jsx(FormGroup, {
                                        className: styles.radioGroup,
                                        children: (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) > 0 ? paymentMethods.map(function(item) {
                                            var ref;
                                            /*#__PURE__*/ return _jsx(RadioGroup, {
                                                value: paymentMethodSelected,
                                                className: styles.groupCheckBox,
                                                onChange: handleChangePaymentMethodOption,
                                                children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                                    value: item.code,
                                                    disabled: item.isDisable,
                                                    control: /*#__PURE__*/ _jsx(Radio, {
                                                        size: "small"
                                                    }),
                                                    label: /*#__PURE__*/ _jsxs(Box, {
                                                        display: "flex",
                                                        gridGap: 8,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Box, {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                flexGrow: 1,
                                                                gridGap: 4,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("h6", {
                                                                        className: styles.titleContent,
                                                                        children: item.name
                                                                    }),
                                                                    item.additionFeeText.length > 0 && !item.isDisable && /*#__PURE__*/ _jsx("span", {
                                                                        className: styles.subTitleContent,
                                                                        children: translateCheckout("addition_fee_text", {
                                                                            text: item.additionFeeText
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Box, {
                                                                display: "flex",
                                                                flexWrap: "no-wrap",
                                                                gridGap: 4,
                                                                children: (item === null || item === void 0 ? void 0 : (ref = item.svgIcons) === null || ref === void 0 ? void 0 : ref.length) > 0 && item.svgIcons.map(function(svgIconURL) {
                                                                    return /*#__PURE__*/ _jsx(ImageFallback, {
                                                                        src: svgIconURL,
                                                                        alt: item.name,
                                                                        width: "32px",
                                                                        height: "32px"
                                                                    }, svgIconURL);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, item.code);
                                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.listItems,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.donePaymentButtonBox,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "contained",
                                        color: "primary",
                                        className: styles.donePaymentButton,
                                        onClick: handleSubmitPaymentMethod,
                                        children: translateCheckout("confirm")
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var methodSubTitle = function(param) {
    var subTitle = param.subTitle, isDisable = param.isDisable, code = param.code, additionFeeText = param.additionFeeText, translateCheckout = param.translateCheckout;
    var content = "";
    if ([
        Enums/* PAYMENT_METHOD.TRANSFER */.hL.TRANSFER,
        Enums/* PAYMENT_METHOD.COD */.hL.COD,
        Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT,
        Enums/* PAYMENT_METHOD.QR_BEAM */.hL.QR_BEAM, 
    ].includes(code)) {
        if (subTitle.length > 0 && !isDisable) {
            content = subTitle.replace("{percentage}%", additionFeeText);
        }
    } else if (additionFeeText.length > 0 && !isDisable) {
        content = translateCheckout("addition_fee_text", {
            text: additionFeeText
        });
    }
    return content.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PaymentMethod_styles_module_default()).subTitle,
        children: content
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var PaymentMethodItem = /*#__PURE__*/ react.memo(function(param) {
    var item = param.item, isSelected = param.isSelected, onChange = param.onChange, translateCheckout = param.translateCheckout;
    var ref = item || {}, code = ref.code, name = ref.name, additionFeeText = ref.additionFeeText, url = ref.url, isDisable = ref.isDisable, _svgIcons = ref.svgIcons, svgIcons = _svgIcons === void 0 ? [] : _svgIcons, subTitle = ref.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
        className: (PaymentMethod_styles_module_default()).fieldset,
        value: isSelected && code,
        onChange: onChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
            value: code,
            disabled: isDisable,
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {
                classes: {
                    root: isSelected ? (PaymentMethod_styles_module_default()).checkbox_color : (PaymentMethod_styles_module_default()).noncheckbox_color
                },
                "data-test": "radio-checkout-payment"
            }),
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                display: "flex",
                gridGap: 8,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        flexGrow: 1,
                        gridGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: (PaymentMethod_styles_module_default()).fw500,
                                children: name
                            }),
                            methodSubTitle({
                                subTitle: subTitle,
                                isDisable: isDisable,
                                code: code,
                                additionFeeText: additionFeeText,
                                translateCheckout: translateCheckout
                            }),
                            code === Enums/* PAYMENT_METHOD.TRANSFER */.hL.TRANSFER && url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    "\xa0(",
                                    translateCheckout("guide_transfer"),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        display: "flex",
                        flexWrap: "no-wrap",
                        gridGap: 4,
                        children: (svgIcons === null || svgIcons === void 0 ? void 0 : svgIcons.length) > 0 && svgIcons.map(function(svgIconURL) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* default */.ZP, {
                                src: svgIconURL,
                                alt: name,
                                width: "24px",
                                height: "24px"
                            }, svgIconURL);
                        })
                    })
                ]
            })
        })
    });
});
var PaymentMethod = function(param) {
    var handleChange = param.handleChange, _selectedValue = param.selectedValue, selectedValue = _selectedValue === void 0 ? "" : _selectedValue, _paymentMethods = param.paymentMethods, paymentMethods = _paymentMethods === void 0 ? [] : _paymentMethods, paymentMethodDefault = param.paymentMethodDefault, user = param.user, translateCheckout = param.translateCheckout, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _bankTransferWaitingHours = param.bankTransferWaitingHours, bankTransferWaitingHours = _bankTransferWaitingHours === void 0 ? Enums/* DEFAULT_BANK_TRANSFER_WAITING_HOURS */.qG : _bankTransferWaitingHours, _isBankConfigActive = param.isBankConfigActive, isBankConfigActive = _isBankConfigActive === void 0 ? false : _isBankConfigActive;
    var _wardCode = user.wardCode, wardCode = _wardCode === void 0 ? "" : _wardCode, _districtCode = user.districtCode, districtCode = _districtCode === void 0 ? "" : _districtCode, _provinceCode = user.provinceCode, provinceCode = _provinceCode === void 0 ? "" : _provinceCode;
    var selectedVal = (0,react.useMemo)(function() {
        return selectedValue || (paymentMethodDefault === null || paymentMethodDefault === void 0 ? void 0 : paymentMethodDefault.code) || "";
    }, [
        selectedValue,
        paymentMethodDefault === null || paymentMethodDefault === void 0 ? void 0 : paymentMethodDefault.code
    ]);
    var selectedPaymentMethod = paymentMethods.find(function(method) {
        return method.code === selectedVal;
    });
    var ref = selectedPaymentMethod || {}, code = ref.code, description = ref.description, errorMessage = ref.errorMessage, subTitle = ref.subTitle;
    var checkExistDescriptionContent = (0,react.useMemo)(function() {
        return description && description.length > 0 && description !== "<p></p>\n";
    }, [
        description
    ]);
    // const [openTab, setOpenTab] = useState(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper_Paper/* default */.Z, {
        className: (PaymentMethod_styles_module_default()).root,
        elevation: 4,
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                    container: true,
                    alignItems: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (PaymentMethod_styles_module_default()).title,
                                children: translateCheckout("payment_method")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            container: true,
                            direction: "column",
                            style: {
                                height: "100%",
                                flexWrap: "unset"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).listItems,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                                    component: "fieldset",
                                    style: {
                                        width: "100%",
                                        height: "85%",
                                        marginTop: 8
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup_FormGroup/* default */.Z, {
                                        className: (PaymentMethod_styles_module_default()).radioGroup,
                                        children: (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) > 0 ? paymentMethods.map(function(item) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(RadioGroup_RadioGroup/* default */.Z, {
                                                value: selectedVal,
                                                className: (PaymentMethod_styles_module_default()).groupCheckBox,
                                                onChange: function(e) {
                                                    return handleChange(e);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel_FormControlLabel/* default */.Z, {
                                                    value: item.code,
                                                    disabled: item.isDisable,
                                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio/* default */.Z, {}),
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                        display: "flex",
                                                        gridGap: 8,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                flexGrow: 1,
                                                                gridGap: 4,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        className: (PaymentMethod_styles_module_default()).titleContent,
                                                                        children: item.name
                                                                    }),
                                                                    methodSubTitle({
                                                                        subTitle: (item === null || item === void 0 ? void 0 : item.subTitle) || "",
                                                                        isDisable: item === null || item === void 0 ? void 0 : item.isDisable,
                                                                        code: (item === null || item === void 0 ? void 0 : item.code) || "",
                                                                        additionFeeText: (item === null || item === void 0 ? void 0 : item.additionFeeText) || "",
                                                                        translateCheckout: translateCheckout
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                display: "flex",
                                                                flexWrap: "no-wrap",
                                                                gridGap: 4,
                                                                children: (item === null || item === void 0 ? void 0 : (ref = item.svgIcons) === null || ref === void 0 ? void 0 : ref.length) > 0 && item.svgIcons.map(function(svgIconURL) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* default */.ZP, {
                                                                        src: svgIconURL,
                                                                        alt: item.name,
                                                                        width: "32px",
                                                                        height: "32px"
                                                                    }, svgIconURL);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, item.code);
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rect",
                                                    width: "100%",
                                                    height: 70
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (PaymentMethod_styles_module_default()).title,
                        children: translateCheckout("payment_method")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                        component: "fieldset",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).paymentMethodsGrid,
                                children: (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) > 0 ? paymentMethods.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodItem, {
                                        item: item,
                                        isSelected: selectedVal === item.code,
                                        onChange: handleChange,
                                        translateCheckout: translateCheckout
                                    }, item.code);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(material_Skeleton_Skeleton/* default */.Z, {
                                            variant: "rect",
                                            width: "100%",
                                            height: 70
                                        })
                                    ]
                                })
                            }),
                            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PaymentMethod_styles_module_default()).subTitle,
                                children: errorMessage
                            }),
                            !!checkExistDescriptionContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                                    className: (PaymentMethod_styles_module_default()).bank_info,
                                    icon: false,
                                    severity: "info",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                        container: true,
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            spacing: 2,
                                            className: (PaymentMethod_styles_module_default()).content,
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            }
                                        })
                                    })
                                })
                            }, (0,v4/* default */.Z)())
                        ]
                    })
                ]
            }),
            selectedVal && selectedVal !== Enums/* PAYMENT_METHOD.COD */.hL.COD && selectedVal !== Enums/* PAYMENT_METHOD.CREDIT */.hL.CREDIT && selectedVal !== Enums/* PAYMENT_METHOD.TRANSFER */.hL.TRANSFER && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                severity: "warning",
                style: {
                    borderRadius: "8px",
                    marginTop: "12px"
                },
                icon: false,
                children: translateCheckout("non_cod_payment_hint", {
                    hours: Enums/* DEFAULT_NON_BANK_WAITING_HOURS */.Iw
                })
            }),
            selectedVal === Enums/* PAYMENT_METHOD.TRANSFER */.hL.TRANSFER && isBankConfigActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, {
                severity: "warning",
                style: {
                    borderRadius: "8px",
                    marginTop: "12px"
                },
                icon: false,
                children: translateCheckout("non_cod_payment_hint", {
                    hours: bankTransferWaitingHours
                })
            }),
            (!wardCode || !districtCode || !provinceCode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert_Alert/* default */.Z, {
                severity: "info",
                style: {
                    borderRadius: "8px",
                    marginTop: "15px"
                },
                children: [
                    translateCheckout("please_enter_full"),
                    " ",
                    !wardCode && translateCheckout("ward"),
                    !districtCode && ", ".concat(translateCheckout("district")),
                    !provinceCode && ", ".concat(translateCheckout("province")),
                    " ",
                    translateCheckout("in"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/my-account",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/my-account",
                                target: "_blank",
                                children: translateCheckout("account_info")
                            })
                        })
                    }),
                    " ",
                    translateCheckout("to_get_discount")
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_PaymentMethod = (PaymentMethod);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Print.js
var Print = __webpack_require__(20394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell_TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow_TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./src/components/mocules/PrintInvoiceModal/style.module.css
var PrintInvoiceModal_style_module = __webpack_require__(28829);
var PrintInvoiceModal_style_module_default = /*#__PURE__*/__webpack_require__.n(PrintInvoiceModal_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceModal/validateForm.js

var PrintInvoiceModal_validateForm_validateForm = function(param) {
    var _businessName = param.businessName, businessName = _businessName === void 0 ? "" : _businessName, _mst = param.mst, mst = _mst === void 0 ? "" : _mst, _taxCode = param.taxCode, taxCode = _taxCode === void 0 ? "" : _taxCode, _email = param.email, email = _email === void 0 ? "" : _email, _address = param.address, address = _address === void 0 ? "" : _address, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(businessName)) throw Error("message_clinic_name_cannot_be_empty");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(mst || taxCode)) throw Error("message_empty_tax_code");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(email)) throw Error("message_cannot_be_empty");
    if (utils/* ValidateUtils.isEmpty */.IN.isEmpty(address)) throw Error("message_empty_address");
    if (provinceCode === "0") throw Error("message_empty_province_city");
    if (districtCode === "0") throw Error("message_empty_district");
    if (wardCode === "0") throw Error("message_empty_ward");
    if (!utils/* ValidateUtils.validateEmail */.IN.validateEmail(email)) throw Error("message_invalid_email");
    if (!utils/* ValidateUtils.isNumber */.IN.isNumber(mst || taxCode)) throw Error("message_tax_code_wrong_format");
};
/* harmony default export */ var PrintInvoiceModal_validateForm = (PrintInvoiceModal_validateForm_validateForm);

;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceModal/index.js






function PrintInvoiceModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff !important;\n  background-color: #005c29 !important;\n  border: 1px solid #005c29 !important;\n  font-weight: 500 !important;\n  margin-top: 50px !important;\n  border-radius: 10px !important;\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n\n  &:hover {\n    background: #fff !important;\n    color: #005c29 !important;\n    border: 1px solid #005c29 !important;\n  }\n"
    ]);
    PrintInvoiceModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var StyledCompleteButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).withConfig({
    componentId: "sc-6e296b0d-0"
})(PrintInvoiceModal_templateObject());
var PrintInvoiceModal = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var heads = [
        {
            text: "Sản phẩm h\xf3a đơn nhanh",
            align: Enums/* ALIGN.LEFT */.Hp.LEFT
        },
        {
            text: "Gi\xe1 (đ)",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        },
        {
            text: "Số lượng",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        },
        {
            text: "Tổng cộng (đ)",
            align: Enums/* ALIGN.RIGHT */.Hp.RIGHT
        }, 
    ];
    var onClose = props.onClose, visible = props.visible, className = props.className, restProps = props.restProps, orderCode = props.orderCode, user = props.user;
    var add = user.address, businessName = user.businessName, email = user.email, taxCode = user.taxCode;
    var ref1 = (0,react.useState)({
        taxCode: taxCode || "",
        email: email || "",
        businessName: businessName || "",
        address: add || ""
    }), val = ref1[0], setVal = ref1[1];
    var ref2 = (0,react.useState)({
        province: user === null || user === void 0 ? void 0 : user.provinceCode,
        district: user === null || user === void 0 ? void 0 : user.districtCode,
        ward: user === null || user === void 0 ? void 0 : user.wardCode
    }), address = ref2[0], setAddress = ref2[1];
    var ref3 = (0,react.useState)({
        changeType: Enums/* ADDRESS_CHANGE_TYPE.ASSIGNED */.Ei.ASSIGNED,
        province: address.province,
        district: address.district,
        ward: address.ward
    }), currentAddress = ref3[0], setCurrentAddress = ref3[1];
    var handleSetCurrentAddress = function(addressinfo) {
        setCurrentAddress(addressinfo);
        setAddress((0,src_object_spread/* default */.Z)({}, address, addressinfo));
    };
    var ref4 = (0,react.useState)([]), products = ref4[0], setProducts = ref4[1];
    var handleChangeVal = function(key, value) {
        setVal((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, val), (0,src_define_property/* default */.Z)({}, key, value)));
    };
    var handleCompleted = function() {
        try {
            PrintInvoiceModal_validateForm(val);
            utils/* NotifyUtils.success */.QP.success("Xuất ho\xe1 đơn th\xe0nh c\xf4ng.");
            onClose();
        } catch (error) {
            utils/* NotifyUtils.error */.QP.error(translateAlertAction(error === null || error === void 0 ? void 0 : error.message) || "Xuất ho\xe1 đơn thất bại");
        }
    };
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,src_async_to_generator/* default */.Z)(function() {
                var res, _tmp, orderItems, orderItemInfoRes, _tmp1, orderItemInfoMap, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            _tmp = {};
                            return [
                                4,
                                clients/* OrderClient.getProductByOrderCode */.ZT.getProductByOrderCode((_tmp.orderCode = orderCode, _tmp))
                            ];
                        case 1:
                            res = _state.sent();
                            if (!(0,clients/* isValid */.JY)(res)) throw Error();
                            orderItems = (res === null || res === void 0 ? void 0 : res.data) || [];
                            _tmp1 = {};
                            return [
                                4,
                                services/* OrderService.getInfoOrderItem */.px.getInfoOrderItem((_tmp1.orderItems = orderItems, _tmp1))
                            ];
                        case 2:
                            orderItemInfoRes = _state.sent();
                            if (!(0,clients/* isValid */.JY)(orderItemInfoRes)) throw Error("Load th\xf4ng tin sản phẩm thất bại");
                            orderItemInfoMap = orderItemInfoRes.data[0];
                            orderItems = orderItems.map(function(product) {
                                var sku = product === null || product === void 0 ? void 0 : product.productSku;
                                return (0,src_object_spread/* default */.Z)({
                                    productInfo: orderItemInfoMap[sku] || {}
                                }, product);
                            });
                            setProducts(orderItems);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setProducts([]);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (PrintInvoiceModal_style_module_default()).confirm_modal_wrap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (PrintInvoiceModal_style_module_default()).title,
                        children: " Th\xf4ng tin xuất ho\xe1 đơn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "T\xean nh\xe0 thuốc/ph\xf2ng kh\xe1m",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "businessName",
                                    value: val.businessName,
                                    onChange: function(e) {
                                        return handleChangeVal("businessName", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "M\xe3 số thuế",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "taxCode",
                                    value: val.taxCode,
                                    onChange: function(e) {
                                        return handleChangeVal("taxCode", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "Email",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "email",
                                    value: val.email,
                                    onChange: function(e) {
                                        return handleChangeVal("email", e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                xs: 12,
                                label: "Địa chỉ nhận ho\xe1 đơn",
                                htmlFor: "address",
                                isRequired: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_InfoInput/* default */.Z, {
                                    id: "address",
                                    value: val.address,
                                    onChange: function(e) {
                                        return handleChangeVal("address", e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_GroupAddressSelect, {
                        id: (0,v4/* default */.Z)(),
                        currentAddress: currentAddress,
                        handleSetCurrentAddress: handleSetCurrentAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoTable */.CE, {
                        heads: heads,
                        stickyHeader: true,
                        className: (PrintInvoiceModal_style_module_default()).ovfy,
                        children: products.map(function(product) {
                            var salePrice = product.salePrice, quantity = product.quantity, totalPrice = product.totalPrice;
                            var ref = product.productInfo || {}, _name = ref.name, name = _name === void 0 ? "" : _name, _slug = ref.slug, slug = _slug === void 0 ? "" : _slug;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow_TableRow/* default */.Z, {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.LEFT */.Hp.LEFT,
                                        className: (PrintInvoiceModal_style_module_default()).product_name,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                            variant: "h5",
                                            href: (0,Paths/* getPathProductBySlug */.hq)(slug),
                                            className: (PrintInvoiceModal_style_module_default()).product_name,
                                            children: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(salePrice)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(quantity)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell_TableCell/* default */.Z, {
                                        align: Enums/* ALIGN.RIGHT */.Hp.RIGHT,
                                        children: (0,FormatNumber/* formatNumber */.uf)(totalPrice)
                                    })
                                ]
                            }, (0,v4/* default */.Z)());
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompleteButton, {
                        onClick: handleCompleted,
                        children: " Xuất ho\xe1 đơn "
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var mocules_PrintInvoiceModal = (PrintInvoiceModal);

;// CONCATENATED MODULE: ./src/components/mocules/PrintInvoiceButton/index.js





var PrintInvoiceButton = function(param) {
    var disabled = param.disabled, orderCode = param.orderCode, user = param.user;
    var ref = (0,react.useState)(false), val = ref[0], setVal = ref[1];
    var handleChangeVal = function() {
        setVal(!val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Print/* default */.Z, {}),
                className: "my-order__button my-order__button--secondary",
                disabled: disabled,
                onClick: handleChangeVal,
                children: "Xuất ho\xe1 đơn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PrintInvoiceModal, {
                visible: val,
                onClose: handleChangeVal,
                orderCode: orderCode,
                user: user
            })
        ]
    });
};
/* harmony default export */ var mocules_PrintInvoiceButton = (/*#__PURE__*/react.memo(PrintInvoiceButton));

// EXTERNAL MODULE: ./src/components/mocules/ProductCardContent/index.js + 1 modules
var ProductCardContent = __webpack_require__(19963);
// EXTERNAL MODULE: ./src/components/mocules/ProductCardInput/index.js + 1 modules
var ProductCardInput = __webpack_require__(77524);
// EXTERNAL MODULE: ./src/components/mocules/ProductDetailTabs/index.js
var ProductDetailTabs = __webpack_require__(88491);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabContext/TabContext.js
var TabContext = __webpack_require__(78207);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabList/TabList.js
var TabList = __webpack_require__(37313);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabPanel/TabPanel.js
var TabPanel = __webpack_require__(64532);
// EXTERNAL MODULE: ./src/components/mocules/ProductDetailTabsV2/styles.module.css
var ProductDetailTabsV2_styles_module = __webpack_require__(69815);
var ProductDetailTabsV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetailTabsV2_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductDetailTabsV2/index.js
/* eslint-disable react/no-danger */ 














function ProductDetailTabsV2(param) {
    var data = param.data, product = param.product, _ingredients = param.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients, isMobile = param.isMobile, _isAuthenticate = param.isAuthenticate, isAuthenticate = _isAuthenticate === void 0 ? true : _isAuthenticate;
    var ref = (0,esm/* useTranslation */.$G)("productDetail"), translateProductDetail = ref.t;
    var ref1 = (0,react.useState)(0), height = ref1[0], setHeight = ref1[1];
    var ref2 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        setHeight((ref2 === null || ref2 === void 0 ? void 0 : (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0);
    });
    var ref3 = product || {}, _description = ref3.description, description = _description === void 0 ? {} : _description;
    var ref4 = (0,context/* useSetting */.yu)(), _mapIngredients = ref4.mapIngredients, mapIngredients = _mapIngredients === void 0 ? null : _mapIngredients;
    var ref5 = (0,react.useState)(0), activeTab = ref5[0], setActiveTab = ref5[1];
    var handleChangeTab = function(e, newValue) {
        setActiveTab(newValue);
    };
    var tabPanels = [
        {
            label: translateProductDetail("general_information"),
            value: 0,
            data: data.slice(0, 2)
        }, 
    ];
    if (isAuthenticate) {
        tabPanels.push({
            label: translateProductDetail("in_depth_information"),
            value: 1,
            data: data.slice(2)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ProductDetailTabsV2_styles_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContext/* default */.ZP, {
            value: activeTab,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList/* default */.Z, {
                        TabIndicatorProps: {
                            className: (ProductDetailTabsV2_styles_module_default()).indicator
                        },
                        onChange: handleChangeTab,
                        "aria-label": "product details tabs",
                        variant: "scrollable",
                        className: (ProductDetailTabsV2_styles_module_default()).tabs,
                        children: tabPanels.map(function(tab) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                classes: {
                                    root: (ProductDetailTabsV2_styles_module_default()).tab,
                                    selected: (ProductDetailTabsV2_styles_module_default()).active_tab
                                },
                                label: tab.label,
                                value: tab.value
                            }, (0,v4/* default */.Z)());
                        })
                    })
                }),
                tabPanels.map(function(tabPanel, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).tab_panel, (0,src_define_property/* default */.Z)({}, (ProductDetailTabsV2_styles_module_default()).tab_panel_mv2, isMobile)),
                        value: tabPanel === null || tabPanel === void 0 ? void 0 : tabPanel.value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(!isMobile ? (ProductDetailTabsV2_styles_module_default()).item_wrapper : (ProductDetailTabsV2_styles_module_default()).mobile_item_wrapper),
                            children: tabPanel.data.map(function(tab) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(!isMobile ? (ProductDetailTabsV2_styles_module_default()).item : (ProductDetailTabsV2_styles_module_default()).mobile_item, index === 0 && (ProductDetailTabsV2_styles_module_default()).general_item),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ProductDetailTabsV2_styles_module_default()).item_label,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: tab.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ProductDetailTabsV2_styles_module_default()).item_label_border
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ProductDetailTabsV2_styles_module_default()).item_content,
                                            children: [
                                                (tab === null || tab === void 0 ? void 0 : tab.code) === "ingredients" && (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (ProductDetailTabsV2_styles_module_default()).ingredientList,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row, (ProductDetailTabsV2_styles_module_default()).ingredient_row_heading),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row_label, (ProductDetailTabsV2_styles_module_default()).ingredient_heading),
                                                                    children: translateProductDetail("composition")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (0,clsx_m/* default */.Z)((ProductDetailTabsV2_styles_module_default()).ingredient_row_content, (ProductDetailTabsV2_styles_module_default()).ingredient_heading),
                                                                    children: translateProductDetail("ingredient_content")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: ingredients === null || ingredients === void 0 ? void 0 : ingredients.map(function(param) {
                                                                var ingredientCode = param.ingredientCode, ingredientVolume = param.volume;
                                                                var ref = (mapIngredients === null || mapIngredients === void 0 ? void 0 : mapIngredients.get(ingredientCode)) || {}, slug = ref.slug, tmp = ref.name, ingredientName = tmp === void 0 ? "" : tmp;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (ProductDetailTabsV2_styles_module_default()).ingredient_row,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                                                            href: "".concat(Paths/* INGREDIENT */.gL, "/").concat(slug),
                                                                            className: (ProductDetailTabsV2_styles_module_default()).ingredient_row_label,
                                                                            children: ingredientName
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (ProductDetailTabsV2_styles_module_default()).ingredient_row_content,
                                                                            children: ingredientVolume
                                                                        })
                                                                    ]
                                                                }, (0,v4/* default */.Z)());
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (tab === null || tab === void 0 ? void 0 : tab.code) !== "ingredients" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: description[tab === null || tab === void 0 ? void 0 : tab.code]
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, (0,v4/* default */.Z)());
                            })
                        })
                    }, tabPanel === null || tabPanel === void 0 ? void 0 : tabPanel.value);
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./src/components-v2/atoms/LoadingBM/index.js
var LoadingBM = __webpack_require__(30274);
// EXTERNAL MODULE: ./src/components/mocules/PromotionDetailModal/styles.module.css
var PromotionDetailModal_styles_module = __webpack_require__(57770);
var PromotionDetailModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionDetailModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/PromotionDetailModal/index.js













var PromotionDetailModal = /*#__PURE__*/ (0,react.memo)(function PromotionDetailModal(param) {
    var onClose = param.onClose, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, _listsPromo = param.listsPromo, listsPromo = _listsPromo === void 0 ? [] : _listsPromo, loading = param.loading, err = param.err;
    // max 5 list promo
    // const maxPromoLists = listsPromo.slice(0, 5);
    var renderDescriptionPromo = function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: data
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: Backdrop/* default */.Z,
        BackdropProps: {
            timeout: 300
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
            in: visible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                className: (PromotionDetailModal_styles_module_default()).confirm_modal_wrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).header,
                        style: {
                            background: "#005C29",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                style: {
                                    display: "flex",
                                    marginLeft: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).wrapImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VOUCHER_TITLE_BOX */.Ue, {})
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).modal_title,
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                className: (PromotionDetailModal_styles_module_default()).closeIcon,
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).containerPromoDiablog,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).wrapLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBM/* default */.Z, {
                                animateText: true
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).children,
                            children: [
                                err && err,
                                listsPromo === null || listsPromo === void 0 ? void 0 : listsPromo.map(function(param) {
                                    var _conditionDescription = param.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, voucherId = param.voucherId;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: renderDescriptionPromo(conditionDescription)
                                    }, voucherId);
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var mocules_PromotionDetailModal = (/*#__PURE__*/react.memo(PromotionDetailModal));

// EXTERNAL MODULE: ./src/components/mocules/RegisterGuestForm/styles.module.css
var RegisterGuestForm_styles_module = __webpack_require__(5070);
var RegisterGuestForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(RegisterGuestForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/RegisterGuestForm/RegisterGuestForm.js






var SignInForm = /*#__PURE__*/ react.memo(function SignInForm(param) {
    var className = param.className, onClickRegister = param.onClickRegister;
    var regExp = /(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var ref = (0,react.useState)(false), errorPhone = ref[0], setErrorPhone = ref[1];
    var ref1 = (0,react.useState)(""), errorPhoneMessage = ref1[0], setErrorPhoneMessage = ref1[1];
    var validatePhone = function(data) {
        setErrorPhone(false);
        if (data === "") {
            setErrorPhone(true);
            setErrorPhoneMessage("Vui l\xf2ng nhập số điện thoại v\xe0 bắt đầu bằng số 0");
            return false;
        }
        if (!data.match(regExp)) {
            setErrorPhone(true);
            setErrorPhoneMessage("Số điện thoại bạn nhập kh\xf4ng đ\xfang");
            return false;
        }
        return true;
    };
    // handle login with data
    var handleRegisterGuest = function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        if (!validatePhone(data.phone)) {
            return;
        }
        onClickRegister(data);
    };
    var handleOnChange = function(e) {
        e.preventDefault();
        validatePhone(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RegisterGuestForm_styles_module_default()).form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleRegisterGuest,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (RegisterGuestForm_styles_module_default()).title,
                    children: "Vui l\xf2ng nhập số điện thoại trước khi d\xf9ng thử"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
                    className: (RegisterGuestForm_styles_module_default()).formInput,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            id: "phone",
                            name: "phone",
                            type: "number",
                            placeholder: "Nhập số điện thoại",
                            variant: "outlined",
                            error: errorPhone,
                            onChange: handleOnChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (RegisterGuestForm_styles_module_default()).error,
                            children: errorPhone && errorPhoneMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RegisterGuestForm_styles_module_default()).bottom_text,
                    children: "M\xe3 giảm gi\xe1 100k d\xe0nh cho nh\xe0 thuốc mới đăng k\xfd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RegisterGuestForm_styles_module_default()).btnWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        className: "btnLogin",
                        color: "white",
                        type: "submit",
                        children: "Đăng K\xfd"
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var RegisterGuestForm = (SignInForm);

;// CONCATENATED MODULE: ./src/components/mocules/RegisterGuestForm/index.js

function RegisterGuestForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: ",
        "px;\n  }\n  .rememberPassword {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btnLogin {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    margin: 1rem 0;\n    border-radius: 50px;\n  }\n  .register {\n    padding: 1rem;\n  }\n"
    ]);
    RegisterGuestForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RegisterGuestForm_RegisterGuestForm = (0,styled_components_browser_esm/* default */.ZP)(RegisterGuestForm).withConfig({
    componentId: "sc-4d2e0a5a-0"
})(RegisterGuestForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 400 : _width;
    return width;
});
/* harmony default export */ var mocules_RegisterGuestForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(RegisterGuestForm_RegisterGuestForm))));

// EXTERNAL MODULE: ./src/styles/index.js
var src_styles = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var atoms_LinkComp = __webpack_require__(24618);
;// CONCATENATED MODULE: ./src/components/mocules/SearchDropdown/index.js






var SearchDropdown_SearchDropdown = function(props) {
    var data = props.data, keyword = props.keyword;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.searchDropdown,
        children: data ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(LinkComp, {
                    className: styles.searchResults,
                    href: "".concat(PRODUCTS_LOADING_URL, "?q=").concat(keyword),
                    children: [
                        /*#__PURE__*/ _jsx("em", {
                            children: keyword
                        }),
                        "\xa0\xa0Trong\xa0",
                        /*#__PURE__*/ _jsx("b", {
                            className: styles.textPrimary,
                            children: "Tất Cả Sản Phẩm"
                        })
                    ]
                }),
                data.map(function(item) {
                    return /*#__PURE__*/ _jsx(LinkComp, {
                        className: styles.searchResults,
                        href: getPathProductBySlug(item.sku.slug),
                        children: item.product.name
                    }, uuidv4());
                })
            ]
        }) : /*#__PURE__*/ _jsxs("span", {
            className: styles.searchResults,
            children: [
                "Kh\xf4ng c\xf3 sản phẩm với từ kh\xf3a ",
                /*#__PURE__*/ _jsx("em", {
                    children: keyword
                }),
                "\xa0\xa0Trong\xa0",
                /*#__PURE__*/ _jsx("b", {
                    className: styles.textPrimary,
                    children: "Tất Cả Sản Phẩm"
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_SearchDropdown = ((/* unused pure expression or super */ null && (SearchDropdown_SearchDropdown)));

;// CONCATENATED MODULE: ./src/components/mocules/SearchInput/index.js






// import InputAdornment from '@material-ui/core/InputAdornment';
// import TextField from '@material-ui/core/TextField';







var SearchInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function SearchInput(_param) {
    var useOutsideSearchCLick = function useOutsideSearchCLick(ref) {
        React.useEffect(function() {
            function handleClickOutside(e) {
                if (ref.current && !ref.current.contains(e.target)) {
                    setShow(false);
                }
            }
            document.addEventListener("click", handleClickOutside);
            return function() {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var classCustom = _param.classCustom, restProps = _object_without_properties(_param, [
        "classCustom"
    ]);
    var ref = useSearch(), keyword = ref.keyword, hidden = ref.hidden, searchProduct = ref.searchProduct, handleBlur = ref.handleBlur, handleSearchbox = ref.handleSearchbox, handleKeyDown = ref.handleKeyDown, handleFocus = ref.handleFocus;
    var inputEl = useRef(null);
    var ref1 = useState(false), show = ref1[0], setShow = ref1[1];
    var handleShowFirstClick = function() {
        setShow(true);
    };
    React.useEffect(function() {
        if (document.activeElement === inputEl.current) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [
        hidden,
        keyword
    ]);
    useOutsideSearchCLick(inputEl);
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx(styles.search_wrap, classCustom),
        onBlur: handleBlur,
        children: [
            /*#__PURE__*/ _jsx("form", {
                children: /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                    onClick: handleShowFirstClick,
                    inputRef: inputEl,
                    // defaultValue={keyword}
                    value: keyword
                }, restProps), {
                    classes: {
                        root: styles.root_input
                    },
                    async: true,
                    onChange: handleSearchbox,
                    onKeyDown: handleKeyDown,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ _jsx(Search, {
                                style: {
                                    color: WEB_STYLES.COLORS.GREEN
                                }
                            })
                        }),
                        placeholder: "Nhập t\xean thuốc, hoạt chất cần t\xecm...",
                        autoComplete: "off",
                        type: "search",
                        classes: {
                            focused: styles.focus
                        }
                    },
                    onFocus: handleFocus
                }))
            }),
            show && /*#__PURE__*/ _jsx(SearchDropdown, {
                keyword: keyword,
                data: searchProduct
            })
        ]
    });
})));
/* harmony default export */ var mocules_SearchInput = ((/* unused pure expression or super */ null && (SearchInput)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(38799);
// EXTERNAL MODULE: ./src/components/mocules/SearchOrder/styles.module.css
var SearchOrder_styles_module = __webpack_require__(19024);
var SearchOrder_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchOrder_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchOrder/index.js











var iconStart = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
    position: "start",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Search/* default */.Z, {
        style: {
            color: src_styles/* WEB_STYLES.COLORS.GREEN */.i.COLORS.GREEN
        }
    })
});
var SearchOrder = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var onSearch = _param.onSearch, isMobile = _param.isMobile, _text = _param.text, text = _text === void 0 ? "" : _text, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "onSearch",
        "isMobile",
        "text"
    ]);
    var ref = (0,esm/* useTranslation */.$G)("quickOrder"), translateQuickOrder = ref.t;
    var handleKeyDown = (0,react.useCallback)(function(event) {
        if (event.keyCode === 13) {
            onSearch(event);
            event.preventDefault();
            event.target.blur();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        classes: {
            root: (SearchOrder_styles_module_default()).root_input,
            input: (SearchOrder_styles_module_default()).input,
            focused: (SearchOrder_styles_module_default()).focus
        },
        disableUnderline: true,
        value: text,
        placeholder: translateQuickOrder("search_input"),
        onKeyDown: handleKeyDown,
        startAdornment: !isMobile && iconStart,
        onChange: onSearch,
        type: "search"
    }));
});
/* harmony default export */ var mocules_SearchOrder = (SearchOrder);

// EXTERNAL MODULE: ./src/components/mocules/SearchResultText/style.module.css
var SearchResultText_style_module = __webpack_require__(55711);
var SearchResultText_style_module_default = /*#__PURE__*/__webpack_require__.n(SearchResultText_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/SearchResultText/index.js




function SearchResultText(param) {
    var _total = param.total, total = _total === void 0 ? 0 : _total;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SearchResultText_style_module_default()).search_result,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                translateCommon("text_search_result_1"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: (0,FormatNumber/* formatNumber */.uf)(total, ",")
                }),
                " ",
                translateCommon("text_search_result_2")
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Rating/Rating.js + 1 modules
var Rating = __webpack_require__(43871);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./src/components/mocules/SellerInfoProductDetail/styles.module.css
var SellerInfoProductDetail_styles_module = __webpack_require__(37721);
var SellerInfoProductDetail_styles_module_default = /*#__PURE__*/__webpack_require__.n(SellerInfoProductDetail_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SellerInfoProductDetail/index.js
/* eslint-disable react/destructuring-assignment */ 















// const ButtonChatNgay = ({ isMobileV2 = false, translateProductDetail }) => (
//   <LinkComp className={styles.linkShop} href="https://zalo.me/0932036749" target="_blank">
//     <ImageFallbackStatic src={`${ICON_CHAT_NGAY}?size=origin`} className={styles.sellerIcon} width={14} height={16} alt="" />
//     <Typography variant={`${isMobileV2 ? 'body2' : 'body'}`} style={{ marginLeft: 5 }}>
//       {translateProductDetail('chat_now')}
//     </Typography>
//   </LinkComp>
// );
var SellerInfoProductDetail = function(props) {
    var ref;
    var ref1 = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref1.t;
    var ref2 = (0,esm/* useTranslation */.$G)("productDetail"), translateProductDetail = ref2.t;
    // gọi tới cache chung lấy seller map
    var _seller = props.seller, seller = _seller === void 0 ? {} : _seller, _tags = props.tags, tags = _tags === void 0 ? [] : _tags, _flagshipStoreInfo = props.flagshipStoreInfo, flagshipStoreInfo = _flagshipStoreInfo === void 0 ? null : _flagshipStoreInfo, isMobile = props.isMobile;
    var code = seller.code;
    var getNameSeller = (0,context/* useSetting */.yu)().getNameSeller;
    var ref3 = getNameSeller({
        seller: seller,
        tags: tags
    }), sellerName = ref3.sellerName, linkStore = ref3.linkStore, _avatar = ref3.avatar, avatar = _avatar === void 0 ? [] : _avatar, tcode = ref3.tcode, fullNameSeller = ref3.fullNameSeller;
    var displayName = tcode !== "seller" ? translateCommon("seller.".concat(tcode)).replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS) : fullNameSeller;
    // const newSellerName = translateCommon(`seller.${tcode}`) || fullNameSeller;
    var partnerName = ((ref = translateProductDetail("partner_of_thuocsi")) === null || ref === void 0 ? void 0 : ref.replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)) || "";
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    // const [yearNumber, setYearNumber] = useState(null);
    // không show nút chat ngay đối với các seller từ bên supplier
    // các seller đó là seller internal & các seller flagshipstore durex & sanofi
    // const isShowBtnChat = !isInternal && isStore && ENV_COUNTRY === 'vn';
    // yearNumber
    // useEffect(async () => {
    //   // số năm hợp tác với thuocsi -> deprecate
    //   const supplierRes = await SupplierService.getInfoSupplier({});
    //   if (isValid(supplierRes)) {
    //     const yearNumberCur = new Date().getFullYear() - getFirst(supplierRes).yearFounded;
    //     setYearNumber(yearNumberCur);
    //   }
    // }, []);
    if (flagshipStoreInfo) {
        var primaryColor = flagshipStoreInfo.primaryColor;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                position: "relative",
                marginTop: 8,
                backgroundColor: "#fff"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SellerInfoProductDetail_styles_module_default()).flagshipTag,
                    style: {
                        backgroundColor: primaryColor
                    },
                    children: translateProductDetail("brand_booth")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SellerInfoProductDetail_styles_module_default()).seller_top_info,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SellerInfoProductDetail_styles_module_default()).avatar_name,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: flagshipStoreInfo.logo[0],
                                    className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).avatar, (0,src_define_property/* default */.Z)({}, (SellerInfoProductDetail_styles_module_default()).avatar_mv2, isMobile)),
                                    style: {
                                        border: "1px solid ".concat(primaryColor)
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            className: (SellerInfoProductDetail_styles_module_default()).name,
                                            children: flagshipStoreInfo.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            className: (SellerInfoProductDetail_styles_module_default()).subName,
                                            children: translateProductDetail("supplier")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                            className: (SellerInfoProductDetail_styles_module_default()).linkCustomShop,
                            href: flagshipStoreInfo.url,
                            style: {
                                border: "1px solid #025BAC"
                            },
                            onClick: function() {
                                utils/* gtag.clickViewShop */.SX.clickViewShop(flagshipStoreInfo.name);
                            },
                            children: [
                                translateProductDetail("view_store"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    className: (SellerInfoProductDetail_styles_module_default()).subNameBottom,
                    children: translateProductDetail("authentic_product_x_distributed", {
                        slug: flagshipStoreInfo.slug.toUpperCase()
                    })
                })
            ]
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: code && sellerName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SellerInfoProductDetail_styles_module_default()).mobile_wrapper,
                role: "presentation",
                "data-test": "product-seller",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SellerInfoProductDetail_styles_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar_name,
                                children: [
                                    sellerName === "MEDX" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStoreImage */.cE, {
                                        alt: "MEDX",
                                        src: Images/* LOGO_THUOCSI_SHORTENED */.SlS,
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar,
                                        width: 18,
                                        height: 18
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatar[0],
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_avatar
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        className: (SellerInfoProductDetail_styles_module_default()).mobile_name,
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                                className: (SellerInfoProductDetail_styles_module_default()).visit_store,
                                href: linkStore,
                                onClick: function() {
                                    utils/* gtag.clickViewShop */.SX.clickViewShop(sellerName);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        children: translateProductDetail("view_store")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                        width: 16,
                                        height: 16
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SellerInfoProductDetail_styles_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                children: translateProductDetail("rating")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                name: "rating",
                                value: 5,
                                readOnly: true,
                                size: "medium",
                                className: (SellerInfoProductDetail_styles_module_default()).rating
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: code && sellerName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).wrapper, code && seller && (SellerInfoProductDetail_styles_module_default()).hide_border_top),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SellerInfoProductDetail_styles_module_default()).avatar_name,
                children: [
                    sellerName === "MEDX" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_ImageFallback/* ImageFallbackStoreImage */.cE, {
                        alt: "MEDX",
                        src: Images/* LOGO_THUOCSI_SHORTENED */.SlS,
                        className: (SellerInfoProductDetail_styles_module_default()).sellerIcon,
                        width: 48,
                        height: 48
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: avatar[0],
                        className: (SellerInfoProductDetail_styles_module_default()).avatar
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)((SellerInfoProductDetail_styles_module_default()).name, sellerName === partnerName && (SellerInfoProductDetail_styles_module_default()).text_tf_none),
                            children: displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                        name: "rating",
                        value: 5,
                        readOnly: true,
                        size: "medium",
                        className: (SellerInfoProductDetail_styles_module_default()).rating
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* LinkComp */.vk, {
                        className: (SellerInfoProductDetail_styles_module_default()).visit_store,
                        href: linkStore,
                        onClick: function() {
                            utils/* gtag.clickViewShop */.SX.clickViewShop(sellerName);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                children: translateProductDetail("view_store")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                width: 16,
                                height: 16
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mocules_SellerInfoProductDetail = (SellerInfoProductDetail);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountCircle.js
var AccountCircle = __webpack_require__(82067);
// EXTERNAL MODULE: ./src/utils/EventUtils.js
var EventUtils = __webpack_require__(21986);
;// CONCATENATED MODULE: ./src/components/mocules/SignInForm/SignInForm.js













var SignInForm_SignInForm = /*#__PURE__*/ react.memo(function SignInForm(param) {
    var className = param.className, onClickForget = param.onClickForget, onClickLogin = param.onClickLogin, onClickSignUp = param.onClickSignUp;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), errorUserName = ref1[0], setErrorUserName = ref1[1];
    var ref2 = (0,react.useState)(false), errorPassword = ref2[0], setErrorPassword = ref2[1];
    var ref3 = (0,react.useState)(""), userName = ref3[0], setUserName = ref3[1];
    var ref4 = (0,react.useState)(""), password = ref4[0], setPassword = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(true), 2), rememberMe = ref5[0], toggleRememberMe = ref5[1];
    var validateLogin = function(data) {
        setErrorUserName(false);
        setErrorPassword(false);
        if (!data) {
            setErrorUserName(true);
            setErrorPassword(true);
            return false;
        }
        if (!data.username) {
            setErrorUserName(true);
            return false;
        }
        if (!data.password) {
            setErrorPassword(true);
            return false;
        }
        return true;
    };
    // handle login with data
    var handleLogin = function() {
        var data = {
            username: userName,
            password: password,
            rememberMe: rememberMe
        };
        if (!validateLogin(data)) {
            return;
        }
        onClickLogin(data);
    };
    // handle forget password
    var handleClickForget = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickForget();
    }, [
        onClickForget
    ]);
    var handleClickSignUp = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignUp();
    }, [
        onClickSignUp
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleLogin,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "username",
                        name: "username",
                        startAdornment: IconAccount,
                        placeholder: "Nhập số điện thoại hoặc email",
                        variant: "outlined",
                        error: errorUserName,
                        onChange: function(e) {
                            var ref;
                            return setUserName((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                        },
                        onKeyPress: function(e) {
                            return EventUtils/* default.handleKeyPressEnter */.Z.handleKeyPressEnter(e, handleLogin);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "password",
                        name: "password",
                        type: showPassword ? "text" : "password",
                        startAdornment: IconPassword,
                        endAdornment: IconEndPassword,
                        placeholder: "Nhập mật khẩu",
                        variant: "outlined",
                        error: errorPassword,
                        onChange: function(e) {
                            var ref;
                            return setPassword((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "");
                        },
                        onKeyPress: function(e) {
                            return EventUtils/* default.handleKeyPressEnter */.Z.handleKeyPressEnter(e, handleLogin);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rememberPassword",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, {
                        isChecked: rememberMe,
                        onClick: toggleRememberMe,
                        name: "rememberMe",
                        label: "Giữ t\xf4i đăng nhập"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "forgetPassword",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        className: "forgetPassword",
                        onClick: handleClickForget,
                        children: "Qu\xean Mật Khẩu"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    className: "btnLogin",
                    color: "white",
                    onClick: handleLogin,
                    children: "Đăng Nhập"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "register",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-capitalize",
                        children: [
                            "Để nhận Ưu đ\xe3i hấp dẫn,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#top",
                                style: {
                                    color: "#f9b514",
                                    padding: "2px"
                                },
                                onClick: handleClickSignUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Đăng k\xfd th\xe0nh vi\xean"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var mocules_SignInForm_SignInForm = (SignInForm_SignInForm);

;// CONCATENATED MODULE: ./src/components/mocules/SignInForm/index.js

function SignInForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: ",
        "px;\n  }\n  .rememberPassword {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btnLogin {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    margin: 1rem;\n    border-radius: 50px;\n  }\n  .register {\n    padding: 1rem;\n  }\n"
    ]);
    SignInForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var components_mocules_SignInForm_SignInForm = (0,styled_components_browser_esm/* default */.ZP)(mocules_SignInForm_SignInForm).withConfig({
    componentId: "sc-fa9bb14c-0"
})(SignInForm_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 400 : _width;
    return width;
});
/* harmony default export */ var mocules_SignInForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(components_mocules_SignInForm_SignInForm))));

// EXTERNAL MODULE: ./src/components/mocules/SignUpForm/styles.module.css
var SignUpForm_styles_module = __webpack_require__(14025);
var SignUpForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(SignUpForm_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SignUpForm/SignUpForm.js


























var validateData = utils/* ValidateUtils.validateData */.IN.validateData, SignUpForm_Error = utils/* ValidateUtils.Error */.IN.Error, SignUpForm_isEmpty = utils/* ValidateUtils.isEmpty */.IN.isEmpty;
var validateSignUp = function(param, failCallback) {
    var isCheckAgree = param.isCheckAgree, name = param.name, email = param.email, password = param.password, phone = param.phone;
    try {
        validateData.name(name);
        validateData.phoneNumber(phone);
        if (!SignUpForm_isEmpty(email)) {
            validateData.email(email);
        }
        validateData.password(password);
        if (isCheckAgree !== "") throw new SignUpForm_Error("Vui l\xf2ng chọn Đồng \xfd với Điều khoản sử dụng.");
        return true;
    } catch (error) {
        utils/* NotifyUtils.error */.QP.error((error === null || error === void 0 ? void 0 : error.message) || "Đ\xe3 c\xf3 lỗi xảy ra");
        failCallback(error);
        return false;
    }
};
var SignUpForm = /*#__PURE__*/ react.memo(function SignUpForm(props) {
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var className = props.className, onClickSignIn = props.onClickSignIn, onClickSignUp = props.onClickSignUp, referCode = props.referCode;
    var ref1 = (0,react.useState)({}), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)([]), provinces = ref2[0], setProvinces = ref2[1];
    (0,react.useEffect)(function() {
        var getListProvince = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var provinceResult, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                AddressService/* default.getProvinces */.Z.getProvinces()
                            ];
                        case 1:
                            provinceResult = _state.sent();
                            setProvinces(provinceResult);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            utils/* NotifyUtils.error */.QP.error("Lấy danh s\xe1ch tỉnh th\xe0nh kh\xf4ng th\xe0nh c\xf4ng");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListProvince() {
                return _ref.apply(this, arguments);
            };
        }();
        getListProvince();
    }, []);
    var handleSubmitSignUp = (0,react.useCallback)(function(e) {
        var data = utils/* FormDataUtils.convert */.iC.convert(e);
        e.preventDefault();
        // validate
        if (validateSignUp(data, function(error) {
            if (error) {
                var newError = {};
                newError[error.type] = true;
                setErrors((0,src_object_spread/* default */.Z)({}, newError));
            }
        })) {
            onClickSignUp(data);
        }
    }, [
        onClickSignUp
    ]);
    var handleClickSignIn = (0,react.useCallback)(function(e) {
        e.preventDefault();
        onClickSignIn();
    }, [
        onClickSignIn
    ]);
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var IconAccount = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
    });
    var IconPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOutlined/* default */.Z, {})
    });
    var IconPhone = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneOutlined/* default */.Z, {})
    });
    var IconLocation = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {})
    });
    var IconEndPassword = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
            onClick: handleClickShowPassword,
            children: !showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {})
        })
    });
    var IconInviter = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeopleOutlined/* default */.Z, {})
    });
    var IconEmail = /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment_InputAdornment/* default */.Z, {
        position: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {})
    });
    var labelAgree = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "T\xf4i đ\xe3 đọc v\xe0 đồng \xfd với",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/terms-and-condition",
                target: "_blank",
                rel: "noreferrer",
                style: {
                    color: "green"
                },
                children: "Điều khoản sử dụng *"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: className,
            onSubmit: handleSubmitSignUp,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "username",
                        name: "name",
                        startAdornment: IconAccount,
                        placeholder: "Nhập t\xean (bắt buộc)",
                        variant: "outlined",
                        error: errors.name || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "phonenumber",
                        name: "phone",
                        startAdornment: IconPhone,
                        placeholder: "Nhập số điện thoại (bắt buộc)",
                        variant: "outlined",
                        error: errors.phone || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "email",
                        name: "email",
                        startAdornment: IconEmail,
                        placeholder: "Nhập email",
                        variant: "outlined",
                        error: errors.email || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "password",
                        name: "password",
                        type: showPassword ? "text" : "password",
                        startAdornment: IconPassword,
                        endAdornment: IconEndPassword,
                        placeholder: "Nhập mật khẩu (bắt buộc)",
                        variant: "outlined",
                        error: errors.password || false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                        id: "provinceCode",
                        name: "provinceCode",
                        IconComponent: ExpandMore/* default */.Z,
                        input: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                            startAdornment: IconLocation
                        }),
                        className: (SignUpForm_styles_module_default()).province,
                        children: provinces.map(function(province) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: province.value,
                                children: [
                                    " ",
                                    province.label
                                ]
                            }, (0,v4/* default */.Z)());
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {
                        id: "inviter",
                        name: "referCode",
                        startAdornment: IconInviter,
                        value: referCode,
                        placeholder: "Nhập m\xe3 người giới thiệu.",
                        variant: "outlined",
                        disabled: !!referCode
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl_FormControl/* default */.Z, {
                    className: "form-control",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        defaultValue: Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
                        variant: "standard",
                        id: "menu-dropDown",
                        className: (SignUpForm_styles_module_default()).menuDropdown,
                        IconComponent: ExpandMore/* default */.Z,
                        input: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Input */.II, {}),
                        name: "scope",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                className: (SignUpForm_styles_module_default()).itemMenu,
                                value: Enums/* ENUM_SCOPE.PHARMACY */.hD.PHARMACY,
                                children: "Nh\xe0 thuốc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                className: (SignUpForm_styles_module_default()).itemMenu,
                                value: Enums/* ENUM_SCOPE.CLINIC */.hD.CLINIC,
                                children: "Ph\xf2ng kh\xe1m"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.DRUGSTORE */.hD.DRUGSTORE,
                                children: "Quầy thuốc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.HOSPITAL */.hD.HOSPITAL,
                                children: "Bệnh viện"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.PHARMA_COMPANY */.hD.PHARMA_COMPANY,
                                children: "C\xf4ng ty Dược phẩm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.DENTISTRY */.hD.DENTISTRY,
                                children: "Nha khoa"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                value: Enums/* ENUM_SCOPE.BEAUTY_SALON */.hD.BEAUTY_SALON,
                                children: "Thẩm mỹ viện"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "agree-term",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CheckBox */.Jg, {
                        name: "isCheckAgree",
                        label: labelAgree
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "link-login",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-capitalize",
                        children: [
                            "Nếu bạn đ\xe3 c\xf3 t\xe0i khoản, vui l\xf2ng",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#top",
                                style: {
                                    color: "#f9b514",
                                    padding: "2px"
                                },
                                onClick: handleClickSignIn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: " Đăng nhập"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    className: "btn-register",
                    color: "white",
                    type: "submit",
                    children: "Tạo t\xe0i khoản"
                })
            ]
        })
    });
});
/* harmony default export */ var SignUpForm_SignUpForm = (SignUpForm);

;// CONCATENATED MODULE: ./src/components/mocules/SignUpForm/index.js

function SignUpForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .form-control {\n    width: 100%;\n  }\n  .agree-term {\n    align-self: flex-start;\n    font-size: 13px;\n  }\n  a.forgetPassword {\n    color: #005c29;\n    text-decoration: none;\n    background-color: transparent;\n  }\n  .btn-register {\n    background: linear-gradient(102.04deg, #005c29 0%, #9ac100 100%);\n    color: white;\n    height: 50px;\n    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    padding: 1.5rem;\n    margin: 1rem;\n    border-radius: 50px;\n  }\n  .link-login {\n    padding: 1rem;\n  }\n"
    ]);
    SignUpForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var mocules_SignUpForm_SignUpForm = (0,styled_components_browser_esm/* default */.ZP)(SignUpForm_SignUpForm).withConfig({
    componentId: "sc-6b1b78a3-0"
})(SignUpForm_templateObject());
/* harmony default export */ var mocules_SignUpForm = (/*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(mocules_SignUpForm_SignUpForm))));

;// CONCATENATED MODULE: ./src/components/mocules/Skeleton/LineItem.js




var LineItemSkeleton = /*#__PURE__*/ (0,react.memo)(function LineItemSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            width: "100%",
            height: 24,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                children: "."
            })
        })
    });
});
/* harmony default export */ var LineItem = (LineItemSkeleton);

;// CONCATENATED MODULE: ./src/components/mocules/Skeleton/ProductHorizontal.js




var ProductHorizontalSkeleton = /*#__PURE__*/ (0,react.memo)(function ProductHorizontalSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rect",
                height: 220
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    paddingTop: "4px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "70%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    paddingTop: "40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    width: "25%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    paddingTop: "8px",
                    alignItems: "center",
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginRight: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            animation: "wave",
                            variant: "circle",
                            width: 25,
                            height: 25
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: "100%",
                        height: 35,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            children: "."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            animation: "wave",
                            variant: "circle",
                            width: 25,
                            height: 25
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var ProductHorizontal = (ProductHorizontalSkeleton);

// EXTERNAL MODULE: ./src/constants/Enums/EnumsTicket.js
var EnumsTicket = __webpack_require__(6899);
// EXTERNAL MODULE: ./src/constants/Images/default.js
var Images_default = __webpack_require__(44776);
// EXTERNAL MODULE: ./src/components/mocules/TicketDetailModal/style.module.css
var TicketDetailModal_style_module = __webpack_require__(469);
var TicketDetailModal_style_module_default = /*#__PURE__*/__webpack_require__.n(TicketDetailModal_style_module);
;// CONCATENATED MODULE: ./src/components/mocules/TicketDetailModal/index.js




































// const ChatMessages = styled.div`
//   overflow-y: scroll;
//   overflow: hidden;
// `;
// todo
var MAP_USER_FEEDBACK_ICON = {
    cam: function(source) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: source === "CUSTOMER" ? "/images/feedbackDetail/userFeedback.png" : Images_default/* LOGO_BUYMED_GG */.dV,
            width: source === "CUSTOMER" ? 22 : 80,
            height: source === "CUSTOMER" ? 22 : 20
        });
    },
    vn: function(source) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: source === "CUSTOMER" ? "/images/feedbackDetail/userFeedback.png" : "/images/feedbackDetail/logoThuocsi.png",
            width: 22,
            height: 22
        });
    },
    en: function(source) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    },
    th: function(source) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
var TicketDetailModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12 = (0,esm/* useTranslation */.$G)("popup-action"), translatePopupAction = ref12.t;
    var ref13 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref13.t;
    var ref14 = (0,esm/* useTranslation */.$G)("myTicket"), translateMyTicket = ref14.t;
    var ref15 = (0,context/* useSetting */.yu)(), _mapReasonsTicket = ref15.mapReasonsTicket, mapReasonsTicket = _mapReasonsTicket === void 0 ? new Map() : _mapReasonsTicket;
    // const { user } = useAuth();
    var visible = props.visible, onClose = props.onClose, user = props.user, reloadFunc = props.reloadFunc, ticketId = props.ticketId;
    var name = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) || "";
    // const { ticketId, orderId, bankName, bankAccountName, bankBranch, bankCode, feedbackContent, imageUrls, statusOrder, reasonCodes, type, status } =
    //   ticket;
    var ref16 = (0,react.useState)(true), setIsLoading = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), isShowSendFeedback = ref17[0], toogleSendFeedback = ref17[1];
    var ref18 = (0,react.useState)(0), reloadFeedbacks = ref18[0], setReloadFeedbacks = ref18[1];
    var ref19 = (0,react.useState)({}), detail = ref19[0], setDetail = ref19[1];
    var isShowBankAccount = false;
    detail === null || detail === void 0 ? void 0 : (ref = detail.reasonCodes) === null || ref === void 0 ? void 0 : ref.forEach(function(code) {
        var ref;
        if ((ref = mapReasonsTicket.get(code)) === null || ref === void 0 ? void 0 : ref.showBankAccount) isShowBankAccount = true;
    });
    // load data
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ticketDetailRes, _tmp, ticketDetail, _feedbacks, feedbacks, feedbackContentDetail, reasonCodes, orderRes, _tmp1, productInfoRes, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                clients/* TicketClient.getDetailTicket */.ZX.getDetailTicket((_tmp.ticketId = ticketId, _tmp))
                            ];
                        case 1:
                            ticketDetailRes = _state.sent();
                            if (!(0,clients/* isValid */.JY)(ticketDetailRes)) {
                                setIsLoading(false);
                                utils_NotifyUtils/* default.error */.Z.error(translatePopupAction("popup-ticket.No_information_found"));
                                onClose();
                                return [
                                    2
                                ];
                            }
                            ticketDetail = (0,clients/* getFirst */.Xi)(ticketDetailRes);
                            _feedbacks = ticketDetail.feedbacks, feedbacks = _feedbacks === void 0 ? [] : _feedbacks, feedbackContentDetail = ticketDetail.feedbackConent, reasonCodes = ticketDetail.reasonCodes;
                            ticketDetail.reasonCodesList = reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.map(function(reasonCode) {
                                return mapReasonsTicket.get(reasonCode);
                            }).filter(function(item) {
                                return item;
                            });
                            ticketDetail.listFeedback = (feedbacks === null || feedbacks === void 0 ? void 0 : feedbacks.length) > 0 && ((ref = feedbacks[feedbacks.length - 1]) === null || ref === void 0 ? void 0 : ref.content) === feedbackContentDetail ? feedbacks.slice(0, -1) : feedbacks;
                            if (!ticketDetail.orderId) return [
                                3,
                                3
                            ];
                            _tmp1 = {};
                            return [
                                4,
                                clients/* OrderClient.getOrderById */.ZT.getOrderById((_tmp1.id = ticketDetail.orderId, _tmp1))
                            ];
                        case 2:
                            orderRes = _state.sent();
                            ticketDetail.order = (0,clients/* getFirst */.Xi)(orderRes);
                            ticketDetail.isOrderExist = (0,clients/* isValid */.JY)(orderRes);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            ticketDetail.isOrderExist = false;
                            _state.label = 4;
                        case 4:
                            if (!ticketDetail.sku) return [
                                3,
                                6
                            ];
                            _tmp2 = {};
                            return [
                                4,
                                services/* ProductServiceV2.getProductInfoFromSkus */.Rl.getProductInfoFromSkus((_tmp2.skus = [
                                    ticketDetail.sku
                                ], _tmp2))
                            ];
                        case 5:
                            productInfoRes = _state.sent();
                            ticketDetail.productInfo = (0,clients/* getFirst */.Xi)(productInfoRes);
                            _state.label = 6;
                        case 6:
                            setDetail(ticketDetail);
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    }, [
        reloadFeedbacks,
        ticketId
    ]);
    var ref20 = (0,react.useState)(""), currentImage = ref20[0], setCurrentImage = ref20[1];
    var ref21 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), open = ref21[0], toggle = ref21[1];
    var handleClickImage = function(imageUrl) {
        setCurrentImage(imageUrl);
        toggle();
    };
    // submit feedback
    var ref22 = (0,react.useState)({
        feedbackValue: ""
    }), feedback = ref22[0], setFeedback = ref22[1];
    var handleChange = function(e) {
        setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
            feedbackValue: e.target.value
        }));
    };
    var handleOnChangeImages = function(imgs) {
        setTimeout(function() {
            setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
                isDisableSubmit: false,
                attachments: imgs
            }));
        }, 1500);
    };
    var disableSubmitFeedback = function() {
        setFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
            isDisableSubmit: true
        }));
    };
    var handleAcceptFeedback = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* TicketClient.acceptFeedback */.ZX.acceptFeedback(detail)
                        ];
                    case 1:
                        result = _state.sent();
                        if ((0,clients/* isValid */.JY)(result)) {
                            utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_success"));
                            onClose();
                            reloadFunc();
                        } else {
                            utils_NotifyUtils/* default.error */.Z.error(result.message);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAcceptFeedback() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var content, send, _tmp, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        content = feedback.feedbackValue;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!content) {
                            utils_NotifyUtils/* default.error */.Z.error(translatePopupAction("popup-ticket.please_fill_feedback"));
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            clients/* TicketClient.sendFeedback */.ZX.sendFeedback((_tmp.ticketId = detail.ticketId, _tmp.content = content, _tmp.attachments = (feedback === null || feedback === void 0 ? void 0 : feedback.attachments) || [], _tmp))
                        ];
                    case 2:
                        send = _state.sent();
                        if (!(0,clients/* isValid */.JY)(send)) throw new Error(send.message || translateAlertAction("message_error"));
                        toogleSendFeedback();
                        _tmp1 = {};
                        setFeedback((_tmp1.feedbackValue = "", _tmp1));
                        setReloadFeedbacks(reloadFeedbacks + 1);
                        utils_NotifyUtils/* default.success */.Z.success(translateAlertAction("message_send_feedback"));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_NotifyUtils/* default.error */.Z.error(error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
                open: visible,
                onClose: onClose,
                className: "ticket-modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TicketDetailModal_style_module_default()).feedback_order,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            className: (TicketDetailModal_style_module_default()).title,
                            container: true,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: Images/* FEEDBACKSTATUS_ICON */.xrP,
                                                width: 24,
                                                height: 24
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                className: (TicketDetailModal_style_module_default()).statusTitle,
                                                children: translateMyTicket((ref1 = EnumsTicket/* default */.Z === null || EnumsTicket/* default */.Z === void 0 ? void 0 : EnumsTicket/* default.TicketStatus */.Z.TicketStatus[detail === null || detail === void 0 ? void 0 : detail.status]) === null || ref1 === void 0 ? void 0 : ref1.code) || translateMyTicket("IN_PROCESS")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                        container: true,
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            "aria-label": "close",
                                            onClick: onClose,
                                            style: {
                                                float: "right",
                                                padding: "0px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es.FontAwesomeIcon, {
                                                icon: free_solid_svg_icons_index_es.faTimes
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                            container: true,
                            className: (TicketDetailModal_style_module_default()).container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TicketDetailModal_style_module_default()).info_bank_title,
                                    children: [
                                        translatePopupAction("popup-ticket.feedback_info"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TicketDetailModal_style_module_default()).info_group,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.Customer_name"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: name
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : detail.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.phoneNumber"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.phone
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : detail.email) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: "Email: "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: (detail === null || detail === void 0 ? void 0 : detail.orderId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).label,
                                                        children: [
                                                            translatePopupAction("popup-ticket.order_id"),
                                                            ":",
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).value,
                                                        children: [
                                                            "#",
                                                            detail === null || detail === void 0 ? void 0 : detail.orderId,
                                                            !detail.isOrderExist ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    color: "rgb(204, 85, 85)"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    "(",
                                                                    translatePopupAction("popup-ticket.No_information_found"),
                                                                    ")"
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    color: "#000099"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    translatePopupAction("order_status_label.".concat(detail === null || detail === void 0 ? void 0 : (ref2 = detail.order) === null || ref2 === void 0 ? void 0 : ref2.status)) || translateAlertAction("popup-ticket.other") || ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 12,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            style: {
                                                display: "flex"
                                            },
                                            children: (detail === null || detail === void 0 ? void 0 : detail.productInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (TicketDetailModal_style_module_default()).label,
                                                        children: [
                                                            translatePopupAction("popup-ticket.products"),
                                                            ":",
                                                            " "
                                                        ]
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* LinkComp */.vk, {
                                                        href: "".concat((0,Paths/* getPathProductBySlug */.hq)(detail === null || detail === void 0 ? void 0 : (ref3 = detail.productInfo) === null || ref3 === void 0 ? void 0 : ref3.slug)),
                                                        target: "_blank",
                                                        style: {
                                                            padding: "0px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "green",
                                                                fontSize: "15px",
                                                                paddingRight: "5px"
                                                            },
                                                            children: detail === null || detail === void 0 ? void 0 : (ref4 = detail.productInfo) === null || ref4 === void 0 ? void 0 : ref4.name
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.Problems_needing_help"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: translateMyTicket((ref5 = EnumsTicket/* default.TicketLabelEnums */.Z.TicketLabelEnums[detail === null || detail === void 0 ? void 0 : detail.type]) === null || ref5 === void 0 ? void 0 : ref5.code)
                                                })
                                            ]
                                        }),
                                        (detail === null || detail === void 0 ? void 0 : (ref6 = detail.reasonCodesList) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            md: 6,
                                            container: true,
                                            direction: "row",
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.sup_reasons"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                detail === null || detail === void 0 ? void 0 : (ref7 = detail.reasonCodesList) === null || ref7 === void 0 ? void 0 : ref7.map(function(reason) {
                                                    return reason ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            variant: "contained",
                                                            disabled: true,
                                                            className: (TicketDetailModal_style_module_default()).reason_button,
                                                            children: reason.name
                                                        }, (0,v4/* default */.Z)())
                                                    }, (0,v4/* default */.Z)()) : null;
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (detail === null || detail === void 0 ? void 0 : detail.type) === EnumsTicket/* default.TicketEnums.ORDER */.Z.TicketEnums.ORDER && isShowBankAccount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_Grid/* default */.Z, {
                                            container: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TicketDetailModal_style_module_default()).info_bank_title,
                                                children: translatePopupAction("popup-ticket.bank_info")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.acc_holder"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankAccountName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.bank"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.acc_number"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankCode
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            md: 6,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TicketDetailModal_style_module_default()).label,
                                                    children: [
                                                        translatePopupAction("popup-ticket.branch_bank"),
                                                        ":",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (TicketDetailModal_style_module_default()).value,
                                                    children: detail === null || detail === void 0 ? void 0 : detail.bankBranch
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                    container: true,
                                    className: (TicketDetailModal_style_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TicketDetailModal_style_module_default()).info_bank_title,
                                            style: {
                                                marginBottom: "7px"
                                            },
                                            children: translatePopupAction("popup-ticket.content_sp")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            item: true,
                                            xs: 12,
                                            className: (TicketDetailModal_style_module_default()).text_body,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).feedbackWrap,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).feedbackConent,
                                                            children: (detail === null || detail === void 0 ? void 0 : detail.feedbackContent) || translatePopupAction("popup-ticket.sp_notice")
                                                        }),
                                                        (detail === null || detail === void 0 ? void 0 : detail.imageUrls) && (detail === null || detail === void 0 ? void 0 : detail.imageUrls.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).feedbackImg,
                                                            children: detail === null || detail === void 0 ? void 0 : (ref8 = detail.imageUrls) === null || ref8 === void 0 ? void 0 : ref8.map(function(imageUrl) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                    onClick: function() {
                                                                        return handleClickImage(imageUrl);
                                                                    },
                                                                    style: {
                                                                        marginRight: "8px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: (TicketDetailModal_style_module_default()).ticket_img,
                                                                        width: "90",
                                                                        height: "90",
                                                                        src: (0,ImageUtils/* getLinkGCS */.jA)(imageUrl),
                                                                        alt: "ticket img"
                                                                    })
                                                                }, (0,v4/* default */.Z)());
                                                            })
                                                        })
                                                    ]
                                                }),
                                                detail === null || detail === void 0 ? void 0 : (ref9 = detail.listFeedback) === null || ref9 === void 0 ? void 0 : ref9.map(function(param) {
                                                    var source = param.source, createdTime = param.createdTime, content = param.content, _attachments = param.attachments, attachments = _attachments === void 0 ? [] : _attachments;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                        className: (TicketDetailModal_style_module_default()).feedbackReturn,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).feedbackReturn_title,
                                                                children: [
                                                                    (MAP_USER_FEEDBACK_ICON[sysconfig/* ENV_COUNTRY */.ng] || MAP_USER_FEEDBACK_ICON.en)(source),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).date,
                                                                        children: utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(createdTime), "DD/MM/YYYY HH:mm")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).feedbackWrap,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).feedbackConent,
                                                                        children: content
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                        className: (TicketDetailModal_style_module_default()).feedbackImg,
                                                                        children: attachments && attachments.map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                                                onClick: function() {
                                                                                    return handleClickImage(item);
                                                                                },
                                                                                style: {
                                                                                    marginRight: "8px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ImageFallback */.oy, {
                                                                                    className: (TicketDetailModal_style_module_default()).ticket_img,
                                                                                    src: item,
                                                                                    width: 90,
                                                                                    height: 90
                                                                                }, (0,v4/* default */.Z)())
                                                                            }, (0,v4/* default */.Z)());
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, (0,v4/* default */.Z)());
                                                }),
                                                [
                                                    EnumsTicket/* default.TicketStatus.IN_PROCESS.code */.Z.TicketStatus.IN_PROCESS.code,
                                                    EnumsTicket/* default.TicketStatus.PENDING.code */.Z.TicketStatus.PENDING.code,
                                                    EnumsTicket/* default.TicketStatus.REPLIED.code */.Z.TicketStatus.REPLIED.code, 
                                                ].indexOf(detail === null || detail === void 0 ? void 0 : detail.status) >= 0 && !isShowSendFeedback && detail.status !== EnumsTicket/* default.TicketStatus.DONE.code */.Z.TicketStatus.DONE.code && ((detail === null || detail === void 0 ? void 0 : (ref10 = detail.listFeedback) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && (detail === null || detail === void 0 ? void 0 : detail.listFeedback[0]) && ((ref11 = detail === null || detail === void 0 ? void 0 : detail.listFeedback[0]) === null || ref11 === void 0 ? void 0 : ref11.source) !== "CUSTOMER" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).accept,
                                                    children: [
                                                        !(detail === null || detail === void 0 ? void 0 : detail.waitForCustomerFeedback) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                            children: [
                                                                translatePopupAction("popup-ticket.satisfied_content").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS),
                                                                " ",
                                                                utils/* DateTimeUtils.getFormattedDate */.IM.getFormattedDate(new Date(+new Date(detail === null || detail === void 0 ? void 0 : detail.listFeedback[0].createdTime) + data/* ONE_DAY */.s2), "DD/MM/YYYY HH:mm"),
                                                                ".",
                                                                translatePopupAction("popup-ticket.close_ticket").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS)
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).btnAcept,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    className: (TicketDetailModal_style_module_default()).buttonActive,
                                                                    onClick: toogleSendFeedback,
                                                                    children: translatePopupAction("popup-ticket.send_feedback")
                                                                }),
                                                                !(detail === null || detail === void 0 ? void 0 : detail.waitForCustomerFeedback) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    className: (TicketDetailModal_style_module_default()).buttonInActive,
                                                                    onClick: handleAcceptFeedback,
                                                                    children: translatePopupAction("popup-ticket.I_am_satisfied")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).accept,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                            className: (TicketDetailModal_style_module_default()).btnAcept,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                className: (TicketDetailModal_style_module_default()).buttonActive,
                                                                onClick: toogleSendFeedback,
                                                                children: translatePopupAction("popup-ticket.send_feedback")
                                                            })
                                                        })
                                                    ]
                                                }))
                                            ]
                                        })
                                    ]
                                }),
                                isShowSendFeedback && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* InfoFormControl */.iD, {
                                            xs: 12,
                                            htmlFor: "description",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                                                    id: "description",
                                                    name: "formFeedback",
                                                    multiline: true,
                                                    minRows: 4,
                                                    variant: "outlined",
                                                    placeholder: translatePopupAction("popup-ticket.entered_feedback_content"),
                                                    className: (TicketDetailModal_style_module_default()).formfeedback,
                                                    onBlur: handleChange,
                                                    defaultValue: feedback.feedbackValue
                                                }, "formFeedback")
                                            ]
                                        }, (0,v4/* default */.Z)()),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_Grid/* default */.Z, {
                                            className: (TicketDetailModal_style_module_default()).imagesField,
                                            item: true,
                                            xs: 12,
                                            container: true,
                                            justifyContent: "space-evenly",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* InfoFormControl */.iD, {
                                                    label: translatePopupAction("popup-ticket.images"),
                                                    xs: 12,
                                                    className: (TicketDetailModal_style_module_default()).customText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImages/* default */.Z, {
                                                    onChange: handleOnChangeImages,
                                                    setLoading: disableSubmitFeedback
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                            className: (TicketDetailModal_style_module_default()).buttonSend,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    onClick: toogleSendFeedback,
                                                    className: (TicketDetailModal_style_module_default()).buttonCancel,
                                                    children: translatePopupAction("popup-ticket.cancel")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    className: (TicketDetailModal_style_module_default()).buttonActive,
                                                    onClick: handleSubmit,
                                                    disabled: feedback.isDisableSubmit,
                                                    children: translatePopupAction("popup-ticket.send")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
                open: open,
                onClose: toggle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TicketDetailModal_style_module_default()).image_modal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            onClick: toggle,
                            className: (TicketDetailModal_style_module_default()).close_button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,ImageUtils/* getLinkGCS */.jA)(currentImage),
                            style: {
                                maxWidth: "800px",
                                maxHeight: "800px"
                            },
                            alt: "ticket img"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_TicketDetailModal = (TicketDetailModal);

// EXTERNAL MODULE: ./src/components/mocules/LuckyWheel/index.js + 1 modules
var LuckyWheel = __webpack_require__(31896);
;// CONCATENATED MODULE: ./src/components/mocules/index.js




// export { default as CardInfo } from './CardInfo';





















































/***/ }),

/***/ 63574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ QR_CODE_BANK_PAYMENT_METHOD; }
/* harmony export */ });
var QR_CODE_BANK_PAYMENT_METHOD = "/static/images/payment/payment.png";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    QR_CODE_BANK_PAYMENT_METHOD: QR_CODE_BANK_PAYMENT_METHOD
});


/***/ }),

/***/ 30984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ FLAGSHIP_STORE_SLUGS; },
/* harmony export */   "_h": function() { return /* binding */ getHardcodeStoreByTagList; },
/* harmony export */   "dH": function() { return /* binding */ TITLE_IMAGE_RESPONSIVE_STEP; },
/* harmony export */   "qn": function() { return /* binding */ FLAGSHIP_STORE_TAGS; }
/* harmony export */ });
/* unused harmony exports DUREX_INFO, SANOFI_INFO, DUREX_SELLER_INFO, SANOFI_SELLER_INFO, MapFlagshipStoreBySlug */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65342);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);



var DUREX_INFO = {
    primaryColor: "#025BAC",
    secondaryColor: "#D0E7FF",
    titleColor: "#025BAC",
    backgroundColor: "#E9F3FE",
    borderAvatarColor: "#2D9CDB",
    url: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex"),
    backgrounds: [
        "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40")
    ],
    thumbnail: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/thumbnail.png")
    ],
    banners: [
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-promotion-13_9_2022.png"), 
            ],
            isActive: true,
            link: "https://bit.ly/durex-store-banner",
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-1.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-2.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-4.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-5.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/sliding-banner-6.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/home/banner.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_CONTENT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-0.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-1.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-2.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-3.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-4.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-5.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-6.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại thuocsi.vn để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.",
            hashTag: "durex",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/product/product-banner-7.png")
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/durex/list-product"),
            name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        }, 
    ],
    description: '<p>Bao Cao Su l\xe0 sản phẩm được lựa chọn nhiều nhất để ph\xf2ng tr\xe1nh thai, trong đ\xf3 k\xeanh nh\xe0 thuốc chiếm vai tr\xf2 rất quan trọng đối với việc ph\xe2n phối sản phẩm tới người ti\xeau d\xf9ng. Durex l\xe0 thương hiệu bao cao su số 1 thế giới v\xe0 Việt Nam. H\xe3y lựa chọn mua Durex ch\xednh h\xe3ng tại <a target="_blank" href="http://thuocsi.vn">http://thuocsi.vn</a> để c\xf3 những sản phẩm an to\xe0n v\xe0 chất lượng.</p>\n	',
    email: "durex@thuocsi.vn",
    feedbacks: [
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer1.png")
            ],
            content: "thuocsi c\xf3 đầy đủ mặt h\xe0ng của Durex n\xean mỗi lần l\xean đơn c\xf9ng một chỗ rất tiện, gi\xe1 sỉ d\xf9 mua lẻ.",
            customerName: "Chị Mai"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer2.png")
            ],
            content: "H\xe0ng ch\xednh h\xe3ng, mua rất an t\xe2m.",
            customerName: "Chị Lan Anh"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/customer/customer3.png")
            ],
            content: "Giao h\xe0ng đủ khi đặt h\xe0ng.",
            customerName: "Anh Tuấn Văn"
        }, 
    ],
    landingPages: [],
    logo: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStatic */ .Jw)("/images/flagship-store/durex/logo.png")
    ],
    name: "Gian h\xe0ng DUREX ch\xednh h\xe3ng",
    numberProductDisplay: 0,
    numberProducts: 0,
    sellerClass: "EXTERNAL",
    slug: "durex",
    status: "ACTIVE",
    storeType: "FLAGSHIP",
    videoIntroduces: [
        "https://www.youtube.com/watch?v=AVPOa6lyv_0"
    ],
    tags: [
        {
            code: "DUREX-HERO",
            type: "fav",
            backgroundTitleColor: "transparent",
            titleColor: "#025BAC",
            backgroundColor: "#D0E7FF"
        },
        {
            code: "DUREX",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        },
        {
            code: "DUREX-CAT1",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        },
        {
            code: "DUREX-CAT2",
            type: "new",
            backgroundTitleColor: "#025BAC",
            titleColor: "#fff",
            backgroundColor: "#fff"
        }, 
    ]
};
var SANOFI_INFO = {
    primaryColor: "#7404E0",
    secondaryColor: "#EEE9FE",
    titleColor: "#7404E0",
    backgroundColor: "#EEE9FE",
    borderAvatarColor: "#7404E0",
    backgrounds: [
        "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-testing/images/2022f79adf10d22789d52c674d398e40")
    ],
    url: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi"),
    banners: [
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-1_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-2_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-5_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        // {
        //   description: 'Sanofi',
        //   hashTag: 'sanofi',
        //   images: [getLinkImageStatic(`/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png`)],
        //   isActive: true,
        //   link: `${WEB_HOST}/products?tag=SANOFI-CAT3`,
        //   name: 'Gian hàng SANOFI chính hãng',
        //   type: 'SLIDER',
        // },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-4_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT4"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/home/sliding-banner-3_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT3"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "SLIDER"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-1_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-2_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-5_5-8-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/flagship-store/sanofi/list-product"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-4_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT4"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        },
        {
            description: "Sanofi",
            hashTag: "sanofi",
            images: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/product-banner-3_15-9-2022.png"), 
            ],
            isActive: true,
            link: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .WEB_HOST */ .Ul, "/products?tag=SANOFI-CAT3"),
            name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
            type: "BANNER_PRODUCT"
        }, 
    ],
    description: "<p>Sanofi l\xe0 tập đo\xe0n chăm s\xf3c sức khỏe h\xe0ng đầu thế giới, lu\xf4n cam kết hỗ trợ chăm s\xf3c v\xe0 cải thiện chất lượng sức khỏe của bệnh nh\xe2n. Từ ph\xf2ng ngừa đến điều trị, Sanofi đ\xe3 dựa tr\xean những th\xe0nh tựu nghi\xean cứu khoa học để đưa đến những giải ph\xe1p chăm s\xf3c sức khỏe con người, như vắc-xin, thuốc trị bệnh hiếm gặp, bệnh đa xơ cứng, ung thư, c\xe1c bệnh li\xean quan đến miễn dịch, bệnh truyền nhiễm, tiểu đường, c\xe1c giải ph\xe1p cho tim mạch cũng như chăm s\xf3c sức khỏe người ti\xeau d\xf9ng. Hơn 100.000 nh\xe2n vi\xean của Sanofi l\xe0m việc tại 100 quốc gia đang nỗ lực để tạo n\xean sự kh\xe1c biệt cho đời sống bệnh nh\xe2n ở bất cứ nơi n\xe0o họ sống v\xe0 cho ph\xe9p họ tận hưởng một cuộc sống l\xe0nh mạnh hơn.</p>",
    email: "sanofi@thuocsi.vn",
    feedbacks: [
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer1.png")
            ],
            content: "Lượng mặt h\xe0ng đa dạng được liệt k\xea r\xf5 r\xe0ng, t\xf4i c\xf3 thể dễ d\xe0ng t\xecm kiếm được những sản phẩm m\xe0 t\xf4i cần.",
            customerName: "Chị Ho\xe0ng Ng\xe2n"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer2.png")
            ],
            content: "Gi\xe1 c\xe1c sản phẩm lu\xf4n b\xecnh ổn cũng như c\xf3 nhiều chương tr\xecnh khuyến m\xe3i, qu\xe0 tặng v\xe0 ưu đ\xe3i trong th\xe1ng.",
            customerName: "Anh Tuấn Anh"
        },
        {
            avatar: [
                (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/customer/customer3.png")
            ],
            content: "H\xe0ng h\xf3a đ\xf3ng g\xf3i cẩn thận, kĩ c\xe0ng cũng như tư vấn về c\xe1c sản phẩm rất nhiệt t\xecnh v\xe0 r\xf5 r\xe0ng.",
            customerName: "Anh Duy H\xe0"
        }, 
    ],
    landingPages: [],
    logo: [
        (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/logo.png")
    ],
    name: "Gian h\xe0ng SANOFI ch\xednh h\xe3ng",
    numberProductDisplay: 0,
    numberProducts: 0,
    sellerClass: "EXTERNAL",
    slug: "sanofi",
    status: "ACTIVE",
    storeType: "FLAGSHIP",
    videoIntroduces: [
        "https://www.youtube.com/watch?v=ssY36cNs2SA&ab_channel=TPBVSKPharmaton"
    ],
    tags: [
        // {
        //   code: 'SANOFI-HERO',
        //   type: 'fav',
        //   backgroundColor: '#1E034A',
        //   backgroundTitleColor: 'transparent',
        //   titleColor: '#fff',
        // },
        {
            code: "SANOFI",
            type: "deal",
            backgroundColor: "#1E034A",
            backgroundTitleColor: "transparent",
            titleColor: "#fff"
        },
        // {
        //   code: 'SANOFI-CAT1',
        //   type: 'new',
        //   backgroundColor: '#1E034A',
        //   backgroundTitleColor: 'transparent',
        //   titleColor: '#fff',
        // },
        {
            code: "SANOFI-CAT2",
            type: "new",
            backgroundColor: "#0A71CE",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Duongruot.png"),
            bannerHeight: 81,
            priority: [
                "medx-enterogermina-4-billion5ml-sanofi-hop20ong5ml",
                "medx-enterogermina-2-billion5ml-sanofi-hop20ong5ml",
                "medx-phosphalugel-sanofi-hop26goi20gram",
                "medx-mepraz-omeprazol-20mg-sanofi-hop28-vien-nang", 
            ]
        },
        {
            code: "SANOFI-CAT3",
            type: "new",
            backgroundColor: "#EF8C21",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocxuongkhop.png"),
            bannerHeight: 73,
            priority: [
                "medx-bo-sung-vitamin-va-khoang-chat-pharmaton-energy-rottendorf-chai30-vien-nen",
                "medx-bo-sung-vitamin-va-khoang-chat-pharmaton-essential-biofarma-srl-chai30-vien-nen",
                "medx-calcium-corbiere-extra-sanofi-hop30ong10ml",
                "medx-calcium-corbiere-kids-extra-hop30ong5ml", 
            ]
        },
        {
            code: "SANOFI-CAT4",
            type: "new",
            backgroundColor: "#AC3786",
            titleColor: "#fff",
            titleBanner: (0,utils_CacheImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkImageStaticWebHost */ .v5)("/images/flagship-store/sanofi/product/categoryBannerTitle/Thuocho-Diung.png"),
            bannerHeight: 120,
            priority: [
                "medx-telfast-hd-fexofenadin-180mg-sanofi-hop10-vien-nen",
                "medx-telfast-bd-fexofenadin-60mg-sanofi-hop10-vien-nen",
                "medx-telfast-kids-fexofenadin-30mg-sanofi-hop10-vien-nen",
                "medx-bisolvon-kids-bromhexin-4mg5ml-sanofi-chai60ml",
                "medx-acemuc-acetylcysein-100mg-sanofi-hop30goi0.5gram",
                "medx-acemuc-acetylcystein-200mg-sanofi-hop30goi1gram", 
            ]
        }, 
    ]
};
var DUREX_SELLER_INFO = {
    code: "durex-hardcode-unique-id",
    name: DUREX_INFO.name,
    product: {
        topProducts: []
    },
    sellerStore: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, DUREX_INFO),
    slug: DUREX_INFO.slug,
    sellerType: "FLAGSHIP",
    isVip: true,
    favTag: "DUREX-HERO"
};
var SANOFI_SELLER_INFO = {
    code: "sanofi-hardcode-unique-id",
    name: SANOFI_INFO.name,
    product: {
        topProducts: []
    },
    sellerStore: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, SANOFI_INFO),
    slug: SANOFI_INFO.slug,
    sellerType: "FLAGSHIP",
    isVip: true,
    favTag: "SANOFI-HERO"
};
var MapFlagshipStoreBySlug = {
    durex: DUREX_INFO,
    sanofi: SANOFI_INFO,
    DUREX: DUREX_INFO,
    SANOFI: SANOFI_INFO
};
var FLAGSHIP_STORE_SLUGS = [
    "durex",
    "sanofi"
];
var FLAGSHIP_STORE_TAGS = [
    "DUREX",
    "SANOFI"
];
var TITLE_IMAGE_RESPONSIVE_STEP = [
    350,
    750
];
var getHardcodeStoreByTagList = function(tags) {
    if (tags === null || tags === void 0 ? void 0 : tags.length) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tag = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator1 = FLAGSHIP_STORE_TAGS[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var flagshipStoreTag = _step1.value;
                        if (tag.includes(flagshipStoreTag)) {
                            return MapFlagshipStoreBySlug[flagshipStoreTag];
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return null;
};


/***/ }),

/***/ 71637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ WEB_STYLES; }
/* harmony export */ });
/* unused harmony export APP_STYLES */
/* harmony import */ var _material_ui_core_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18334);

var COLORS = {
    GREEN: "#005C29",
    TEXT: {
        DEFAULT: "#495057"
    },
    green: _material_ui_core_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
};
var BACKGROUND_COLORS = {
    MAIN: "#f4f7fc",
    WHITE: "#fff",
    BLACK: "#000"
};
var WEB_STYLES = {
    COLORS: COLORS,
    BACKGROUND_COLORS: BACKGROUND_COLORS
};
var APP_STYLES = {
    COLORS: COLORS,
    BACKGROUND_COLORS: BACKGROUND_COLORS
};


/***/ }),

/***/ 21986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ downloadPDFFile; }
/* harmony export */ });
/* eslint-disable no-shadow */ var handleKeyPressEnter = function(event, callback) {
    if (event.key === "Enter" && callback) {
        callback();
    }
};
var downloadPDFFile = function(link, fileName) {
    fetch(link, {
        method: "GET",
        headers: {
            "Content-Type": "application/pdf"
        }
    }).then(function(response) {
        return response.blob();
    }).then(function(blob) {
        // Create blob link to download
        var url = window.URL.createObjectURL(new Blob([
            blob
        ]));
        var _$link = document.createElement("a");
        _$link.href = url;
        _$link.setAttribute("download", fileName);
        // Append to html link element page
        document.body.appendChild(_$link);
        // Start download
        _$link.click();
        // Clean up and remove the link
        _$link.parentNode.removeChild(_$link);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    handleKeyPressEnter: handleKeyPressEnter,
    downloadPDFFile: downloadPDFFile
});


/***/ }),

/***/ 33665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ initFBSharing; },
/* harmony export */   "Eq": function() { return /* binding */ cleanup; },
/* harmony export */   "S1": function() { return /* binding */ init; }
/* harmony export */ });
/* unused harmony exports FBSharePost, FBCheckLogin */
/* harmony import */ var clients_PromoClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46128);
/* harmony import */ var components_mocules_LuckyWheel_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41936);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66225);
/* eslint-disable func-names */ /* eslint-disable prefer-const */ /* eslint-disable no-undef */ /**
 *
 * @param {*} noInsertScript
 */ 




var ENUM_LOGIN_STATUS = {
    CONNECTED: "connected",
    NOT_AUTHORIZED: "not_authorized"
};
function init() {
    var chatbox = document.getElementById("fb-customer-chat");
    chatbox.setAttribute("page_id", sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_MESSENGER_ID */ .$K); // TODO: move to args
    chatbox.setAttribute("attribution", "biz_inbox");
    window.fbAsyncInit = function() {
        if (FB) FB.init({
            xfbml: true,
            version: "v14.0"
        });
    };
    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
}
function FBSharePost(param) {
    var postInfo = param.postInfo, user = param.user, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, reRenderMission = param.reRenderMission;
    var method = postInfo.method, link = postInfo.link;
    var ref = user || {}, accountID = ref.accountID, customerID = ref.customerID;
    function callBackSharing(response) {
        return _callBackSharing.apply(this, arguments);
    }
    function _callBackSharing() {
        _callBackSharing = _async_to_generator(function(response) {
            var _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(response && !response.error_message)) return [
                            3,
                            3
                        ];
                        if (!(typeof response !== "undefined")) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            postGamificationScore((_tmp.type = CONDITION_TYPE.SHARE, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = "share facebook post", _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.socialNetwork = POPUP_SHARING_ITEM.FACEBOOK, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        // NotifyUtils.success('Chia sẻ bài viết facebook thành công!');
                        // re-render list mission
                        reRenderMission();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _callBackSharing.apply(this, arguments);
    }
    if (FB) {
        FB.ui({
            display: "popup",
            method: method,
            link: link
        }, function() {
            var _ref = // callback
            _async_to_generator(function(response) {
                return _ts_generator(this, function(_state) {
                    callBackSharing(response);
                    return [
                        2
                    ];
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
    }
}
function FBCheckLogin(param) {
    var postInfo = param.postInfo, user = param.user, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, setOpenConfirmSharing = param.setOpenConfirmSharing, reRenderMission = param.reRenderMission;
    function statusChangeCallback(response) {
        return _statusChangeCallback.apply(this, arguments);
    }
    function _statusChangeCallback() {
        _statusChangeCallback = _async_to_generator(function(response) {
            var _tmp, _tmp1, _tmp2;
            return _ts_generator(this, function(_state) {
                _tmp = {};
                _tmp1 = {};
                _tmp2 = {};
                if (response.status === ENUM_LOGIN_STATUS.CONNECTED) {
                    // user had logged before, show popup sharing post
                    FBSharePost((_tmp.postInfo = postInfo, _tmp.user = user, _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.reRenderMission = reRenderMission, _tmp));
                } else if (response.status === ENUM_LOGIN_STATUS.NOT_AUTHORIZED) {
                    // not authorized, request access permission for user
                    // NotifyUtils.info('Vui lòng cấp quyền chia sẽ bài viết cho thuocsi.vn !');
                    FB.login(function(res) {
                        if (res.authResponse) {
                            // user have allow access permission
                            setOpenConfirmSharing(true);
                        } else {
                        // user is not logged in
                        // NotifyUtils.error('Đăng nhập thất bại! Vui lòng thử lại.');
                        }
                    }, (_tmp1.scope = "email", _tmp1));
                } else {
                    FB.login(function(res) {
                        if (res.authResponse) {
                            // user have allow access permission
                            setOpenConfirmSharing(true);
                        } else {
                        // user close or not allow
                        // NotifyUtils.error('Đăng nhập thất bại! Vui lòng thử lại.');
                        }
                    }, (_tmp2.scope = "email", _tmp2)); // which data to access from user profile
                }
                return [
                    2
                ];
            });
        });
        return _statusChangeCallback.apply(this, arguments);
    }
    FB.getLoginStatus(function() {
        var _ref = _async_to_generator(function(response) {
            return _ts_generator(this, function(_state) {
                statusChangeCallback(response);
                return [
                    2
                ];
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), true);
}
function initFBSharing() {
    var buttonShare = document === null || document === void 0 ? void 0 : document.getElementById("fb-button-share");
    buttonShare === null || buttonShare === void 0 ? void 0 : buttonShare.setAttribute("app_id", sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ);
    // FB JS SDK config and setup
    window.fbAsyncInit = function() {
        if (FB) {
            FB.init({
                appId: sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ,
                status: true,
                xfbml: true,
                version: "v3.2"
            });
        }
    };
    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_GB/all.js#xfbml=1&appId=".concat(sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ);
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
}
/**
 *
 */ function cleanup() {
    (function(d, id) {
        var target = d.getElementById(id);
        if (target) {
            target.parentNode.removeChild(target);
        }
    })(document, "facebook-jssdk");
    delete window.FB;
}


/***/ }),

/***/ 86553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IJ": function() { return /* binding */ WRONG_ANSWER; },
/* harmony export */   "W7": function() { return /* binding */ LUCKY_NEXT_TIME; },
/* harmony export */   "i8": function() { return /* binding */ YOU_SPUN_AND_HIT; },
/* harmony export */   "kE": function() { return /* binding */ convertLuckyMessage; },
/* harmony export */   "w6": function() { return /* binding */ convertMissionType; }
/* harmony export */ });
/* unused harmony exports CONGRATULATIONS_TO, FOR_SUCCESSFULLY_SPINNING_AND_WINNING, LUCKY_WHEEL_NOT_FOUND */
var MAPPING_CODE_TO_TEXT = {
    LUCKY_NEXT_TIME: "LUCKY_NEXT_TIME",
    YOU_SPUN_AND_HIT: "YOU_SPUN_AND_HIT",
    CONGRATULATIONS_TO: "CONGRATULATIONS_TO",
    FOR_SUCCESSFULLY_SPINNING_AND_WINNING: "FOR_SUCCESSFULLY_SPINNING_AND_WINNING",
    LUCKY_WHEEL_NOT_FOUND: "LUCKY_WHEEL_NOT_FOUND",
    CUSTOMER_NOT_FOUND: "CUSTOMER_NOT_FOUND",
    REWARD_POINT: "REWARD_POINT",
    TURN: "TURN",
    TICKET_PATTERN: "TICKET_PATTERN",
    WRONG_ANSWER: "WRONG_ANSWER"
};
var MAPPING_MISSION_TYPE_TO_TEXT = {
    QUANTITY_OF_PRODUCTS: "Quantity of products",
    NUMBER_OF_ORDERS: "Number of orders",
    TOTAL_VALUE_ORDERED: "Total value ordered",
    NUMBER_OF_SHARES: "Number of shares",
    NUMBER_OF_EXPLORATIONS: "Number of explorations"
};
var convertLuckyMessage = function() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
    var encodeMessage = message;
    Object.keys(MAPPING_CODE_TO_TEXT).forEach(function(key) {
        encodeMessage = encodeMessage.replace(key, t(key));
    });
    return encodeMessage;
};
var convertMissionType = function() {
    var mission = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
    var encodeMessage = mission;
    Object.keys(MAPPING_MISSION_TYPE_TO_TEXT).forEach(function(key) {
        encodeMessage = encodeMessage.replace(key, t(key));
    });
    return encodeMessage;
};
var LUCKY_NEXT_TIME = "LUCKY_NEXT_TIME";
var YOU_SPUN_AND_HIT = "YOU_SPUN_AND_HIT";
var CONGRATULATIONS_TO = "CONGRATULATIONS_TO";
var FOR_SUCCESSFULLY_SPINNING_AND_WINNING = "FOR_SUCCESSFULLY_SPINNING_AND_WINNING";
var LUCKY_WHEEL_NOT_FOUND = "LUCKY_WHEEL_NOT_FOUND";
var WRONG_ANSWER = "WRONG_ANSWER";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    convertLuckyMessage: convertLuckyMessage,
    LUCKY_NEXT_TIME: LUCKY_NEXT_TIME,
    YOU_SPUN_AND_HIT: YOU_SPUN_AND_HIT,
    CONGRATULATIONS_TO: CONGRATULATIONS_TO,
    FOR_SUCCESSFULLY_SPINNING_AND_WINNING: FOR_SUCCESSFULLY_SPINNING_AND_WINNING,
    LUCKY_WHEEL_NOT_FOUND: LUCKY_WHEEL_NOT_FOUND,
    WRONG_ANSWER: WRONG_ANSWER
});


/***/ }),

/***/ 43775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"styles_drawerContainer__1HUsk","container":"styles_container__M30G0","title":"styles_title__lbyvo","header":"styles_header__EZSA5","iconButton":"styles_iconButton__w7_Ys","content":"styles_content__9O2wd","bottomSection":"styles_bottomSection__SPmQ_"};

/***/ }),

/***/ 5596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_warning":"styles_text_warning__OQOk3"};

/***/ }),

/***/ 9904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price_row":"styles_price_row__2YbWA","current_price":"styles_current_price__KWIc8","old_price":"styles_old_price__jArF3","price_after_voucher":"styles_price_after_voucher__mMzPz","price_after_voucher_label":"styles_price_after_voucher_label__fei_Y"};

/***/ }),

/***/ 99182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__52bCp","image_wrapper":"styles_image_wrapper__PD7e7","image":"styles_image__i60k7","content":"styles_content__qkkag","link":"styles_link__h7knV","product_name":"styles_product_name__hyq3G","product_volume":"styles_product_volume__UTWFu","product_tags":"styles_product_tags__gpxnV","price_block":"styles_price_block__RHZYm","price_row":"styles_price_row__0vMUa","price_label":"styles_price_label__Icpdp","price_label_strong":"styles_price_label_strong__j_rzo","old_price":"styles_old_price__mRrzI","new_price":"styles_new_price__SOb5W","fluctuation_row":"styles_fluctuation_row__h0W8E","fluctuation_text":"styles_fluctuation_text__XQy40","increased":"styles_increased__iRuvQ","reason_text":"styles_reason_text__5l1T8","quantity_block":"styles_quantity_block__S7ThG","limit_text":"styles_limit_text__vtYca","quantity_control":"styles_quantity_control__DNE_8","quantity_input_wrapper":"styles_quantity_input_wrapper__9R5GX","quantity_input":"styles_quantity_input__P4Ae_","item_mobile":"styles_item_mobile__P4NG5","minus_button":"styles_minus_button__jtZEP"};

/***/ }),

/***/ 57624:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IbkF1","drawer_paper":"styles_drawer_paper__QO2LX","drawer_content":"styles_drawer_content__eEjXf","header":"styles_header__Bg5oB","title":"styles_title__SYE7i","btn_close":"styles_btn_close__e_0Bh","close_text":"styles_close_text__32zYk","body":"styles_body__q4u_P","group":"styles_group__PrBrh","group_header":"styles_group_header__wsgNY","group_header_increased":"styles_group_header_increased___aFDL","items":"styles_items__1aIhD","items_collapsed":"styles_items_collapsed__gPm_6","see_all":"styles_see_all__IKNjs","disclaimer":"styles_disclaimer__vHD6O","actions":"styles_actions__V8Jwb","btn_back":"styles_btn_back__QTM8w","btn_continue":"styles_btn_continue__mrukQ","footer":"styles_footer__pruHN"};

/***/ }),

/***/ 93454:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img_container":"styles_img_container__tyMor","text_product_name":"styles_text_product_name__KHDFa","text_product_quantity":"styles_text_product_quantity__QQzsv","text_product_err":"styles_text_product_err__9vwjb","link":"styles_link__MZXJp"};

/***/ }),

/***/ 4890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9cc9W","content":"styles_content__ZyEb2","text_err_notification":"styles_text_err_notification__EVbVf","text_total_style":"styles_text_total_style__V8Tve","img_container":"styles_img_container__q0v_U","text_product_name":"styles_text_product_name__c82xl","text_product_quantity":"styles_text_product_quantity__6w5xy","text_product_err":"styles_text_product_err__JDQl2","scroll_y":"styles_scroll_y__eAGjY"};

/***/ }),

/***/ 72910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_wrapper":"styles_modal_wrapper__ebZ5l","modal_mobile_wrapper":"styles_modal_mobile_wrapper__2zjZ8","warning_icon":"styles_warning_icon__sD2_w","text_icon":"styles_text_icon__vlSSv","btn_cancel":"styles_btn_cancel__tHSUr","btn_ok":"styles_btn_ok__7KRMT","text_title":"styles_text_title__1zNVV","btn_ok_mobile":"styles_btn_ok_mobile__CMCQ_","text_top_mobile":"styles_text_top_mobile__uiqhB","btn_ic_close":"styles_btn_ic_close__W99e8","icon_close":"styles_icon_close__p_9Wb"};

/***/ }),

/***/ 94328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper_modal":"styles_wrapper_modal__JD2VD","modalBackdrop":"styles_modalBackdrop__6l882","modalImage":"styles_modalImage__ATIHb","closeWrapper":"styles_closeWrapper__uCKj0","imageMain":"styles_imageMain__spbIb","imageMainMobile":"styles_imageMainMobile__hZnbT","wrapperImg":"styles_wrapperImg__PDDk2","wrapperMobileImg":"styles_wrapperMobileImg__L8TbE","imageNameText":"styles_imageNameText__9IHtY","wrapper_thumbnail":"styles_wrapper_thumbnail__oQiOk","scroll_vertical":"styles_scroll_vertical__l9ELW","wrapper_mobile_thumbnail":"styles_wrapper_mobile_thumbnail__qoNG6","flex_center":"styles_flex_center__p71b_","thumbnail_image_wrapper":"styles_thumbnail_image_wrapper__h4gYD","thumbnail_image_wrapper_mobile":"styles_thumbnail_image_wrapper_mobile__PqCTw","thumbnail_selected":"styles_thumbnail_selected__RBkuM","slider":"styles_slider__7hMX7","leftNavBtn":"styles_leftNavBtn__GOfq4","rightNavBtn":"styles_rightNavBtn__nZUo1"};

/***/ }),

/***/ 8928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__dwJUO","province":"styles_province__fzh9Z","input_icon":"styles_input_icon__vOzUq"};

/***/ }),

/***/ 79250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_warning":"styles_text_warning__J4AOt"};

/***/ }),

/***/ 3793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sharingContent_wrapper":"styles_sharingContent_wrapper__CtnPO","sharingContent_leftArrow":"styles_sharingContent_leftArrow__licX2","sharingContent_rightArrow":"styles_sharingContent_rightArrow__WHUVR","sharingItem_container":"styles_sharingItem_container__5l4xh","sharingContent_listContainer":"styles_sharingContent_listContainer__Vg7XV","sharingContent_formControl":"styles_sharingContent_formControl__3MwW1","sharingContent_input":"styles_sharingContent_input__WL4Xv","sharingContent_inputFocused":"styles_sharingContent_inputFocused__Hr5et","shareItem_wrapper":"styles_shareItem_wrapper__JzTgt","sharingOpts_removeSlide":"styles_sharingOpts_removeSlide__TevlQ"};

/***/ }),

/***/ 96584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default_tag":"styles_default_tag__0jRYW","selected_tag":"styles_selected_tag__kk0ls","card":"styles_card__EMuyE","card_selected":"styles_card_selected__tpbi7","action_button":"styles_action_button__oTgTK","important_action_button":"styles_important_action_button__ccpsy","group_button":"styles_group_button__Es4pH","defaull_button":"styles_defaull_button__lZjJH","ellipsis_1_line":"styles_ellipsis_1_line__MTRZ0","ellipsis_2_line":"styles_ellipsis_2_line__K3X8F"};

/***/ }),

/***/ 56889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"address_dialog":"styles_address_dialog__zARwE","close_button":"styles_close_button__joa5I"};

/***/ }),

/***/ 5177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alphabetFilterWrapper":"styles_alphabetFilterWrapper__k8Be4","mobileAlphabetFilterWrapper":"styles_mobileAlphabetFilterWrapper__e_6hC","alphabetFilterItem":"styles_alphabetFilterItem__Cof_l","alphabetFilterItemActive":"styles_alphabetFilterItemActive__5UvKP"};

/***/ }),

/***/ 78762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4vDlH","total":"styles_total__KriKQ","titleWrapper":"styles_titleWrapper__3vU__","title":"styles_title__1wYID"};

/***/ }),

/***/ 97230:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_area":"styles_text_area__ay6bm"};

/***/ }),

/***/ 20430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y_VKO","d_flex":"styles_d_flex__EGI5X","checkout_title":"styles_checkout_title__3gsGZ","checkout_label":"styles_checkout_label__iXelv","checkout_content":"styles_checkout_content__EmYHv","break_line":"styles_break_line__Z1rbC","checkout_promo_code":"styles_checkout_promo_code__xbF0m","total":"styles_total__X0oDt","debt":"styles_debt__h6UYV","btn":"styles_btn__m8hHk","icon":"styles_icon__VklQh","text_right":"styles_text_right__hPXHz","checkout_btn":"styles_checkout_btn__26HAi","condition":"styles_condition__YukLe","checkout_sticky":"styles_checkout_sticky__mRZtX","list_note":"styles_list_note__2N5zg","checkbox":"styles_checkbox__uHLqG","check_agree_txt":"styles_check_agree_txt__FzwMv","checkout_label_second":"styles_checkout_label_second___ZDk0","fwc_container":"styles_fwc_container__T7VIL","price":"styles_price___z6Km","flex_price":"styles_flex_price__37Ajs","label":"styles_label__3lchT","root_btn":"styles_root_btn__avvoU","sticky_checkout_bar_mobile":"styles_sticky_checkout_bar_mobile__1a98L","sticky_checkout_bar_mobileNew":"styles_sticky_checkout_bar_mobileNew__VUQf7","totalM":"styles_totalM__u_YSx","mobileRoot_btn":"styles_mobileRoot_btn__Ohedm","card_err_container":"styles_card_err_container__IA044","text_err_notification":"styles_text_err_notification__hfBAt","delete_text":"styles_delete_text__j74qS","text_content_modal":"styles_text_content_modal__sDWR8","checkout_label_first":"styles_checkout_label_first__8nbgt","continue_btn":"styles_continue_btn__mStF4","dividerCustom":"styles_dividerCustom__qNOpO"};

/***/ }),

/***/ 7867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__bul_F","value":"styles_value__DKXci"};

/***/ }),

/***/ 13402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__ZgmeA","btn":"style_btn___MgGl","outlined_btn":"style_outlined_btn__B9iEy","brown_btn":"style_brown_btn__uRHWa","fill_btn":"style_fill_btn__op2rZ","warning_icon":"style_warning_icon__J42_2","text_icon":"style_text_icon__Ooxdl","modal_title":"style_modal_title__2G9R7","modal_content":"style_modal_content__KTErm","font_gg":"style_font_gg__R9o9V"};

/***/ }),

/***/ 68786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__AN39n","btn":"style_btn__vTgO_","outlined_btn":"style_outlined_btn__cJEJx","brown_btn":"style_brown_btn__fMyBz","fill_btn":"style_fill_btn__dQNkZ","warning_icon":"style_warning_icon__Ji2_B","text_icon":"style_text_icon__gkZCA","modal_title":"style_modal_title__EbHxf","modal_content":"style_modal_content__Ah6TT","root":"style_root__Yndk9","title":"style_title__XPQx_","display_none":"style_display_none___BMQx"};

/***/ }),

/***/ 37838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__9H3QU","add_icon_row":"styles_add_icon_row__Xl49q","add_icon_column":"styles_add_icon_column__LUhdp"};

/***/ }),

/***/ 54773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bo4EW","title":"styles_title__jiXAZ","checkbox":"styles_checkbox__fYUKM","text_muted":"styles_text_muted__biVZO","required":"styles_required__JzwBo","fw500":"styles_fw500__iy8nG","add_new_button":"styles_add_new_button__2VFAd","full_width":"styles_full_width__xfCV7","text":"styles_text__FNHL9","grid_fix":"styles_grid_fix__B5rfu","save_info_cb":"styles_save_info_cb__cO1LP"};

/***/ }),

/***/ 91618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NL0Ar","title":"styles_title__c9FhR","checkbox_color":"styles_checkbox_color__I_LkQ","checkbox":"styles_checkbox__zxnw5","checkout_description":"styles_checkout_description__lyJea","icon":"styles_icon____coe","fw500":"styles_fw500__l1726","fw300":"styles_fw300__5a8kF"};

/***/ }),

/***/ 92929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editBtn":"styles_editBtn__I94Hu","disableBtn":"styles_disableBtn__1_yfC","order_edit_btn":"styles_order_edit_btn__0Ge1b"};

/***/ }),

/***/ 39335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__CYhqI","btn":"style_btn___Qno3","outlined_btn":"style_outlined_btn__klXg_","brown_btn":"style_brown_btn__u1xuR","fill_btn":"style_fill_btn__bLg8N","warning_icon":"style_warning_icon__ItUph","text_icon":"style_text_icon__8ptoU","modal_title":"style_modal_title__V9mgj","modal_content":"style_modal_content__IvlAY","root":"style_root__BWf9A","title":"style_title__9vpiB","display_none":"style_display_none___nl9i"};

/***/ }),

/***/ 90124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"styles_searchBox__Mgjzq","mobileSearchBox":"styles_mobileSearchBox__3qg0e","searchInput":"styles_searchInput__y4Duh"};

/***/ }),

/***/ 52200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Bvp9U","title":"styles_title__FbqSm","bottom_text":"styles_bottom_text__CZiM6","error":"styles_error__wWyib","formInput":"styles_formInput__3v20h","input":"styles_input__jqmJJ","disabled":"styles_disabled__kroW2","custom_field":"styles_custom_field__C0_Ks","right_c":"styles_right_c__hot1N","remaining":"styles_remaining__UVxTt","confirm_modal_wrap":"styles_confirm_modal_wrap__GAO__","btn":"styles_btn__s0npd","outlined_btn":"styles_outlined_btn__TdkBl","brown_btn":"styles_brown_btn__bb676","fill_btn":"styles_fill_btn__S6meI","warning_icon":"styles_warning_icon__V38QN","text_icon":"styles_text_icon__NbrIo","modal_title":"styles_modal_title__CaVu5","modal_content":"styles_modal_content__nQrFV","btngroup":"styles_btngroup__B3Bfc"};

/***/ }),

/***/ 69470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"desc":"styles_desc__gww0i","error":"styles_error__4ZRps","input":"styles_input__nk__v","disabled":"styles_disabled__oxEUf","timing_wrapper":"styles_timing_wrapper__9wcL2","timing":"styles_timing__i5kis","center":"styles_center__ijy9t","btn":"styles_btn__7hepk","confirm_modal_wrap":"styles_confirm_modal_wrap__0GQr7","warning_icon":"styles_warning_icon__vU7hL","text_icon":"styles_text_icon__5OcCc","modal_title":"styles_modal_title__8eybH","mb_10":"styles_mb_10__heATs"};

/***/ }),

/***/ 81966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fw500":"styles_fw500__bG5Yd","address_field":"styles_address_field__J2BY1"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paperroot":"styles_paperroot__KzU4N","root":"styles_root__5BFMs","title":"styles_title__cCVNj","margin_none":"styles_margin_none__56x10","checkbox":"styles_checkbox__bRfmf","Mui-disabled":"styles_Mui-disabled__iVHe2","text_area":"styles_text_area__QO3Jm","red_bill":"styles_red_bill__N_EEP","fw500":"styles_fw500__9QhPv","icon":"styles_icon__7Dzvc","helper_text":"styles_helper_text__jRe_x","full_width":"styles_full_width__1adlY","notifi_list":"styles_notifi_list__SAdZo","inputInvoice":"styles_inputInvoice__RJtHa","text_muted":"styles_text_muted__UiBYI","text":"styles_text__XuLr_","grid_fix":"styles_grid_fix__0bxO1","save_info_cb":"styles_save_info_cb__0I6UO","invoiceList":"styles_invoiceList__fpWSO","error":"styles_error__vJuvA"};

/***/ }),

/***/ 1773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawArrow":"styles_drawArrow__IgkLe","draw":"styles_draw__o3GQF"};

/***/ }),

/***/ 74730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"styles_canvasContainer__y_UeM","luckyWheel_container":"styles_luckyWheel_container__MO6lH","mobileSpinner_container":"styles_mobileSpinner_container__lFOXl","mobileSectionWheelTitle_container":"styles_mobileSectionWheelTitle_container__ohQMX","webviewSpinner_container":"styles_webviewSpinner_container__mGpYo","sectionWheelTitle_container":"styles_sectionWheelTitle_container__iii4P","selector_container":"styles_selector_container__KVNHe","result_container":"styles_result_container__B__oM","borderWheel":"styles_borderWheel__Byix5","centerWheel":"styles_centerWheel___6EUQ","fireWork_effect":"styles_fireWork_effect__HUIc3","firework":"styles_firework__sMfHr","btnSpin_container":"styles_btnSpin_container__FEX9t","btnSpin_head":"styles_btnSpin_head__0yO_s","btnSpin_active":"styles_btnSpin_active__cw0NI","btnSpin_bottom":"styles_btnSpin_bottom__F3Luo","btnSpin_containerDisabled":"styles_btnSpin_containerDisabled__yLejN","iconClose":"styles_iconClose__Mt0wi","popupWarning_subTitle":"styles_popupWarning_subTitle__U9pcn","btnClosePopup":"styles_btnClosePopup__6hAfm","btnPopupReset":"styles_btnPopupReset__HRKG_","btnPopupUsing":"styles_btnPopupUsing__lsAaC","drawCanvas_container":"styles_drawCanvas_container__yyrBk","popupGotPrize_subTitle":"styles_popupGotPrize_subTitle__bfj_E","mobilePopupGotPrize_subTitle":"styles_mobilePopupGotPrize_subTitle__G35rD","historyBoard":"styles_historyBoard__FhLDz","boardTab":"styles_boardTab__afiwM","boardContainer":"styles_boardContainer__89aCm","boardGuildLine":"styles_boardGuildLine__0au_D","historyBoard_guildContainer":"styles_historyBoard_guildContainer__U0Vh_","historyBoard_guildLineText":"styles_historyBoard_guildLineText__qf9D4","notHasMore":"styles_notHasMore___24Du","historyRewardScroll_container":"styles_historyRewardScroll_container__Ve_vc","historyReward_loading":"styles_historyReward_loading__ePQxL","boardContainer_childList":"styles_boardContainer_childList__AEozv","boardItem_container":"styles_boardItem_container__OCzkd","boardMissionItem_container":"styles_boardMissionItem_container____nSk","boardItem_imageWrapper":"styles_boardItem_imageWrapper__fvqtC","boardItem_itemName":"styles_boardItem_itemName__ItlTR","boardMissionItem_itemName":"styles_boardMissionItem_itemName__3oTl4","boardItem_created":"styles_boardItem_created__vEdkS","boardMissinItem_btn":"styles_boardMissinItem_btn__FuqgT","historyReward":"styles_historyReward__XSBJx","active":"styles_active__8tOI4","boxHistoryReward":"styles_boxHistoryReward__fzFB_","guildLine":"styles_guildLine__Lj3H4","missionTab":"styles_missionTab__U5nH1","wheelTitle_imageWrapper":"styles_wheelTitle_imageWrapper__OLoL9","mobileWheelTitle_imageWrapper":"styles_mobileWheelTitle_imageWrapper__FqmJH","webViewWheelTitle_imageWrapper":"styles_webViewWheelTitle_imageWrapper__OOdSQ","luckyUser_container":"styles_luckyUser_container__N8hY1","fadeEffect":"styles_fadeEffect__bB8wt","mobileLuckyUser_container":"styles_mobileLuckyUser_container__9nJTy","historyReward_endMessage":"styles_historyReward_endMessage__uG1Ha","historyReward_loadingHidden":"styles_historyReward_loadingHidden__X40Wg","countDownTime_container":"styles_countDownTime_container__WbqhR","mobileCountDownTime_container":"styles_mobileCountDownTime_container__qx5_m","mobileMenuSection_container":"styles_mobileMenuSection_container__Vm8xk","mobileDialogContainer":"styles_mobileDialogContainer__WXJZF","mobilePopupPrize_container":"styles_mobilePopupPrize_container__deFvh","mobilePopupPrize_wrapper":"styles_mobilePopupPrize_wrapper__aHtqX","countDownUser_container":"styles_countDownUser_container__ArVky","luckyUser_messageContent":"styles_luckyUser_messageContent__8LnKn","mobileLuckyUser_messageContent":"styles_mobileLuckyUser_messageContent___Oh5c","luckyUser_containerHidden":"styles_luckyUser_containerHidden__4_0zh","luckyWheel_central":"styles_luckyWheel_central__rRf2Q","luckyWheel_borderWheel":"styles_luckyWheel_borderWheel__zhON1","luckyWheel_selector":"styles_luckyWheel_selector__5JaZ_","webViewLuckyWheel_selector":"styles_webViewLuckyWheel_selector__hQGER","mobileLuckyWheel_central":"styles_mobileLuckyWheel_central__pEsxa","mobileGroupButton_container":"styles_mobileGroupButton_container__GnqAf","mobileMoreTurn_btn":"styles_mobileMoreTurn_btn__bqZUF","mobileNextSpin_btn":"styles_mobileNextSpin_btn__4qMZt","mobileGroupBtn":"styles_mobileGroupBtn__yqxyh","mobileUseNow_btn":"styles_mobileUseNow_btn__13jFk","processBar_container":"styles_processBar_container__dhHM2","boardItemMission_content":"styles_boardItemMission_content__18V9n","textFixedTurn":"styles_textFixedTurn__f4b_K","textFixedTurn_hide":"styles_textFixedTurn_hide__XDb0s","webViewLuckyUser_container":"styles_webViewLuckyUser_container___lW8V","positionArrowEffect":"styles_positionArrowEffect__J_7rr","glowOnEffect":"styles_glowOnEffect__l2PdM","glowing":"styles_glowing__gv1pM","boardMission_disablesBtn":"styles_boardMission_disablesBtn__RtSjp","fbShareButton_wrapper":"styles_fbShareButton_wrapper__JjMbY","fbShareButton_container":"styles_fbShareButton_container___B4Nb","sharingContainer":"styles_sharingContainer__5Hgel","mobileSharingContainer":"styles_mobileSharingContainer__DF1eI","sharingPost_button":"styles_sharingPost_button__PbAQx","webViewSharingPost_button":"styles_webViewSharingPost_button__TWG10","btnSharingNow":"styles_btnSharingNow__AFDYG","popupIconClose_container":"styles_popupIconClose_container__H3bNM","show":"styles_show__XZUEg","hide":"styles_hide__2fMma","popupQuestionContainer":"styles_popupQuestionContainer__ds1pC","popupQuestionTitle":"styles_popupQuestionTitle__r2WTp","popupQuestionName":"styles_popupQuestionName__kJ_fH","answersContainer":"styles_answersContainer___tQi1","answer":"styles_answer__qGsB7","answerSelected":"styles_answerSelected__rL8o2","answerSuccess":"styles_answerSuccess__DWogT","answerWrong":"styles_answerWrong__eFRkz","answerText":"styles_answerText__Lsf6i","wrongAnswerMessage":"styles_wrongAnswerMessage__wdVHc","btnSubmitAnswer":"styles_btnSubmitAnswer__DzAXy","spinnerReward_wrapper":"styles_spinnerReward_wrapper__GLZj5","guidelineMarker":"styles_guidelineMarker__g5KD6","mobileCountDownTime_content":"styles_mobileCountDownTime_content__BXd_J","wrapGuidelineBox":"styles_wrapGuidelineBox__INwqy","tempPrizePosition":"styles_tempPrizePosition__1EB62","tooltipPrizeWrapper":"styles_tooltipPrizeWrapper__XO_Cb","tooltipImageWrapper":"styles_tooltipImageWrapper__cB4rw","tooltipPrizeText":"styles_tooltipPrizeText__Xb8Z8","fadeinout":"styles_fadeinout__NQmOo","display":"styles_display__9TylT"};

/***/ }),

/***/ 73330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__89Lnv","wrapperImg":"styles_wrapperImg__t3OOq","thumbnail":"styles_thumbnail__TbmOL","thumbnailImage":"styles_thumbnailImage__4VUxM","thumbnailSelected":"styles_thumbnailSelected__l9eW6","slider":"styles_slider___hiDP","imageMain":"styles_imageMain__UQ9fH","imageNotFound":"styles_imageNotFound__F6i5M","modalBackdrop":"styles_modalBackdrop__VHM2r","modalButton":"styles_modalButton__5sKlJ","imgButtonBase":"styles_imgButtonBase__RoFW4","descImg":"styles_descImg__MudDr","product_tag":"styles_product_tag__Ob_PB","product_tags":"styles_product_tags__24U9j"};

/***/ }),

/***/ 99148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"auth_modal_header":"styles_auth_modal_header__8MVV9","auth_modal_content":"styles_auth_modal_content__gD2DP","auth_modal_title":"styles_auth_modal_title__7Ht8G","auth_modal_close":"styles_auth_modal_close__CfXli","auth_modal_body":"styles_auth_modal_body__le_XM","form_control":"styles_form_control__Q6ZcO"};

/***/ }),

/***/ 6911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forget_password":"styles_forget_password__Bgi8f","form_forget_password":"styles_form_forget_password__LFLRV","form_control":"styles_form_control__Fh4Bx","error":"styles_error__kc_eh","input":"styles_input__nYkkM","disabled":"styles_disabled__9z3X7","input_icon":"styles_input_icon__GyGX0","confirm_modal_wrap":"styles_confirm_modal_wrap__3VIvi","warning_icon":"styles_warning_icon__ULHEc","text_icon":"styles_text_icon__5s1_y","modal_title":"styles_modal_title__pi0zH","modal_content":"styles_modal_content__QFga1","center":"styles_center__P1JFJ","btn":"styles_btn__hHdKy"};

/***/ }),

/***/ 77827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"auth_modal_content":"styles_auth_modal_content__PvVG_","auth_modal_title":"styles_auth_modal_title__rXe5Q","auth_modal_close":"styles_auth_modal_close__FhiYT","hiddenClose":"styles_hiddenClose__7srCw","iconBack":"styles_iconBack__AF2xw"};

/***/ }),

/***/ 31312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3o7Fu","title":"styles_title__aWThL","bottom_text":"styles_bottom_text__q10_X","error":"styles_error__vO_4D","formInput":"styles_formInput__4d5ir","input":"styles_input__uSP42","disabled":"styles_disabled__lVtJL","custom_field":"styles_custom_field__Q3Gf2","right_c":"styles_right_c__PZfHv","remaining":"styles_remaining___aV6o","confirm_modal_wrap":"styles_confirm_modal_wrap__pUV7U","btn":"styles_btn__iB1lB","outlined_btn":"styles_outlined_btn__TLYCx","brown_btn":"styles_brown_btn__At592","fill_btn":"styles_fill_btn__7GPS_","warning_icon":"styles_warning_icon__WOM0c","text_icon":"styles_text_icon__SRoaP","modal_title":"styles_modal_title__4Zaji","modal_content":"styles_modal_content__NYrDG","btngroup":"styles_btngroup__SlsQL"};

/***/ }),

/***/ 74689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__55sKa","form":"styles_form__PkJAF","title":"styles_title__R0ICH","bottom_text":"styles_bottom_text__h6dKa","error":"styles_error__EVRHG","formInput":"styles_formInput__MS1rR","btn_wrapper":"styles_btn_wrapper__6uhGB","btn":"styles_btn__PdzcE"};

/***/ }),

/***/ 47638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__EYLUj","sendData":"styles_sendData__I_cSt","textError":"styles_textError__V1TeQ","iconError":"styles_iconError__Qm_ie","textRequired":"styles_textRequired__4p7OM","slideLeft":"styles_slideLeft__tDHbv","slide-left":"styles_slide-left__7t8IP","slide-right":"styles_slide-right__cpbTS"};

/***/ }),

/***/ 9992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form_sign_up":"styles_form_sign_up__OFHCD","input":"styles_input__oe1e7","province":"styles_province__4b6xO","text_error":"styles_text_error__R_ylU","input_icon":"styles_input_icon__5UgkE","agree_term":"styles_agree_term__aVgph","radioGroup":"styles_radioGroup__HNzMe","radio_wrapper":"styles_radio_wrapper__TpTwO","item":"styles_item__9tuYb","link_login_wrapper":"styles_link_login_wrapper__5szuS","link_login":"styles_link_login__bBjfG","center":"styles_center__sgJJ3","btn_register":"styles_btn_register__zCg7F","disclaimer":"styles_disclaimer__4zlxV","wrapperTitle":"styles_wrapperTitle__emIpZ","badge":"styles_badge__26zQs","greenIcon":"styles_greenIcon__EUCw5","mt_16":"styles_mt_16__KJngJ","container_select":"styles_container_select__0m1Rs","form_hero":"styles_form_hero__Qvd7x","form_hero_body":"styles_form_hero_body__3yMAj","fields_area":"styles_fields_area__ZusmU","footer_hero":"styles_footer_hero__cVrY0","btn_call_to_action":"styles_btn_call_to_action__KBY_I"};

/***/ }),

/***/ 5397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PnlWX","title":"styles_title__WsbwW","checkbox_color":"styles_checkbox_color__KTpvK","checkbox":"styles_checkbox__eFdbB","bank_info":"styles_bank_info__QXFqo","MuiAlert-message":"styles_MuiAlert-message__QBX_8","bank_info_label":"styles_bank_info_label__amxRh","bank_info_content":"styles_bank_info_content__n_fsY","fw500":"styles_fw500__Ev_4_","d_flex":"styles_d_flex__DmMy6","text_muted":"styles_text_muted__QhYxo","subTitle":"styles_subTitle__J5Agn","paymentMethodsGrid":"styles_paymentMethodsGrid__ay1iS","fieldset":"styles_fieldset__BqASy","noncheckbox_color":"styles_noncheckbox_color__HYKWr","boxPercentage":"styles_boxPercentage__LRqfu","percentageText":"styles_percentageText__CPF7L","containerModal":"styles_containerModal__c6QqQ","headerBack":"styles_headerBack__auf2n","iconBackButton":"styles_iconBackButton__fb0dj","titleBackButton":"styles_titleBackButton__Q9PyQ","listItemsBox":"styles_listItemsBox__fSt2m","listItems":"styles_listItems__kmBgu","radioGroup":"styles_radioGroup__eKFeD","donePaymentButtonBox":"styles_donePaymentButtonBox__YtjM0","donePaymentButton":"styles_donePaymentButton__U4nZg","groupCheckBox":"styles_groupCheckBox__GInDK","titleContent":"styles_titleContent___ghPn","subTitleContent":"styles_subTitleContent__X1PM_"};

/***/ }),

/***/ 28829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"style_confirm_modal_wrap__vWm7v","title":"style_title__Se24i","button":"style_button__tDpHC","product_name":"style_product_name__ekoUR","ovfy":"style_ovfy__Wn635"};

/***/ }),

/***/ 37315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_content_column":"styles_product_content_column__uMZ6Y","product_name":"styles_product_name__GYznx","flex_wrap":"styles_flex_wrap__pzZMG","giftlink":"styles_giftlink__sjx5V","link":"styles_link__9frSU","product_type":"styles_product_type__Bm_uX","align_center":"styles_align_center__4oU0Z","muted":"styles_muted__Hq7Sf","product_category":"styles_product_category__XKs0l","product_tags":"styles_product_tags__4oFLJ","product_tags_column":"styles_product_tags_column__Osvao","product_title_column_wrap":"styles_product_title_column_wrap__BXF_B","product_title":"styles_product_title__2A7U3","h40":"styles_h40__Ab6IB","product_content":"styles_product_content__bPOWw","discount_flag":"styles_discount_flag__rA_oc","boxPerDay":"styles_boxPerDay__w1O_U","product_name_mv2":"styles_product_name_mv2___Gi_9","product_tag_mv2":"styles_product_tag_mv2__Vww8e","linkMobile":"styles_linkMobile__v9CZ8","mobileProduct_type":"styles_mobileProduct_type__GhTdv","giftPromo":"styles_giftPromo__rWO81","prioritizedPromo":"styles_prioritizedPromo__zs2io","product_title_wrap":"styles_product_title_wrap__hdUa_","product_action":"styles_product_action__E8b9e","flex_70":"styles_flex_70__PSotj","flex_40":"styles_flex_40__0yh6j","mw_440":"styles_mw_440__iyM_s","product_name_mv2_horizontal":"styles_product_name_mv2_horizontal__N_Qdc"};

/***/ }),

/***/ 65369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__F2fym","indicator":"styles_indicator__2pXj_","mobileIndicator":"styles_mobileIndicator__ZMT4p","content":"styles_content__6RTCG","tabs":"styles_tabs__gKnEf","tab_panel":"styles_tab_panel__ScV41"};

/***/ }),

/***/ 69815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__ul4ax","tab_panel":"styles_tab_panel__NAwAa","root":"styles_root__yHa_F","active_tab":"styles_active_tab__57bQP","indicator":"styles_indicator__oOTul","content":"styles_content__L0lSp","ingredient":"styles_ingredient__YBVN8","ingredientList":"styles_ingredientList___k512","cb_link":"styles_cb_link__XAKSc","product_tags":"styles_product_tags__ExhNu","warpper":"styles_warpper__a1pGy","manufactureInfo":"styles_manufactureInfo__3LBBp","manufactureInfoLink":"styles_manufactureInfoLink__NlYlw","warpperIcon":"styles_warpperIcon__8WfDk","tab_mv2":"styles_tab_mv2__f7QpT","tab_panel_mv2":"styles_tab_panel_mv2__j1JOq","mobile_item_wrapper":"styles_mobile_item_wrapper__jtSmF","item_wrapper":"styles_item_wrapper__FoAJK","manufactureInfo_mv2":"styles_manufactureInfo_mv2__W0QaA","mobile_item":"styles_mobile_item__lGYxd","item":"styles_item__8W9c_","general_item":"styles_general_item__PYGAu","input_label":"styles_input_label__oQp_e","item_label":"styles_item_label__Jq3we","item_label_border":"styles_item_label_border__fwR0E","item_content":"styles_item_content__fOfKI","ingredient_row":"styles_ingredient_row__FFyQU","ingredient_row_label":"styles_ingredient_row_label__P93In","ingredient_row_content":"styles_ingredient_row_content__seZL3","ingredient_heading":"styles_ingredient_heading__eQ4Pg","ingredient_row_heading":"styles_ingredient_row_heading__FkE_4"};

/***/ }),

/***/ 57770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"styles_confirm_modal_wrap__uTxNL","header":"styles_header__lEBHn","closeIcon":"styles_closeIcon__8jfJQ","fixed_width_wrapper":"styles_fixed_width_wrapper__G_sjn","modal_title":"styles_modal_title__2q_64","children":"styles_children__W0hg0","gift_icon":"styles_gift_icon__TNl3o","wrapLoading":"styles_wrapLoading__tiTSv","containerPromoDiablog":"styles_containerPromoDiablog__tgs8S","wrapImg":"styles_wrapImg__iDCCh","btn_container":"styles_btn_container__7SXzj"};

/***/ }),

/***/ 5070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__4CR4M","title":"styles_title__Bye3n","bottom_text":"styles_bottom_text__nEKSZ","btnWrapper":"styles_btnWrapper__FW9IP","error":"styles_error__LIpZk","formInput":"styles_formInput__JstrB"};

/***/ }),

/***/ 55166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchDropdown":"styles_searchDropdown__FryBv","searchResults":"styles_searchResults__HEeR_","textPrimary":"styles_textPrimary__0O4Pe"};

/***/ }),

/***/ 19024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__Gyi3H","input":"styles_input___qtIu","root_input_column":"styles_root_input_column__Y9PFv","focus":"styles_focus__Gs1L7"};

/***/ }),

/***/ 70179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__z8jk6","input":"styles_input__evwLt","focus":"styles_focus__iyfyA","search_wrap":"styles_search_wrap__0bclL"};

/***/ }),

/***/ 55711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search_result":"style_search_result__5jWKu"};

/***/ }),

/***/ 46639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5ZQbt","trigger":"styles_trigger__hJIBW","trigger_error":"styles_trigger_error__9LZOj","trigger_open":"styles_trigger_open__xerQj","start_icon":"styles_start_icon__8vwys","value":"styles_value__Ait1n","placeholder":"styles_placeholder__9u866","chevron":"styles_chevron__bRkmz","paper":"styles_paper__2zHdJ","panel":"styles_panel__Iw8bU","search":"styles_search__mKJuI","search_icon":"styles_search_icon__18Tue","search_input":"styles_search_input__YiuNK","list":"styles_list__xw3pX","option":"styles_option__6OEpz","option_active":"styles_option_active__gMfoH","option_selected":"styles_option_selected__5QzkJ","option_label":"styles_option_label__FN2LK","option_check":"styles_option_check__MllXt","empty":"styles_empty__nk2Z6"};

/***/ }),

/***/ 37721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__cyIKQ","mobile_wrapper":"styles_mobile_wrapper__RMksv","row":"styles_row__aF_r7","avatar_name":"styles_avatar_name__AuzRP","mobile_avatar_name":"styles_mobile_avatar_name__vqF5m","avatar":"styles_avatar__itYY0","mobile_avatar":"styles_mobile_avatar__J3Ktl","name":"styles_name__Jz1Pr","mobile_name":"styles_mobile_name__Upo9k","visit_store":"styles_visit_store__e_j87","hide_border_top":"styles_hide_border_top__V20U7"};

/***/ }),

/***/ 14025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"province":"styles_province__grk_9","radioGroup":"styles_radioGroup__h9_i4","item":"styles_item__uNdJN","menuDropdown":"styles_menuDropdown__Gywm6"};

/***/ }),

/***/ 469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedback_order":"style_feedback_order__54hgm","container":"style_container__kRZ5D","title":"style_title__jnP7a","statusTitle":"style_statusTitle__kImWo","label":"style_label__Zaovr","text_body":"style_text_body__gVrlt","value":"style_value__aN3JA","feedbackWrap":"style_feedbackWrap__BeNMN","feedbackConent":"style_feedbackConent__o_0ax","feedbackImg":"style_feedbackImg__dZK0N","button_find":"style_button_find__cGYdT","text_red":"style_text_red__krwD9","button_send":"style_button_send__8GGNd","reason_select":"style_reason_select__RO__H","textarea":"style_textarea__UVnXx","imagesField":"style_imagesField__K4t_c","info_group":"style_info_group__Or8_F","rug-handle-icon":"style_rug-handle-icon__sZq3B","customText":"style_customText__PYtfw","card":"style_card__lR2DI","bank_name":"style_bank_name__qRpsF","bank_code":"style_bank_code__m9t2n","info_bank_title":"style_info_bank_title__0pH0H","content":"style_content__UefVl","ticket_status_chip":"style_ticket_status_chip__7i97l","reason_button":"style_reason_button__FcOas","ticket_img_container":"style_ticket_img_container__UOaAE","ticket_img":"style_ticket_img__9bWAs","pop_over":"style_pop_over__Myhh6","text_field":"style_text_field__MRrI5","close_button":"style_close_button__wYgc2","image_modal":"style_image_modal__CjTAi","buttonSend":"style_buttonSend__zCDbp","SendFeedback":"style_SendFeedback__JQcbY","formfeedback":"style_formfeedback__TQv_T","buttonCancel":"style_buttonCancel__CZWud","buttonActive":"style_buttonActive__2q3Gt","buttonInActive":"style_buttonInActive__47cdd","feedbackReturn":"style_feedbackReturn__XSfye","feedbackReturn_title":"style_feedbackReturn_title__ZbfjC","nameTS":"style_nameTS__hkcBI","avatarUser":"style_avatarUser__j4p04","nameUser":"style_nameUser__E5ZG9","date":"style_date__sl6Ju","accept":"style_accept__xNYPw","btnAcept":"style_btnAcept__dVIjr"};

/***/ }),

/***/ 81330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedback_order":"style_feedback_order__Z6zbB","container":"style_container__FxEZt","title":"style_title___O13n","label":"style_label__7PpI0","text_body":"style_text_body__UO9Ob","button_find":"style_button_find__6D_1p","text_red":"style_text_red__KJUwg","button_send":"style_button_send__QfvU9","reason_select":"style_reason_select__Ns8N8","textarea":"style_textarea__6lgdK","imagesField":"style_imagesField___qpc5","info_group":"style_info_group__CnrdR","rug-handle-icon":"style_rug-handle-icon__zrgJl","customText":"style_customText__9q0rK"};

/***/ })

}]);